var L1 = Object.defineProperty;
var B1 = (e, t, a) => t in e ? L1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var Ja = (e, t, a) => B1(e, typeof t != "symbol" ? t + "" : t, a);
import { defineComponent as oe, renderSlot as W, reactive as jr, ref as N, useSlots as $t, createCommentVNode as H, computed as b, createBlock as X, openBlock as m, resolveDynamicComponent as Ye, normalizeStyle as Oe, withCtx as L, createElementBlock as $, normalizeClass as ce, createElementVNode as Y, unref as D, toDisplayString as re, withKeys as ct, withModifiers as Ke, shallowRef as rg, watch as ie, getCurrentScope as ig, onScopeDispose as og, shallowReadonly as hr, useAttrs as na, onMounted as it, mergeProps as Re, toHandlers as Bl, Teleport as R1, toValue as An, getCurrentInstance as Nu, useId as yt, onBeforeUnmount as fn, createVNode as G, createTextVNode as be, Transition as ea, withDirectives as pa, vShow as Xn, useCssVars as Wt, nextTick as ht, Fragment as Ee, renderList as Fe, onUnmounted as ya, isReadonly as F1, toRefs as lg, watchEffect as Lu, useTemplateRef as dt, createSlots as kt, isVNode as sg, normalizeProps as la, warn as z1, inject as Bi, toRef as Ho, provide as Ri, guardReactiveProps as Oa, isRef as kr, resolveComponent as qt, resolveDirective as Y1, mergeModels as _s, useModel as eu, vModelText as tu, Comment as H1, cloneVNode as q1, onBeforeMount as W1, TransitionGroup as U1, render as qc, h as fs, createPropsRestProxy as ug } from "vue";
async function cg(e) {
  var n, r;
  if (navigator.clipboard)
    try {
      return await navigator.clipboard.writeText(e), !0;
    } catch {
    }
  const t = document == null ? void 0 : document.createElement("textarea");
  t && (t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.style.width = "32px", t.style.height = "32px", t.style.padding = "0", t.style.border = "none", t.style.outline = "none", t.style.boxShadow = "none", t.style.background = "transparent", t.value = e, (n = document == null ? void 0 : document.body) == null || n.appendChild(t), t.focus(), t.select());
  let a;
  try {
    a = document == null ? void 0 : document.execCommand("copy");
  } catch {
    a = !1;
  } finally {
    (r = document == null ? void 0 : document.body) == null || r.removeChild(t);
  }
  return a;
}
const dg = /* @__PURE__ */ oe({
  __name: "KClipboardProvider",
  setup(e) {
    const t = (a = "") => cg(a);
    return (a, n) => W(a.$slots, "default", { copyToClipboard: t });
  }
}), fg = oe({
  name: "KComponent",
  props: {
    data: {
      type: Object,
      default: {},
      required: !0
    }
  },
  setup(e, { slots: t }) {
    const a = jr(e.data);
    return () => (t == null ? void 0 : t.default) && t.default({
      data: a
    });
  }
}), Rl = /* @__PURE__ */ oe({
  __name: "KToggle",
  props: {
    toggled: { type: Boolean }
  },
  emits: ["toggled"],
  setup(e, { emit: t }) {
    const a = t, n = N(e.toggled), r = [n], i = () => {
      n.value = !n.value, a("toggled", n.value);
    };
    return $t().default || console.error(`KToggle expects to have slot content.

Example usage:

<KToggle>
  <template #default="{ isToggled, toggle }">
    <button @click="toggle">
      {{ isToggled ? 'hello' : 'goodbye' }}
    </button>
  </template>
</KToggle>
`), (u, s) => u.$slots.default ? W(u.$slots, "default", {
      key: 0,
      isToggled: r[0],
      toggle: i
    }) : H("", !0);
  }
}), gr = {
  info: "info",
  success: "success",
  danger: "danger",
  warning: "warning",
  decorative: "decorative"
}, vg = {
  get: "get",
  post: "post",
  put: "put",
  delete: "delete",
  patch: "patch",
  options: "options",
  head: "head",
  connect: "connect",
  trace: "trace",
  custom: "custom"
}, Dq = {
  info: "info",
  success: "success",
  warning: "warning",
  danger: "danger",
  decorative: "decorative",
  neutral: "neutral",
  ...vg
}, Aq = {
  medium: "medium",
  small: "small"
}, K1 = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  danger: "danger",
  none: "none"
}, Iq = {
  large: "large",
  medium: "medium",
  small: "small"
}, Eq = ["div", "p", "span", "a", "legend", "h1", "h2", "h3", "h4", "h5", "h6"], Mq = ["large", "medium", "small"], Oq = ["leading", "trailing"];
var Fl = /* @__PURE__ */ ((e) => (e.Date = "date", e.Time = "time", e.Datetime = "dateTime", e.Relative = "relative", e.RelativeDate = "relativeDate", e.RelativeDateTime = "relativeDateTime", e))(Fl || {});
const Pq = Fl, Nq = Object.values(Fl), V1 = [
  "date",
  "time",
  "dateTime"
  /* Datetime */
], j1 = [
  "relative",
  "relativeDate",
  "relativeDateTime"
  /* RelativeDateTime */
], G1 = [
  "date",
  "relativeDate"
  /* RelativeDate */
];
var Na = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Search = "search", e.Kong = "kong", e))(Na || {});
const Lq = ["get", "post", "put", "patch", "delete", "head", "options", "trace", "connect", "custom"], Bq = ["click", "hover"], Rq = [
  "auto",
  "top",
  "top-start",
  "top-end",
  "left",
  "left-start",
  "left-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end"
], Fq = ["", "radio", "card"], zq = [
  "table",
  "card",
  "form",
  "spinner",
  "fullscreen-kong",
  "fullscreen-generic",
  ""
  // default Skeleton.vue
], Yq = ["1", "2", "5", "6", "10", "25", "50", "75", "100"], Hq = ["1", "2"], qq = ["active", "default", "pending", "completed", "error"];
var Ge = /* @__PURE__ */ ((e) => (e.EXPANDABLE = "expandable", e.ACTIONS = "actions", e.BULK_ACTIONS = "bulkActions", e))(Ge || {});
const hg = {
  info: "info",
  success: "success",
  danger: "danger",
  warning: "warning",
  system: "system"
}, De = "24px", Q1 = ["aria-hidden"], Wc = '<path d="M7 17H9V12H7V17ZM15 17H17V7H15V17ZM11 17H13V14H11V17ZM11 12H13V10H11V12ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z" fill="currentColor"/>', Uc = /* @__PURE__ */ oe({
  __name: "AnalyticsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Wc : r(Wc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon analytics-icon",
      "data-testid": "kui-icon-wrapper-analytics-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-analytics-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Q1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Z1 = ["aria-hidden"], Kc = '<path d="M12 20L4 12L5.4 10.575L11 16.175V4H13V16.175L18.6 10.575L20 12L12 20Z" fill="currentColor"/>', Bu = /* @__PURE__ */ oe({
  __name: "ArrowDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Kc : r(Kc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-down-icon",
      "data-testid": "kui-icon-wrapper-arrow-down-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Z1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), X1 = ["aria-hidden"], Vc = '<path d="M11 20V7.825L5.4 13.425L4 12L12 4L20 12L18.6 13.425L13 7.825V20H11Z" fill="currentColor"/>', J1 = /* @__PURE__ */ oe({
  __name: "ArrowUpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Vc : r(Vc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-up-icon",
      "data-testid": "kui-icon-wrapper-arrow-up-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-up-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, X1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), _1 = ["aria-hidden"], jc = '<path d="M9 18L3 12L9 6L10.4 7.4L6.8 11H21V13H6.8L10.4 16.6L9 18Z" fill="currentColor"/>', gg = /* @__PURE__ */ oe({
  __name: "BackIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? jc : r(jc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon back-icon",
      "data-testid": "kui-icon-wrapper-back-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-back-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, _1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ey = ["aria-hidden"], Gc = '<path d="M12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20Z" fill="currentColor"/>', ty = /* @__PURE__ */ oe({
  __name: "CalIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Gc : r(Gc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon cal-icon",
      "data-testid": "kui-icon-wrapper-cal-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-cal-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ey))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ay = ["aria-hidden"], Qc = '<path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', mg = /* @__PURE__ */ oe({
  __name: "CheckCircleIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Qc : r(Qc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-circle-icon",
      "data-testid": "kui-icon-wrapper-check-circle-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-circle-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ay))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ny = ["aria-hidden"], Zc = '<path d="M8 14.4L4 10.4L5.4 9L8 11.6L14.6 5L16 6.4L8 14.4Z" fill="currentColor"/>', ry = /* @__PURE__ */ oe({
  __name: "CheckSmallIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Zc : r(Zc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-small-icon",
      "data-testid": "kui-icon-wrapper-check-small-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-small-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ny))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), iy = ["aria-hidden"], Xc = '<path d="M9.7 18.025L4 12.325L5.425 10.9L9.7 15.175L18.875 6L20.3 7.425L9.7 18.025Z" fill="currentColor"/>', oy = /* @__PURE__ */ oe({
  __name: "CheckIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Xc : r(Xc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-icon",
      "data-testid": "kui-icon-wrapper-check-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, iy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ly = ["aria-hidden"], Jc = '<path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="currentColor"/>', zl = /* @__PURE__ */ oe({
  __name: "ChevronDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Jc : r(Jc)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-down-icon",
      "data-testid": "kui-icon-wrapper-chevron-down-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ly))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), sy = ["aria-hidden"], _c = '<path d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z" fill="currentColor"/>', Ru = /* @__PURE__ */ oe({
  __name: "ChevronRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? _c : r(_c)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-right-icon",
      "data-testid": "kui-icon-wrapper-chevron-right-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, sy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), uy = ["aria-hidden"], ed = '<path d="M7.4 15.4L6 14L12 8L18 14L16.6 15.4L12 10.8L7.4 15.4Z" fill="currentColor"/>', cy = /* @__PURE__ */ oe({
  __name: "ChevronUpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ed : r(ed)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-up-icon",
      "data-testid": "kui-icon-wrapper-chevron-up-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-up-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, uy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), dy = ["aria-hidden"], td = '<path d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', fy = /* @__PURE__ */ oe({
  __name: "ClearIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? td : r(td)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon clear-icon",
      "data-testid": "kui-icon-wrapper-clear-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-clear-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, dy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), vy = ["aria-hidden"], ad = '<path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor"/>', ha = /* @__PURE__ */ oe({
  __name: "CloseIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ad : r(ad)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon close-icon",
      "data-testid": "kui-icon-wrapper-close-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-close-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, vy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), hy = ["aria-hidden"], nd = '<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16Z" fill="currentColor"/>', pg = /* @__PURE__ */ oe({
  __name: "CopyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? nd : r(nd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon copy-icon",
      "data-testid": "kui-icon-wrapper-copy-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-copy-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, hy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), gy = ["aria-hidden"], rd = '<path d="M8.575 21.25C8.30833 21.25 8.05417 21.2 7.8125 21.1C7.57083 21 7.35833 20.8583 7.175 20.675L3.075 16.575C2.89167 16.3917 2.75 16.1792 2.65 15.9375C2.55 15.6958 2.5 15.4417 2.5 15.175V9.325C2.5 9.05833 2.55 8.80417 2.65 8.5625C2.75 8.32083 2.89167 8.10833 3.075 7.925L7.175 3.825C7.35833 3.64167 7.57083 3.5 7.8125 3.4C8.05417 3.3 8.30833 3.25 8.575 3.25H14.425C14.6917 3.25 14.9458 3.3 15.1875 3.4C15.4292 3.5 15.6417 3.64167 15.825 3.825L19.925 7.925C20.1083 8.10833 20.25 8.32083 20.35 8.5625C20.45 8.80417 20.5 9.05833 20.5 9.325V15.175C20.5 15.4417 20.45 15.6958 20.35 15.9375C20.25 16.1792 20.1083 16.3917 19.925 16.575L15.825 20.675C15.6417 20.8583 15.4292 21 15.1875 21.1C14.9458 21.2 14.6917 21.25 14.425 21.25H8.575ZM11.5 13.65L13.65 15.8C13.8333 15.9833 14.0667 16.075 14.35 16.075C14.6333 16.075 14.8667 15.9833 15.05 15.8C15.2333 15.6167 15.325 15.3833 15.325 15.1C15.325 14.8167 15.2333 14.5833 15.05 14.4L12.9 12.25L15.05 10.1C15.2333 9.91667 15.325 9.68333 15.325 9.4C15.325 9.11667 15.2333 8.88333 15.05 8.7C14.8667 8.51667 14.6333 8.425 14.35 8.425C14.0667 8.425 13.8333 8.51667 13.65 8.7L11.5 10.85L9.35 8.7C9.16667 8.51667 8.93333 8.425 8.65 8.425C8.36667 8.425 8.13333 8.51667 7.95 8.7C7.76667 8.88333 7.675 9.11667 7.675 9.4C7.675 9.68333 7.76667 9.91667 7.95 10.1L10.1 12.25L7.95 14.4C7.76667 14.5833 7.675 14.8167 7.675 15.1C7.675 15.3833 7.76667 15.6167 7.95 15.8C8.13333 15.9833 8.36667 16.075 8.65 16.075C8.93333 16.075 9.16667 15.9833 9.35 15.8L11.5 13.65Z" fill="currentColor"/>', my = /* @__PURE__ */ oe({
  __name: "DangerIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? rd : r(rd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon danger-icon",
      "data-testid": "kui-icon-wrapper-danger-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-danger-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, gy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), py = ["aria-hidden"], id = '<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z" fill="currentColor"/>', yy = /* @__PURE__ */ oe({
  __name: "ExternalLinkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? id : r(id)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon external-link-icon",
      "data-testid": "kui-icon-wrapper-external-link-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-external-link-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, py))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), by = ["aria-hidden"], od = '<path d="M6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" fill="currentColor"/>', wy = /* @__PURE__ */ oe({
  __name: "FileEmptyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? od : r(od)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon file-empty-icon",
      "data-testid": "kui-icon-wrapper-file-empty-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-file-empty-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, by))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Cy = ["aria-hidden"], ld = '<path d="M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z" fill="currentColor"/>', ky = /* @__PURE__ */ oe({
  __name: "FilterIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ld : r(ld)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon filter-icon",
      "data-testid": "kui-icon-wrapper-filter-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-filter-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Cy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), $y = ["aria-hidden"], sd = '<path d="M15 18L21 12L15 6L13.6 7.4L17.2 11H3V13H17.2L13.6 16.6L15 18Z" fill="currentColor"/>', yg = /* @__PURE__ */ oe({
  __name: "ForwardIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? sd : r(sd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon forward-icon",
      "data-testid": "kui-icon-wrapper-forward-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-forward-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, $y))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Sy = ["aria-hidden"], ud = '<path d="M5 11V9H15V11H5Z" fill="currentColor"/>', xy = /* @__PURE__ */ oe({
  __name: "IndeterminateSmallIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ud : r(ud)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon indeterminate-small-icon",
      "data-testid": "kui-icon-wrapper-indeterminate-small-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-indeterminate-small-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Sy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ty = ["aria-hidden"], cd = '<path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', En = /* @__PURE__ */ oe({
  __name: "InfoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? cd : r(cd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon info-icon",
      "data-testid": "kui-icon-wrapper-info-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-info-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ty))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Dy = ["aria-hidden"], dd = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.56654 17.8134H12.2371L14.1429 20.2096L13.8152 21.026H9.0731L9.18942 20.2096L8.07153 18.4462L8.56654 17.8134ZM11.193 7.28639L13.1602 7.28343L22 17.822L21.3132 21.026H17.5245L17.7604 20.1233L9.50009 10.2732L11.193 7.28639ZM14.6686 3L18.778 6.22975L18.2519 6.77265L18.9644 7.76492V8.82592L16.9157 10.496L13.4703 6.42551H11.4644L12.272 4.94512L14.6686 3ZM6.04318 13.3443L8.90974 10.853L12.7144 15.4313L11.6342 17.1086H8.12603L5.69899 20.2934L5.14469 21.026H2V17.1183L4.93106 13.3443H6.04318Z" fill="currentColor"/>', Fu = /* @__PURE__ */ oe({
  __name: "KongIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? dd : r(dd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon kong-icon",
      "data-testid": "kui-icon-wrapper-kong-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-kong-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Dy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ay = ["aria-hidden"], fd = '<path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="currentColor"/>', bg = /* @__PURE__ */ oe({
  __name: "MoreIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? fd : r(fd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon more-icon",
      "data-testid": "kui-icon-wrapper-more-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-more-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ay))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Iy = ["aria-hidden"], vd = `<style>@keyframes kong-icon-spin { from {transform: rotate(0deg);} to {transform: rotate(360deg);} }</style>
<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7167 20.0958 11.4792 20.2875 11.2875C20.4792 11.0958 20.7167 11 21 11C21.2833 11 21.5208 11.0958 21.7125 11.2875C21.9042 11.4792 22 11.7167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22Z" fill="currentColor" style="transform-origin: 50% 50%; animation: kong-icon-spin 1.5s linear infinite;"/>`, Fi = /* @__PURE__ */ oe({
  __name: "ProgressIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? vd : r(vd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon progress-icon",
      "data-testid": "kui-icon-wrapper-progress-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-progress-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Iy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ey = ["aria-hidden"], hd = '<path d="M4.30937 19.025C3.49271 18.075 2.86198 16.9917 2.41719 15.775C1.9724 14.5583 1.75 13.2833 1.75 11.95C1.75 10.6167 1.96875 9.34167 2.40625 8.125C2.84375 6.90833 3.47812 5.825 4.30937 4.875L5.55625 6.3C4.88542 7.05 4.375 7.9125 4.025 8.8875C3.675 9.8625 3.5 10.8833 3.5 11.95C3.5 13.0167 3.67865 14.0375 4.03594 15.0125C4.39323 15.9875 4.9 16.85 5.55625 17.6L4.30937 19.025ZM8.3125 18C7.94792 18 7.63802 17.8542 7.38281 17.5625C7.1276 17.2708 7 16.9167 7 16.5C7 16.0833 7.1276 15.7292 7.38281 15.4375C7.63802 15.1458 7.94792 15 8.3125 15C8.67708 15 8.98698 15.1458 9.24219 15.4375C9.49739 15.7292 9.625 16.0833 9.625 16.5C9.625 16.9167 9.49739 17.2708 9.24219 17.5625C8.98698 17.8542 8.67708 18 8.3125 18ZM11.3531 13V11.225L10.0187 12.125L9.14375 10.375L10.4781 9.5L9.14375 8.625L10.0187 6.875L11.3531 7.775V6H13.1031V7.775L14.4375 6.875L15.3125 8.625L13.9781 9.5L15.3125 10.375L14.4375 12.125L13.1031 11.225V13H11.3531ZM16.6906 19.025L15.4437 17.6C16.1146 16.85 16.625 15.9875 16.975 15.0125C17.325 14.0375 17.5 13.0167 17.5 11.95C17.5 10.8833 17.3214 9.8625 16.9641 8.8875C16.6068 7.9125 16.1 7.05 15.4437 6.3L16.6906 4.875C17.5073 5.825 18.138 6.90833 18.5828 8.125C19.0276 9.34167 19.25 10.6167 19.25 11.95C19.25 13.2833 19.0312 14.5583 18.5937 15.775C18.1562 16.9917 17.5219 18.075 16.6906 19.025Z" fill="currentColor"/>', My = /* @__PURE__ */ oe({
  __name: "RegexIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? hd : r(hd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon regex-icon",
      "data-testid": "kui-icon-wrapper-regex-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-regex-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ey))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Oy = ["aria-hidden"], gd = '<path d="M2.4498 10.575L6.6498 6.37504C6.88314 6.1417 7.15814 5.97504 7.4748 5.87504C7.79147 5.77504 8.11647 5.75837 8.4498 5.82504L9.7498 6.10004C8.8498 7.1667 8.14147 8.13337 7.6248 9.00004C7.10814 9.8667 6.60814 10.9167 6.1248 12.15L2.4498 10.575ZM7.5748 12.85C7.95814 11.65 8.47897 10.5167 9.1373 9.45004C9.79564 8.38337 10.5915 7.38337 11.5248 6.45004C12.9915 4.98337 14.6665 3.88754 16.5498 3.16254C18.4331 2.43754 20.1915 2.2167 21.8248 2.50004C22.1081 4.13337 21.8915 5.8917 21.1748 7.77504C20.4581 9.65837 19.3665 11.3334 17.8998 12.8C16.9831 13.7167 15.9831 14.5125 14.8998 15.1875C13.8165 15.8625 12.6748 16.3917 11.4748 16.775L7.5748 12.85ZM14.4748 9.85004C14.8581 10.2334 15.329 10.425 15.8873 10.425C16.4456 10.425 16.9165 10.2334 17.2998 9.85004C17.6831 9.4667 17.8748 8.99587 17.8748 8.43754C17.8748 7.8792 17.6831 7.40837 17.2998 7.02504C16.9165 6.6417 16.4456 6.45004 15.8873 6.45004C15.329 6.45004 14.8581 6.6417 14.4748 7.02504C14.0915 7.40837 13.8998 7.8792 13.8998 8.43754C13.8998 8.99587 14.0915 9.4667 14.4748 9.85004ZM13.7748 21.875L12.1748 18.2C13.4081 17.7167 14.4623 17.2167 15.3373 16.7C16.2123 16.1834 17.1831 15.475 18.2498 14.575L18.4998 15.875C18.5665 16.2084 18.5498 16.5375 18.4498 16.8625C18.3498 17.1875 18.1831 17.4667 17.9498 17.7L13.7748 21.875ZM4.0498 16.05C4.63314 15.4667 5.34147 15.1709 6.1748 15.1625C7.00814 15.1542 7.71647 15.4417 8.2998 16.025C8.88314 16.6084 9.1748 17.3167 9.1748 18.15C9.1748 18.9834 8.88314 19.6917 8.2998 20.275C7.88314 20.6917 7.1873 21.05 6.2123 21.35C5.2373 21.65 3.89147 21.9167 2.1748 22.15C2.40814 20.4334 2.6748 19.0917 2.9748 18.125C3.2748 17.1584 3.63314 16.4667 4.0498 16.05Z" fill="currentColor"/>', Py = /* @__PURE__ */ oe({
  __name: "RocketIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? gd : r(gd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon rocket-icon",
      "data-testid": "kui-icon-wrapper-rocket-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-rocket-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Oy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ny = ["aria-hidden"], md = '<path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="currentColor"/>', zu = /* @__PURE__ */ oe({
  __name: "SearchIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? md : r(md)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon search-icon",
      "data-testid": "kui-icon-wrapper-search-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-search-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ny))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ly = ["aria-hidden"], pd = '<path d="M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" fill="currentColor"/>', By = /* @__PURE__ */ oe({
  __name: "ServiceDocumentIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? pd : r(pd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon service-document-icon",
      "data-testid": "kui-icon-wrapper-service-document-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-service-document-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ly))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ry = ["aria-hidden"], yd = '<path d="M8 13V5.825L5.425 8.4L4 7L9 2L14 7L12.575 8.4L10 5.825V13H8ZM15 22L10 17L11.425 15.6L14 18.175V11H16V18.175L18.575 15.6L20 17L15 22Z" fill="currentColor"/>', Fy = /* @__PURE__ */ oe({
  __name: "SwapSortIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? yd : r(yd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon swap-sort-icon",
      "data-testid": "kui-icon-wrapper-swap-sort-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-swap-sort-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ry))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), zy = ["aria-hidden"], bd = '<path d="M3.0249 17.75V7.75C3.0249 7.2 3.22074 6.72917 3.6124 6.3375C4.00407 5.94583 4.4749 5.75 5.0249 5.75H18.9999C19.5499 5.75 20.0207 5.94583 20.4124 6.3375C20.8041 6.72917 20.9999 7.2 20.9999 7.75V17.75C20.9999 18.3 20.8041 18.7708 20.4124 19.1625C20.0207 19.5542 19.5499 19.75 18.9999 19.75H5.0249C4.4749 19.75 4.00407 19.5542 3.6124 19.1625C3.22074 18.7708 3.0249 18.3 3.0249 17.75ZM4.9999 17.75H8.3249V7.75H4.9999V17.75ZM10.3249 17.75H13.6499V7.75H10.3249V17.75ZM15.6499 17.75H18.9749V7.75H15.6499V17.75Z" fill="currentColor"/>', Yy = /* @__PURE__ */ oe({
  __name: "TableColumnsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? bd : r(bd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon table-columns-icon",
      "data-testid": "kui-icon-wrapper-table-columns-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-table-columns-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, zy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Hy = ["aria-hidden"], wd = '<path d="M11 16.5V8.35L8.4 10.95L7 9.5L12 4.5L17 9.5L15.6 10.95L13 8.35V16.5H11ZM6 20.5C5.45 20.5 4.97917 20.3042 4.5875 19.9125C4.19583 19.5208 4 19.05 4 18.5V15.5H6V18.5H18V15.5H20V18.5C20 19.05 19.8042 19.5208 19.4125 19.9125C19.0208 20.3042 18.55 20.5 18 20.5H6Z" fill="currentColor"/>', qy = /* @__PURE__ */ oe({
  __name: "UploadIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? wd : r(wd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon upload-icon",
      "data-testid": "kui-icon-wrapper-upload-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-upload-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Hy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Wy = ["aria-hidden"], Cd = '<path d="M19.0999 21.9L15.5999 18.45C15.0166 18.6333 14.4249 18.7708 13.8249 18.8625C13.2249 18.9541 12.6166 19 11.9999 19C9.76657 19 7.7249 18.4 5.8749 17.2C4.0249 16 2.5749 14.4166 1.5249 12.45C1.44157 12.3 1.37907 12.1458 1.3374 11.9875C1.29574 11.8291 1.2749 11.6666 1.2749 11.5C1.2749 11.3333 1.29574 11.1708 1.3374 11.0125C1.37907 10.8541 1.44157 10.7 1.5249 10.55C1.89157 9.89998 2.28324 9.26664 2.6999 8.64998C3.11657 8.03331 3.5999 7.48331 4.1499 6.99998L2.0749 4.89998C1.89157 4.71664 1.7999 4.48748 1.7999 4.21248C1.7999 3.93748 1.8999 3.69998 2.0999 3.49998C2.28324 3.31664 2.51657 3.22498 2.7999 3.22498C3.08324 3.22498 3.31657 3.31664 3.4999 3.49998L20.4999 20.5C20.6832 20.6833 20.7791 20.9125 20.7874 21.1875C20.7957 21.4625 20.6999 21.7 20.4999 21.9C20.3166 22.0833 20.0832 22.175 19.7999 22.175C19.5166 22.175 19.2832 22.0833 19.0999 21.9ZM11.9999 16C12.1832 16 12.3582 15.9916 12.5249 15.975C12.6916 15.9583 12.8582 15.925 13.0249 15.875L7.6249 10.475C7.5749 10.6416 7.54157 10.8083 7.5249 10.975C7.50824 11.1416 7.4999 11.3166 7.4999 11.5C7.4999 12.75 7.9374 13.8125 8.8124 14.6875C9.6874 15.5625 10.7499 16 11.9999 16ZM11.9999 3.99998C14.2332 3.99998 16.2791 4.60414 18.1374 5.81248C19.9957 7.02081 21.4499 8.60831 22.4999 10.575C22.5832 10.7083 22.6457 10.8541 22.6874 11.0125C22.7291 11.1708 22.7499 11.3333 22.7499 11.5C22.7499 11.6666 22.7332 11.8291 22.6999 11.9875C22.6666 12.1458 22.6082 12.2916 22.5249 12.425C22.2082 13.0416 21.8541 13.625 21.4624 14.175C21.0707 14.725 20.6332 15.2416 20.1499 15.725C19.9166 15.9583 19.6416 16.0666 19.3249 16.05C19.0082 16.0333 18.7332 15.9083 18.4999 15.675L16.4999 13.675C16.3832 13.5583 16.3082 13.4208 16.2749 13.2625C16.2416 13.1041 16.2499 12.9416 16.2999 12.775C16.3666 12.5583 16.4166 12.35 16.4499 12.15C16.4832 11.95 16.4999 11.7333 16.4999 11.5C16.4999 10.25 16.0624 9.18748 15.1874 8.31248C14.3124 7.43748 13.2499 6.99998 11.9999 6.99998C11.7666 6.99998 11.5499 7.01664 11.3499 7.04998C11.1499 7.08331 10.9416 7.13331 10.7249 7.19998C10.5582 7.24998 10.3916 7.25831 10.2249 7.22498C10.0582 7.19164 9.91657 7.11664 9.7999 6.99998L8.9749 6.17498C8.65824 5.85831 8.55407 5.49164 8.6624 5.07498C8.77074 4.65831 9.03324 4.39164 9.4499 4.27498C9.86657 4.19164 10.2874 4.12498 10.7124 4.07498C11.1374 4.02498 11.5666 3.99998 11.9999 3.99998ZM13.9749 9.64998C14.1582 9.86664 14.3124 10.1041 14.4374 10.3625C14.5624 10.6208 14.6416 10.8916 14.6749 11.175C14.6916 11.3083 14.6416 11.4 14.5249 11.45C14.4082 11.5 14.2999 11.475 14.1999 11.375L12.1499 9.32498C12.0499 9.22498 12.0291 9.11664 12.0874 8.99998C12.1457 8.88331 12.2416 8.82498 12.3749 8.82498C12.6916 8.85831 12.9832 8.94581 13.2499 9.08748C13.5166 9.22914 13.7582 9.41664 13.9749 9.64998Z" fill="currentColor"/>', Uy = /* @__PURE__ */ oe({
  __name: "VisibilityOffIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Cd : r(Cd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon visibility-off-icon",
      "data-testid": "kui-icon-wrapper-visibility-off-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-visibility-off-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Wy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Ky = ["aria-hidden"], kd = '<path d="M12 16C13.25 16 14.3125 15.5625 15.1875 14.6875C16.0625 13.8125 16.5 12.75 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C10.75 7 9.6875 7.4375 8.8125 8.3125C7.9375 9.1875 7.5 10.25 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.5625 12.8875 9.3 12.25 9.3 11.5C9.3 10.75 9.5625 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 19C9.56667 19 7.35 18.3208 5.35 16.9625C3.35 15.6042 1.9 13.7833 1 11.5C1.9 9.21667 3.35 7.39583 5.35 6.0375C7.35 4.67917 9.56667 4 12 4C14.4333 4 16.65 4.67917 18.65 6.0375C20.65 7.39583 22.1 9.21667 23 11.5C22.1 13.7833 20.65 15.6042 18.65 16.9625C16.65 18.3208 14.4333 19 12 19Z" fill="currentColor"/>', Vy = /* @__PURE__ */ oe({
  __name: "VisibilityIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? kd : r(kd)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon visibility-icon",
      "data-testid": "kui-icon-wrapper-visibility-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-visibility-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Ky))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), jy = ["aria-hidden"], $d = '<path d="M12.025 22.05C11.7583 22.05 11.5042 22 11.2625 21.9C11.0208 21.8 10.8 21.6583 10.6 21.475L2.575 13.45C2.39167 13.25 2.25 13.0292 2.15 12.7875C2.05 12.5458 2 12.2917 2 12.025C2 11.7583 2.05 11.5 2.15 11.25C2.25 11 2.39167 10.7833 2.575 10.6L10.6 2.575C10.8 2.375 11.0208 2.22917 11.2625 2.1375C11.5042 2.04583 11.7583 2 12.025 2C12.2917 2 12.55 2.04583 12.8 2.1375C13.05 2.22917 13.2667 2.375 13.45 2.575L21.475 10.6C21.675 10.7833 21.8208 11 21.9125 11.25C22.0042 11.5 22.05 11.7583 22.05 12.025C22.05 12.2917 22.0042 12.5458 21.9125 12.7875C21.8208 13.0292 21.675 13.25 21.475 13.45L13.45 21.475C13.2667 21.6583 13.05 21.8 12.8 21.9C12.55 22 12.2917 22.05 12.025 22.05ZM11.025 13.025H13.025V7.025H11.025V13.025ZM12.025 16.025C12.3083 16.025 12.5458 15.9292 12.7375 15.7375C12.9292 15.5458 13.025 15.3083 13.025 15.025C13.025 14.7417 12.9292 14.5042 12.7375 14.3125C12.5458 14.1208 12.3083 14.025 12.025 14.025C11.7417 14.025 11.5042 14.1208 11.3125 14.3125C11.1208 14.5042 11.025 14.7417 11.025 15.025C11.025 15.3083 11.1208 15.5458 11.3125 15.7375C11.5042 15.9292 11.7417 16.025 12.025 16.025Z" fill="currentColor"/>', Yu = /* @__PURE__ */ oe({
  __name: "WarningIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: De,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const s = String(t.size).replace(/px/gi, ""), l = Number(s);
        if (l && !isNaN(l) && Number.isInteger(l) && l > 0)
          return `${l}px`;
      }
      return De;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (s) => {
      const l = {}, c = Math.random().toString(36).substring(2, 12);
      return s.replace(/id="([^"]+)"/g, (d, f) => {
        const v = `${c}-${f}`;
        return l[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (d, f) => l[f] ? `#${l[f]}` : d);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (s) => s.replace(/[<>"'&]/g, (l) => i[l]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? $d : r($d)}`;
    return (s, l) => (m(), X(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon warning-icon",
      "data-testid": "kui-icon-wrapper-warning-icon",
      style: Oe(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: L(() => [
        (m(), $("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-warning-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, jy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Gy = "#000933", wg = "#00abd2", au = "#ffffff", Ya = "#6c7489", Qy = "#52596e", Cg = "#afb7c5", kg = "#0044f4", Zy = "#995c00", Sa = "16px", Qt = "20px", Xy = "24px", Jy = "32px", _y = "20px", $g = "4px", Yl = "8px", eb = "12px", Sg = "16px", tb = {
  key: 0,
  class: "alert-icon-container"
}, ab = { class: "alert-content" }, nb = {
  key: 0,
  class: "alert-title"
}, rb = {
  key: 1,
  class: "alert-message"
}, ib = /* @__PURE__ */ oe({
  __name: "KAlert",
  props: {
    title: { default: "" },
    message: { default: "" },
    appearance: { default: () => gr.info },
    showIcon: { type: Boolean },
    dismissible: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const a = t, n = b(() => {
      switch (e.appearance) {
        case gr.info:
          return En;
        case gr.success:
          return mg;
        case gr.warning:
          return Yu;
        case gr.danger:
          return my;
        case gr.decorative:
          return Py;
        default:
          return En;
      }
    });
    return (r, i) => (m(), $("div", {
      class: ce(["k-alert", [e.appearance]])
    }, [
      e.showIcon || r.$slots.icon ? (m(), $("div", tb, [
        W(r.$slots, "icon", {}, () => [
          (m(), X(Ye(n.value), {
            class: "alert-icon",
            decorative: "",
            size: D(Qt)
          }, null, 8, ["size"]))
        ])
      ])) : H("", !0),
      Y("div", ab, [
        e.title ? (m(), $("span", nb, re(e.title), 1)) : H("", !0),
        e.message || r.$slots.default ? (m(), $("div", rb, [
          W(r.$slots, "default", {}, () => [
            Y("p", null, re(e.message), 1)
          ])
        ])) : H("", !0)
      ]),
      e.dismissible ? (m(), X(D(ha), {
        key: 1,
        class: "alert-dismiss-icon",
        size: D(Qt),
        tabindex: "0",
        onClick: i[0] || (i[0] = (o) => a("dismiss")),
        onKeydown: i[1] || (i[1] = ct(Ke(() => {
        }, ["prevent"]), ["space"])),
        onKeyup: [
          i[2] || (i[2] = ct((o) => a("dismiss"), ["enter"])),
          i[3] || (i[3] = ct((o) => a("dismiss"), ["space"]))
        ]
      }, null, 8, ["size"])) : H("", !0)
    ], 2));
  }
}), Pe = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, r] of t)
    a[n] = r;
  return a;
}, ob = /* @__PURE__ */ Pe(ib, [["__scopeId", "data-v-ada2b8a8"]]), lb = ["top", "right", "bottom", "left"], Sd = ["start", "end"], xd = /* @__PURE__ */ lb.reduce((e, t) => e.concat(t, t + "-" + Sd[0], t + "-" + Sd[1]), []), al = Math.min, Qn = Math.max, nl = Math.round, Vi = Math.floor, Ra = (e) => ({
  x: e,
  y: e
}), sb = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ub = {
  start: "end",
  end: "start"
};
function Td(e, t, a) {
  return Qn(e, al(t, a));
}
function Hl(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Mn(e) {
  return e.split("-")[0];
}
function In(e) {
  return e.split("-")[1];
}
function xg(e) {
  return e === "x" ? "y" : "x";
}
function Tg(e) {
  return e === "y" ? "height" : "width";
}
const cb = /* @__PURE__ */ new Set(["top", "bottom"]);
function Vn(e) {
  return cb.has(Mn(e)) ? "y" : "x";
}
function Dg(e) {
  return xg(Vn(e));
}
function Ag(e, t, a) {
  a === void 0 && (a = !1);
  const n = In(e), r = Dg(e), i = Tg(r);
  let o = r === "x" ? n === (a ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = il(o)), [o, il(o)];
}
function db(e) {
  const t = il(e);
  return [rl(e), t, rl(t)];
}
function rl(e) {
  return e.replace(/start|end/g, (t) => ub[t]);
}
const Dd = ["left", "right"], Ad = ["right", "left"], fb = ["top", "bottom"], vb = ["bottom", "top"];
function hb(e, t, a) {
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? Ad : Dd : t ? Dd : Ad;
    case "left":
    case "right":
      return t ? fb : vb;
    default:
      return [];
  }
}
function gb(e, t, a, n) {
  const r = In(e);
  let i = hb(Mn(e), a === "start", n);
  return r && (i = i.map((o) => o + "-" + r), t && (i = i.concat(i.map(rl)))), i;
}
function il(e) {
  return e.replace(/left|right|bottom|top/g, (t) => sb[t]);
}
function mb(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function pb(e) {
  return typeof e != "number" ? mb(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ol(e) {
  const {
    x: t,
    y: a,
    width: n,
    height: r
  } = e;
  return {
    width: n,
    height: r,
    top: a,
    left: t,
    right: t + n,
    bottom: a + r,
    x: t,
    y: a
  };
}
function Id(e, t, a) {
  let {
    reference: n,
    floating: r
  } = e;
  const i = Vn(t), o = Dg(t), u = Tg(o), s = Mn(t), l = i === "y", c = n.x + n.width / 2 - r.width / 2, d = n.y + n.height / 2 - r.height / 2, f = n[u] / 2 - r[u] / 2;
  let v;
  switch (s) {
    case "top":
      v = {
        x: c,
        y: n.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      v = {
        x: n.x - r.width,
        y: d
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (In(t)) {
    case "start":
      v[o] -= f * (a && l ? -1 : 1);
      break;
    case "end":
      v[o] += f * (a && l ? -1 : 1);
      break;
  }
  return v;
}
const yb = async (e, t, a) => {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: o
  } = a, u = i.filter(Boolean), s = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: c,
    y: d
  } = Id(l, n, s), f = n, v = {}, y = 0;
  for (let C = 0; C < u.length; C++) {
    const {
      name: h,
      fn: g
    } = u[C], {
      x: p,
      y: w,
      data: k,
      reset: S
    } = await g({
      x: c,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: r,
      middlewareData: v,
      rects: l,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = p ?? c, d = w ?? d, v = {
      ...v,
      [h]: {
        ...v[h],
        ...k
      }
    }, S && y <= 50 && (y++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (l = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : S.rects), {
      x: c,
      y: d
    } = Id(l, f, s)), C = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: v
  };
};
async function Hu(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: i,
    rects: o,
    elements: u,
    strategy: s
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: v = 0
  } = Hl(t, e), y = pb(v), h = u[f ? d === "floating" ? "reference" : "floating" : d], g = ol(await i.getClippingRect({
    element: (a = await (i.isElement == null ? void 0 : i.isElement(h))) == null || a ? h : h.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(u.floating)),
    boundary: l,
    rootBoundary: c,
    strategy: s
  })), p = d === "floating" ? {
    x: n,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u.floating)), k = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = ol(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: p,
    offsetParent: w,
    strategy: s
  }) : p);
  return {
    top: (g.top - S.top + y.top) / k.y,
    bottom: (S.bottom - g.bottom + y.bottom) / k.y,
    left: (g.left - S.left + y.left) / k.x,
    right: (S.right - g.right + y.right) / k.x
  };
}
function bb(e, t, a) {
  return (e ? [...a.filter((r) => In(r) === e), ...a.filter((r) => In(r) !== e)] : a.filter((r) => Mn(r) === r)).filter((r) => e ? In(r) === e || (t ? rl(r) !== r : !1) : !0);
}
const wb = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var a, n, r;
      const {
        rects: i,
        middlewareData: o,
        placement: u,
        platform: s,
        elements: l
      } = t, {
        crossAxis: c = !1,
        alignment: d,
        allowedPlacements: f = xd,
        autoAlignment: v = !0,
        ...y
      } = Hl(e, t), C = d !== void 0 || f === xd ? bb(d || null, v, f) : f, h = await Hu(t, y), g = ((a = o.autoPlacement) == null ? void 0 : a.index) || 0, p = C[g];
      if (p == null)
        return {};
      const w = Ag(p, i, await (s.isRTL == null ? void 0 : s.isRTL(l.floating)));
      if (u !== p)
        return {
          reset: {
            placement: C[0]
          }
        };
      const k = [h[Mn(p)], h[w[0]], h[w[1]]], S = [...((n = o.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: p,
        overflows: k
      }], T = C[g + 1];
      if (T)
        return {
          data: {
            index: g + 1,
            overflows: S
          },
          reset: {
            placement: T
          }
        };
      const A = S.map((O) => {
        const z = In(O.placement);
        return [O.placement, z && c ? (
          // Check along the mainAxis and main crossAxis side.
          O.overflows.slice(0, 2).reduce((U, x) => U + x, 0)
        ) : (
          // Check only the mainAxis.
          O.overflows[0]
        ), O.overflows];
      }).sort((O, z) => O[1] - z[1]), Z = ((r = A.filter((O) => O[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        In(O[0]) ? 2 : 3
      ).every((z) => z <= 0))[0]) == null ? void 0 : r[0]) || A[0][0];
      return Z !== u ? {
        data: {
          index: g + 1,
          overflows: S
        },
        reset: {
          placement: Z
        }
      } : {};
    }
  };
}, Cb = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, n;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: u,
        platform: s,
        elements: l
      } = t, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: C = !0,
        ...h
      } = Hl(e, t);
      if ((a = i.arrow) != null && a.alignmentOffset)
        return {};
      const g = Mn(r), p = Vn(u), w = Mn(u) === u, k = await (s.isRTL == null ? void 0 : s.isRTL(l.floating)), S = f || (w || !C ? [il(u)] : db(u)), T = y !== "none";
      !f && T && S.push(...gb(u, C, y, k));
      const A = [u, ...S], F = await Hu(t, h), Z = [];
      let O = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (c && Z.push(F[g]), d) {
        const I = Ag(r, o, k);
        Z.push(F[I[0]], F[I[1]]);
      }
      if (O = [...O, {
        placement: r,
        overflows: Z
      }], !Z.every((I) => I <= 0)) {
        var z, U;
        const I = (((z = i.flip) == null ? void 0 : z.index) || 0) + 1, E = A[I];
        if (E && (!(d === "alignment" ? p !== Vn(E) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        O.every((K) => Vn(K.placement) === p ? K.overflows[0] > 0 : !0)))
          return {
            data: {
              index: I,
              overflows: O
            },
            reset: {
              placement: E
            }
          };
        let P = (U = O.filter((R) => R.overflows[0] <= 0).sort((R, K) => R.overflows[1] - K.overflows[1])[0]) == null ? void 0 : U.placement;
        if (!P)
          switch (v) {
            case "bestFit": {
              var x;
              const R = (x = O.filter((K) => {
                if (T) {
                  const J = Vn(K.placement);
                  return J === p || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  J === "y";
                }
                return !0;
              }).map((K) => [K.placement, K.overflows.filter((J) => J > 0).reduce((J, q) => J + q, 0)]).sort((K, J) => K[1] - J[1])[0]) == null ? void 0 : x[0];
              R && (P = R);
              break;
            }
            case "initialPlacement":
              P = u;
              break;
          }
        if (r !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
}, kb = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: n,
        placement: r
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: u = {
          fn: (h) => {
            let {
              x: g,
              y: p
            } = h;
            return {
              x: g,
              y: p
            };
          }
        },
        ...s
      } = Hl(e, t), l = {
        x: a,
        y: n
      }, c = await Hu(t, s), d = Vn(Mn(r)), f = xg(d);
      let v = l[f], y = l[d];
      if (i) {
        const h = f === "y" ? "top" : "left", g = f === "y" ? "bottom" : "right", p = v + c[h], w = v - c[g];
        v = Td(p, v, w);
      }
      if (o) {
        const h = d === "y" ? "top" : "left", g = d === "y" ? "bottom" : "right", p = y + c[h], w = y - c[g];
        y = Td(p, y, w);
      }
      const C = u.fn({
        ...t,
        [f]: v,
        [d]: y
      });
      return {
        ...C,
        data: {
          x: C.x - a,
          y: C.y - n,
          enabled: {
            [f]: i,
            [d]: o
          }
        }
      };
    }
  };
};
function ql() {
  return typeof window < "u";
}
function ir(e) {
  return qu(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ua(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ua(e) {
  var t;
  return (t = (qu(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function qu(e) {
  return ql() ? e instanceof Node || e instanceof ua(e).Node : !1;
}
function Ta(e) {
  return ql() ? e instanceof Element || e instanceof ua(e).Element : !1;
}
function Ha(e) {
  return ql() ? e instanceof HTMLElement || e instanceof ua(e).HTMLElement : !1;
}
function Ed(e) {
  return !ql() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ua(e).ShadowRoot;
}
const $b = /* @__PURE__ */ new Set(["inline", "contents"]);
function zi(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: n,
    display: r
  } = Da(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + a) && !$b.has(r);
}
const Sb = /* @__PURE__ */ new Set(["table", "td", "th"]);
function xb(e) {
  return Sb.has(ir(e));
}
const Tb = [":popover-open", ":modal"];
function Wl(e) {
  return Tb.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Db = ["transform", "translate", "scale", "rotate", "perspective"], Ab = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Ib = ["paint", "layout", "strict", "content"];
function Wu(e) {
  const t = Uu(), a = Ta(e) ? Da(e) : e;
  return Db.some((n) => a[n] ? a[n] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || Ab.some((n) => (a.willChange || "").includes(n)) || Ib.some((n) => (a.contain || "").includes(n));
}
function Eb(e) {
  let t = On(e);
  for (; Ha(t) && !Rr(t); ) {
    if (Wu(t))
      return t;
    if (Wl(t))
      return null;
    t = On(t);
  }
  return null;
}
function Uu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Mb = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Rr(e) {
  return Mb.has(ir(e));
}
function Da(e) {
  return ua(e).getComputedStyle(e);
}
function Ul(e) {
  return Ta(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function On(e) {
  if (ir(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ed(e) && e.host || // Fallback.
    Ua(e)
  );
  return Ed(t) ? t.host : t;
}
function Ig(e) {
  const t = On(e);
  return Rr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ha(t) && zi(t) ? t : Ig(t);
}
function Ai(e, t, a) {
  var n;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const r = Ig(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = ua(r);
  if (i) {
    const u = nu(o);
    return t.concat(o, o.visualViewport || [], zi(r) ? r : [], u && a ? Ai(u) : []);
  }
  return t.concat(r, Ai(r, [], a));
}
function nu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Eg(e) {
  const t = Da(e);
  let a = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const r = Ha(e), i = r ? e.offsetWidth : a, o = r ? e.offsetHeight : n, u = nl(a) !== i || nl(n) !== o;
  return u && (a = i, n = o), {
    width: a,
    height: n,
    $: u
  };
}
function Ku(e) {
  return Ta(e) ? e : e.contextElement;
}
function Mr(e) {
  const t = Ku(e);
  if (!Ha(t))
    return Ra(1);
  const a = t.getBoundingClientRect(), {
    width: n,
    height: r,
    $: i
  } = Eg(t);
  let o = (i ? nl(a.width) : a.width) / n, u = (i ? nl(a.height) : a.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: o,
    y: u
  };
}
const Ob = /* @__PURE__ */ Ra(0);
function Mg(e) {
  const t = ua(e);
  return !Uu() || !t.visualViewport ? Ob : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Pb(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== ua(e) ? !1 : t;
}
function Jn(e, t, a, n) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const r = e.getBoundingClientRect(), i = Ku(e);
  let o = Ra(1);
  t && (n ? Ta(n) && (o = Mr(n)) : o = Mr(e));
  const u = Pb(i, a, n) ? Mg(i) : Ra(0);
  let s = (r.left + u.x) / o.x, l = (r.top + u.y) / o.y, c = r.width / o.x, d = r.height / o.y;
  if (i) {
    const f = ua(i), v = n && Ta(n) ? ua(n) : n;
    let y = f, C = nu(y);
    for (; C && n && v !== y; ) {
      const h = Mr(C), g = C.getBoundingClientRect(), p = Da(C), w = g.left + (C.clientLeft + parseFloat(p.paddingLeft)) * h.x, k = g.top + (C.clientTop + parseFloat(p.paddingTop)) * h.y;
      s *= h.x, l *= h.y, c *= h.x, d *= h.y, s += w, l += k, y = ua(C), C = nu(y);
    }
  }
  return ol({
    width: c,
    height: d,
    x: s,
    y: l
  });
}
function Kl(e, t) {
  const a = Ul(e).scrollLeft;
  return t ? t.left + a : Jn(Ua(e)).left + a;
}
function Og(e, t) {
  const a = e.getBoundingClientRect(), n = a.left + t.scrollLeft - Kl(e, a), r = a.top + t.scrollTop;
  return {
    x: n,
    y: r
  };
}
function Nb(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: n,
    strategy: r
  } = e;
  const i = r === "fixed", o = Ua(n), u = t ? Wl(t.floating) : !1;
  if (n === o || u && i)
    return a;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = Ra(1);
  const c = Ra(0), d = Ha(n);
  if ((d || !d && !i) && ((ir(n) !== "body" || zi(o)) && (s = Ul(n)), Ha(n))) {
    const v = Jn(n);
    l = Mr(n), c.x = v.x + n.clientLeft, c.y = v.y + n.clientTop;
  }
  const f = o && !d && !i ? Og(o, s) : Ra(0);
  return {
    width: a.width * l.x,
    height: a.height * l.y,
    x: a.x * l.x - s.scrollLeft * l.x + c.x + f.x,
    y: a.y * l.y - s.scrollTop * l.y + c.y + f.y
  };
}
function Lb(e) {
  return Array.from(e.getClientRects());
}
function Bb(e) {
  const t = Ua(e), a = Ul(e), n = e.ownerDocument.body, r = Qn(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = Qn(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -a.scrollLeft + Kl(e);
  const u = -a.scrollTop;
  return Da(n).direction === "rtl" && (o += Qn(t.clientWidth, n.clientWidth) - r), {
    width: r,
    height: i,
    x: o,
    y: u
  };
}
const Md = 25;
function Rb(e, t) {
  const a = ua(e), n = Ua(e), r = a.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, u = 0, s = 0;
  if (r) {
    i = r.width, o = r.height;
    const c = Uu();
    (!c || c && t === "fixed") && (u = r.offsetLeft, s = r.offsetTop);
  }
  const l = Kl(n);
  if (l <= 0) {
    const c = n.ownerDocument, d = c.body, f = getComputedStyle(d), v = c.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, y = Math.abs(n.clientWidth - d.clientWidth - v);
    y <= Md && (i -= y);
  } else l <= Md && (i += l);
  return {
    width: i,
    height: o,
    x: u,
    y: s
  };
}
const Fb = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function zb(e, t) {
  const a = Jn(e, !0, t === "fixed"), n = a.top + e.clientTop, r = a.left + e.clientLeft, i = Ha(e) ? Mr(e) : Ra(1), o = e.clientWidth * i.x, u = e.clientHeight * i.y, s = r * i.x, l = n * i.y;
  return {
    width: o,
    height: u,
    x: s,
    y: l
  };
}
function Od(e, t, a) {
  let n;
  if (t === "viewport")
    n = Rb(e, a);
  else if (t === "document")
    n = Bb(Ua(e));
  else if (Ta(t))
    n = zb(t, a);
  else {
    const r = Mg(e);
    n = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return ol(n);
}
function Pg(e, t) {
  const a = On(e);
  return a === t || !Ta(a) || Rr(a) ? !1 : Da(a).position === "fixed" || Pg(a, t);
}
function Yb(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let n = Ai(e, [], !1).filter((u) => Ta(u) && ir(u) !== "body"), r = null;
  const i = Da(e).position === "fixed";
  let o = i ? On(e) : e;
  for (; Ta(o) && !Rr(o); ) {
    const u = Da(o), s = Wu(o);
    !s && u.position === "fixed" && (r = null), (i ? !s && !r : !s && u.position === "static" && !!r && Fb.has(r.position) || zi(o) && !s && Pg(e, o)) ? n = n.filter((c) => c !== o) : r = u, o = On(o);
  }
  return t.set(e, n), n;
}
function Hb(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: n,
    strategy: r
  } = e;
  const o = [...a === "clippingAncestors" ? Wl(t) ? [] : Yb(t, this._c) : [].concat(a), n], u = o[0], s = o.reduce((l, c) => {
    const d = Od(t, c, r);
    return l.top = Qn(d.top, l.top), l.right = al(d.right, l.right), l.bottom = al(d.bottom, l.bottom), l.left = Qn(d.left, l.left), l;
  }, Od(t, u, r));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function qb(e) {
  const {
    width: t,
    height: a
  } = Eg(e);
  return {
    width: t,
    height: a
  };
}
function Wb(e, t, a) {
  const n = Ha(t), r = Ua(t), i = a === "fixed", o = Jn(e, !0, i, t);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Ra(0);
  function l() {
    s.x = Kl(r);
  }
  if (n || !n && !i)
    if ((ir(t) !== "body" || zi(r)) && (u = Ul(t)), n) {
      const v = Jn(t, !0, i, t);
      s.x = v.x + t.clientLeft, s.y = v.y + t.clientTop;
    } else r && l();
  i && !n && r && l();
  const c = r && !n && !i ? Og(r, u) : Ra(0), d = o.left + u.scrollLeft - s.x - c.x, f = o.top + u.scrollTop - s.y - c.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
function vs(e) {
  return Da(e).position === "static";
}
function Pd(e, t) {
  if (!Ha(e) || Da(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return Ua(e) === a && (a = a.ownerDocument.body), a;
}
function Ng(e, t) {
  const a = ua(e);
  if (Wl(e))
    return a;
  if (!Ha(e)) {
    let r = On(e);
    for (; r && !Rr(r); ) {
      if (Ta(r) && !vs(r))
        return r;
      r = On(r);
    }
    return a;
  }
  let n = Pd(e, t);
  for (; n && xb(n) && vs(n); )
    n = Pd(n, t);
  return n && Rr(n) && vs(n) && !Wu(n) ? a : n || Eb(e) || a;
}
const Ub = async function(e) {
  const t = this.getOffsetParent || Ng, a = this.getDimensions, n = await a(e.floating);
  return {
    reference: Wb(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Kb(e) {
  return Da(e).direction === "rtl";
}
const Vb = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Nb,
  getDocumentElement: Ua,
  getClippingRect: Hb,
  getOffsetParent: Ng,
  getElementRects: Ub,
  getClientRects: Lb,
  getDimensions: qb,
  getScale: Mr,
  isElement: Ta,
  isRTL: Kb
};
function Lg(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function jb(e, t) {
  let a = null, n;
  const r = Ua(e);
  function i() {
    var u;
    clearTimeout(n), (u = a) == null || u.disconnect(), a = null;
  }
  function o(u, s) {
    u === void 0 && (u = !1), s === void 0 && (s = 1), i();
    const l = e.getBoundingClientRect(), {
      left: c,
      top: d,
      width: f,
      height: v
    } = l;
    if (u || t(), !f || !v)
      return;
    const y = Vi(d), C = Vi(r.clientWidth - (c + f)), h = Vi(r.clientHeight - (d + v)), g = Vi(c), w = {
      rootMargin: -y + "px " + -C + "px " + -h + "px " + -g + "px",
      threshold: Qn(0, al(1, s)) || 1
    };
    let k = !0;
    function S(T) {
      const A = T[0].intersectionRatio;
      if (A !== s) {
        if (!k)
          return o();
        A ? o(!1, A) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !Lg(l, e.getBoundingClientRect()) && o(), k = !1;
    }
    try {
      a = new IntersectionObserver(S, {
        ...w,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(S, w);
    }
    a.observe(e);
  }
  return o(!0), i;
}
function Gb(e, t, a, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = n, l = Ku(e), c = r || i ? [...l ? Ai(l) : [], ...Ai(t)] : [];
  c.forEach((g) => {
    r && g.addEventListener("scroll", a, {
      passive: !0
    }), i && g.addEventListener("resize", a);
  });
  const d = l && u ? jb(l, a) : null;
  let f = -1, v = null;
  o && (v = new ResizeObserver((g) => {
    let [p] = g;
    p && p.target === l && v && (v.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = v) == null || w.observe(t);
    })), a();
  }), l && !s && v.observe(l), v.observe(t));
  let y, C = s ? Jn(e) : null;
  s && h();
  function h() {
    const g = Jn(e);
    C && !Lg(C, g) && a(), C = g, y = requestAnimationFrame(h);
  }
  return a(), () => {
    var g;
    c.forEach((p) => {
      r && p.removeEventListener("scroll", a), i && p.removeEventListener("resize", a);
    }), d == null || d(), (g = v) == null || g.disconnect(), v = null, s && cancelAnimationFrame(y);
  };
}
const Qb = wb, Zb = kb, Xb = Cb, Jb = (e, t, a) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: Vb,
    ...a
  }, i = {
    ...r.platform,
    _c: n
  };
  return yb(e, t, {
    ...r,
    platform: i
  });
};
function _b(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Nd(e) {
  if (_b(e)) {
    const t = e.$el;
    return qu(t) && ir(t) === "#comment" ? null : t;
  }
  return e;
}
function ni(e) {
  return typeof e == "function" ? e() : D(e);
}
function Bg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ld(e, t) {
  const a = Bg(e);
  return Math.round(t * a) / a;
}
function e0(e, t, a) {
  a === void 0 && (a = {});
  const n = a.whileElementsMounted, r = b(() => {
    var A;
    return (A = ni(a.open)) != null ? A : !0;
  }), i = b(() => ni(a.middleware)), o = b(() => {
    var A;
    return (A = ni(a.placement)) != null ? A : "bottom";
  }), u = b(() => {
    var A;
    return (A = ni(a.strategy)) != null ? A : "absolute";
  }), s = b(() => {
    var A;
    return (A = ni(a.transform)) != null ? A : !0;
  }), l = b(() => Nd(e.value)), c = b(() => Nd(t.value)), d = N(0), f = N(0), v = N(u.value), y = N(o.value), C = rg({}), h = N(!1), g = b(() => {
    const A = {
      position: v.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return A;
    const F = Ld(c.value, d.value), Z = Ld(c.value, f.value);
    return s.value ? {
      ...A,
      transform: "translate(" + F + "px, " + Z + "px)",
      ...Bg(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: v.value,
      left: F + "px",
      top: Z + "px"
    };
  });
  let p;
  function w() {
    if (l.value == null || c.value == null)
      return;
    const A = r.value;
    Jb(l.value, c.value, {
      middleware: i.value,
      placement: o.value,
      strategy: u.value
    }).then((F) => {
      d.value = F.x, f.value = F.y, v.value = F.strategy, y.value = F.placement, C.value = F.middlewareData, h.value = A !== !1;
    });
  }
  function k() {
    typeof p == "function" && (p(), p = void 0);
  }
  function S() {
    if (k(), n === void 0) {
      w();
      return;
    }
    if (l.value != null && c.value != null) {
      p = n(l.value, c.value, w);
      return;
    }
  }
  function T() {
    r.value || (h.value = !1);
  }
  return ie([i, o, u, r], w, {
    flush: "sync"
  }), ie([l, c], S, {
    flush: "sync"
  }), ie(r, T, {
    flush: "sync"
  }), ig() && og(k), {
    x: hr(d),
    y: hr(f),
    strategy: hr(v),
    placement: hr(y),
    middlewareData: hr(C),
    isPositioned: hr(h),
    floatingStyles: g,
    update: w
  };
}
const t0 = {
  inheritAttrs: !1
}, a0 = /* @__PURE__ */ oe({
  ...t0,
  __name: "KButton",
  props: {
    appearance: { default: "primary" },
    size: { default: "medium" },
    to: { default: null },
    type: { default: "button" },
    disabled: { type: Boolean },
    icon: { type: Boolean }
  },
  setup(e) {
    ie(() => e.icon, (l) => {
      typeof l == "string" && console.warn("KButton: `icon` prop usage has changed. Please refer to the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kbutton");
    }, { immediate: !0 });
    const t = $t(), a = na(), n = b(() => e.to && typeof e.to == "string" ? "a" : e.to ? "router-link" : "button"), r = b(() => Object.values(K1).indexOf(e.appearance) === -1 ? ["primary", e.appearance] : e.appearance), i = b(() => e.appearance === "none" && !e.icon ? null : e.size), o = b(() => {
      const l = Object.assign({}, a);
      return e.to && (typeof e.to == "string" ? l.href = e.to : l.to = e.to, e.disabled && (l.href = null)), e.disabled !== void 0 && e.disabled !== !1 || delete l.disabled, l;
    }), u = (l) => {
      l.preventDefault(), l.stopPropagation();
    }, s = b(() => !e.disabled || n.value === "button" ? {} : {
      clickCapture: u,
      dblclickCapture: u,
      mousedownCapture: u,
      mouseupCapture: u
    });
    return it(() => {
      t.icon && console.warn("KButton: `icon` slot is deprecated. Please slot an icon into the `default` slot instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kbutton");
    }), (l, c) => (m(), X(Ye(n.value), Re({
      class: ["k-button", [i.value, r.value, { "icon-button": e.icon === !0 || !t.default && t.icon }]],
      disabled: e.disabled ? e.disabled : void 0,
      tabindex: e.disabled && n.value !== "button" ? "-1" : void 0,
      type: e.type
    }, o.value, Bl(s.value)), {
      default: L(() => [
        W(l.$slots, "icon", {}, void 0, !0),
        W(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "disabled", "tabindex", "type"]));
  }
}), rt = /* @__PURE__ */ Pe(a0, [["__scopeId", "data-v-3ba3c07b"]]), n0 = /* @__PURE__ */ oe({
  __name: "KPopTeleportWrapper",
  props: {
    useTeleport: { type: Boolean },
    target: { default: null }
  },
  setup(e) {
    return (t, a) => e.useTeleport ? (m(), X(R1, {
      key: 0,
      to: e.target
    }, [
      W(t.$slots, "default")
    ], 8, ["to"])) : W(t.$slots, "default", { key: 1 });
  }
});
function Rg(e) {
  return ig() ? (og(e), !0) : !1;
}
const Fg = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const r0 = Object.prototype.toString, i0 = (e) => r0.call(e) === "[object Object]", mr = () => {
}, o0 = /* @__PURE__ */ l0();
function l0() {
  var e, t;
  return Fg && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function hs(e) {
  return Array.isArray(e) ? e : [e];
}
function s0(e, t, a) {
  return ie(
    e,
    t,
    {
      ...a,
      immediate: !0
    }
  );
}
const Vl = Fg ? window : void 0;
function jn(e) {
  var t;
  const a = An(e);
  return (t = a == null ? void 0 : a.$el) != null ? t : a;
}
function $a(...e) {
  const t = [], a = () => {
    t.forEach((u) => u()), t.length = 0;
  }, n = (u, s, l, c) => (u.addEventListener(s, l, c), () => u.removeEventListener(s, l, c)), r = b(() => {
    const u = hs(An(e[0])).filter((s) => s != null);
    return u.every((s) => typeof s != "string") ? u : void 0;
  }), i = s0(
    () => {
      var u, s;
      return [
        (s = (u = r.value) == null ? void 0 : u.map((l) => jn(l))) != null ? s : [Vl].filter((l) => l != null),
        hs(An(r.value ? e[1] : e[0])),
        hs(D(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        An(r.value ? e[3] : e[2])
      ];
    },
    ([u, s, l, c]) => {
      if (a(), !(u != null && u.length) || !(s != null && s.length) || !(l != null && l.length))
        return;
      const d = i0(c) ? { ...c } : c;
      t.push(
        ...u.flatMap(
          (f) => s.flatMap(
            (v) => l.map((y) => n(f, v, y, d))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    i(), a();
  };
  return Rg(a), o;
}
let Bd = !1;
function u0(e, t, a = {}) {
  const { window: n = Vl, ignore: r = [], capture: i = !0, detectIframe: o = !1, controls: u = !1 } = a;
  if (!n)
    return u ? { stop: mr, cancel: mr, trigger: mr } : mr;
  if (o0 && !Bd) {
    Bd = !0;
    const h = { passive: !0 };
    Array.from(n.document.body.children).forEach((g) => g.addEventListener("click", mr, h)), n.document.documentElement.addEventListener("click", mr, h);
  }
  let s = !0;
  const l = (h) => An(r).some((g) => {
    if (typeof g == "string")
      return Array.from(n.document.querySelectorAll(g)).some((p) => p === h.target || h.composedPath().includes(p));
    {
      const p = jn(g);
      return p && (h.target === p || h.composedPath().includes(p));
    }
  });
  function c(h) {
    const g = An(h);
    return g && g.$.subTree.shapeFlag === 16;
  }
  function d(h, g) {
    const p = An(h), w = p.$.subTree && p.$.subTree.children;
    return w == null || !Array.isArray(w) ? !1 : w.some((k) => k.el === g.target || g.composedPath().includes(k.el));
  }
  const f = (h) => {
    const g = jn(e);
    if (h.target != null && !(!(g instanceof Element) && c(e) && d(e, h)) && !(!g || g === h.target || h.composedPath().includes(g))) {
      if ("detail" in h && h.detail === 0 && (s = !l(h)), !s) {
        s = !0;
        return;
      }
      t(h);
    }
  };
  let v = !1;
  const y = [
    $a(n, "click", (h) => {
      v || (v = !0, setTimeout(() => {
        v = !1;
      }, 0), f(h));
    }, { passive: !0, capture: i }),
    $a(n, "pointerdown", (h) => {
      const g = jn(e);
      s = !l(h) && !!(g && !h.composedPath().includes(g));
    }, { passive: !0 }),
    o && $a(n, "blur", (h) => {
      setTimeout(() => {
        var g;
        const p = jn(e);
        ((g = n.document.activeElement) == null ? void 0 : g.tagName) === "IFRAME" && !(p != null && p.contains(n.document.activeElement)) && t(h);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), C = () => y.forEach((h) => h());
  return u ? {
    stop: C,
    cancel: () => {
      s = !1;
    },
    trigger: (h) => {
      s = !0, f(h), s = !1;
    }
  } : C;
}
// @__NO_SIDE_EFFECTS__
function c0() {
  const e = rg(!1), t = Nu();
  return t && it(() => {
    e.value = !0;
  }, t), e;
}
// @__NO_SIDE_EFFECTS__
function d0(e) {
  const t = /* @__PURE__ */ c0();
  return b(() => (t.value, !!e()));
}
function f0(e, t, a = {}) {
  const { window: n = Vl, ...r } = a;
  let i;
  const o = /* @__PURE__ */ d0(() => n && "ResizeObserver" in n), u = () => {
    i && (i.disconnect(), i = void 0);
  }, s = b(() => {
    const d = An(e);
    return Array.isArray(d) ? d.map((f) => jn(f)) : [jn(d)];
  }), l = ie(
    s,
    (d) => {
      if (u(), o.value && n) {
        i = new ResizeObserver(t);
        for (const f of d)
          f && i.observe(f, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), c = () => {
    u(), l();
  };
  return Rg(c), {
    isSupported: o,
    stop: c
  };
}
function v0(e) {
  var t;
  const a = (t = e.rangeCount) != null ? t : 0;
  return Array.from({ length: a }, (n, r) => e.getRangeAt(r));
}
// @__NO_SIDE_EFFECTS__
function h0(e = {}) {
  const {
    window: t = Vl
  } = e, a = N(null), n = b(() => {
    var u, s;
    return (s = (u = a.value) == null ? void 0 : u.toString()) != null ? s : "";
  }), r = b(() => a.value ? v0(a.value) : []), i = b(() => r.value.map((u) => u.getBoundingClientRect()));
  function o() {
    a.value = null, t && (a.value = t.getSelection());
  }
  return t && $a(t.document, "selectionchange", o, { passive: !0 }), {
    text: n,
    rects: i,
    ranges: r,
    selection: a
  };
}
const It = (e) => {
  const t = Number(e);
  return Number.isNaN(t) ? `${e}` : `${t}px`;
}, g0 = ["id", "aria-labelledby", "x-placement"], m0 = ["tabindex"], p0 = {
  key: 1,
  class: "popover-header"
}, y0 = ["id"], b0 = {
  key: 2,
  class: "popover-footer"
}, w0 = /* @__PURE__ */ oe({
  __name: "KPop",
  props: {
    buttonText: { default: "" },
    title: { default: "" },
    placement: { default: "auto" },
    trigger: { default: "click" },
    popoverTimeout: { default: 300 },
    hideCloseIcon: { type: Boolean },
    hideCaret: { type: Boolean },
    closeOnPopoverClick: { type: Boolean },
    disabled: { type: Boolean },
    width: { default: "200px" },
    maxWidth: { default: "none" },
    maxHeight: { default: "none" },
    popoverClasses: { default: "" },
    popoverElementAttributes: { default: () => ({}) },
    tag: { default: "div" },
    zIndex: { default: 1e3 },
    offset: { default: () => Sg },
    target: { default: null }
  },
  emits: ["open", "close", "popover-click"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = $t(), i = yt(), o = yt(), u = N(null), s = N(null), l = N(!1), c = b(() => {
      var I, E;
      return u.value && ((I = u.value) != null && I.children[0]) ? (E = u.value) == null ? void 0 : E.children[0] : null;
    }), d = N(null), f = () => {
      l.value ? g() : h();
    }, v = N(), y = () => {
      v.value && v.value();
    }, C = () => {
      y(), c.value && s.value && (v.value = Gb(c.value, s.value, F));
    }, h = async () => {
      e.disabled || (d.value && clearTimeout(d.value), C(), l.value = !0);
    }, g = () => {
      d.value = setTimeout(() => {
        y(), l.value = !1;
      }, e.trigger === "hover" ? e.popoverTimeout : 0);
    }, p = () => {
      f();
    }, w = () => {
      n("popover-click"), e.closeOnPopoverClick && g();
    }, k = (I) => {
      var K, J;
      if (!l.value)
        return;
      const E = I.target, P = (K = u.value) == null ? void 0 : K.contains(E), R = (J = s.value) == null ? void 0 : J.contains(E);
      P || R || g();
    }, S = b(() => e.placement.trim().replace(/ /g, "-").replace(/[A-Z]+(?![a-z])|[A-Z]/g, (I, E) => (E ? "-" : "") + I.toLowerCase()).replace(/--+/g, "-").replace(/-+$/g, "")), { floatingStyles: T, placement: A, update: F } = e0(c, s, {
      ...S.value === "auto" && { middleware: [Qb()] },
      // when placement is auto just use autoPlacement middleware
      ...S.value !== "auto" && {
        placement: S.value,
        middleware: [
          Zb(),
          // Shifts the floating element to keep it in view.
          Xb()
          // Changes the placement of the floating element to keep it in view.
        ]
      },
      strategy: "fixed",
      transform: !1
    }), Z = b(() => It(e.offset)), O = b(() => A.value.includes("top") ? {
      marginBottom: Z.value
    } : A.value.includes("bottom") ? {
      marginTop: Z.value
    } : A.value.includes("right") ? {
      marginLeft: Z.value
    } : A.value.includes("left") ? {
      marginRight: Z.value
    } : {}), z = b(() => ({
      ...T.value,
      zIndex: e.zIndex
    })), U = b(() => ({
      ...O.value,
      width: It(e.width),
      maxWidth: It(e.maxWidth),
      maxHeight: It(e.maxHeight)
    })), x = b(() => [e.popoverClasses, { "hide-caret": e.hideCaret }]);
    return t({
      hidePopover: g,
      showPopover: h
    }), it(() => {
      if ($a(window, "mousedown", k, { capture: !0 }), c.value) {
        const I = c.value.querySelector('button[data-dropdown-trigger="true"]') || c.value;
        I.hasAttribute("aria-controls") || I.setAttribute("aria-controls", i);
      }
      e.trigger === "hover" && [s.value, c.value].forEach((I) => {
        I && ($a(I, "mouseenter", h), $a(I, "focusin", h), $a(I, "mouseleave", g), $a(I, "focusout", g));
      });
    }), fn(() => {
      y();
    }), ie(l, (I) => {
      n(I ? "open" : "close");
    }), (I, E) => (m(), X(Ye(e.tag), {
      class: "k-popover",
      onKeydown: ct(Ke(g, ["stop"]), ["esc"])
    }, {
      default: L(() => [
        Y("div", {
          ref_key: "triggerWrapperElement",
          ref: u,
          class: "popover-trigger-wrapper",
          onClick: p
        }, [
          W(I.$slots, "default", {}, () => [
            G(rt, {
              "aria-controls": D(i),
              "data-testid": "popover-button"
            }, {
              default: L(() => [
                be(re(e.buttonText), 1)
              ]),
              _: 1
            }, 8, ["aria-controls"])
          ], !0)
        ], 512),
        G(n0, {
          target: e.target,
          "use-teleport": !!e.target
        }, {
          default: L(() => [
            G(ea, { name: "kongponents-fade-transition" }, {
              default: L(() => [
                pa(Y("div", Re(e.popoverElementAttributes, {
                  id: D(i),
                  ref_key: "popoverElement",
                  ref: s,
                  "aria-labelledby": r.title || e.title ? D(o) : void 0,
                  class: ["popover", x.value],
                  role: "dialog",
                  style: z.value,
                  "x-placement": D(A),
                  onClick: w
                }), [
                  Y("div", {
                    class: "popover-container",
                    style: Oe(U.value)
                  }, [
                    e.hideCloseIcon ? H("", !0) : (m(), $("button", {
                      key: 0,
                      ref: "popoverCloseButton",
                      "aria-label": "Close popover",
                      class: "popover-close-button",
                      tabindex: l.value ? 0 : -1,
                      type: "button",
                      onClick: g
                    }, [
                      G(D(ha), {
                        class: "popover-close-icon",
                        decorative: "",
                        size: D(Sa)
                      }, null, 8, ["size"])
                    ], 8, m0)),
                    r.title || e.title ? (m(), $("div", p0, [
                      r.title || e.title ? (m(), $("div", {
                        key: 0,
                        id: D(o),
                        class: ce(["popover-title", { "close-icon-spacing": !e.hideCloseIcon }])
                      }, [
                        W(I.$slots, "title", {}, () => [
                          be(re(e.title), 1)
                        ], !0)
                      ], 10, y0)) : H("", !0)
                    ])) : H("", !0),
                    Y("div", {
                      class: ce(["popover-content", { "close-icon-spacing": !e.hideCloseIcon && !(r.title || e.title) }])
                    }, [
                      W(I.$slots, "content", {}, void 0, !0)
                    ], 2),
                    r.footer ? (m(), $("div", b0, [
                      W(I.$slots, "footer", {}, void 0, !0)
                    ])) : H("", !0)
                  ], 4)
                ], 16, g0), [
                  [Xn, l.value]
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["target", "use-teleport"])
      ]),
      _: 3
    }, 40, ["onKeydown"]));
  }
}), or = /* @__PURE__ */ Pe(w0, [["__scopeId", "data-v-259ec85d"]]), C0 = ["id"], ba = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KTooltip",
  props: {
    text: { default: "" },
    placement: { default: "bottom" },
    maxWidth: { default: "none" },
    label: { default: "" },
    tooltipId: { default: "" },
    zIndex: { default: 9999 },
    kpopAttributes: { default: () => ({}) },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = $t(), a = b(() => !e.disabled && (!!e.text || !!e.label || !!t.content)), n = yt();
    return (r, i) => a.value ? (m(), X(or, Re({
      key: 0,
      "hide-caret": "",
      "hide-close-icon": "",
      "max-width": e.maxWidth,
      offset: D($g),
      placement: e.placement,
      "popover-classes": "k-tooltip",
      "popover-timeout": 100,
      trigger: "hover",
      width: "auto",
      "z-index": e.zIndex
    }, { ...r.$attrs, ...e.kpopAttributes }), {
      content: L(() => [
        Y("div", {
          id: e.tooltipId || D(n),
          role: "tooltip"
        }, [
          W(r.$slots, "content", {
            label: e.text || e.label
          }, () => [
            be(re(e.text || e.label), 1)
          ])
        ], 8, C0)
      ]),
      default: L(() => [
        W(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["max-width", "offset", "placement", "z-index"])) : W(r.$slots, "default", { key: 1 });
  }
}), k0 = ["tabindex"], $0 = /* @__PURE__ */ oe({
  __name: "KBadge",
  props: {
    appearance: { default: "info" },
    size: { default: "medium" },
    tooltip: { default: "" },
    truncationTooltip: { type: Boolean, default: !1 },
    maxWidth: { default: "200px" },
    iconBefore: { type: Boolean, default: !0 },
    tooltipAttributes: { default: () => ({}) }
  },
  setup(e) {
    Wt((u) => ({
      v815b0bb8: r.value
    }));
    const t = b(() => Object.keys(vg).includes(e.appearance)), a = N(), n = N(!1), r = b(() => It(e.maxWidth)), i = async () => {
      var u, s;
      a.value && (await ht(), n.value = ((u = a.value) == null ? void 0 : u.offsetWidth) < ((s = a.value) == null ? void 0 : s.scrollWidth));
    }, o = b(() => e.tooltip ? e.truncationTooltip ? n.value : !0 : !1);
    return it(() => {
      i();
    }), (u, s) => (m(), $("div", {
      class: ce(["k-badge", [e.appearance, e.size, { method: t.value }]])
    }, [
      G(ba, Re({
        text: o.value ? e.tooltip : void 0
      }, e.tooltipAttributes), {
        default: L(() => [
          Y("div", {
            class: ce(["badge-content", { "icon-after": !e.iconBefore }]),
            tabindex: o.value ? 0 : void 0
          }, [
            u.$slots.icon ? W(u.$slots, "icon", { key: 0 }, void 0, !0) : H("", !0),
            Y("div", {
              ref_key: "badgeTextElement",
              ref: a,
              class: "badge-content-wrapper"
            }, [
              W(u.$slots, "default", {}, void 0, !0)
            ], 512)
          ], 10, k0)
        ]),
        _: 3
      }, 16, ["text"])
    ], 2));
  }
}), vi = /* @__PURE__ */ Pe($0, [["__scopeId", "data-v-56e217c6"]]), S0 = {
  key: 0,
  class: "breadcrumbs-icon-container"
}, x0 = {
  key: 0,
  class: "breadcrumbs-divider"
}, T0 = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KBreadcrumbs",
  props: {
    items: {},
    itemMaxWidth: { default: "100px" }
  },
  setup(e) {
    const t = (n) => {
      const r = n.title || n.text;
      return n.to ? typeof n.to == "object" ? {
        type: "router-link",
        attrs: {
          title: r,
          to: n.to
        }
      } : {
        type: "a",
        attrs: {
          href: n.to,
          title: r
        }
      } : {
        type: "div",
        attrs: {
          title: r
        }
      };
    }, a = (n, r) => n.key || `breadcrumb-${r}`;
    return (n, r) => (m(), $("ul", Re({ class: "k-breadcrumbs" }, n.$attrs), [
      (m(!0), $(Ee, null, Fe(e.items, (i, o) => (m(), $("li", {
        key: a(i, o),
        class: "breadcrumbs-item-container"
      }, [
        (m(), X(Ye(t(i).type), Re({ ref_for: !0 }, t(i).attrs, {
          class: ["breadcrumbs-item", { link: !!i.to, active: o === e.items.length - 1 }]
        }), {
          default: L(() => [
            n.$slots[`icon-${a(i, o)}`] ? (m(), $("span", S0, [
              W(n.$slots, `icon-${a(i, o)}`, {}, void 0, !0)
            ])) : H("", !0),
            i.text ? (m(), $("span", {
              key: 1,
              class: "breadcrumbs-text",
              style: Oe({ maxWidth: D(It)(i.maxWidth ?? e.itemMaxWidth) })
            }, re(i.text), 5)) : H("", !0)
          ]),
          _: 2
        }, 1040, ["class"])),
        o < e.items.length - 1 ? (m(), $("span", x0, [
          W(n.$slots, "divider", {}, () => [
            r[0] || (r[0] = be(" / ", -1))
          ], !0)
        ])) : H("", !0)
      ]))), 128))
    ], 16));
  }
}), D0 = /* @__PURE__ */ Pe(T0, [["__scopeId", "data-v-b4649555"]]), A0 = { class: "k-card" }, I0 = {
  key: 0,
  class: "card-header"
}, E0 = {
  key: 1,
  class: "card-actions"
}, M0 = {
  key: 1,
  class: "card-content"
}, O0 = {
  key: 2,
  class: "card-footer"
}, P0 = /* @__PURE__ */ oe({
  __name: "KCard",
  props: {
    title: { default: "" },
    titleTag: { default: "div" }
  },
  setup(e) {
    const t = $t(), a = b(() => !!(t.title || e.title || t.actions));
    return (n, r) => (m(), $("div", A0, [
      a.value ? (m(), $("div", I0, [
        t.title || e.title ? (m(), X(Ye(e.titleTag), {
          key: 0,
          class: "card-title"
        }, {
          default: L(() => [
            W(n.$slots, "title", {}, () => [
              be(re(e.title), 1)
            ], !0)
          ]),
          _: 3
        })) : H("", !0),
        t.actions ? (m(), $("div", E0, [
          W(n.$slots, "actions", {}, void 0, !0)
        ])) : H("", !0)
      ])) : H("", !0),
      t.default ? (m(), $("div", M0, [
        W(n.$slots, "default", {}, void 0, !0)
      ])) : H("", !0),
      t.footer ? (m(), $("div", O0, [
        W(n.$slots, "footer", {}, void 0, !0)
      ])) : H("", !0)
    ]));
  }
}), Vu = /* @__PURE__ */ Pe(P0, [["__scopeId", "data-v-ee47edc8"]]);
var gs = /* @__PURE__ */ new WeakMap(), Rd = 0;
function N0(e) {
  if (!e.length)
    return "";
  for (var t = "arg", a = 0; a < e.length; ++a) {
    var n = void 0;
    e[a] === null || typeof e[a] != "object" && typeof e[a] != "function" ? typeof e[a] == "string" ? n = '"' + e[a] + '"' : n = String(e[a]) : gs.has(e[a]) ? n = gs.get(e[a]) : (n = Rd, gs.set(e[a], Rd++)), t += "@" + n;
  }
  return t;
}
function L0(e) {
  if (typeof e == "function")
    try {
      e = e();
    } catch {
      e = "";
    }
  return Array.isArray(e) ? e = N0(e) : e = String(e || ""), e;
}
var ju = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = 0), this.items = /* @__PURE__ */ new Map(), this.ttl = t;
    }
    return e.prototype.serializeKey = function(t) {
      return L0(t);
    }, e.prototype.get = function(t) {
      var a = this.serializeKey(t);
      return this.items.get(a);
    }, e.prototype.set = function(t, a, n) {
      var r = this.serializeKey(t), i = n || this.ttl, o = Date.now(), u = {
        data: a,
        createdAt: o,
        expiresAt: i ? o + i : 1 / 0
      };
      this.dispatchExpire(i, u, r), this.items.set(r, u);
    }, e.prototype.dispatchExpire = function(t, a, n) {
      var r = this;
      t && setTimeout(function() {
        var i = Date.now(), o = i >= a.expiresAt;
        o && r.delete(n);
      }, t);
    }, e.prototype.delete = function(t) {
      this.items.delete(t);
    }, e;
  })()
);
function B0() {
  return typeof navigator.onLine < "u" ? navigator.onLine : !0;
}
function R0() {
  return typeof document < "u" && typeof document.visibilityState < "u" ? document.visibilityState !== "hidden" : !0;
}
var F0 = function(e) {
  return fetch(e).then(function(t) {
    return t.json();
  });
};
const ms = {
  isOnline: B0,
  isDocumentVisible: R0,
  fetcher: F0
};
var en = function() {
  return en = Object.assign || function(e) {
    for (var t, a = 1, n = arguments.length; a < n; a++) {
      t = arguments[a];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, en.apply(this, arguments);
}, $r = function(e, t, a, n) {
  function r(i) {
    return i instanceof a ? i : new a(function(o) {
      o(i);
    });
  }
  return new (a || (a = Promise))(function(i, o) {
    function u(c) {
      try {
        l(n.next(c));
      } catch (d) {
        o(d);
      }
    }
    function s(c) {
      try {
        l(n.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function l(c) {
      c.done ? i(c.value) : r(c.value).then(u, s);
    }
    l((n = n.apply(e, t || [])).next());
  });
}, Sr = function(e, t) {
  var a = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, r, i, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(l) {
    return function(c) {
      return s([l, c]);
    };
  }
  function s(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a; ) try {
      if (n = 1, r && (i = l[0] & 2 ? r.return : l[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, l[1])).done) return i;
      switch (r = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return a.label++, { value: l[1], done: !1 };
        case 5:
          a.label++, r = l[1], l = [0];
          continue;
        case 7:
          l = a.ops.pop(), a.trys.pop();
          continue;
        default:
          if (i = a.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            a = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            a.label = l[1];
            break;
          }
          if (l[0] === 6 && a.label < i[1]) {
            a.label = i[1], i = l;
            break;
          }
          if (i && a.label < i[2]) {
            a.label = i[2], a.ops.push(l);
            break;
          }
          i[2] && a.ops.pop(), a.trys.pop();
          continue;
      }
      l = t.call(e, a);
    } catch (c) {
      l = [6, c], r = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}, z0 = function(e, t) {
  var a = typeof Symbol == "function" && e[Symbol.iterator];
  if (!a) return e;
  var n = a.call(e), r, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = n.next()).done; ) i.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (a = n.return) && a.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}, Y0 = function(e, t, a) {
  if (a || arguments.length === 2) for (var n = 0, r = t.length, i; n < r; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, zg = new ju(), ll = new ju(), ps = new ju(), Yg = {
  cache: zg,
  refreshInterval: 0,
  ttl: 0,
  serverTTL: 1e3,
  dedupingInterval: 2e3,
  revalidateOnFocus: !0,
  revalidateDebounce: 0,
  shouldRetryOnError: !0,
  errorRetryInterval: 5e3,
  errorRetryCount: 5,
  fetcher: ms.fetcher,
  isOnline: ms.isOnline,
  isDocumentVisible: ms.isDocumentVisible
};
function H0(e, t, a) {
  var n = ll.get(e);
  if (n)
    n.data.push(t);
  else {
    var r = 5e3;
    ll.set(e, [t], a > 0 ? a + r : a);
  }
}
function q0(e, t, a) {
  if (a.isDocumentVisible() && !(a.errorRetryCount !== void 0 && t > a.errorRetryCount)) {
    var n = Math.min(t || 0, a.errorRetryCount), r = n * a.errorRetryInterval;
    setTimeout(function() {
      e(null, { errorRetryCount: n + 1, shouldRetryOnError: !0 });
    }, r);
  }
}
var Fd = function(e, t, a, n) {
  return a === void 0 && (a = zg), n === void 0 && (n = Yg.ttl), $r(void 0, void 0, void 0, function() {
    var r, i, o, u, s, l, c;
    return Sr(this, function(d) {
      switch (d.label) {
        case 0:
          if (!U0(t)) return [3, 5];
          d.label = 1;
        case 1:
          return d.trys.push([1, 3, , 4]), [4, t];
        case 2:
          return r = d.sent(), [3, 4];
        case 3:
          return u = d.sent(), i = u, [3, 4];
        case 4:
          return [3, 6];
        case 5:
          r = t, d.label = 6;
        case 6:
          if (o = !1, s = { data: r, error: i, isValidating: o }, typeof r < "u")
            try {
              a.set(e, s, n);
            } catch (f) {
              console.error("swrv(mutate): failed to set cache", f);
            }
          return l = ll.get(e), l && l.data.length && (c = l.data.filter(function(f) {
            return f.key === e;
          }), c.forEach(function(f, v) {
            typeof s.data < "u" && (f.data = s.data), f.error = s.error, f.isValidating = s.isValidating, f.isLoading = s.isValidating;
            var y = v === c.length - 1;
            y || delete c[v];
          }), c = c.filter(Boolean)), [2, s];
      }
    });
  });
};
function W0() {
  for (var e = this, t = [], a = 0; a < arguments.length; a++)
    t[a] = arguments[a];
  var n, r, i = en({}, Yg), o = !1, u = !1, s = Nu(), l = (s == null ? void 0 : s.proxy) || s;
  if (!l)
    return console.error("Could not get current instance, check to make sure that `useSwrv` is declared in the top level of the setup function."), null;
  var c = (l == null ? void 0 : l.$isServer) || !1;
  t.length >= 1 && (n = t[0]), t.length >= 2 && (r = t[1]), t.length > 2 && (i = en(en({}, i), t[2]));
  var d = c ? i.serverTTL : i.ttl, f = typeof n == "function" ? n : N(n);
  typeof r > "u" && (r = i.fetcher);
  var v = null;
  v || (v = jr({
    data: void 0,
    error: void 0,
    isValidating: !0,
    isLoading: !0,
    key: null
  }));
  var y = function(p, w) {
    return $r(e, void 0, void 0, function() {
      var k, S, T, A, F, Z, O, z = this;
      return Sr(this, function(U) {
        switch (U.label) {
          case 0:
            return k = v.data === void 0, S = f.value, S ? (T = i.cache.get(S), A = T && T.data, v.isValidating = !0, v.isLoading = !A, A && (v.data = A.data, v.error = A.error), F = p || r, !F || !i.isDocumentVisible() && !k || (w == null ? void 0 : w.forceRevalidate) !== void 0 && !(w != null && w.forceRevalidate) ? (v.isValidating = !1, v.isLoading = !1, [
              2
              /*return*/
            ]) : T && (Z = !!(Date.now() - T.createdAt >= i.dedupingInterval || w != null && w.forceRevalidate), !Z) ? (v.isValidating = !1, v.isLoading = !1, [
              2
              /*return*/
            ]) : (O = function() {
              return $r(z, void 0, void 0, function() {
                var x, I, E, P;
                return Sr(this, function(R) {
                  switch (R.label) {
                    case 0:
                      return x = ps.get(S), x ? [3, 2] : (I = Array.isArray(S) ? S : [S], E = F.apply(void 0, Y0([], z0(I), !1)), ps.set(S, E, i.dedupingInterval), [4, Fd(S, E, i.cache, d)]);
                    case 1:
                      return R.sent(), [3, 4];
                    case 2:
                      return [4, Fd(S, x.data, i.cache, d)];
                    case 3:
                      R.sent(), R.label = 4;
                    case 4:
                      return v.isValidating = !1, v.isLoading = !1, ps.delete(S), v.error !== void 0 && (P = !o && i.shouldRetryOnError && (w ? w.shouldRetryOnError : !0), P && q0(y, w ? w.errorRetryCount : 1, i)), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, A && i.revalidateDebounce ? (setTimeout(function() {
              return $r(z, void 0, void 0, function() {
                return Sr(this, function(x) {
                  switch (x.label) {
                    case 0:
                      return o ? [3, 2] : [4, O()];
                    case 1:
                      x.sent(), x.label = 2;
                    case 2:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, i.revalidateDebounce), [3, 3]) : [3, 1])) : [
              2
              /*return*/
            ];
          case 1:
            return [4, O()];
          case 2:
            U.sent(), U.label = 3;
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, C = function() {
    return $r(e, void 0, void 0, function() {
      return Sr(this, function(p) {
        return [2, y(null, { shouldRetryOnError: !1 })];
      });
    });
  }, h = null;
  it(function() {
    var p = function() {
      return $r(e, void 0, void 0, function() {
        return Sr(this, function(w) {
          switch (w.label) {
            case 0:
              return !v.error && i.isOnline() ? [4, y()] : [3, 2];
            case 1:
              return w.sent(), [3, 3];
            case 2:
              h && clearTimeout(h), w.label = 3;
            case 3:
              return i.refreshInterval && !o && (h = setTimeout(p, i.refreshInterval)), [
                2
                /*return*/
              ];
          }
        });
      });
    };
    i.refreshInterval && (h = setTimeout(p, i.refreshInterval)), i.revalidateOnFocus && (document.addEventListener("visibilitychange", C, !1), window.addEventListener("focus", C, !1));
  }), ya(function() {
    o = !0, h && clearTimeout(h), i.revalidateOnFocus && (document.removeEventListener("visibilitychange", C, !1), window.removeEventListener("focus", C, !1));
    var p = ll.get(f.value);
    p && (p.data = p.data.filter(function(w) {
      return w !== v;
    }));
  });
  try {
    ie(f, function(p) {
      F1(f) || (f.value = p), v.key = p, v.isValidating = !!p, H0(f.value, v, d), !c && !u && f.value && y(), u = !1;
    }, {
      immediate: !0
    });
  } catch {
  }
  var g = en(en({}, lg(v)), { mutate: function(p, w) {
    return y(p, en(en({}, w), { forceRevalidate: !0 }));
  } });
  return g;
}
function U0(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
const _a = {
  VALIDATING: "VALIDATING",
  VALIDATING_HAS_DATA: "VALIDATING_HAS_DATA",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  SUCCESS_HAS_DATA: "SUCCESS_HAS_DATA",
  ERROR: "ERROR",
  STALE_IF_ERROR: "STALE_IF_ERROR"
};
function Bn() {
  return {
    useRequest: (o, u, s) => {
      const {
        data: l,
        error: c,
        isValidating: d,
        isLoading: f,
        mutate: v
      } = W0(o, u, {
        revalidateDebounce: 500,
        dedupingInterval: 100,
        ...s
      });
      return {
        data: b(() => {
          var C;
          return (C = l.value) == null ? void 0 : C.data;
        }),
        response: l,
        error: c,
        isValidating: d,
        isLoading: f,
        revalidate: v
      };
    },
    useDebounce: (o, u = 300) => {
      let s;
      const l = (c) => async (...d) => {
        clearTimeout(s), c > 0 ? await new Promise((f) => {
          s = setTimeout(async () => {
            await o(...d), f();
          }, c);
        }) : await o(...d);
      };
      return {
        debouncedFn: l(u),
        generateDebouncedFn: l
      };
    },
    clientSideSorter: (o, u, s, l) => {
      let c = null;
      const d = (v, y) => typeof y == "number" && !Number.isNaN(v) && !Number.isNaN(y) ? v - y : 0, f = (v, y) => v.localeCompare(y);
      return o !== u ? (c = (v, y) => {
        const C = (p) => p == null ? "" : typeof p == "number" ? p : Array.isArray(p) && p.length && typeof p[0] == "number" ? p[0] : String(p), h = C(v[o]), g = C(y[o]);
        switch (typeof h) {
          case "number":
            return d(h, g);
          default:
            return f(h, g);
        }
      }, l.sort(c), u = o, s = "ascending") : (l.reverse(), s === "descending" || s === "desc" ? s = "ascending" : s = "descending"), { previousKey: u, sortOrder: s };
    },
    useSwrvState: (o, u, s) => {
      const l = N(_a.PENDING), c = N(!1);
      return Lu(() => {
        var d, f, v, y, C, h;
        if (c.value = o.value && !!((d = Object.keys(o.value)) != null && d.length || (f = o.value.data) != null && f.length || (y = (v = o.value.data) == null ? void 0 : v.data) != null && y.length || !((C = o.value.data) != null && C.data) && typeof o.value.data == "object" && Object.keys((h = o.value) == null ? void 0 : h.data).length), o.value && c.value && s.value) {
          l.value = _a.VALIDATING_HAS_DATA;
          return;
        }
        if (o.value && s.value) {
          l.value = _a.VALIDATING;
          return;
        }
        if (o.value && u.value) {
          l.value = _a.STALE_IF_ERROR;
          return;
        }
        if (o.value === void 0 && !u.value) {
          l.value = _a.PENDING;
          return;
        }
        if (o.value && !u.value && c.value) {
          l.value = _a.SUCCESS_HAS_DATA;
          return;
        }
        if (o.value && !u.value) {
          l.value = _a.SUCCESS;
          return;
        }
        o.value === void 0 && u && (l.value = _a.ERROR);
      }), {
        hasData: c,
        state: l,
        swrvState: _a
      };
    },
    cloneDeep: (o) => {
      if (o)
        return JSON.parse(JSON.stringify(o));
    },
    stripRequiredLabel: (o, u) => !u || !o ? o || "" : /( )?\*$/gi.test(o) ? o.replace(/\*$/gi, "").trim() : o
  };
}
const K0 = /* @__PURE__ */ oe({
  __name: "KSkeletonBox",
  props: {
    width: { default: "1" },
    height: { default: "1" }
  },
  setup(e) {
    return (t, a) => (m(), $("div", {
      class: ce(["skeleton-box", { [`width-${e.width}`]: !0, [`height-${e.height}`]: !0 }])
    }, null, 2));
  }
}), xa = /* @__PURE__ */ Pe(K0, [["__scopeId", "data-v-5081cdc2"]]), V0 = { class: "skeleton-loader" }, j0 = /* @__PURE__ */ oe({
  __name: "SkeletonBase",
  setup(e) {
    return (t, a) => (m(), $("div", V0, [
      W(t.$slots, "default", {}, () => [
        G(xa, {
          height: "1",
          width: "100"
        }),
        G(xa, {
          height: "1",
          width: "100"
        }),
        G(xa, {
          height: "1",
          width: "100"
        })
      ], !0)
    ]));
  }
}), G0 = /* @__PURE__ */ Pe(j0, [["__scopeId", "data-v-72b558ed"]]), Q0 = { class: "skeleton-card-wrapper" }, Z0 = { class: "skeleton-card-header" }, X0 = { class: "skeleton-card-content" }, J0 = { class: "skeleton-card-footer" }, _0 = /* @__PURE__ */ oe({
  __name: "CardSkeleton",
  props: {
    cardCount: {},
    maxWidth: {}
  },
  setup(e) {
    Wt((a) => ({
      v243e7eb5: t.value
    }));
    const t = b(() => e.maxWidth ? It(e.maxWidth) : e.cardCount === 1 ? "470px" : `calc((100% / 3) - ${eb})`);
    return (a, n) => (m(), $("div", Q0, [
      (m(!0), $(Ee, null, Fe(e.cardCount, (r) => (m(), $("div", {
        key: r,
        class: "skeleton-card"
      }, [
        Y("div", Z0, [
          W(a.$slots, "card-header", {}, () => [
            G(xa, { width: "50" })
          ], !0)
        ]),
        Y("div", X0, [
          W(a.$slots, "card-content", {}, () => [
            (m(), $(Ee, null, Fe(3, (i) => G(xa, {
              key: i,
              width: "100"
            })), 64)),
            G(xa, { width: "50" })
          ], !0)
        ]),
        Y("div", J0, [
          W(a.$slots, "card-footer", {}, () => [
            (m(), $(Ee, null, Fe(2, (i) => G(xa, {
              key: i,
              height: "2",
              width: "5"
            })), 64))
          ], !0)
        ])
      ]))), 128))
    ]));
  }
}), e2 = /* @__PURE__ */ Pe(_0, [["__scopeId", "data-v-0fa22dc7"]]), t2 = { class: "skeleton-table-wrapper" }, a2 = /* @__PURE__ */ oe({
  __name: "TableSkeleton",
  props: {
    rows: {},
    columns: {}
  },
  setup(e) {
    Wt((a) => ({
      v11294cba: a.columns
    }));
    const t = (a, n) => a === 1 && n === 1 || a !== 1 && n !== 1 ? "25" : "50";
    return (a, n) => (m(), $("div", t2, [
      (m(!0), $(Ee, null, Fe(e.rows, (r) => (m(), $("div", {
        key: r,
        class: "skeleton-table-row"
      }, [
        W(a.$slots, "default", {}, () => [
          (m(!0), $(Ee, null, Fe(e.columns, (i) => (m(), $("div", {
            key: i,
            class: "skeleton-cell-container"
          }, [
            G(xa, {
              class: "skeleton-cell",
              width: t(i, r)
            }, null, 8, ["width"])
          ]))), 128))
        ], !0)
      ]))), 128))
    ]));
  }
}), n2 = /* @__PURE__ */ Pe(a2, [["__scopeId", "data-v-35dc3248"]]), r2 = { class: "skeleton-form-wrapper" }, i2 = /* @__PURE__ */ oe({
  __name: "FormSkeleton",
  setup(e) {
    return (t, a) => (m(), $("div", r2, [
      (m(), $(Ee, null, Fe(4, (n) => Y("div", {
        key: n,
        class: "skeleton-form-row"
      }, [
        G(xa, {
          height: "2",
          width: "10"
        }),
        G(xa, {
          height: "2",
          width: "100"
        })
      ])), 64))
    ]));
  }
}), o2 = /* @__PURE__ */ Pe(i2, [["__scopeId", "data-v-f750ceb7"]]), l2 = "data:image/gif;base64,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", s2 = {
  class: "fullscreen-loading-container",
  "data-testid": "full-screen-loader"
}, u2 = ["src"], c2 = {
  key: 0,
  class: "progress"
}, d2 = /* @__PURE__ */ oe({
  __name: "FullScreenKongSkeleton",
  props: {
    progress: {},
    hideProgress: { type: Boolean },
    zIndex: {}
  },
  setup(e) {
    Wt((r) => ({
      v4d434712: r.zIndex
    }));
    const t = N(0), a = N(0), n = b(() => e.progress !== null ? e.progress : a.value);
    return it(() => {
      e.progress || (t.value = setInterval(() => {
        a.value >= 100 && (clearInterval(t.value), a.value = 100), a.value = Math.min(a.value + Math.ceil(Math.random() * 10 * 30), 100);
      }, 200));
    }), ya(() => {
      clearInterval(t.value);
    }), (r, i) => (m(), $("div", s2, [
      Y("div", null, [
        Y("img", {
          alt: "Loading",
          src: D(l2)
        }, null, 8, u2),
        e.hideProgress ? H("", !0) : (m(), $("div", c2, [
          Y("div", {
            class: "progress-bar",
            role: "progressbar",
            style: Oe({ width: `${n.value}%` }),
            title: "Loading"
          }, null, 4)
        ]))
      ])
    ]));
  }
}), f2 = /* @__PURE__ */ Pe(d2, [["__scopeId", "data-v-bc7e2b16"]]), v2 = {
  class: "fullscreen-loading-container",
  "data-testid": "full-screen-spinner-loader"
}, h2 = {
  key: 0,
  class: "progress"
}, g2 = /* @__PURE__ */ oe({
  __name: "FullScreenGenericSpinner",
  props: {
    progress: {},
    hideProgress: { type: Boolean },
    zIndex: {}
  },
  setup(e) {
    Wt((r) => ({
      v07a3a490: r.zIndex
    }));
    const t = N(0), a = N(0), n = b(() => e.progress !== null ? e.progress : a.value);
    return it(() => {
      e.progress || (t.value = setInterval(() => {
        a.value >= 100 && (clearInterval(t.value), a.value = 100), a.value = Math.min(a.value + Math.ceil(Math.random() * 10 * 30), 100);
      }, 200));
    }), ya(() => {
      clearInterval(t.value);
    }), (r, i) => (m(), $("div", v2, [
      Y("div", null, [
        i[0] || (i[0] = Y("div", { class: "spinner-loader" }, null, -1)),
        e.hideProgress ? H("", !0) : (m(), $("div", h2, [
          Y("div", {
            class: "progress-bar",
            role: "progressbar",
            style: Oe({ width: `${n.value}%` }),
            title: "Loading"
          }, null, 4)
        ]))
      ])
    ]));
  }
}), m2 = /* @__PURE__ */ Pe(g2, [["__scopeId", "data-v-a0d12d73"]]), jl = /* @__PURE__ */ oe({
  __name: "KSkeleton",
  props: {
    type: { default: "" },
    delayMilliseconds: { default: 0 },
    cardCount: { default: 1 },
    cardMaxWidth: { default: "" },
    tableRows: { default: 6 },
    tableColumns: { default: 5 },
    progress: { default: null },
    hideProgress: { type: Boolean },
    zIndex: { default: 10500 }
  },
  setup(e) {
    const t = N(e.delayMilliseconds === 0);
    return it(() => {
      t.value || setTimeout(() => {
        t.value = !0;
      }, e.delayMilliseconds);
    }), (a, n) => t.value ? (m(), $("div", {
      key: 0,
      class: ce(["k-skeleton", { "not-spinner": e.type !== "spinner" }])
    }, [
      e.type === "card" ? (m(), X(e2, {
        key: 0,
        "card-count": e.cardCount,
        "max-width": e.cardMaxWidth
      }, {
        "card-header": L(() => [
          W(a.$slots, "card-header")
        ]),
        "card-content": L(() => [
          W(a.$slots, "card-content")
        ]),
        "card-footer": L(() => [
          W(a.$slots, "card-footer")
        ]),
        _: 3
      }, 8, ["card-count", "max-width"])) : e.type === "table" ? (m(), X(n2, {
        key: 1,
        columns: e.tableColumns,
        rows: e.tableRows
      }, {
        default: L(() => [
          W(a.$slots, "default")
        ]),
        _: 3
      }, 8, ["columns", "rows"])) : e.type === "form" ? (m(), X(o2, { key: 2 })) : e.type === "fullscreen-kong" ? (m(), X(f2, {
        key: 3,
        "hide-progress": e.hideProgress,
        progress: e.progress,
        "z-index": e.zIndex
      }, null, 8, ["hide-progress", "progress", "z-index"])) : e.type === "fullscreen-generic" ? (m(), X(m2, {
        key: 4,
        "hide-progress": e.hideProgress,
        progress: e.progress,
        "z-index": e.zIndex
      }, null, 8, ["hide-progress", "progress", "z-index"])) : e.type === "spinner" ? (m(), X(D(Fi), {
        key: 5,
        class: "skeleton-spinner",
        color: `var(--kui-color-text-neutral, ${D(Ya)})`,
        title: "Loading"
      }, null, 8, ["color"])) : (m(), X(G0, { key: 6 }))
    ], 2)) : H("", !0);
  }
}), p2 = { class: "empty-state-content" }, y2 = ["aria-hidden"], b2 = {
  key: 0,
  class: "empty-state-title"
}, w2 = {
  key: 1,
  class: "empty-state-message"
}, C2 = {
  key: 2,
  class: "empty-state-action"
}, k2 = {
  key: 0,
  class: "empty-state-features-container"
}, $2 = {
  key: 0,
  "aria-hidden": "true",
  class: "feature-icon"
}, S2 = { class: "card-header" }, x2 = ["title"], T2 = {
  key: 1,
  class: "empty-state-footer-container"
}, D2 = /* @__PURE__ */ oe({
  __name: "KEmptyState",
  props: {
    title: { default: "" },
    message: { default: "" },
    actionButtonVisible: { type: Boolean, default: !0 },
    actionButtonText: { default: "" },
    actionButtonDisabled: { type: Boolean },
    iconVariant: { default: () => Na.Default },
    iconBackground: { type: Boolean, default: !1 },
    features: { default: () => [] }
  },
  emits: ["click-action"],
  setup(e, { emit: t }) {
    const a = t, n = $t(), r = yt(), i = b(() => {
      switch (e.iconVariant) {
        case Na.Default:
          return Uc;
        case Na.Error:
          return Yu;
        case Na.Search:
          return zu;
        case Na.Kong:
          return Fu;
        default:
          return Uc;
      }
    }), o = b(() => {
      if (e.iconBackground)
        return wg;
      switch (e.iconVariant) {
        case Na.Error:
          return Zy;
        default:
          return Ya;
      }
    }), u = b(() => {
      if (n.image)
        return "empty-state-image";
      const s = "empty-state-icon";
      return e.iconBackground ? `${s} has-background` : s;
    });
    return (s, l) => (m(), $("div", {
      class: ce(["k-empty-state", [e.iconVariant]])
    }, [
      Y("div", p2, [
        Y("div", {
          "aria-hidden": s.$slots.image ? void 0 : "true",
          class: ce(u.value)
        }, [
          W(s.$slots, "image", {}, () => [
            W(s.$slots, "icon", {}, () => [
              (m(), X(Ye(i.value), {
                color: o.value,
                decorative: "",
                size: D(Jy)
              }, null, 8, ["color", "size"]))
            ], !0)
          ], !0)
        ], 10, y2),
        e.title || s.$slots.title ? (m(), $("div", b2, [
          W(s.$slots, "title", {}, () => [
            be(re(e.title), 1)
          ], !0)
        ])) : H("", !0),
        e.message || s.$slots.default ? (m(), $("div", w2, [
          W(s.$slots, "default", {}, () => [
            Y("p", null, re(e.message), 1)
          ], !0)
        ])) : H("", !0),
        e.actionButtonVisible && e.actionButtonText || s.$slots.action ? (m(), $("div", C2, [
          W(s.$slots, "action", {}, () => [
            G(rt, {
              disabled: e.actionButtonDisabled,
              type: "button",
              onClick: l[0] || (l[0] = (c) => a("click-action"))
            }, {
              default: L(() => [
                W(s.$slots, "action-button-icon", {}, void 0, !0),
                be(" " + re(e.actionButtonText), 1)
              ]),
              _: 3
            }, 8, ["disabled"])
          ], !0)
        ])) : H("", !0)
      ]),
      e.features.length ? (m(), $("div", k2, [
        (m(!0), $(Ee, null, Fe(e.features, (c, d) => (m(), X(Vu, {
          key: `feature-${D(r)}-${c.key || d}`,
          class: "empty-state-feature-card"
        }, {
          title: L(() => [
            c.key && s.$slots[`feature-icon-${c.key}`] ? (m(), $("div", $2, [
              W(s.$slots, `feature-icon-${c.key}`, {}, void 0, !0)
            ])) : H("", !0),
            Y("div", S2, re(c.title), 1)
          ]),
          default: L(() => [
            Y("div", {
              title: c.description
            }, re(c.description), 9, x2)
          ]),
          _: 2
        }, 1024))), 128))
      ])) : H("", !0),
      s.$slots.footer ? (m(), $("div", T2, [
        W(s.$slots, "footer", {}, void 0, !0)
      ])) : H("", !0)
    ], 2));
  }
}), _n = /* @__PURE__ */ Pe(D2, [["__scopeId", "data-v-53495b9b"]]), A2 = { class: "dropdown-item-trigger-label" }, ji = "dropdown-item-trigger", I2 = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KDropdownItem",
  props: {
    item: { default: null },
    hasDivider: { type: Boolean },
    danger: { type: Boolean },
    disabled: { type: Boolean },
    selected: { type: Boolean },
    selectionMenuChild: { type: Boolean },
    onClick: { type: Function },
    isDangerous: { type: Boolean, default: () => {
    } }
  },
  emits: ["click", "change"],
  setup(e, { emit: t }) {
    const a = na();
    ie(() => e.isDangerous, (d) => {
      typeof d < "u" && console.warn("KDropdownItem: `isDangerous` prop is deprecated. Please use `danger` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    });
    const n = t, r = b(() => {
      var d;
      return (d = e.item) != null && d.to ? "link" : typeof e.onClick < "u" || e.selectionMenuChild ? "button" : "default";
    }), i = b(() => {
      var d;
      return ((d = e.item) == null ? void 0 : d.label) || "";
    }), o = b(() => {
      var d;
      return ((d = e.item) == null ? void 0 : d.to) || void 0;
    }), u = (d) => {
      n("click", d), e.selectionMenuChild && n("change", e.item);
    }, s = b(() => {
      let d = "div";
      return r.value === "link" && o.value && typeof o.value == "string" ? d = "link" : r.value === "link" && o.value && typeof o.value == "object" ? d = "router-link" : r.value === "button" && (d = "button"), d;
    }), l = b(() => {
      const d = Object.assign({}, a);
      return delete d.class, delete d.disabled, delete d.style, d;
    }), c = b(() => ({
      link: {
        tag: "a",
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for links
          class: `${ji} ${e.disabled ? "disabled" : ""}`,
          href: o.value,
          ...l.value
        }
      },
      "router-link": {
        tag: "router-link",
        onClick: u,
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for links
          class: `${ji} ${e.disabled ? "disabled" : ""}`,
          to: o.value,
          ...l.value
        }
      },
      button: {
        tag: "button",
        onClick: u,
        attrs: {
          type: "button",
          // don't add disabled class because we want the disabled attribute on the button
          class: ji,
          disabled: e.disabled,
          ...l.value
        }
      },
      div: {
        tag: "div",
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for div
          class: `${ji} ${e.disabled ? "disabled" : ""}`,
          ...l.value
        }
      }
    }));
    return (d, f) => (m(), $("li", {
      class: ce(["k-dropdown-item", [{
        "has-divider": e.hasDivider,
        disabled: e.disabled,
        danger: e.danger || e.isDangerous,
        "dropdown-selected-option": e.selected
      }, d.$attrs.class, d.$attrs.style]]),
      "data-testid": "dropdown-item"
    }, [
      (m(), X(Ye(c.value[s.value].tag), Re({ "data-testid": "dropdown-item-trigger" }, c.value[s.value].attrs, {
        onClick: c.value[s.value].onClick
      }), {
        default: L(() => [
          Y("span", A2, [
            W(d.$slots, "default", {}, () => [
              be(re(i.value), 1)
            ], !0)
          ])
        ]),
        _: 3
      }, 16, ["onClick"]))
    ], 2));
  }
}), Gu = /* @__PURE__ */ Pe(I2, [["__scopeId", "data-v-2413eb0e"]]), E2 = {
  class: "dropdown-list",
  "data-testid": "dropdown-list"
}, M2 = /* @__PURE__ */ oe({
  __name: "KDropdown",
  props: {
    selectionMenu: { type: Boolean },
    appearance: { default: "primary" },
    triggerText: { default: "" },
    showCaret: { type: Boolean },
    width: { default: "" },
    kpopAttributes: { default: () => ({}) },
    items: { default: () => [] },
    disabled: { type: Boolean },
    disabledTooltip: { default: "" },
    label: {}
  },
  emits: ["toggleDropdown", "change"],
  setup(e, { expose: t, emit: a }) {
    var v;
    ie(() => e.appearance, (y) => {
      (y === "menu" || y === "selectionMenu") && console.warn("KDropdown: the usage for the `appearance` prop has changed. Please see the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    }, { immediate: !0 }), ie(() => e.label, (y) => {
      y && console.warn("KDropdown: `label` prop is deprecated. Please use `triggerText` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    }, { immediate: !0 });
    const n = a, r = b(() => e.disabledTooltip ? ba : "div"), i = dt("kPop"), o = {
      hideCaret: !0,
      popoverClasses: "k-dropdown-popover dropdown-popover",
      popoverTimeout: 0,
      placement: "bottom-start"
    }, u = {
      ...o,
      ...e.kpopAttributes,
      width: e.width || void 0,
      popoverClasses: `${o.popoverClasses} ${((v = e.kpopAttributes) == null ? void 0 : v.popoverClasses) || ""}`
    }, s = b(() => {
      var y;
      return ((y = l.value) == null ? void 0 : y.label) || e.triggerText || e.label || "";
    }), l = N(), c = (y) => {
      e.selectionMenu && (l.value = y);
    }, d = () => {
      var y;
      (y = i.value) == null || y.hidePopover();
    }, f = (y, C, h) => {
      y.value !== h && (C(), n("toggleDropdown", y.value));
    };
    return ie(l, (y, C) => {
      y && y !== C && n("change", y);
    }), it(() => {
      if (e.items) {
        const y = e.items.filter((C) => C.selected);
        y.length && (l.value = y[0]);
      }
    }), t({
      openDropdown: () => {
        var y;
        (y = i.value) == null || y.showPopover();
      },
      closeDropdown: d
    }), (y, C) => (m(), $("div", {
      class: ce(["k-dropdown", { "selection-dropdown-menu": e.selectionMenu }])
    }, [
      G(Rl, null, {
        default: L(({ toggle: h, isToggled: g }) => [
          G(or, Re({ ref: "kPop" }, u, {
            "close-on-popover-click": "",
            "data-testid": "dropdown-popover",
            "hide-close-icon": "",
            offset: D($g),
            onClose: () => f(g, h, !1),
            onOpen: () => f(g, h, !0),
            onPopoverClick: () => f(g, h, !1)
          }), {
            content: L(() => [
              Y("ul", E2, [
                W(y.$slots, "items", {
                  closeDropdown: d,
                  handleSelection: c,
                  items: e.items
                }, () => [
                  (m(!0), $(Ee, null, Fe(e.items, (p, w) => {
                    var k;
                    return m(), X(Gu, Re({ ref_for: !0 }, p, {
                      key: `${p.label}-${w}`,
                      item: p,
                      selected: e.selectionMenu && ((k = l.value) == null ? void 0 : k.value) === p.value,
                      "selection-menu-child": e.selectionMenu,
                      onChange: c
                    }), null, 16, ["item", "selected", "selection-menu-child"]);
                  }), 128))
                ], !0)
              ])
            ]),
            default: L(() => [
              (m(), X(Ye(r.value), {
                class: "dropdown-trigger",
                "data-testid": "dropdown-trigger",
                label: e.disabledTooltip ? e.disabledTooltip : void 0,
                "max-width": e.disabledTooltip ? "240" : void 0,
                position: e.disabledTooltip ? "bottom" : void 0
              }, {
                default: L(() => [
                  W(y.$slots, "default", {
                    isOpen: g.value
                  }, () => [
                    s.value ? (m(), X(rt, {
                      key: 0,
                      appearance: e.appearance,
                      class: "dropdown-trigger-button",
                      "data-dropdown-trigger": "true",
                      "data-testid": "dropdown-trigger-button",
                      disabled: e.disabled
                    }, {
                      default: L(() => [
                        be(re(s.value) + " ", 1),
                        e.showCaret ? (m(), X(D(zl), {
                          key: 0,
                          decorative: ""
                        })) : H("", !0)
                      ]),
                      _: 1
                    }, 8, ["appearance", "disabled"])) : H("", !0)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["label", "max-width", "position"]))
            ]),
            _: 2
          }, 1040, ["offset", "onClose", "onOpen", "onPopoverClick"])
        ]),
        _: 3
      })
    ], 2));
  }
}), Fr = /* @__PURE__ */ Pe(M2, [["__scopeId", "data-v-ce46a64c"]]), O2 = { class: "pagination-offset-button-container" }, P2 = /* @__PURE__ */ oe({
  __name: "PaginationOffset",
  props: {
    previousButtonDisabled: {
      type: Boolean,
      default: !1
    },
    nextButtonDisabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["getPreviousOffset", "getNextOffset"],
  setup(e, { emit: t }) {
    const a = t;
    return (n, r) => (m(), $("div", O2, [
      G(rt, {
        appearance: "tertiary",
        "aria-label": "Go to the previous page",
        class: "pagination-button",
        "data-testid": "previous-button",
        disabled: e.previousButtonDisabled,
        icon: "",
        size: "small",
        type: "button",
        onClick: r[0] || (r[0] = Ke((i) => a("getPreviousOffset"), ["prevent"]))
      }, {
        default: L(() => [
          G(D(gg), { decorative: "" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      G(rt, {
        appearance: "tertiary",
        "aria-label": "Go to the next page",
        class: "pagination-button",
        "data-testid": "next-button",
        disabled: e.nextButtonDisabled,
        icon: "",
        size: "small",
        type: "button",
        onClick: r[1] || (r[1] = Ke((i) => a("getNextOffset"), ["prevent"]))
      }, {
        default: L(() => [
          G(D(yg), { decorative: "" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), N2 = /* @__PURE__ */ Pe(P2, [["__scopeId", "data-v-34b46660"]]);
class lr {
  constructor(t) {
    Ja(this, "resizeObserver");
    Ja(this, "callback");
    this.callback = t, this.resizeObserver = new ResizeObserver((a) => {
      window.requestAnimationFrame(() => {
        !Array.isArray(a) || !a.length || t();
      });
    });
  }
  static create(t) {
    return new lr(t);
  }
  observe(t) {
    !this.resizeObserver || !t || this.resizeObserver.observe(t);
  }
  unobserve(t) {
    !this.resizeObserver || !t || this.resizeObserver.unobserve(t);
  }
}
const L2 = {
  class: "pagination-text large-screen",
  "data-testid": "visible-items"
}, B2 = { class: "pagination-text-pages" }, R2 = { class: "pagination-button-container" }, F2 = { key: 0 }, z2 = {
  key: 1,
  class: "pagination-button placeholder"
}, Y2 = ["aria-current", "aria-label", "data-testid", "onClick"], H2 = {
  key: 2,
  class: "pagination-button placeholder"
}, q2 = { key: 3 }, W2 = { class: "page-size-select" }, U2 = {
  key: 0,
  class: "pagination-text small-screen",
  "data-testid": "visible-items"
}, K2 = { class: "pagination-text-pages" }, V2 = /* @__PURE__ */ oe({
  __name: "KPagination",
  props: {
    items: { default: () => [] },
    totalCount: { default: 0 },
    pageSizes: { default: () => [15, 30, 50, 75, 100] },
    initialPageSize: { default: null },
    neighbors: { default: 1 },
    currentPage: { default: null },
    disablePageJump: { type: Boolean },
    offset: { type: Boolean },
    offsetPreviousButtonDisabled: { type: Boolean },
    offsetNextButtonDisabled: { type: Boolean }
  },
  emits: ["pageChange", "pageSizeChange", "getNextOffset", "getPreviousOffset"],
  setup(e, { emit: t }) {
    const a = {
      placement: "top"
    }, n = t, r = N(null), i = N(), o = N(e.currentPage ? e.currentPage : 1), u = N(e.initialPageSize ? e.initialPageSize : e.pageSizes[0]), s = b(() => Math.ceil(e.totalCount / u.value)), l = e.pageSizes.map((K, J) => ({
      label: `${K}`,
      key: `size-${J}`,
      value: K,
      selected: K === u.value
    })), c = b(() => `${u.value} ${u.value === 1 ? "item per page" : " items per page"}`), d = N(e.neighbors), f = N(3), v = async () => (await ht(), r.value ? r.value.scrollWidth > r.value.clientWidth : !1), y = async () => {
      await v() && (d.value > 1 || f.value > 1) && (d.value > 1 ? d.value-- : f.value > 1 && f.value--, O.value = C(o.value, s.value, F.value, Z.value));
    }, C = (K, J, q, se) => {
      if (e.disablePageJump)
        return [];
      let fe = [...Array(J).keys()].map((ae) => ae + 1);
      const ne = f.value + 2 + 2 * d.value;
      return fe.length <= ne || (q ? q && se ? fe = fe.filter(
        (ae) => ae > K - d.value - 1 && ae < K + d.value + 1
      ) : q && !se && (fe = fe.filter((ae) => ae > J - d.value * 2 - f.value)) : fe = fe.filter((ae) => ae <= d.value * 2 + f.value)), fe;
    }, h = N(o.value === 1), g = N(o.value === s.value), p = b(() => (o.value - 1) * u.value + 1), w = b(() => {
      const K = p.value - 1 + u.value;
      return K > e.totalCount ? e.totalCount : K;
    }), k = b(() => `${p.value} to ${w.value}`), S = b(() => ` of ${e.totalCount}`), T = b(() => e.currentPage ? e.currentPage : o.value), A = b(() => 5 + 2 * d.value), F = N(T.value >= d.value + (f.value + 1) && s.value > A.value), Z = N(s.value > f.value + 2 + 2 * d.value), O = N(C(
      T.value,
      s.value,
      F.value,
      Z.value
    )), z = () => {
      o.value++, I();
    }, U = () => {
      o.value--, I();
    }, x = (K) => {
      o.value = K, I();
    }, I = () => {
      const K = (o.value - 1) * u.value + u.value;
      g.value = K >= e.totalCount, h.value = o.value === 1, s.value <= A.value ? (F.value = !1, Z.value = !1) : (F.value = o.value >= d.value + (f.value + 1), Z.value = o.value <= s.value - d.value - f.value), O.value = C(o.value, s.value, F.value, Z.value), n("pageChange", {
        page: o.value,
        pageCount: s.value,
        firstItem: p.value,
        lastItem: w.value,
        visibleItems: e.items.slice(p.value - 1, w.value)
      });
    }, E = (K) => {
      u.value !== K.value && (u.value = K.value, n("pageSizeChange", {
        pageSize: u.value,
        pageCount: s.value
      }), e.currentPage !== 1 && x(1));
    }, P = () => {
      n("getNextOffset");
    }, R = () => {
      n("getPreviousOffset");
    };
    return ie(() => e.currentPage, (K, J) => {
      K !== J && K && x(K);
    }), ie(s, (K, J) => {
      K !== J && (g.value = o.value === K, Z.value = K > f.value + 2 + 2 * d.value, O.value = C(
        T.value,
        K,
        !1,
        Z.value
      ));
    }), ie(O, () => {
      !e.disablePageJump && !e.offset && y();
    }), it(() => {
      !e.disablePageJump && !e.offset && (i.value = lr.create(y), i.value.observe(r.value));
    }), fn(() => {
      var K;
      !e.disablePageJump && !e.offset && ((K = i.value) == null || K.unobserve(r.value));
    }), (K, J) => (m(), $("nav", {
      ref_key: "kPaginationElement",
      ref: r,
      class: ce(["k-pagination", { "page-jump": !e.disablePageJump && !e.offset }]),
      "data-testid": "k-pagination"
    }, [
      e.offset ? (m(), X(N2, {
        key: 1,
        "next-button-disabled": e.offsetNextButtonDisabled,
        "previous-button-disabled": e.offsetPreviousButtonDisabled,
        onGetNextOffset: P,
        onGetPreviousOffset: R
      }, null, 8, ["next-button-disabled", "previous-button-disabled"])) : (m(), $(Ee, { key: 0 }, [
        Y("span", L2, [
          Y("span", B2, re(k.value), 1),
          be(" " + re(S.value), 1)
        ]),
        Y("ul", R2, [
          Y("li", null, [
            G(rt, {
              appearance: "tertiary",
              "aria-label": "Go to the previous page",
              class: "pagination-button arrow",
              "data-testid": "previous-button",
              disabled: h.value,
              icon: "",
              size: "small",
              type: "button",
              onClick: U
            }, {
              default: L(() => [
                G(D(gg), {
                  class: "pagination-arrow-icon",
                  decorative: ""
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          !e.disablePageJump && F.value ? (m(), $("li", F2, [
            Y("button", {
              "aria-label": "Go to the first page",
              class: "pagination-button",
              "data-testid": "page-1-button",
              type: "button",
              onClick: J[0] || (J[0] = (q) => x(1))
            }, " 1 ")
          ])) : H("", !0),
          !e.disablePageJump && F.value ? (m(), $("li", z2, " ... ")) : H("", !0),
          (m(!0), $(Ee, null, Fe(O.value, (q) => (m(), $("li", { key: q }, [
            Y("button", {
              "aria-current": q == T.value && "page" || void 0,
              "aria-label": `Go to page ${q}`,
              class: ce(["pagination-button", { active: q == T.value }]),
              "data-testid": `page-${q}-button`,
              type: "button",
              onClick: (se) => x(q)
            }, re(q), 11, Y2)
          ]))), 128)),
          !e.disablePageJump && Z.value ? (m(), $("li", H2, " ... ")) : H("", !0),
          !e.disablePageJump && Z.value ? (m(), $("li", q2, [
            Y("button", {
              "aria-label": "Go to the last page",
              class: "pagination-button",
              "data-testid": "last-button",
              type: "button",
              onClick: J[1] || (J[1] = (q) => x(s.value))
            }, re(s.value), 1)
          ])) : H("", !0),
          Y("li", null, [
            G(rt, {
              appearance: "tertiary",
              "aria-label": "Go to the next page",
              class: "pagination-button arrow",
              "data-testid": "next-button",
              disabled: g.value ? !0 : void 0,
              icon: "",
              size: "small",
              type: "button",
              onClick: z
            }, {
              default: L(() => [
                G(D(yg), {
                  class: "pagination-arrow-icon",
                  decorative: ""
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 64)),
      Y("div", W2, [
        !e.disablePageJump && !e.offset ? (m(), $("span", U2, [
          Y("span", K2, re(k.value), 1),
          be(" " + re(S.value), 1)
        ])) : H("", !0),
        G(Fr, {
          class: "page-size-dropdown",
          "data-testid": "page-size-dropdown",
          disabled: D(l).length <= 1,
          items: D(l),
          "kpop-attributes": a,
          "selection-menu": "",
          onChange: E
        }, {
          default: L(() => [
            G(rt, {
              appearance: "tertiary",
              class: "page-size-dropdown-trigger",
              "data-testid": "page-size-dropdown-trigger",
              disabled: D(l).length <= 1,
              size: "small",
              type: "button"
            }, {
              default: L(() => [
                be(re(c.value) + " ", 1),
                D(l).length > 1 ? (m(), X(D(zl), {
                  key: 0,
                  decorative: ""
                })) : H("", !0)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "items"])
      ])
    ], 2));
  }
}), Gl = /* @__PURE__ */ Pe(V2, [["__scopeId", "data-v-4c877fe6"]]), j2 = /* @__PURE__ */ oe({
  __name: "KCatalogItem",
  props: {
    item: {},
    truncate: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = t, n = (r) => {
      a("click", {
        evt: r,
        item: e.item
      });
    };
    return (r, i) => (m(), X(Vu, {
      class: "k-catalog-item",
      "data-testid": e.item && e.item.title ? `${e.item.title.replace(/[^0-9a-z]/gi, "-")}-catalog-item` : "catalog-item",
      role: "button",
      tabindex: "0",
      onClick: n
    }, {
      title: L(() => [
        W(r.$slots, "card-title", {}, () => [
          be(re(e.item ? e.item.title : ""), 1)
        ], !0)
      ]),
      actions: L(() => [
        W(r.$slots, "card-actions", {}, void 0, !0)
      ]),
      footer: L(() => [
        W(r.$slots, "card-footer", {}, void 0, !0)
      ]),
      default: L(() => [
        Y("div", {
          class: ce({ "multi-line-truncate": e.truncate })
        }, [
          W(r.$slots, "card-body", {}, () => [
            be(re(e.item ? e.item.description : ""), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["data-testid"]));
  }
}), Hg = /* @__PURE__ */ Pe(j2, [["__scopeId", "data-v-fd663621"]]), G2 = { class: "k-catalog" }, Q2 = {
  key: 1,
  class: "catalog-toolbar",
  "data-testid": "catalog-toolbar"
}, Z2 = {
  key: 3,
  class: "catalog-error-state",
  "data-testid": "catalog-error-state"
}, X2 = {
  key: 4,
  class: "catalog-empty-state",
  "data-testid": "catalog-empty-state"
}, J2 = ["data-tableid"], zd = 15, _2 = /* @__PURE__ */ oe({
  __name: "KCatalog",
  props: {
    titleTag: { default: "div" },
    loading: { type: Boolean },
    cardSize: { default: "medium" },
    title: { default: "" },
    truncateDescription: { type: Boolean, default: !0 },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: { default: "" },
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: "default" },
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: { default: "" },
    errorStateActionMessage: { default: "" },
    fetcher: { type: Function },
    initialFetcherParams: { default: null },
    cacheIdentifier: { default: "" },
    fetcherCacheKey: { default: "" },
    searchInput: { default: "" },
    paginationNeighbors: { default: 1 },
    paginationPageSizes: { default: () => [15, 30, 50, 75, 100] },
    paginationTotalItems: { default: null },
    disablePaginationPageJump: { type: Boolean },
    disablePagination: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    paginationOffset: { type: Boolean }
  },
  emits: ["card-click", "error-action-click", "empty-state-action-click", "update:catalog-preferences", "state"],
  setup(e, { emit: t }) {
    const { useRequest: a, useDebounce: n, useSwrvState: r } = Bn(), i = t, o = $t(), u = yt(), s = () => {
      var me;
      const pe = (me = e.paginationPageSizes) == null ? void 0 : me[0];
      return pe || zd;
    }, l = N([]), c = N(0), d = N(""), f = N(1), v = N(s()), y = N(null), C = N([]), h = b(() => C.value[f.value - 1]), g = N(null), p = N(!0), w = N(!1), k = b(() => !!o.toolbar), S = {
      page: 1,
      pageSize: v.value,
      query: "",
      offset: null
    }, T = b(() => (ae.value || e.loading || et.value) && !e.error), A = b(() => !T.value && l.value && !l.value.length), F = b(() => ({
      pageSize: v.value
    })), Z = N(!0), O = async () => {
      var me, he;
      const pe = await e.fetcher({
        query: e.searchInput || d.value,
        pageSize: v.value,
        page: f.value,
        offset: y.value
      });
      if (pe == null)
        throw new Error("KCatalog: Fetcher did not return data correctly.");
      return l.value = pe.data, c.value = e.paginationTotalItems || pe.total || ((me = pe.data) == null ? void 0 : me.length), e.paginationOffset && ((he = pe.pagination) != null && he.offset ? (g.value = pe.pagination.offset, C.value[f.value] || C.value.push(pe.pagination.offset)) : g.value = null, p.value = pe.pagination && "hasNextPage" in pe.pagination ? !!pe.pagination.hasNextPage : !0), l.value.length === 0 && f.value > 1 && (f.value = 1, C.value = [null], y.value = null), Z.value = !1, pe;
    }, z = () => {
      const pe = {
        ...S,
        ...e.initialFetcherParams
      };
      f.value = pe.page ?? S.page, v.value = pe.pageSize ?? S.pageSize, d.value = pe.query ?? S.query, e.paginationOffset && (y.value = pe.offset, C.value.push(pe.offset)), w.value = !0;
    }, U = b(() => {
      if (!e.fetcher || !w.value)
        return "";
      let pe = u;
      return e.cacheIdentifier && (pe = e.cacheIdentifier), e.fetcherCacheKey && (pe += `-${e.fetcherCacheKey}`), `k-catalog_${pe}`;
    }), x = N(""), { debouncedFn: I, generateDebouncedFn: E } = n((pe) => {
      x.value = pe;
    }, 350), P = E(0), { data: R, error: K, revalidate: J, isValidating: q } = a(
      () => U.value,
      () => O(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: se, hasData: fe, swrvState: ne } = r(R, K, q), ae = N(!0), ve = b(() => ({
      hasData: fe.value,
      state: se.value
    })), Ae = b(() => ae.value ? "loading" : K.value ? "error" : "success"), Te = ({ page: pe }) => {
      f.value = pe;
    }, Le = ({ pageSize: pe }) => {
      C.value = [null], y.value = null, v.value = pe, f.value = 1;
    }, ze = () => {
      f.value++, y.value = g.value;
    }, _e = () => {
      f.value--, y.value = h.value;
    }, tt = (pe) => pe.toLowerCase().replace(/[^[a-z0-9]/gi, "-"), Xe = b(() => {
      var me;
      if (!e.fetcher || e.disablePagination || !l.value || !l.value.length || e.error)
        return !1;
      const pe = ((me = e.paginationPageSizes) == null ? void 0 : me[0]) ?? zd;
      return e.hidePaginationWhenOptional && f.value === 1 ? e.paginationOffset ? !!h.value || !!g.value || l.value.length >= pe : c.value > pe : !0;
    });
    ie(R, (pe) => {
      pe != null && pe.length && !l.value.length && (l.value = pe);
    }, { deep: !0, immediate: !0 }), ie(se, () => {
      switch (se.value) {
        case ne.PENDING:
          ae.value = !0;
          break;
        case ne.VALIDATING_HAS_DATA:
          ae.value = et.value;
          break;
        default:
          ae.value = !1;
          break;
      }
    }, { immediate: !0 }), ie([ve, Ae], (pe) => {
      var me;
      i("state", {
        state: pe == null ? void 0 : pe[1],
        // newData[catalogState]
        hasData: (me = pe == null ? void 0 : pe[0]) == null ? void 0 : me.hasData
        // newData[stateData].hasData
      });
    }), ie(() => e.searchInput, (pe) => {
      f.value !== 1 && (f.value = 1), pe === "" ? P(pe) : I(pe);
    }, { immediate: !0 });
    const et = N(!1);
    return ie([x, f, v], async (pe, me) => {
      const he = me == null ? void 0 : me[0], V = pe[0], Se = pe[1];
      V !== he && Se !== 1 && (f.value = 1, C.value = [null], y.value = null), w.value && !Z.value && (et.value = !0, await J(), et.value = !1);
    }, { deep: !0, immediate: !0 }), ie(F, (pe) => {
      i("update:catalog-preferences", pe);
    }), it(() => {
      z();
    }), (pe, me) => (m(), $("div", G2, [
      e.title ? (m(), X(Ye(e.titleTag), {
        key: 0,
        class: "catalog-title",
        "data-testid": "catalog-title"
      }, {
        default: L(() => [
          be(re(e.title), 1)
        ]),
        _: 1
      })) : H("", !0),
      k.value ? (m(), $("div", Q2, [
        W(pe.$slots, "toolbar", { state: ve.value }, void 0, !0)
      ])) : H("", !0),
      T.value ? (m(), X(jl, {
        key: 2,
        "card-count": 4,
        class: "catalog-skeleton-loader",
        "data-testid": "catalog-skeleton-loader",
        type: "card"
      })) : e.error ? (m(), $("div", Z2, [
        W(pe.$slots, "error-state", {}, () => [
          G(_n, {
            "icon-variant": "error",
            message: e.errorStateMessage,
            title: e.errorStateTitle
          }, kt({ _: 2 }, [
            e.errorStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  "data-testid": tt(e.errorStateActionMessage),
                  to: e.errorStateActionRoute ? e.errorStateActionRoute : void 0,
                  onClick: me[0] || (me[0] = (he) => i("error-action-click"))
                }, {
                  default: L(() => [
                    be(re(e.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : A.value ? (m(), $("div", X2, [
        W(pe.$slots, "empty-state", {}, () => [
          G(_n, {
            "icon-variant": e.emptyStateIconVariant,
            message: e.emptyStateMessage,
            title: e.emptyStateTitle
          }, kt({ _: 2 }, [
            e.emptyStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  appearance: e.searchInput ? "tertiary" : "primary",
                  "data-testid": tt(e.emptyStateActionMessage),
                  to: e.emptyStateActionRoute ? e.emptyStateActionRoute : void 0,
                  onClick: me[1] || (me[1] = (he) => i("empty-state-action-click"))
                }, {
                  default: L(() => [
                    W(pe.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + re(e.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (m(), $("div", {
        key: 5,
        class: ce(["catalog-page", `card-${e.cardSize}`]),
        "data-tableid": D(u)
      }, [
        W(pe.$slots, "body", { data: l.value }, () => [
          (m(!0), $(Ee, null, Fe(l.value, (he, V) => (m(), X(Hg, {
            key: he.key ? he.key : `catalog-${D(u)}-item-${V}`,
            class: "catalog-item",
            "data-testid": he.id ? he.id : `catalog-item-${V}`,
            item: he,
            truncate: e.truncateDescription,
            onClick: (Se) => i("card-click", he)
          }, {
            "card-title": L(() => [
              W(pe.$slots, "card-title", { item: he }, () => [
                be(re(he.title), 1)
              ], !0)
            ]),
            "card-actions": L(() => [
              W(pe.$slots, "card-actions", { item: he }, void 0, !0)
            ]),
            "card-body": L(() => [
              W(pe.$slots, "card-body", { item: he }, () => [
                be(re(he.description), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["data-testid", "item", "truncate", "onClick"]))), 128))
        ], !0)
      ], 10, J2)),
      Xe.value ? (m(), X(Gl, {
        key: 6,
        class: "card-pagination",
        "current-page": f.value,
        "data-testid": "catalog-pagination",
        "disable-page-jump": e.disablePaginationPageJump,
        "initial-page-size": v.value,
        neighbors: e.paginationNeighbors,
        offset: e.paginationOffset,
        "offset-next-button-disabled": !g.value || !p.value,
        "offset-previous-button-disabled": !h.value,
        "page-sizes": e.paginationPageSizes,
        "total-count": c.value,
        onGetNextOffset: ze,
        onGetPreviousOffset: _e,
        onPageChange: Te,
        onPageSizeChange: Le
      }, null, 8, ["current-page", "disable-page-jump", "initial-page-size", "neighbors", "offset", "offset-next-button-disabled", "offset-previous-button-disabled", "page-sizes", "total-count"])) : H("", !0)
    ]));
  }
}), ew = /* @__PURE__ */ Pe(_2, [["__scopeId", "data-v-2935e34d"]]), tw = /* @__PURE__ */ oe({
  __name: "KLabel",
  props: {
    info: { default: "" },
    required: { type: Boolean },
    tooltipAttributes: { default: () => ({}) },
    help: { default: "" }
  },
  setup(e) {
    ie(() => e.help, (s) => {
      s && console.warn("KLabel: `help` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { immediate: !0 });
    const t = $t(), a = b(() => !!(e.help || e.info || t.tooltip)), n = yt(), r = dt("label"), i = [
      /* interactive content */
      "a[href]",
      "audio[controls]",
      "button",
      "details",
      "embed",
      "iframe",
      "img[usemap]",
      'input:not([type="hidden"])',
      "label",
      "select",
      "textarea",
      "video[controls]",
      /* elements having their own activation behavior */
      // 'a[href]' - already included in interactive content
      "area[href]"
      // 'summary', - already covered as child of details
    ].join(", ");
    function o(s) {
      return s.closest(i);
    }
    function u(s) {
      const l = s.target, c = o(l);
      c && c !== r.value || s.preventDefault();
    }
    return (s, l) => (m(), $("label", {
      ref: "label",
      class: ce(["k-label", { required: e.required }])
    }, [
      W(s.$slots, "default", {}, void 0, !0),
      a.value ? (m(), X(ba, Re({ key: 0 }, e.tooltipAttributes, {
        class: "label-tooltip",
        "tooltip-id": D(n),
        onClick: u
      }), {
        content: L(() => [
          W(s.$slots, "tooltip", {}, () => [
            be(re(e.info || e.help), 1)
          ], !0)
        ]),
        default: L(() => [
          G(D(En), {
            "aria-describedby": D(n),
            class: "tooltip-trigger-icon",
            color: `var(--kui-color-text-neutral, ${D(Ya)})`,
            tabindex: "0"
          }, null, 8, ["aria-describedby", "color"])
        ]),
        _: 3
      }, 16, ["tooltip-id"])) : H("", !0)
    ], 2));
  }
}), Ka = /* @__PURE__ */ Pe(tw, [["__scopeId", "data-v-cabbe309"]]), aw = ["id", "aria-checked"], nw = { class: "checkbox-label-wrapper" }, rw = {
  key: 1,
  class: "checkbox-description"
}, iw = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KCheckbox",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    description: { default: "" },
    error: { type: Boolean, default: !1 }
  },
  emits: ["change", "input", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = $t(), r = na(), i = yt(), o = b(() => r.id ? String(r.id) : i), u = b(() => !!(e.label || n.default)), s = b(() => (r == null ? void 0 : r.disabled) !== void 0 && String(r == null ? void 0 : r.disabled) !== "false"), l = b(() => u.value && (!!e.description || !!n.description)), c = b(() => !!n.tooltip), d = b(() => {
      const C = { ...r };
      return delete C.class, C.checked = e.modelValue, C.indeterminate !== void 0 && String(C.indeterminate) !== "false" && !e.modelValue ? (delete C.checked, C.indeterminate = !0) : delete C.indeterminate, C;
    }), f = b(() => ({
      disabled: s.value,
      "has-description": l.value,
      "input-error": e.error
    })), v = b(() => d.value.indeterminate !== void 0 && String(d.value.indeterminate) !== "false");
    ie(() => e.labelAttributes, (C) => {
      C.help && console.warn("KCheckbox: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { immediate: !0 });
    const y = (C) => {
      a("change", C.target.checked), a("input", C.target.checked), a("update:modelValue", C.target.checked);
    };
    return (C, h) => (m(), $("div", {
      class: ce(["k-checkbox", [C.$attrs.class, f.value]])
    }, [
      Y("div", {
        class: ce(["checkbox-input-wrapper", { "has-label": u.value }])
      }, [
        Y("input", Re({ id: o.value }, d.value, {
          "aria-checked": e.modelValue,
          class: "checkbox-input",
          type: "checkbox",
          onChange: y
        }), null, 16, aw),
        e.modelValue ? (m(), X(D(ry), {
          key: 0,
          class: "checkbox-icon",
          "data-testid": "check-icon",
          decorative: "",
          size: D(Qt),
          tabindex: "-1"
        }, null, 8, ["size"])) : H("", !0),
        v.value && !e.modelValue ? (m(), X(D(xy), {
          key: 1,
          class: "checkbox-icon",
          "data-testid": "indeterminate-icon",
          decorative: "",
          size: D(Qt),
          tabindex: "-1"
        }, null, 8, ["size"])) : H("", !0)
      ], 2),
      Y("div", nw, [
        u.value ? (m(), X(Ka, Re({ key: 0 }, e.labelAttributes, {
          class: "checkbox-label",
          for: o.value
        }), kt({
          default: L(() => [
            W(C.$slots, "default", {}, () => [
              be(re(e.label), 1)
            ], !0)
          ]),
          _: 2
        }, [
          c.value ? {
            name: "tooltip",
            fn: L(() => [
              W(C.$slots, "tooltip", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["for"])) : H("", !0),
        l.value ? (m(), $("div", rw, [
          W(C.$slots, "description", {}, () => [
            Y("p", null, re(e.description), 1)
          ], !0)
        ])) : H("", !0)
      ])
    ], 2));
  }
}), sl = /* @__PURE__ */ Pe(iw, [["__scopeId", "data-v-a6d9ed7c"]]), Or = null, { min: Pr, max: tn, abs: Yd, floor: ow } = Math, qg = (e, t, a) => Pr(a, tn(t, e)), Wg = (e) => [...e].sort(((t, a) => t - a)), lw = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
}, ru = () => {
  let e;
  return [new Promise(((t) => {
    e = t;
  })), e];
}, Qu = (e) => {
  let t;
  return () => (e && (t = e(), e = void 0), t);
}, ul = (e, t, a) => {
  const n = a ? "unshift" : "push";
  for (let r = 0; r < t; r++) e[n](-1);
  return e;
}, cl = (e, t) => {
  const a = e.t[t];
  return a === -1 ? e.o : a;
}, sw = (e, t, a) => {
  const n = e.t[t] === -1;
  return e.t[t] = a, e.i = Pr(t, e.i), n;
}, qo = (e, t) => {
  if (!e.l) return 0;
  if (e.i >= t) return e.u[t];
  e.i < 0 && (e.u[0] = 0, e.i = 0);
  let a = e.i, n = e.u[a];
  for (; a < t; ) n += cl(e, a), e.u[++a] = n;
  return e.i = t, n;
}, zn = (e, t, a = 0, n = e.l - 1) => {
  for (; a <= n; ) {
    const r = ow((a + n) / 2), i = qo(e, r);
    if (i <= t) {
      if (i + cl(e, r) > t) return r;
      a = r + 1;
    } else n = r - 1;
  }
  return qg(a, 0, e.l - 1);
}, Hd = (e, t, a) => {
  const n = t - e.l;
  return e.i = a ? -1 : Pr(t - 1, e.i), e.l = t, n > 0 ? (ul(e.u, n), ul(e.t, n, a), e.o * n) : (e.u.splice(n), (a ? e.t.splice(0, -n) : e.t.splice(n)).reduce(((r, i) => r - (i === -1 ? e.o : i)), 0));
}, uw = typeof window < "u", Ug = () => document.documentElement, cw = (e) => e.ownerDocument, dw = (e) => e.defaultView, Kg = /* @__PURE__ */ Qu((() => !!uw && getComputedStyle(Ug()).direction === "rtl")), Vg = /* @__PURE__ */ Qu((() => !!/iP(hone|od|ad)/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0)), fw = /* @__PURE__ */ Qu((() => "scrollBehavior" in Ug().style)), vw = (e, t = 40, a = 4, n = 0, r, i = !1) => {
  let o = !!n, u = 1, s = 0, l = 0, c = 0, d = 0, f = 0, v = 0, y = 0, C = 0, h = o ? [0, tn(n - 1, 0)] : Or, g = [0, 0], p = 0;
  const w = ((x, I) => ({ o: I, t: ul([], x), l: x, i: -1, u: ul([], x) }))(e, t), k = /* @__PURE__ */ new Set(), S = () => c - l, T = () => S() + f + d, A = (x) => ((I, E, P, R) => {
    if (R = Pr(R, I.l - 1), qo(I, R) <= E) {
      const K = zn(I, E + P, R);
      return [zn(I, E, R, K), K];
    }
    {
      const K = zn(I, E, void 0, R);
      return [K, zn(I, E + P, K)];
    }
  })(w, x, s, g[0]), F = () => ((x) => x.l ? qo(x, x.l - 1) + cl(x, x.l - 1) : 0)(w), Z = (x) => qo(w, x) - f, O = (x) => cl(w, x), z = (x, I = -1) => w.t[x] === I, U = (x) => {
    x && (Vg() && y !== 0 || h && C === 1 ? f += x : d += x);
  };
  return { p: () => u, m: () => ((x) => [x.t.slice(), x.o])(w), h: () => {
    let x, I;
    return v ? [x, I] = g : ([x, I] = g = A(tn(0, T())), h && (x = Pr(x, h[0]), I = tn(I, h[1]))), y !== 1 && (x -= tn(0, a)), y !== 2 && (I += tn(0, a)), [tn(x, 0), Pr(I, w.l - 1)];
  }, v: () => zn(w, T()), S: () => zn(w, T() + s), I: z, k: Z, O, j: () => w.l, T: () => c, q: () => y !== 0, B: () => s, M: () => l, N: F, P: () => (v = d, d = 0, [v, C === 2]), R: (x, I) => {
    const E = [x, I];
    return k.add(E), () => {
      k.delete(E);
    };
  }, A: (x, I) => {
    let E, P, R = 0;
    switch (x) {
      case 1: {
        const K = v;
        v = 0;
        const J = I - c, q = Yd(J);
        K && q < Yd(K) + 1 || C !== 0 || (y = J < 0 ? 2 : 1), o && (h = Or, o = !1), c = I, R = 4;
        const se = S();
        se >= -s && se <= F() && (R += 1, P = q > s);
        break;
      }
      case 2:
        R = 8, y !== 0 && (E = !0, R += 1), y = 0, C = 0, h = Or;
        break;
      case 3: {
        const K = I.filter((([J, q]) => !z(J, q)));
        if (!K.length) break;
        U(K.reduce(((J, [q, se]) => ((C === 2 || (h && C === 1 ? q < h[0] : Z(q) + (y === 0 && C === 0 ? O(q) : 0) < S())) && (J += se - O(q)), J)), 0));
        for (const [J, q] of K) {
          const se = O(J), fe = sw(w, J, q);
          i && (p += fe ? q : q - se);
        }
        i && s && p > s && (U(((J, q) => {
          let se = 0;
          const fe = [];
          J.t.forEach(((Le, ze) => {
            Le !== -1 && (fe.push(Le), ze < q && se++);
          })), J.i = -1;
          const ne = Wg(fe), ae = ne.length, ve = ae / 2 | 0, Ae = ae % 2 == 0 ? (ne[ve - 1] + ne[ve]) / 2 : ne[ve], Te = J.o;
          return ((J.o = Ae) - Te) * tn(q - se, 0);
        })(w, zn(w, T()))), i = !1), R = 3, P = !0;
        break;
      }
      case 4:
        s !== I && (s = I, R = 3);
        break;
      case 5:
        I[1] ? (U(Hd(w, I[0], !0)), C = 2, R = 1) : (Hd(w, I[0]), R = 1);
        break;
      case 6:
        l = I;
        break;
      case 7:
        C = 1;
        break;
      case 8:
        h = A(I), R = 1;
    }
    R && (u = 1 + (2147483647 & u), E && f && (d += f, f = 0), k.forEach((([K, J]) => {
      R & K && J(P);
    })));
  } };
}, Zu = setTimeout, iu = (e, t) => t && Kg() ? -e : e, hw = (e, t, a, n, r, i) => {
  const o = Date.now;
  let u = 0, s = !1, l = !1, c = !1, d = !1;
  const f = (() => {
    let g;
    const p = () => {
      g != Or && clearTimeout(g);
    }, w = () => {
      p(), g = Zu((() => {
        g = Or, (() => {
          if (s || l) return s = !1, void f();
          c = !1, e.A(2);
        })();
      }), 150);
    };
    return w.H = p, w;
  })(), v = () => {
    u = o(), c && (d = !0), e.A(1, n()), f();
  }, y = (g) => {
    if (s || !e.q() || g.ctrlKey) return;
    const p = o() - u;
    150 > p && 50 < p && (a ? g.deltaX : g.deltaY) && (s = !0);
  }, C = () => {
    l = !0, c = d = !1;
  }, h = () => {
    l = !1, Vg() && (c = !0);
  };
  return t.addEventListener("scroll", v), t.addEventListener("wheel", y, { passive: !0 }), t.addEventListener("touchstart", C, { passive: !0 }), t.addEventListener("touchend", h, { passive: !0 }), { V: () => {
    t.removeEventListener("scroll", v), t.removeEventListener("wheel", y), t.removeEventListener("touchstart", C), t.removeEventListener("touchend", h), f.H();
  }, C: () => {
    const [g, p] = e.P();
    g && (r(iu(g, a), p, d), d = !1, p && e.B() > e.N() && e.A(1, n()));
  } };
}, gw = (e, t, a) => {
  let n;
  return [async (r, i) => {
    if (!await t()) return;
    n && n();
    const o = () => {
      const [u, s] = ru();
      return n = () => {
        s(!1);
      }, e.B() && Zu(n, 150), [u, e.R(2, (() => {
        s(!0);
      }))];
    };
    if (i && fw()) e.A(8, r()), lw((async () => {
      for (; ; ) {
        let u = !0;
        for (let [c, d] = e.h(); c <= d; c++) if (e.I(c)) {
          u = !1;
          break;
        }
        if (u) break;
        const [s, l] = o();
        try {
          if (!await s) return;
        } finally {
          l();
        }
      }
      e.A(7), a(r(), i);
    }));
    else for (; ; ) {
      const [u, s] = o();
      try {
        if (e.A(7), a(r()), !await u) return;
      } finally {
        s();
      }
    }
  }, () => {
    n && n();
  }];
}, mw = (e) => {
  let t;
  return { F(a) {
    (t || (t = new (dw(cw(a))).ResizeObserver(e))).observe(a);
  }, J(a) {
    t.unobserve(a);
  }, V() {
    t && t.disconnect();
  } };
}, pw = /* @__PURE__ */ oe({ props: { L: { type: Object, required: !0 }, W: { type: Object, required: !0 }, X: { type: Object, required: !0 }, Y: { type: Function, required: !0 }, D: { type: Number, required: !0 }, U: { type: Boolean }, G: { type: Boolean }, K: { type: String, required: !0 }, Z: Object }, setup(e) {
  const t = N(), a = b((() => e.L.value && e.W.k(e.D))), n = b((() => e.L.value && e.W.I(e.D)));
  return ie((() => t.value && e.D), ((r, i, o) => {
    o(e.Y(t.value, e.D));
  }), { flush: "post" }), () => {
    var r;
    const { X: i, U: o, G: u, K: s } = e, l = n.value, { style: c, ...d } = (r = e.Z) !== null && r !== void 0 ? r : {}, f = { contain: "layout style", position: l && u ? void 0 : "absolute", [o ? "height" : "width"]: "100%", [o ? "top" : "left"]: "0px", [o ? Kg() ? "right" : "left" : "top"]: a.value + "px", visibility: !l || u ? "visible" : "hidden", ...c };
    return o && (f.display = "inline-flex"), G(s, Re({ ref: t, style: f }, d), typeof (v = i) == "function" || Object.prototype.toString.call(v) === "[object Object]" && !sg(v) ? i : { default: () => [i], _: 2 }, 16, ["style"]);
    var v;
  };
} }), yw = (e, t) => {
  const a = e.key;
  return a ?? "_" + t;
}, bw = (e, t) => e[0] === t[0] && e[1] === t[1], qd = /* @__PURE__ */ oe({ props: { data: { type: Array, required: !0 }, overscan: Number, itemSize: Number, shift: Boolean, horizontal: Boolean, startMargin: { type: Number, default: 0 }, ssrCount: Number, scrollRef: Object, as: { type: String, default: "div" }, item: { type: String, default: "div" }, itemProps: Function, keepMounted: Array }, emits: ["scroll", "scrollEnd"], setup(e, { emit: t, expose: a, slots: n }) {
  let r = !!e.ssrCount;
  const i = e.horizontal, o = N(), u = vw(e.data.length, e.itemSize, e.overscan, e.ssrCount, 0, !e.itemSize), s = ((g, p) => {
    let w;
    const k = p ? "width" : "height", S = /* @__PURE__ */ new WeakMap(), T = mw(((A) => {
      const F = [];
      for (const { target: Z, contentRect: O } of A) if (Z.offsetParent) if (Z === w) g.A(4, O[k]);
      else {
        const z = S.get(Z);
        z != Or && F.push([z, O[k]]);
      }
      F.length && g.A(3, F);
    }));
    return { ee(A) {
      T.F(w = A);
    }, te: (A, F) => (S.set(A, F), T.F(A), () => {
      S.delete(A), T.J(A);
    }), oe: T.V };
  })(u, i), l = ((g, p) => {
    let w, k, S = ru();
    const T = p ? "scrollLeft" : "scrollTop", A = p ? "overflowX" : "overflowY", [F, Z] = gw(g, (() => S[0]), ((O, z) => {
      O = iu(O, p), z ? w.scrollTo({ [p ? "left" : "top"]: O, behavior: "smooth" }) : w[T] = O;
    }));
    return { re(O) {
      w = O, k = hw(g, O, p, (() => iu(O[T], p)), ((z, U, x) => {
        if (x) {
          const I = O.style, E = I[A];
          I[A] = "hidden", Zu((() => {
            I[A] = E;
          }));
        }
        O[T] = g.T() + z, U && Z();
      })), S[1](!0);
    }, oe() {
      k && k.V(), S[1](!1), S = ru();
    }, ne(O) {
      F((() => O));
    }, se(O) {
      O += g.T(), F((() => O));
    }, ie(O, { align: z, smooth: U, offset: x = 0 } = {}) {
      if (O = qg(O, 0, g.j() - 1), z === "nearest") {
        const I = g.k(O), E = g.T();
        if (I < E) z = "start";
        else {
          if (!(I + g.O(O) > E + g.B())) return;
          z = "end";
        }
      }
      F((() => x + g.M() + g.k(O) + (z === "end" ? g.O(O) - g.B() : z === "center" ? (g.O(O) - g.B()) / 2 : 0)), U);
    }, le: () => {
      k && k.C();
    } };
  })(u, i), c = N(u.p()), d = u.R(1, (() => {
    c.value = u.p();
  })), f = u.R(4, (() => {
    t("scroll", u.T());
  })), v = u.R(8, (() => {
    t("scrollEnd");
  })), y = b(((g) => {
    c.value;
    const p = u.h();
    return g && bw(g, p) ? g : p;
  })), C = b((() => c.value && u.q())), h = b((() => c.value && u.N()));
  return it((() => {
    r = !1;
    const g = requestAnimationFrame((() => {
      const p = (w) => {
        s.ee(w), l.re(w);
      };
      e.scrollRef ? p(e.scrollRef) : p(o.value.parentElement);
    }));
    ya((() => {
      cancelAnimationFrame(g);
    }));
  })), ya((() => {
    d(), f(), v(), s.oe(), l.oe();
  })), ie((() => e.data.length), ((g) => {
    u.A(5, [g, e.shift]);
  })), ie((() => e.startMargin), ((g) => {
    u.A(6, g);
  }), { immediate: !0 }), ie([c], (() => {
    l.le();
  }), { flush: "post" }), a({ get scrollOffset() {
    return u.T();
  }, get scrollSize() {
    return ((g) => tn(g.N(), g.B()))(u);
  }, get viewportSize() {
    return u.B();
  }, findStartIndex: u.v, findEndIndex: u.S, getItemOffset: u.k, getItemSize: u.O, scrollToIndex: l.ie, scrollTo: l.ne, scrollBy: l.se }), () => {
    const g = e.as, p = e.item, w = h.value, k = [], S = (A) => {
      var F;
      const Z = n.default({ item: e.data[A], index: A })[0];
      return G(pw, { key: yw(Z, A), L: c, W: u, Y: s.te, D: A, X: Z, U: i, G: r, K: p, Z: (F = e.itemProps) === null || F === void 0 ? void 0 : F.call(e, { item: e.data[A], index: A }) }, null, 8, ["L", "W", "Y", "D", "X", "U", "G", "K", "Z"]);
    };
    if (e.keepMounted) {
      const A = new Set(e.keepMounted);
      for (let [F, Z] = y.value; F <= Z; F++) A.add(F);
      Wg([...A]).forEach(((F) => {
        k.push(S(F));
      }));
    } else for (let [A, F] = y.value; A <= F; A++) k.push(S(A));
    return G(g, { ref: o, style: { contain: "size paint style", overflowAnchor: "none", overflow: "clip", flex: "none", position: "relative", width: i ? w + "px" : "100%", height: i ? "100%" : w + "px", pointerEvents: C.value ? "none" : void 0 } }, typeof (T = k) == "function" || Object.prototype.toString.call(T) === "[object Object]" && !sg(T) ? k : { default: () => [k], _: 2 }, 8, ["style"]);
    var T;
  };
} });
var jg = typeof global == "object" && global && global.Object === Object && global, ww = typeof self == "object" && self && self.Object === Object && self, Va = jg || ww || Function("return this")(), Pn = Va.Symbol, Gg = Object.prototype, Cw = Gg.hasOwnProperty, kw = Gg.toString, ri = Pn ? Pn.toStringTag : void 0;
function $w(e) {
  var t = Cw.call(e, ri), a = e[ri];
  try {
    e[ri] = void 0;
    var n = !0;
  } catch {
  }
  var r = kw.call(e);
  return n && (t ? e[ri] = a : delete e[ri]), r;
}
var Sw = Object.prototype, xw = Sw.toString;
function Tw(e) {
  return xw.call(e);
}
var Dw = "[object Null]", Aw = "[object Undefined]", Wd = Pn ? Pn.toStringTag : void 0;
function Gr(e) {
  return e == null ? e === void 0 ? Aw : Dw : Wd && Wd in Object(e) ? $w(e) : Tw(e);
}
function zr(e) {
  return e != null && typeof e == "object";
}
var Iw = "[object Symbol]";
function Ql(e) {
  return typeof e == "symbol" || zr(e) && Gr(e) == Iw;
}
function Qg(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = Array(n); ++a < n; )
    r[a] = t(e[a], a, e);
  return r;
}
var on = Array.isArray, Ud = Pn ? Pn.prototype : void 0, Kd = Ud ? Ud.toString : void 0;
function Zg(e) {
  if (typeof e == "string")
    return e;
  if (on(e))
    return Qg(e, Zg) + "";
  if (Ql(e))
    return Kd ? Kd.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Ew = /\s/;
function Mw(e) {
  for (var t = e.length; t-- && Ew.test(e.charAt(t)); )
    ;
  return t;
}
var Ow = /^\s+/;
function Pw(e) {
  return e && e.slice(0, Mw(e) + 1).replace(Ow, "");
}
function ln(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Vd = NaN, Nw = /^[-+]0x[0-9a-f]+$/i, Lw = /^0b[01]+$/i, Bw = /^0o[0-7]+$/i, Rw = parseInt;
function jd(e) {
  if (typeof e == "number")
    return e;
  if (Ql(e))
    return Vd;
  if (ln(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ln(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Pw(e);
  var a = Lw.test(e);
  return a || Bw.test(e) ? Rw(e.slice(2), a ? 2 : 8) : Nw.test(e) ? Vd : +e;
}
function Fw(e) {
  return e;
}
var zw = "[object AsyncFunction]", Yw = "[object Function]", Hw = "[object GeneratorFunction]", qw = "[object Proxy]";
function Xg(e) {
  if (!ln(e))
    return !1;
  var t = Gr(e);
  return t == Yw || t == Hw || t == zw || t == qw;
}
var ys = Va["__core-js_shared__"], Gd = (function() {
  var e = /[^.]+$/.exec(ys && ys.keys && ys.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function Ww(e) {
  return !!Gd && Gd in e;
}
var Uw = Function.prototype, Kw = Uw.toString;
function sr(e) {
  if (e != null) {
    try {
      return Kw.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Vw = /[\\^$.*+?()[\]{}|]/g, jw = /^\[object .+?Constructor\]$/, Gw = Function.prototype, Qw = Object.prototype, Zw = Gw.toString, Xw = Qw.hasOwnProperty, Jw = RegExp(
  "^" + Zw.call(Xw).replace(Vw, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function _w(e) {
  if (!ln(e) || Ww(e))
    return !1;
  var t = Xg(e) ? Jw : jw;
  return t.test(sr(e));
}
function eC(e, t) {
  return e == null ? void 0 : e[t];
}
function ur(e, t) {
  var a = eC(e, t);
  return _w(a) ? a : void 0;
}
var ou = ur(Va, "WeakMap"), Qd = (function() {
  try {
    var e = ur(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), tC = 9007199254740991, aC = /^(?:0|[1-9]\d*)$/;
function Xu(e, t) {
  var a = typeof e;
  return t = t ?? tC, !!t && (a == "number" || a != "symbol" && aC.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function Jg(e, t, a) {
  t == "__proto__" && Qd ? Qd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
function Ju(e, t) {
  return e === t || e !== e && t !== t;
}
var nC = Object.prototype, rC = nC.hasOwnProperty;
function iC(e, t, a) {
  var n = e[t];
  (!(rC.call(e, t) && Ju(n, a)) || a === void 0 && !(t in e)) && Jg(e, t, a);
}
var oC = 9007199254740991;
function _u(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= oC;
}
function _g(e) {
  return e != null && _u(e.length) && !Xg(e);
}
var lC = Object.prototype;
function em(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || lC;
  return e === a;
}
function sC(e, t) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = t(a);
  return n;
}
var uC = "[object Arguments]";
function Zd(e) {
  return zr(e) && Gr(e) == uC;
}
var tm = Object.prototype, cC = tm.hasOwnProperty, dC = tm.propertyIsEnumerable, am = Zd(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Zd : function(e) {
  return zr(e) && cC.call(e, "callee") && !dC.call(e, "callee");
};
function fC() {
  return !1;
}
var nm = typeof exports == "object" && exports && !exports.nodeType && exports, Xd = nm && typeof module == "object" && module && !module.nodeType && module, vC = Xd && Xd.exports === nm, Jd = vC ? Va.Buffer : void 0, hC = Jd ? Jd.isBuffer : void 0, lu = hC || fC, gC = "[object Arguments]", mC = "[object Array]", pC = "[object Boolean]", yC = "[object Date]", bC = "[object Error]", wC = "[object Function]", CC = "[object Map]", kC = "[object Number]", $C = "[object Object]", SC = "[object RegExp]", xC = "[object Set]", TC = "[object String]", DC = "[object WeakMap]", AC = "[object ArrayBuffer]", IC = "[object DataView]", EC = "[object Float32Array]", MC = "[object Float64Array]", OC = "[object Int8Array]", PC = "[object Int16Array]", NC = "[object Int32Array]", LC = "[object Uint8Array]", BC = "[object Uint8ClampedArray]", RC = "[object Uint16Array]", FC = "[object Uint32Array]", mt = {};
mt[EC] = mt[MC] = mt[OC] = mt[PC] = mt[NC] = mt[LC] = mt[BC] = mt[RC] = mt[FC] = !0;
mt[gC] = mt[mC] = mt[AC] = mt[pC] = mt[IC] = mt[yC] = mt[bC] = mt[wC] = mt[CC] = mt[kC] = mt[$C] = mt[SC] = mt[xC] = mt[TC] = mt[DC] = !1;
function zC(e) {
  return zr(e) && _u(e.length) && !!mt[Gr(e)];
}
function YC(e) {
  return function(t) {
    return e(t);
  };
}
var rm = typeof exports == "object" && exports && !exports.nodeType && exports, bi = rm && typeof module == "object" && module && !module.nodeType && module, HC = bi && bi.exports === rm, bs = HC && jg.process, _d = (function() {
  try {
    var e = bi && bi.require && bi.require("util").types;
    return e || bs && bs.binding && bs.binding("util");
  } catch {
  }
})(), ef = _d && _d.isTypedArray, im = ef ? YC(ef) : zC, qC = Object.prototype, WC = qC.hasOwnProperty;
function om(e, t) {
  var a = on(e), n = !a && am(e), r = !a && !n && lu(e), i = !a && !n && !r && im(e), o = a || n || r || i, u = o ? sC(e.length, String) : [], s = u.length;
  for (var l in e)
    (t || WC.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    Xu(l, s))) && u.push(l);
  return u;
}
function lm(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var UC = lm(Object.keys, Object), KC = Object.prototype, VC = KC.hasOwnProperty;
function jC(e) {
  if (!em(e))
    return UC(e);
  var t = [];
  for (var a in Object(e))
    VC.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
function ec(e) {
  return _g(e) ? om(e) : jC(e);
}
function GC(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var QC = Object.prototype, ZC = QC.hasOwnProperty;
function XC(e) {
  if (!ln(e))
    return GC(e);
  var t = em(e), a = [];
  for (var n in e)
    n == "constructor" && (t || !ZC.call(e, n)) || a.push(n);
  return a;
}
function JC(e) {
  return _g(e) ? om(e, !0) : XC(e);
}
var _C = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ek = /^\w*$/;
function tc(e, t) {
  if (on(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || Ql(e) ? !0 : ek.test(e) || !_C.test(e) || t != null && e in Object(t);
}
var Ii = ur(Object, "create");
function tk() {
  this.__data__ = Ii ? Ii(null) : {}, this.size = 0;
}
function ak(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var nk = "__lodash_hash_undefined__", rk = Object.prototype, ik = rk.hasOwnProperty;
function ok(e) {
  var t = this.__data__;
  if (Ii) {
    var a = t[e];
    return a === nk ? void 0 : a;
  }
  return ik.call(t, e) ? t[e] : void 0;
}
var lk = Object.prototype, sk = lk.hasOwnProperty;
function uk(e) {
  var t = this.__data__;
  return Ii ? t[e] !== void 0 : sk.call(t, e);
}
var ck = "__lodash_hash_undefined__";
function dk(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = Ii && t === void 0 ? ck : t, this;
}
function er(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
er.prototype.clear = tk;
er.prototype.delete = ak;
er.prototype.get = ok;
er.prototype.has = uk;
er.prototype.set = dk;
function fk() {
  this.__data__ = [], this.size = 0;
}
function Zl(e, t) {
  for (var a = e.length; a--; )
    if (Ju(e[a][0], t))
      return a;
  return -1;
}
var vk = Array.prototype, hk = vk.splice;
function gk(e) {
  var t = this.__data__, a = Zl(t, e);
  if (a < 0)
    return !1;
  var n = t.length - 1;
  return a == n ? t.pop() : hk.call(t, a, 1), --this.size, !0;
}
function mk(e) {
  var t = this.__data__, a = Zl(t, e);
  return a < 0 ? void 0 : t[a][1];
}
function pk(e) {
  return Zl(this.__data__, e) > -1;
}
function yk(e, t) {
  var a = this.__data__, n = Zl(a, e);
  return n < 0 ? (++this.size, a.push([e, t])) : a[n][1] = t, this;
}
function vn(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
vn.prototype.clear = fk;
vn.prototype.delete = gk;
vn.prototype.get = mk;
vn.prototype.has = pk;
vn.prototype.set = yk;
var Ei = ur(Va, "Map");
function bk() {
  this.size = 0, this.__data__ = {
    hash: new er(),
    map: new (Ei || vn)(),
    string: new er()
  };
}
function wk(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Xl(e, t) {
  var a = e.__data__;
  return wk(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
function Ck(e) {
  var t = Xl(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function kk(e) {
  return Xl(this, e).get(e);
}
function $k(e) {
  return Xl(this, e).has(e);
}
function Sk(e, t) {
  var a = Xl(this, e), n = a.size;
  return a.set(e, t), this.size += a.size == n ? 0 : 1, this;
}
function hn(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
hn.prototype.clear = bk;
hn.prototype.delete = Ck;
hn.prototype.get = kk;
hn.prototype.has = $k;
hn.prototype.set = Sk;
var xk = "Expected a function";
function ac(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(xk);
  var a = function() {
    var n = arguments, r = t ? t.apply(this, n) : n[0], i = a.cache;
    if (i.has(r))
      return i.get(r);
    var o = e.apply(this, n);
    return a.cache = i.set(r, o) || i, o;
  };
  return a.cache = new (ac.Cache || hn)(), a;
}
ac.Cache = hn;
var Tk = 500;
function Dk(e) {
  var t = ac(e, function(n) {
    return a.size === Tk && a.clear(), n;
  }), a = t.cache;
  return t;
}
var Ak = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Ik = /\\(\\)?/g, Ek = Dk(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(Ak, function(a, n, r, i) {
    t.push(r ? i.replace(Ik, "$1") : n || a);
  }), t;
});
function sm(e) {
  return e == null ? "" : Zg(e);
}
function Jl(e, t) {
  return on(e) ? e : tc(e, t) ? [e] : Ek(sm(e));
}
function Yi(e) {
  if (typeof e == "string" || Ql(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function nc(e, t) {
  t = Jl(t, e);
  for (var a = 0, n = t.length; e != null && a < n; )
    e = e[Yi(t[a++])];
  return a && a == n ? e : void 0;
}
function Mk(e, t, a) {
  var n = e == null ? void 0 : nc(e, t);
  return n === void 0 ? a : n;
}
function um(e, t) {
  for (var a = -1, n = t.length, r = e.length; ++a < n; )
    e[r + a] = t[a];
  return e;
}
var Ok = lm(Object.getPrototypeOf, Object);
function Pk() {
  this.__data__ = new vn(), this.size = 0;
}
function Nk(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
function Lk(e) {
  return this.__data__.get(e);
}
function Bk(e) {
  return this.__data__.has(e);
}
var Rk = 200;
function Fk(e, t) {
  var a = this.__data__;
  if (a instanceof vn) {
    var n = a.__data__;
    if (!Ei || n.length < Rk - 1)
      return n.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new hn(n);
  }
  return a.set(e, t), this.size = a.size, this;
}
function nn(e) {
  var t = this.__data__ = new vn(e);
  this.size = t.size;
}
nn.prototype.clear = Pk;
nn.prototype.delete = Nk;
nn.prototype.get = Lk;
nn.prototype.has = Bk;
nn.prototype.set = Fk;
function zk(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++a < n; ) {
    var o = e[a];
    t(o, a, e) && (i[r++] = o);
  }
  return i;
}
function cm() {
  return [];
}
var Yk = Object.prototype, Hk = Yk.propertyIsEnumerable, tf = Object.getOwnPropertySymbols, dm = tf ? function(e) {
  return e == null ? [] : (e = Object(e), zk(tf(e), function(t) {
    return Hk.call(e, t);
  }));
} : cm, qk = Object.getOwnPropertySymbols, Wk = qk ? function(e) {
  for (var t = []; e; )
    um(t, dm(e)), e = Ok(e);
  return t;
} : cm;
function fm(e, t, a) {
  var n = t(e);
  return on(e) ? n : um(n, a(e));
}
function af(e) {
  return fm(e, ec, dm);
}
function Uk(e) {
  return fm(e, JC, Wk);
}
var su = ur(Va, "DataView"), uu = ur(Va, "Promise"), cu = ur(Va, "Set"), nf = "[object Map]", Kk = "[object Object]", rf = "[object Promise]", of = "[object Set]", lf = "[object WeakMap]", sf = "[object DataView]", Vk = sr(su), jk = sr(Ei), Gk = sr(uu), Qk = sr(cu), Zk = sr(ou), Cn = Gr;
(su && Cn(new su(new ArrayBuffer(1))) != sf || Ei && Cn(new Ei()) != nf || uu && Cn(uu.resolve()) != rf || cu && Cn(new cu()) != of || ou && Cn(new ou()) != lf) && (Cn = function(e) {
  var t = Gr(e), a = t == Kk ? e.constructor : void 0, n = a ? sr(a) : "";
  if (n)
    switch (n) {
      case Vk:
        return sf;
      case jk:
        return nf;
      case Gk:
        return rf;
      case Qk:
        return of;
      case Zk:
        return lf;
    }
  return t;
});
var uf = Va.Uint8Array, Xk = "__lodash_hash_undefined__";
function Jk(e) {
  return this.__data__.set(e, Xk), this;
}
function _k(e) {
  return this.__data__.has(e);
}
function dl(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new hn(); ++t < a; )
    this.add(e[t]);
}
dl.prototype.add = dl.prototype.push = Jk;
dl.prototype.has = _k;
function e$(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length; ++a < n; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
function t$(e, t) {
  return e.has(t);
}
var a$ = 1, n$ = 2;
function vm(e, t, a, n, r, i) {
  var o = a & a$, u = e.length, s = t.length;
  if (u != s && !(o && s > u))
    return !1;
  var l = i.get(e), c = i.get(t);
  if (l && c)
    return l == t && c == e;
  var d = -1, f = !0, v = a & n$ ? new dl() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < u; ) {
    var y = e[d], C = t[d];
    if (n)
      var h = o ? n(C, y, d, t, e, i) : n(y, C, d, e, t, i);
    if (h !== void 0) {
      if (h)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!e$(t, function(g, p) {
        if (!t$(v, p) && (y === g || r(y, g, a, n, i)))
          return v.push(p);
      })) {
        f = !1;
        break;
      }
    } else if (!(y === C || r(y, C, a, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
function r$(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n, r) {
    a[++t] = [r, n];
  }), a;
}
function i$(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n) {
    a[++t] = n;
  }), a;
}
var o$ = 1, l$ = 2, s$ = "[object Boolean]", u$ = "[object Date]", c$ = "[object Error]", d$ = "[object Map]", f$ = "[object Number]", v$ = "[object RegExp]", h$ = "[object Set]", g$ = "[object String]", m$ = "[object Symbol]", p$ = "[object ArrayBuffer]", y$ = "[object DataView]", cf = Pn ? Pn.prototype : void 0, ws = cf ? cf.valueOf : void 0;
function b$(e, t, a, n, r, i, o) {
  switch (a) {
    case y$:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case p$:
      return !(e.byteLength != t.byteLength || !i(new uf(e), new uf(t)));
    case s$:
    case u$:
    case f$:
      return Ju(+e, +t);
    case c$:
      return e.name == t.name && e.message == t.message;
    case v$:
    case g$:
      return e == t + "";
    case d$:
      var u = r$;
    case h$:
      var s = n & o$;
      if (u || (u = i$), e.size != t.size && !s)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= l$, o.set(e, t);
      var c = vm(u(e), u(t), n, r, i, o);
      return o.delete(e), c;
    case m$:
      if (ws)
        return ws.call(e) == ws.call(t);
  }
  return !1;
}
var w$ = 1, C$ = Object.prototype, k$ = C$.hasOwnProperty;
function $$(e, t, a, n, r, i) {
  var o = a & w$, u = af(e), s = u.length, l = af(t), c = l.length;
  if (s != c && !o)
    return !1;
  for (var d = s; d--; ) {
    var f = u[d];
    if (!(o ? f in t : k$.call(t, f)))
      return !1;
  }
  var v = i.get(e), y = i.get(t);
  if (v && y)
    return v == t && y == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var h = o; ++d < s; ) {
    f = u[d];
    var g = e[f], p = t[f];
    if (n)
      var w = o ? n(p, g, f, t, e, i) : n(g, p, f, e, t, i);
    if (!(w === void 0 ? g === p || r(g, p, a, n, i) : w)) {
      C = !1;
      break;
    }
    h || (h = f == "constructor");
  }
  if (C && !h) {
    var k = e.constructor, S = t.constructor;
    k != S && "constructor" in e && "constructor" in t && !(typeof k == "function" && k instanceof k && typeof S == "function" && S instanceof S) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var S$ = 1, df = "[object Arguments]", ff = "[object Array]", Gi = "[object Object]", x$ = Object.prototype, vf = x$.hasOwnProperty;
function T$(e, t, a, n, r, i) {
  var o = on(e), u = on(t), s = o ? ff : Cn(e), l = u ? ff : Cn(t);
  s = s == df ? Gi : s, l = l == df ? Gi : l;
  var c = s == Gi, d = l == Gi, f = s == l;
  if (f && lu(e)) {
    if (!lu(t))
      return !1;
    o = !0, c = !1;
  }
  if (f && !c)
    return i || (i = new nn()), o || im(e) ? vm(e, t, a, n, r, i) : b$(e, t, s, a, n, r, i);
  if (!(a & S$)) {
    var v = c && vf.call(e, "__wrapped__"), y = d && vf.call(t, "__wrapped__");
    if (v || y) {
      var C = v ? e.value() : e, h = y ? t.value() : t;
      return i || (i = new nn()), r(C, h, a, n, i);
    }
  }
  return f ? (i || (i = new nn()), $$(e, t, a, n, r, i)) : !1;
}
function rc(e, t, a, n, r) {
  return e === t ? !0 : e == null || t == null || !zr(e) && !zr(t) ? e !== e && t !== t : T$(e, t, a, n, rc, r);
}
var D$ = 1, A$ = 2;
function I$(e, t, a, n) {
  var r = a.length, i = r;
  if (e == null)
    return !i;
  for (e = Object(e); r--; ) {
    var o = a[r];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++r < i; ) {
    o = a[r];
    var u = o[0], s = e[u], l = o[1];
    if (o[2]) {
      if (s === void 0 && !(u in e))
        return !1;
    } else {
      var c = new nn(), d;
      if (!(d === void 0 ? rc(l, s, D$ | A$, n, c) : d))
        return !1;
    }
  }
  return !0;
}
function hm(e) {
  return e === e && !ln(e);
}
function E$(e) {
  for (var t = ec(e), a = t.length; a--; ) {
    var n = t[a], r = e[n];
    t[a] = [n, r, hm(r)];
  }
  return t;
}
function gm(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
function M$(e) {
  var t = E$(e);
  return t.length == 1 && t[0][2] ? gm(t[0][0], t[0][1]) : function(a) {
    return a === e || I$(a, e, t);
  };
}
function O$(e, t) {
  return e != null && t in Object(e);
}
function P$(e, t, a) {
  t = Jl(t, e);
  for (var n = -1, r = t.length, i = !1; ++n < r; ) {
    var o = Yi(t[n]);
    if (!(i = e != null && a(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != r ? i : (r = e == null ? 0 : e.length, !!r && _u(r) && Xu(o, r) && (on(e) || am(e)));
}
function N$(e, t) {
  return e != null && P$(e, t, O$);
}
var L$ = 1, B$ = 2;
function R$(e, t) {
  return tc(e) && hm(t) ? gm(Yi(e), t) : function(a) {
    var n = Mk(a, e);
    return n === void 0 && n === t ? N$(a, e) : rc(t, n, L$ | B$);
  };
}
function F$(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function z$(e) {
  return function(t) {
    return nc(t, e);
  };
}
function Y$(e) {
  return tc(e) ? F$(Yi(e)) : z$(e);
}
function mm(e) {
  return typeof e == "function" ? e : e == null ? Fw : typeof e == "object" ? on(e) ? R$(e[0], e[1]) : M$(e) : Y$(e);
}
function H$(e) {
  return function(t, a, n) {
    for (var r = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var s = o[++r];
      if (a(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var q$ = H$();
function W$(e, t) {
  return e && q$(e, t, ec);
}
var Cs = function() {
  return Va.Date.now();
}, U$ = "Expected a function", K$ = Math.max, V$ = Math.min;
function j$(e, t, a) {
  var n, r, i, o, u, s, l = 0, c = !1, d = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(U$);
  t = jd(t) || 0, ln(a) && (c = !0, d = "maxWait" in a, i = d ? K$(jd(a.maxWait) || 0, t) : i, f = "trailing" in a ? !0 : f);
  function v(T) {
    var A = n, F = r;
    return n = r = void 0, l = T, o = e.apply(F, A), o;
  }
  function y(T) {
    return l = T, u = setTimeout(g, t), c ? v(T) : o;
  }
  function C(T) {
    var A = T - s, F = T - l, Z = t - A;
    return d ? V$(Z, i - F) : Z;
  }
  function h(T) {
    var A = T - s, F = T - l;
    return s === void 0 || A >= t || A < 0 || d && F >= i;
  }
  function g() {
    var T = Cs();
    if (h(T))
      return p(T);
    u = setTimeout(g, C(T));
  }
  function p(T) {
    return u = void 0, f && n ? v(T) : (n = r = void 0, o);
  }
  function w() {
    u !== void 0 && clearTimeout(u), l = 0, n = s = r = u = void 0;
  }
  function k() {
    return u === void 0 ? o : p(Cs());
  }
  function S() {
    var T = Cs(), A = h(T);
    if (n = arguments, r = this, s = T, A) {
      if (u === void 0)
        return y(s);
      if (d)
        return clearTimeout(u), u = setTimeout(g, t), v(s);
    }
    return u === void 0 && (u = setTimeout(g, t)), o;
  }
  return S.cancel = w, S.flush = k, S;
}
var pm = /[\\^$.*+?()[\]{}|]/g, G$ = RegExp(pm.source);
function Q$(e) {
  return e = sm(e), e && G$.test(e) ? e.replace(pm, "\\$&") : e;
}
function Z$(e, t) {
  var a = {};
  return t = mm(t), W$(e, function(n, r, i) {
    Jg(a, r, t(n, r, i));
  }), a;
}
function X$(e, t, a, n) {
  if (!ln(e))
    return e;
  t = Jl(t, e);
  for (var r = -1, i = t.length, o = i - 1, u = e; u != null && ++r < i; ) {
    var s = Yi(t[r]), l = a;
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return e;
    if (r != o) {
      var c = u[s];
      l = void 0, l === void 0 && (l = ln(c) ? c : Xu(t[r + 1]) ? [] : {});
    }
    iC(u, s, l), u = u[s];
  }
  return e;
}
function J$(e, t, a) {
  for (var n = -1, r = t.length, i = {}; ++n < r; ) {
    var o = t[n], u = nc(e, o);
    a(u, o) && X$(i, Jl(o, e), u);
  }
  return i;
}
function _$(e, t) {
  if (e == null)
    return {};
  var a = Qg(Uk(e), function(n) {
    return [n];
  });
  return t = mm(t), J$(e, a, function(n, r) {
    return t(n, r[0]);
  });
}
const eS = ["id", "aria-describedby", "aria-invalid", "type", "value"], tS = ["aria-label"], aS = ["id"], nS = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KInput",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    help: { default: "" },
    error: { type: Boolean },
    errorMessage: { default: "" },
    characterLimit: { default: null },
    hasError: { type: Boolean },
    type: { default: "text" },
    showPasswordMaskToggle: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "char-limit-exceeded"],
  setup(e, { expose: t, emit: a }) {
    Wt((P) => ({
      v468789b2: U.value,
      v3da179ce: x.value
    })), ie(() => e.hasError, (P) => {
      P && console.warn("KInput: `hasError` prop is deprecated. Please use `error` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kinput");
    }, { immediate: !0 }), ie(() => e.labelAttributes.help, (P) => {
      P && console.warn("KInput: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    });
    const n = a, r = $t(), i = dt("inputElement"), o = N(""), u = N(!1), s = N(0), { stripRequiredLabel: l } = Bn(), c = na(), d = b(() => (c == null ? void 0 : c.required) !== void 0 && String(c == null ? void 0 : c.required) !== "false"), f = yt(), v = b(() => c.id ? String(c.id) : f), y = yt(), C = b(() => l(e.label, d.value)), h = b(() => {
      var P;
      return !!((P = e.labelAttributes) != null && P.info || r["label-tooltip"]);
    }), g = b({
      get() {
        return e.modelValue;
      },
      set(P) {
        A({ target: { value: P } });
      }
    }), p = b(() => {
      const P = { ...c };
      return delete P.class, delete P.input, delete P.onInput, P;
    }), w = b(() => {
      var J, q;
      const P = ((J = o.value) == null ? void 0 : J.toString().length) || 0, R = ((q = e.modelValue) == null ? void 0 : q.toString().length) || 0;
      let K = P;
      return !u.value && R && (K = R), !!e.characterLimit && K > e.characterLimit;
    }), k = b(() => {
      var P, R;
      return w.value ? u.value ? `${(P = o.value) == null ? void 0 : P.toString().length} / ${e.characterLimit}` : `${(R = e.modelValue) == null ? void 0 : R.toString().length} / ${e.characterLimit}` : "";
    }), S = b(() => !w.value && !e.error && !e.hasError && !!(e.help || r.help)), T = b(() => w.value ? k.value : (e.error || e.hasError) && e.errorMessage ? e.errorMessage : e.help);
    ie(w, (P, R) => {
      P !== R && (n("char-limit-exceeded", {
        value: o.value,
        length: o.value.length,
        characterLimit: e.characterLimit,
        limitExceeded: P
      }), s.value += 1);
    }), ie(g, (P, R) => {
      P !== R && A({ target: { value: P } });
    });
    const A = (P) => {
      var K;
      const R = JSON.parse(JSON.stringify((K = P == null ? void 0 : P.target) == null ? void 0 : K.value));
      F(R);
    }, F = (P) => {
      o.value = P, u.value = !0, n("input", P), n("update:modelValue", P);
    }, Z = () => o.value || u.value ? o.value : e.modelValue;
    ie(() => e.error, (P, R) => {
      P !== R && (s.value += 1);
    });
    const O = N(null), z = N(null), U = N(Qt), x = N(Qt), I = N(!1), E = b(() => e.type === "password" && I.value ? "text" : e.type);
    return it(async () => {
      var P, R;
      await ht(), (P = O.value) != null && P.offsetWidth && (U.value = O.value.offsetWidth + "px"), (R = z.value) != null && R.offsetWidth && (x.value = z.value.offsetWidth + "px");
    }), t({
      input: i
    }), (P, R) => (m(), $("div", {
      class: ce(["k-input", [D(c).class, { "input-error": w.value || e.error || e.hasError }]])
    }, [
      e.label ? (m(), X(Ka, Re({
        key: 0,
        for: v.value
      }, e.labelAttributes, { required: d.value }), kt({
        default: L(() => [
          be(re(C.value) + " ", 1)
        ]),
        _: 2
      }, [
        h.value ? {
          name: "tooltip",
          fn: L(() => [
            W(P.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : H("", !0),
      Y("div", {
        class: ce(["input-element-wrapper", { "has-before-content": r.before, "has-after-content": r.after || e.type === "password" && e.showPasswordMaskToggle }])
      }, [
        r.before ? (m(), $("div", {
          key: 0,
          ref_key: "beforeSlotElement",
          ref: O,
          class: "before-content-wrapper"
        }, [
          W(P.$slots, "before", {}, void 0, !0)
        ], 512)) : H("", !0),
        Y("input", Re({
          id: v.value,
          ref: "inputElement",
          "aria-describedby": T.value || r.help ? D(y) : void 0,
          "aria-invalid": e.error || e.hasError || w.value ? "true" : void 0,
          class: "input",
          type: E.value
        }, p.value, {
          value: Z(),
          onInput: A
        }), null, 16, eS),
        r.after || e.type === "password" && e.showPasswordMaskToggle ? (m(), $("div", {
          key: 1,
          ref_key: "afterSlotElement",
          ref: z,
          class: "after-content-wrapper"
        }, [
          e.type === "password" && e.showPasswordMaskToggle ? (m(), $("button", {
            key: 0,
            "aria-label": `${I.value ? "Hide" : "Show"} value`,
            class: "mask-value-toggle-button",
            type: "button",
            onClick: R[0] || (R[0] = Ke((K) => I.value = !I.value, ["stop"])),
            onMousedown: R[1] || (R[1] = Ke(() => {
            }, ["prevent"])),
            onMouseup: R[2] || (R[2] = Ke(() => {
            }, ["prevent"]))
          }, [
            I.value ? (m(), X(D(Uy), {
              key: 0,
              decorative: ""
            })) : (m(), X(D(Vy), {
              key: 1,
              decorative: ""
            }))
          ], 40, tS)) : W(P.$slots, "after", { key: 1 }, void 0, !0)
        ], 512)) : H("", !0)
      ], 2),
      G(ea, {
        mode: "out-in",
        name: "kongponents-fade-transition"
      }, {
        default: L(() => [
          T.value || r.help ? (m(), $("p", {
            id: D(y),
            key: String(s.value),
            class: "help-text"
          }, [
            S.value ? W(P.$slots, "help", { key: 0 }, () => [
              be(re(T.value), 1)
            ], !0) : (m(), $(Ee, { key: 1 }, [
              be(re(T.value), 1)
            ], 64))
          ], 8, aS)) : H("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), Nn = /* @__PURE__ */ Pe(nS, [["__scopeId", "data-v-79d40ca1"]]), rS = ["ControlLeft", "ControlRight", "ShiftLeft", "ShiftRight", "AltLeft"];
class iS {
  constructor(t, a) {
    Ja(this, "commands");
    Ja(this, "keyMap");
    Ja(this, "boundTriggerShortcuts");
    this.commands = a, this.keyMap = Object.fromEntries(Object.entries(t).map(([n, r]) => [n.toLowerCase(), r])), this.boundTriggerShortcuts = this.triggerShortcuts.bind(this);
  }
  registerListener() {
    document == null || document.addEventListener("keydown", this.boundTriggerShortcuts);
  }
  unRegisterListener() {
    document == null || document.removeEventListener("keydown", this.boundTriggerShortcuts);
  }
  triggerShortcuts(t) {
    oS(t, this.keyMap, this.commands);
  }
}
function oS(e, t, a) {
  if (!e.code)
    return;
  const n = lS(e.code), r = [
    e.ctrlKey ? "ctrl" : "",
    e.shiftKey ? "shift" : "",
    e.altKey ? "alt" : "",
    n
  ].filter((u) => u !== "").join("+"), i = t[r];
  if (!i)
    return;
  const o = a[i];
  o.isAllowedContext && !o.isAllowedContext(e) || (o.shouldPreventDefaultAction && e.preventDefault(), !(o.isDisabled && o.isDisabled()) && o.trigger(e));
}
function lS(e) {
  return !e || rS.includes(e) ? "" : e.replace(/^Key/, "").toLowerCase();
}
function ym(e) {
  const t = [0];
  for (let a = 0; a < e.length; a++)
    e[a] === `
` && t.push(a + 1);
  return t;
}
function du(e, t) {
  let a = 0, n = e.length - 1;
  for (; a < n; ) {
    const r = Math.floor((a + n + 1) / 2);
    e[r] <= t ? a = r : n = r - 1;
  }
  return a + 1;
}
function sS(e, t, a) {
  if (!e || !t)
    return [];
  const n = [];
  let r = 0;
  for (; ; ) {
    const i = e.indexOf(t, r);
    if (i === -1) break;
    const o = du(a, i);
    n.push(o), r = o < a.length ? a[o] : e.length;
  }
  return n;
}
function uS(e, t, a) {
  if (!e || !t)
    return [];
  const n = new RegExp(t, "sg"), r = [];
  let i;
  for (; (i = n.exec(e)) !== null; ) {
    const o = i.index, u = i.index + i[0].length - 1, s = du(a, o), l = du(a, u);
    for (let c = s; c <= l; c++)
      r[r.length - 1] !== c && r.push(c);
  }
  return r;
}
function cS(e, t, a, n = ym(e)) {
  return a ? uS(e, t, n) : sS(e, t, n);
}
const dS = (e) => `<mark class="matched-term">${e}</mark>`, bm = /[<&]/;
function Wo(e) {
  return e.replace(/[&<]/g, (t) => t === "&" ? "&amp;" : "&lt;");
}
function hf(e, t = bm, a = Wo) {
  return t.test(e) ? a(e) : e;
}
function fS(e, t, a) {
  if (!e || !t)
    return "";
  let n;
  try {
    n = new RegExp(`(?:${a ? t : Q$(t)})+`, "sgi");
  } catch {
    return e;
  }
  const r = !bm.test(e);
  let i = "", o = 0, u;
  for (; (u = n.exec(e)) !== null; ) {
    const s = u.index;
    i += r ? e.slice(o, s) : Wo(e.slice(o, s)), i += dS(r ? u[0] : Wo(u[0])), o = s + u[0].length;
  }
  return i += r ? e.slice(o) : Wo(e.slice(o)), i;
}
const wm = /^\d+(?:-\d+)?(?:,\d+(?:-\d+)?)*$/;
function vS(e, t) {
  if (!wm.test(e))
    throw new Error("Invalid line number expression.");
  const a = e.split(",").map((n) => {
    const [r, i] = n.split("-").map(Number);
    return i == null ? r : [r, i];
  });
  return Cm(a, t);
}
function Cm(e, t) {
  const a = e.flatMap((n) => {
    if (typeof n == "number")
      return n < 1 || n > t ? [] : n;
    let [r, i] = n[0] < n[1] ? n : [n[1], n[0]];
    return r = Math.max(1, r), i = Math.min(t, i), Array.from({ length: i - r + 1 }, (o, u) => u + r);
  }).sort((n, r) => n - r);
  return Array.from(new Set(a));
}
function hS(e, t) {
  return typeof e == "string" ? vS(e, t) : Cm(e, t);
}
const gS = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KCodeBlockIconButton",
  props: {
    theme: { default: "light" },
    active: { type: Boolean, default: !0 },
    copyTooltip: { default: "" }
  },
  setup(e) {
    const t = N(e.copyTooltip), a = na(), n = () => {
      e.copyTooltip && (t.value = "Copied!");
    };
    return ie(t, () => {
      setTimeout(() => {
        t.value = e.copyTooltip;
      }, 3e3);
    }), (r, i) => (m(), X(ba, {
      class: "code-block-action-tooltip",
      placement: "bottom-start",
      "popover-timeout": 300,
      text: t.value
    }, {
      default: L(() => [
        G(rt, Re({
          appearance: "tertiary",
          class: ["code-block-action-button", [`theme-${e.theme}`, { "code-block-action-button-active": e.active }]]
        }, D(a), {
          icon: "",
          onClick: n
        }), {
          default: L(() => [
            W(r.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["text"]));
  }
}), xr = /* @__PURE__ */ Pe(gS, [["__scopeId", "data-v-798b12f7"]]);
var ng;
const mS = typeof navigator < "u" && ("userAgentData" in navigator && navigator.userAgentData === "macOS" || ((ng = navigator.platform) == null ? void 0 : ng.toLowerCase().includes("mac"))), km = typeof navigator < "u" && navigator.userAgent.includes("Firefox");
function pS(e, t) {
  return typeof CSS < "u" && CSS.supports(e, t);
}
let Qi = null;
function $m() {
  if (Qi !== null)
    return Qi;
  if (typeof document > "u")
    return 0;
  const e = document.createElement("div");
  return e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e), Qi = e.offsetWidth - e.clientWidth, document.body.removeChild(e), Qi;
}
const yS = ["id"], bS = {
  key: 0,
  class: "code-block-actions"
}, wS = {
  key: 0,
  class: "code-block-search-results-container"
}, CS = {
  key: 0,
  class: "code-block-search-results"
}, kS = { class: "code-block-search-actions" }, $S = {
  ref: "codeBlockContent",
  class: "code-block-content"
}, SS = { class: "code-block-secondary-actions" }, xS = ["id", "href"], TS = ["innerHTML"], DS = ["id", "href"], AS = ["innerHTML"], IS = /* @__PURE__ */ oe({
  __name: "KCodeBlock",
  props: {
    id: {},
    code: {},
    language: {},
    initialFilterMode: { type: Boolean },
    initialRegExpMode: { type: Boolean },
    searchable: { type: Boolean },
    highlightedLineNumbers: { default: () => [] },
    processing: { type: Boolean },
    query: { default: "" },
    showCopyButton: { type: [Boolean, String], default: !0 },
    showLineNumbers: { type: Boolean, default: !0 },
    showLineNumberLinks: { type: Boolean },
    theme: { default: "light" },
    singleLine: { type: Boolean },
    maxHeight: { default: "none" }
  },
  emits: ["code-block-render", "matching-lines-change", "query-change", "filter-mode-change", "reg-exp-mode-change"],
  setup(e, { emit: t }) {
    Wt((me) => ({
      v91530a62: E.value,
      v7e175f2e: T.value
    }));
    const a = mS ? "Option" : "Alt", n = j$(ne, 150, { leading: !0, trailing: !0 });
    ie(() => e.highlightedLineNumbers, (me) => {
      typeof me == "string" && wm.test(me) || Array.isArray(me) && me.every((he) => Array.isArray(he) ? he.length === 2 && he.every((V) => typeof V == "number") : typeof he == "number") || console.warn(
        "KCodeBlock: `highlightedLineNumbers` prop should be either a properly formatted string (e.g. '1,3-5,7'), an array of numbers or tuples of numbers."
      );
    }, { immediate: !0 });
    const r = t, i = $t(), o = N(e.query), u = N(!1), s = N(e.initialRegExpMode), l = N(e.initialFilterMode), c = N(null), d = N(e.query), f = N(0), v = N([]), y = N(null), C = dt("codeBlock"), h = dt("codeBlockContent"), g = dt("codeBlockLineNumbers"), p = N(!1), w = N(!1), k = b(() => new Set(v.value)), S = b(() => {
      var me;
      return Array.from({ length: (me = e.code) == null ? void 0 : me.split(`
`).length }, (he, V) => V + 1);
    }), T = b(() => S.value[S.value.length - 1].toString().length + "ch"), A = b(() => e.processing || u.value), F = b(() => l.value && U.value !== ""), Z = b(() => e.id.toLowerCase().replace(/\s+/g, "-"));
    function O(me) {
      return `${Z.value}-L${me}`;
    }
    const z = b(() => ym(e.code)), U = b(() => {
      var he;
      if (d.value === "" || v.value.length === 0)
        return "";
      const me = (he = e.code) == null ? void 0 : he.split(`
`).filter((V, Se) => k.value.has(Se + 1)).join(`
`);
      return fS(me, d.value, s.value);
    }), x = b(() => !e.singleLine && e.searchable), I = b(
      () => e.singleLine ? hf(e.code).replaceAll(`
`, "") : hf(e.code)
    ), E = b(() => It(e.maxHeight));
    ie(() => e.code, async function() {
      await ht(), J(), ve();
    }), ie(() => s.value, function() {
      ve();
    }), ie(() => e.highlightedLineNumbers, function() {
      ae();
    }, { immediate: !0, deep: !0 }), ie(() => F.value, function(me) {
      var he, V;
      typeof document > "u" || (((he = document == null ? void 0 : document.activeElement) == null ? void 0 : he.tagName) === "PRE" && ((V = C.value) == null || V.focus({ preventScroll: !0 })), w.value = w.value || me, p.value = p.value || !me, h.value && (h.value.scrollTop = 0));
    }, { immediate: !0 });
    const P = {
      "alt+c": "copyCode",
      "alt+f": "toggleFilterMode",
      "alt+g": "toggleFilterMode",
      "alt+r": "toggleRegExpMode",
      f3: "jumpToNextMatch",
      "shift+f3": "jumpToPreviousMatch",
      enter: "jumpToNextMatch",
      "shift+enter": "jumpToPreviousMatch"
    }, R = {
      toggleFilterMode: {
        trigger: Le,
        isAllowedContext(me) {
          return C.value !== null && me.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      },
      toggleRegExpMode: {
        trigger: Te,
        isAllowedContext(me) {
          return C.value !== null && me.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      },
      jumpToNextMatch: {
        trigger: ze,
        isAllowedContext(me) {
          return C.value !== null && me.composedPath().includes(C.value);
        },
        isDisabled: () => v.value.length === 0 || l.value,
        shouldPreventDefaultAction: !0
      },
      jumpToPreviousMatch: {
        trigger: _e,
        isAllowedContext(me) {
          return C.value !== null && me.composedPath().includes(C.value);
        },
        isDisabled: () => v.value.length === 0 || l.value,
        shouldPreventDefaultAction: !0
      },
      copyCode: {
        trigger: Xe,
        isAllowedContext(me) {
          return C.value !== null && me.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      }
    }, K = new iS(P, R);
    it(function() {
      K.registerListener(), J(), !e.query && e.highlightedLineNumbers.length ? ae() : ve();
    }), fn(function() {
      K.unRegisterListener();
    });
    function J() {
      var V;
      const me = (V = C.value) == null ? void 0 : V.querySelector(".highlighted-code-block"), he = me == null ? void 0 : me.querySelector("code");
      me instanceof HTMLElement && he instanceof HTMLElement && r("code-block-render", se(me, he));
    }
    function q() {
      var V;
      if (typeof HTMLElement > "u")
        return;
      const me = (V = C.value) == null ? void 0 : V.querySelector(".highlighted-code-block"), he = me == null ? void 0 : me.querySelector("code");
      me instanceof HTMLElement && he instanceof HTMLElement && r("matching-lines-change", se(me, he));
    }
    function se(me, he) {
      return {
        preElement: me,
        codeElement: he,
        code: e.code,
        language: e.language,
        query: o.value,
        matchingLineNumbers: v.value
      };
    }
    function fe() {
      d.value !== o.value && (u.value = !0, n());
    }
    async function ne() {
      await ht(), r("query-change", d.value), ve();
    }
    function ae() {
      u.value = !0, c.value = null, v.value = hS(e.highlightedLineNumbers, S.value.length), f.value = v.value.length, q(), u.value = !1;
    }
    function ve() {
      u.value = !0, c.value = null;
      let me = [];
      if (d.value.length > 0)
        try {
          me = cS(
            e.code.toLowerCase(),
            d.value.toLowerCase(),
            s.value,
            z.value
          );
        } catch (he) {
          if (he instanceof Error)
            c.value = he;
          else
            throw he;
        }
      y.value = null, f.value = me.length, v.value = Array.from(new Set(me)), q(), u.value = !1;
    }
    function Ae() {
      d.value = "", ne();
    }
    function Te() {
      s.value = !s.value, r("reg-exp-mode-change", s.value), s.value || (c.value = null);
    }
    function Le() {
      l.value = !l.value, r("filter-mode-change", l.value);
    }
    function ze() {
      tt(1);
    }
    function _e() {
      tt(-1);
    }
    function tt(me) {
      if (v.value.length === 0 || !(C.value instanceof HTMLElement))
        return;
      typeof y.value == "number" ? y.value = (y.value + me + v.value.length) % v.value.length : y.value = 0;
      const he = v.value[y.value];
      if (!he)
        return;
      const V = C.value.querySelector(`.highlighted-code-block #${O(he)}`);
      V ? "scrollIntoViewIfNeeded" in V && typeof V.scrollIntoViewIfNeeded == "function" ? V.scrollIntoViewIfNeeded(!0) : V.scrollIntoView({ block: "nearest" }) : g.value && g.value.scrollToIndex(he - 1, { align: "center" });
    }
    async function Xe(me) {
      const he = me.target.closest("button");
      await cg(e.code) && (he == null || he.setAttribute("data-tooltip-text", "Copied code!"), window == null || window.setTimeout(function() {
        he == null || he.removeAttribute("data-tooltip-text");
      }, 1500));
    }
    const et = b(() => e.theme === "light" ? Qy : au);
    function pe(me) {
      return {
        // These props essentially renders a structure like this:
        //
        // <span class="line-number-rows">
        //  <span class="line">...line number anchor...</span>
        // </span>
        as: "span",
        class: "line-number-rows",
        data: me ? v.value : S.value,
        item: "span",
        itemProps: ({ item: he }) => ({
          class: ce({
            line: !0,
            "line-is-match": me ? !1 : k.value.has(he),
            "line-is-highlighted-match": me ? !1 : y.value !== null && he === v.value[y.value]
          })
        }),
        // slightly increase the number of items to render to avoid blank items when scrolling fast
        overscan: 8,
        // provide a fixed item height so that Virtualizer can skip estimation
        itemSize: parseInt(_y, 10),
        // the scrollable container isn't the parentElement so we need to manually provide it
        scrollRef: h.value ?? void 0,
        // to override the default `position: relative; width: 100%`.
        style: {
          position: "absolute",
          width: "auto"
        }
      };
    }
    return (me, he) => (m(), $("div", {
      id: e.id,
      ref: "codeBlock",
      class: ce(["k-code-block", [`theme-${e.theme}`]]),
      "data-testid": "k-code-block",
      tabindex: "-1",
      onBlur: he[1] || (he[1] = (V) => y.value = null)
    }, [
      x.value ? (m(), $("div", bS, [
        G(Nn, {
          modelValue: d.value,
          "onUpdate:modelValue": he[0] || (he[0] = (V) => d.value = V),
          "aria-label": "Search",
          autocomplete: "off",
          class: "code-block-search-input",
          "data-testid": "code-block-search-input",
          error: c.value !== null,
          "error-message": c.value !== null ? c.value.message : void 0,
          placeholder: "Search...",
          onInput: fe
        }, {
          before: L(() => [
            G(ea, {
              mode: "out-in",
              name: "kongponents-fade-transition"
            }, {
              default: L(() => [
                d.value ? (m(), $("button", {
                  key: 0,
                  "aria-label": "Clear query",
                  class: "clear-query-button",
                  "data-testid": "clear-query-button",
                  title: "Clear query",
                  type: "button",
                  onClick: Ae
                }, [
                  G(D(ha), { decorative: "" })
                ])) : (m(), X(D(zu), {
                  key: 1,
                  class: "code-block-search-icon",
                  decorative: ""
                }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "error", "error-message"]),
        G(ea, { name: "kongponents-fade-transition" }, {
          default: L(() => [
            A.value || d.value ? (m(), $("div", wS, [
              G(ea, { name: "kongponents-fade-transition" }, {
                default: L(() => [
                  A.value ? (m(), X(D(Fi), {
                    key: 0,
                    class: "code-block-processing-icon",
                    color: et.value,
                    "data-testid": "code-block-processing-icon",
                    size: D(Sa),
                    title: "Loading"
                  }, null, 8, ["color", "size"])) : H("", !0)
                ]),
                _: 1
              }),
              d.value ? (m(), $("p", CS, [
                v.value.length === 0 ? (m(), $(Ee, { key: 0 }, [
                  be(" No results ")
                ], 64)) : typeof y.value == "number" && !F.value ? (m(), $(Ee, { key: 1 }, [
                  be(re(y.value + 1) + " of " + re(v.value.length), 1)
                ], 64)) : (m(), $(Ee, { key: 2 }, [
                  be(re(v.value.length) + " " + re(v.value.length === 1 ? "result" : "results"), 1)
                ], 64))
              ])) : H("", !0)
            ])) : H("", !0)
          ]),
          _: 1
        }),
        Y("div", kS, [
          G(xr, {
            active: s.value,
            "aria-label": `Use regular expression (${D(a)}+R)`,
            "aria-pressed": s.value,
            class: "regexp-mode-button",
            "data-testid": "regexp-mode-button",
            theme: e.theme,
            title: `Use regular expression (${D(a)}+R)`,
            onClick: Te
          }, {
            default: L(() => [
              G(D(My), { decorative: "" })
            ]),
            _: 1
          }, 8, ["active", "aria-label", "aria-pressed", "theme", "title"]),
          G(xr, {
            active: l.value,
            "aria-label": `Filter results (${D(a)}+F)`,
            "aria-pressed": l.value,
            class: "action-button filter-mode-button",
            "data-testid": "filter-mode-button",
            theme: e.theme,
            title: `Filter results (${D(a)}+F)`,
            onClick: Le
          }, {
            default: L(() => [
              G(D(ky), { decorative: "" })
            ]),
            _: 1
          }, 8, ["active", "aria-label", "aria-pressed", "theme", "title"]),
          G(xr, {
            "aria-label": "Previous match (Shift+F3)",
            class: "previous-match-button",
            "data-testid": "previous-match-button",
            disabled: v.value.length === 0 || l.value,
            theme: e.theme,
            title: "Previous match (Shift+F3)",
            onClick: _e
          }, {
            default: L(() => [
              G(D(J1), { decorative: "" })
            ]),
            _: 1
          }, 8, ["disabled", "theme"]),
          G(xr, {
            "aria-label": "Next match (F3)",
            class: "next-match-button",
            "data-testid": "next-match-button",
            disabled: v.value.length === 0 || l.value,
            theme: e.theme,
            title: "Next match (F3)",
            onClick: ze
          }, {
            default: L(() => [
              G(D(Bu), { decorative: "" })
            ]),
            _: 1
          }, 8, ["disabled", "theme"])
        ])
      ])) : H("", !0),
      Y("div", $S, [
        e.showCopyButton || i["secondary-actions"] ? (m(), $("div", {
          key: 0,
          class: ce(["secondary-actions-wrapper", { "always-show": e.showCopyButton === "always" }])
        }, [
          Y("div", SS, [
            e.showCopyButton ? (m(), X(xr, {
              key: 0,
              "aria-label": `Copy (${D(a)}+C)`,
              class: "code-block-copy-button",
              "copy-tooltip": `Copy (${D(a)}+C)`,
              "data-testid": `code-block-copy-button-${e.id}`,
              theme: e.theme,
              onClick: Xe
            }, {
              default: L(() => [
                G(D(pg), { decorative: "" })
              ]),
              _: 1
            }, 8, ["aria-label", "copy-tooltip", "data-testid", "theme"])) : H("", !0),
            W(me.$slots, "secondary-actions", {}, void 0, !0)
          ])
        ], 2)) : H("", !0),
        F.value || w.value ? pa((m(), X(Ye("pre"), {
          key: 1,
          class: ce(["filtered-code-block", {
            "show-line-numbers": e.showLineNumbers
          }]),
          "data-testid": "filtered-code-block"
        }, {
          default: L(() => [
            e.showLineNumbers && !e.singleLine ? (m(), X(D(qd), la(Re({ key: 0 }, pe(!0))), {
              default: L(({ item: V }) => [
                Y("a", {
                  id: O(V),
                  class: "line-anchor",
                  href: e.showLineNumberLinks ? `#${O(V)}` : void 0
                }, re(V), 9, xS)
              ]),
              _: 1
            }, 16)) : H("", !0),
            Y("code", { innerHTML: U.value }, null, 8, TS)
          ]),
          _: 1
        }, 8, ["class"])), [
          [Xn, F.value]
        ]) : H("", !0),
        !F.value || p.value ? pa((m(), X(Ye("pre"), {
          key: 2,
          class: ce(["highlighted-code-block", {
            "show-line-numbers": e.showLineNumbers,
            "single-line": e.singleLine
          }]),
          "data-testid": "highlighted-code-block"
        }, {
          default: L(() => [
            e.showLineNumbers && !e.singleLine ? (m(), X(D(qd), Re({
              key: 0,
              ref: "codeBlockLineNumbers"
            }, pe(!1)), {
              default: L(({ item: V }) => [
                Y("a", {
                  id: O(V),
                  class: ce(["line-anchor", { "hide-links": !e.showLineNumberLinks }]),
                  href: e.showLineNumberLinks ? `#${O(V)}` : void 0
                }, re(V), 11, DS)
              ]),
              _: 1
            }, 16)) : H("", !0),
            Y("code", { innerHTML: I.value }, null, 8, AS)
          ]),
          _: 1
        }, 8, ["class"])), [
          [Xn, !F.value]
        ]) : H("", !0)
      ], 512)
    ], 42, yS));
  }
}), ES = /* @__PURE__ */ Pe(IS, [["__scopeId", "data-v-1c46b88a"]]), MS = { class: "k-collapse" }, OS = { class: "collapse-trigger" }, PS = ["aria-controls", "aria-expanded", "aria-label"], NS = {
  key: 0,
  class: "collapse-trigger-label",
  "data-testid": "collapse-trigger-label"
}, LS = {
  key: 0,
  class: "collapse-visible-content",
  "data-testid": "collapse-visible-content"
}, BS = ["id"], RS = /* @__PURE__ */ oe({
  __name: "KCollapse",
  props: {
    modelValue: { type: Boolean, default: !0 },
    title: { default: "" },
    titleTag: { default: "div" },
    triggerLabel: { default: "" },
    triggerAlignment: { default: "trailing" }
  },
  emits: ["toggle", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = $t(), r = yt(), i = N(!0), o = N(!1), u = b(() => e.triggerAlignment === "trailing"), s = b(() => !!n["visible-content"]), l = b({
      get() {
        return e.modelValue;
      },
      set(f) {
        d(f);
      }
    }), c = b(() => o.value ? i.value : e.modelValue), d = (f) => {
      o.value || (i.value = e.modelValue), i.value = f !== void 0 ? f : !i.value, o.value = !0, a("toggle", i.value), a("update:modelValue", i.value);
    };
    return ie(l, (f, v) => {
      f !== v && d(f);
    }), (f, v) => (m(), $("div", MS, [
      Y("div", {
        class: ce(["collapse-heading", { "has-trailing-trigger": u.value }])
      }, [
        e.title || f.$slots.title ? (m(), X(Ye(e.titleTag), {
          key: 0,
          class: "collapse-title",
          "data-testid": "collapse-title"
        }, {
          default: L(() => [
            W(f.$slots, "title", {}, () => [
              be(re(e.title), 1)
            ], !0)
          ]),
          _: 3
        })) : H("", !0),
        Y("div", OS, [
          W(f.$slots, "trigger", {
            isCollapsed: c.value,
            toggle: d
          }, () => [
            Y("button", {
              "aria-controls": D(r),
              "aria-expanded": !c.value,
              "aria-label": e.triggerLabel ? void 0 : "Toggle content",
              class: "collapse-trigger-content",
              "data-testid": "collapse-trigger-content",
              type: "button",
              onClick: v[0] || (v[0] = Ke((y) => d(), ["prevent", "stop"]))
            }, [
              W(f.$slots, "trigger-content", {}, () => [
                G(D(Ru), {
                  class: ce(["collapse-trigger-icon", { "collapse-expanded": !c.value }]),
                  "data-testid": "collapse-trigger-icon",
                  decorative: "",
                  size: D(Qt)
                }, null, 8, ["class", "size"]),
                e.triggerLabel ? (m(), $("span", NS, re(e.triggerLabel), 1)) : H("", !0)
              ], !0)
            ], 8, PS)
          ], !0)
        ])
      ], 2),
      s.value ? (m(), $("div", LS, [
        W(f.$slots, "visible-content", {}, void 0, !0)
      ])) : H("", !0),
      G(ea, { name: "kongponents-fade-transition" }, {
        default: L(() => [
          pa(Y("div", {
            id: D(r),
            class: "collapse-hidden-content",
            "data-testid": "collapse-hidden-content"
          }, [
            W(f.$slots, "default", {}, void 0, !0)
          ], 8, BS), [
            [Xn, !c.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}), FS = /* @__PURE__ */ Pe(RS, [["__scopeId", "data-v-e3a842da"]]);
function fl(e) {
  "@babel/helpers - typeof";
  return fl = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fl(e);
}
function tr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ft(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function ca(e) {
  Ft(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || fl(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function zS(e, t) {
  Ft(2, arguments);
  var a = ca(e).getTime(), n = tr(t);
  return new Date(a + n);
}
var YS = {};
function _l() {
  return YS;
}
function HS(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function qS(e) {
  Ft(1, arguments);
  var t = ca(e);
  return t.setHours(0, 0, 0, 0), t;
}
function WS(e) {
  return Ft(1, arguments), e instanceof Date || fl(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function US(e) {
  if (Ft(1, arguments), !WS(e) && typeof e != "number")
    return !1;
  var t = ca(e);
  return !isNaN(Number(t));
}
function KS(e, t) {
  Ft(2, arguments);
  var a = tr(t);
  return zS(e, -a);
}
var VS = 864e5;
function jS(e) {
  Ft(1, arguments);
  var t = ca(e), a = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), r = a - n;
  return Math.floor(r / VS) + 1;
}
function vl(e) {
  Ft(1, arguments);
  var t = 1, a = ca(e), n = a.getUTCDay(), r = (n < t ? 7 : 0) + n - t;
  return a.setUTCDate(a.getUTCDate() - r), a.setUTCHours(0, 0, 0, 0), a;
}
function Sm(e) {
  Ft(1, arguments);
  var t = ca(e), a = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(a + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = vl(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(a, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = vl(i);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= o.getTime() ? a : a - 1;
}
function GS(e) {
  Ft(1, arguments);
  var t = Sm(e), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var n = vl(a);
  return n;
}
var QS = 6048e5;
function ZS(e) {
  Ft(1, arguments);
  var t = ca(e), a = vl(t).getTime() - GS(t).getTime();
  return Math.round(a / QS) + 1;
}
function hl(e, t) {
  var a, n, r, i, o, u, s, l;
  Ft(1, arguments);
  var c = _l(), d = tr((a = (n = (r = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : c.weekStartsOn) !== null && n !== void 0 ? n : (s = c.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = ca(e), v = f.getUTCDay(), y = (v < d ? 7 : 0) + v - d;
  return f.setUTCDate(f.getUTCDate() - y), f.setUTCHours(0, 0, 0, 0), f;
}
function xm(e, t) {
  var a, n, r, i, o, u, s, l;
  Ft(1, arguments);
  var c = ca(e), d = c.getUTCFullYear(), f = _l(), v = tr((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = f.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(d + 1, 0, v), y.setUTCHours(0, 0, 0, 0);
  var C = hl(y, t), h = /* @__PURE__ */ new Date(0);
  h.setUTCFullYear(d, 0, v), h.setUTCHours(0, 0, 0, 0);
  var g = hl(h, t);
  return c.getTime() >= C.getTime() ? d + 1 : c.getTime() >= g.getTime() ? d : d - 1;
}
function XS(e, t) {
  var a, n, r, i, o, u, s, l;
  Ft(1, arguments);
  var c = _l(), d = tr((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = c.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = xm(e, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(f, 0, d), v.setUTCHours(0, 0, 0, 0);
  var y = hl(v, t);
  return y;
}
var JS = 6048e5;
function _S(e, t) {
  Ft(1, arguments);
  var a = ca(e), n = hl(a, t).getTime() - XS(a, t).getTime();
  return Math.round(n / JS) + 1;
}
function st(e, t) {
  for (var a = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return a + n;
}
var bn = {
  // Year
  y: function(t, a) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return st(a === "yy" ? r % 100 : r, a.length);
  },
  // Month
  M: function(t, a) {
    var n = t.getUTCMonth();
    return a === "M" ? String(n + 1) : st(n + 1, 2);
  },
  // Day of the month
  d: function(t, a) {
    return st(t.getUTCDate(), a.length);
  },
  // AM or PM
  a: function(t, a) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, a) {
    return st(t.getUTCHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H: function(t, a) {
    return st(t.getUTCHours(), a.length);
  },
  // Minute
  m: function(t, a) {
    return st(t.getUTCMinutes(), a.length);
  },
  // Second
  s: function(t, a) {
    return st(t.getUTCSeconds(), a.length);
  },
  // Fraction of second
  S: function(t, a) {
    var n = a.length, r = t.getUTCMilliseconds(), i = Math.floor(r * Math.pow(10, n - 3));
    return st(i, a.length);
  }
}, pr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ex = {
  // Era
  G: function(t, a, n) {
    var r = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, a, n) {
    if (a === "yo") {
      var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return bn.y(t, a);
  },
  // Local week-numbering year
  Y: function(t, a, n, r) {
    var i = xm(t, r), o = i > 0 ? i : 1 - i;
    if (a === "YY") {
      var u = o % 100;
      return st(u, 2);
    }
    return a === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : st(o, a.length);
  },
  // ISO week-numbering year
  R: function(t, a) {
    var n = Sm(t);
    return st(n, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, a) {
    var n = t.getUTCFullYear();
    return st(n, a.length);
  },
  // Quarter
  Q: function(t, a, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, a, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return st(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, a, n) {
    var r = t.getUTCMonth();
    switch (a) {
      case "M":
      case "MM":
        return bn.M(t, a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, a, n) {
    var r = t.getUTCMonth();
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return st(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, a, n, r) {
    var i = _S(t, r);
    return a === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : st(i, a.length);
  },
  // ISO week of year
  I: function(t, a, n) {
    var r = ZS(t);
    return a === "Io" ? n.ordinalNumber(r, {
      unit: "week"
    }) : st(r, a.length);
  },
  // Day of the month
  d: function(t, a, n) {
    return a === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : bn.d(t, a);
  },
  // Day of year
  D: function(t, a, n) {
    var r = jS(t);
    return a === "Do" ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : st(r, a.length);
  },
  // Day of week
  E: function(t, a, n) {
    var r = t.getUTCDay();
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, a, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return st(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, a, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return st(o, a.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, a, n) {
    var r = t.getUTCDay(), i = r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return st(i, a.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, a, n) {
    var r = t.getUTCHours(), i = r / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, a, n) {
    var r = t.getUTCHours(), i;
    switch (r === 12 ? i = pr.noon : r === 0 ? i = pr.midnight : i = r / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, a, n) {
    var r = t.getUTCHours(), i;
    switch (r >= 17 ? i = pr.evening : r >= 12 ? i = pr.afternoon : r >= 4 ? i = pr.morning : i = pr.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, a, n) {
    if (a === "ho") {
      var r = t.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return bn.h(t, a);
  },
  // Hour [0-23]
  H: function(t, a, n) {
    return a === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : bn.H(t, a);
  },
  // Hour [0-11]
  K: function(t, a, n) {
    var r = t.getUTCHours() % 12;
    return a === "Ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : st(r, a.length);
  },
  // Hour [1-24]
  k: function(t, a, n) {
    var r = t.getUTCHours();
    return r === 0 && (r = 24), a === "ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : st(r, a.length);
  },
  // Minute
  m: function(t, a, n) {
    return a === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : bn.m(t, a);
  },
  // Second
  s: function(t, a, n) {
    return a === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : bn.s(t, a);
  },
  // Fraction of second
  S: function(t, a) {
    return bn.S(t, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (a) {
      // Hours and optional minutes
      case "X":
        return mf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return qn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return qn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Hours and optional minutes
      case "x":
        return mf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return qn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return qn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + gf(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + qn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + gf(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + qn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, a, n, r) {
    var i = r._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return st(o, a.length);
  },
  // Milliseconds timestamp
  T: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTime();
    return st(o, a.length);
  }
};
function gf(e, t) {
  var a = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return a + String(r);
  var o = t;
  return a + String(r) + o + st(i, 2);
}
function mf(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + st(Math.abs(e) / 60, 2);
  }
  return qn(e, t);
}
function qn(e, t) {
  var a = t || "", n = e > 0 ? "-" : "+", r = Math.abs(e), i = st(Math.floor(r / 60), 2), o = st(r % 60, 2);
  return n + i + a + o;
}
var pf = function(t, a) {
  switch (t) {
    case "P":
      return a.date({
        width: "short"
      });
    case "PP":
      return a.date({
        width: "medium"
      });
    case "PPP":
      return a.date({
        width: "long"
      });
    case "PPPP":
    default:
      return a.date({
        width: "full"
      });
  }
}, Tm = function(t, a) {
  switch (t) {
    case "p":
      return a.time({
        width: "short"
      });
    case "pp":
      return a.time({
        width: "medium"
      });
    case "ppp":
      return a.time({
        width: "long"
      });
    case "pppp":
    default:
      return a.time({
        width: "full"
      });
  }
}, tx = function(t, a) {
  var n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return pf(t, a);
  var o;
  switch (r) {
    case "P":
      o = a.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = a.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = a.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = a.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", pf(r, a)).replace("{{time}}", Tm(i, a));
}, ax = {
  p: Tm,
  P: tx
}, nx = ["D", "DD"], rx = ["YY", "YYYY"];
function ix(e) {
  return nx.indexOf(e) !== -1;
}
function ox(e) {
  return rx.indexOf(e) !== -1;
}
function yf(e, t, a) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var lx = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, sx = function(t, a, n) {
  var r, i = lx[t];
  return typeof i == "string" ? r = i : a === 1 ? r = i.one : r = i.other.replace("{{count}}", a.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function ks(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth, n = e.formats[a] || e.formats[e.defaultWidth];
    return n;
  };
}
var ux = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, cx = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, dx = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fx = {
  date: ks({
    formats: ux,
    defaultWidth: "full"
  }),
  time: ks({
    formats: cx,
    defaultWidth: "full"
  }),
  dateTime: ks({
    formats: dx,
    defaultWidth: "full"
  })
}, vx = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hx = function(t, a, n, r) {
  return vx[t];
};
function ii(e) {
  return function(t, a) {
    var n = a != null && a.context ? String(a.context) : "standalone", r;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = a != null && a.width ? String(a.width) : i;
      r = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var u = e.defaultWidth, s = a != null && a.width ? String(a.width) : e.defaultWidth;
      r = e.values[s] || e.values[u];
    }
    var l = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[l];
  };
}
var gx = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, mx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, px = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, yx = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, bx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, wx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Cx = function(t, a) {
  var n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, kx = {
  ordinalNumber: Cx,
  era: ii({
    values: gx,
    defaultWidth: "wide"
  }),
  quarter: ii({
    values: mx,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ii({
    values: px,
    defaultWidth: "wide"
  }),
  day: ii({
    values: yx,
    defaultWidth: "wide"
  }),
  dayPeriod: ii({
    values: bx,
    defaultWidth: "wide",
    formattingValues: wx,
    defaultFormattingWidth: "wide"
  })
};
function oi(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = a.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(r);
    if (!i)
      return null;
    var o = i[0], u = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(u) ? Sx(u, function(d) {
      return d.test(o);
    }) : $x(u, function(d) {
      return d.test(o);
    }), l;
    l = e.valueCallback ? e.valueCallback(s) : s, l = a.valueCallback ? a.valueCallback(l) : l;
    var c = t.slice(o.length);
    return {
      value: l,
      rest: c
    };
  };
}
function $x(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a) && t(e[a]))
      return a;
}
function Sx(e, t) {
  for (var a = 0; a < e.length; a++)
    if (t(e[a]))
      return a;
}
function xx(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var r = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = a.valueCallback ? a.valueCallback(o) : o;
    var u = t.slice(r.length);
    return {
      value: o,
      rest: u
    };
  };
}
var Tx = /^(\d+)(th|st|nd|rd)?/i, Dx = /\d+/i, Ax = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Ix = {
  any: [/^b/i, /^(a|c)/i]
}, Ex = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Mx = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ox = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Px = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Nx = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Lx = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Bx = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Rx = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fx = {
  ordinalNumber: xx({
    matchPattern: Tx,
    parsePattern: Dx,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: oi({
    matchPatterns: Ax,
    defaultMatchWidth: "wide",
    parsePatterns: Ix,
    defaultParseWidth: "any"
  }),
  quarter: oi({
    matchPatterns: Ex,
    defaultMatchWidth: "wide",
    parsePatterns: Mx,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: oi({
    matchPatterns: Ox,
    defaultMatchWidth: "wide",
    parsePatterns: Px,
    defaultParseWidth: "any"
  }),
  day: oi({
    matchPatterns: Nx,
    defaultMatchWidth: "wide",
    parsePatterns: Lx,
    defaultParseWidth: "any"
  }),
  dayPeriod: oi({
    matchPatterns: Bx,
    defaultMatchWidth: "any",
    parsePatterns: Rx,
    defaultParseWidth: "any"
  })
}, zx = {
  code: "en-US",
  formatDistance: sx,
  formatLong: fx,
  formatRelative: hx,
  localize: kx,
  match: Fx,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Yx = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Hx = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, qx = /^'([^]*?)'?$/, Wx = /''/g, Ux = /[a-zA-Z]/;
function Yt(e, t, a) {
  var n, r, i, o, u, s, l, c, d, f, v, y, C, h, g, p, w, k;
  Ft(2, arguments);
  var S = String(t), T = _l(), A = (n = (r = a == null ? void 0 : a.locale) !== null && r !== void 0 ? r : T.locale) !== null && n !== void 0 ? n : zx, F = tr((i = (o = (u = (s = a == null ? void 0 : a.firstWeekContainsDate) !== null && s !== void 0 ? s : a == null || (l = a.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && u !== void 0 ? u : T.firstWeekContainsDate) !== null && o !== void 0 ? o : (d = T.locale) === null || d === void 0 || (f = d.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(F >= 1 && F <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var Z = tr((v = (y = (C = (h = a == null ? void 0 : a.weekStartsOn) !== null && h !== void 0 ? h : a == null || (g = a.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.weekStartsOn) !== null && C !== void 0 ? C : T.weekStartsOn) !== null && y !== void 0 ? y : (w = T.locale) === null || w === void 0 || (k = w.options) === null || k === void 0 ? void 0 : k.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(Z >= 0 && Z <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!A.localize)
    throw new RangeError("locale must contain localize property");
  if (!A.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var O = ca(e);
  if (!US(O))
    throw new RangeError("Invalid time value");
  var z = HS(O), U = KS(O, z), x = {
    firstWeekContainsDate: F,
    weekStartsOn: Z,
    locale: A,
    _originalDate: O
  }, I = S.match(Hx).map(function(E) {
    var P = E[0];
    if (P === "p" || P === "P") {
      var R = ax[P];
      return R(E, A.formatLong);
    }
    return E;
  }).join("").match(Yx).map(function(E) {
    if (E === "''")
      return "'";
    var P = E[0];
    if (P === "'")
      return Kx(E);
    var R = ex[P];
    if (R)
      return !(a != null && a.useAdditionalWeekYearTokens) && ox(E) && yf(E, t, String(e)), !(a != null && a.useAdditionalDayOfYearTokens) && ix(E) && yf(E, t, String(e)), R(U, E, A.localize, x);
    if (P.match(Ux))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + P + "`");
    return E;
  }).join("");
  return I;
}
function Kx(e) {
  var t = e.match(qx);
  return t ? t[1].replace(Wx, "'") : e;
}
function Vx(e, t) {
  Ft(2, arguments);
  var a = ca(e), n = ca(t);
  return a.getTime() < n.getTime();
}
function jx() {
  return qS(Date.now());
}
function es(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zi = { exports: {} }, $s = { exports: {} }, bf;
function St() {
  return bf || (bf = 1, (function(e) {
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })($s)), $s.exports;
}
var Xi = { exports: {} }, Ji = { exports: {} }, Ss = { exports: {} }, wf;
function Dm() {
  return wf || (wf = 1, (function(e) {
    function t(a) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(a);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ss)), Ss.exports;
}
var _i = { exports: {} }, Cf;
function Zt() {
  return Cf || (Cf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      if (r.length < n)
        throw new TypeError(n + " argument" + (n > 1 ? "s" : "") + " required, but only " + r.length + " present");
    }
    e.exports = t.default;
  })(_i, _i.exports)), _i.exports;
}
var kf;
function Gx() {
  return kf || (kf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(Dm()), r = a(/* @__PURE__ */ Zt());
    function i(o) {
      return (0, r.default)(1, arguments), o instanceof Date || (0, n.default)(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
    }
    e.exports = t.default;
  })(Ji, Ji.exports)), Ji.exports;
}
var eo = { exports: {} }, $f;
function ja() {
  return $f || ($f = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(Dm()), r = a(/* @__PURE__ */ Zt());
    function i(o) {
      (0, r.default)(1, arguments);
      var u = Object.prototype.toString.call(o);
      return o instanceof Date || (0, n.default)(o) === "object" && u === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || u === "[object Number]" ? new Date(o) : ((typeof o == "string" || u === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
    }
    e.exports = t.default;
  })(eo, eo.exports)), eo.exports;
}
var Sf;
function Qx() {
  return Sf || (Sf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ Gx()), r = a(/* @__PURE__ */ ja()), i = a(/* @__PURE__ */ Zt());
    function o(u) {
      if ((0, i.default)(1, arguments), !(0, n.default)(u) && typeof u != "number")
        return !1;
      var s = (0, r.default)(u);
      return !isNaN(Number(s));
    }
    e.exports = t.default;
  })(Xi, Xi.exports)), Xi.exports;
}
var to = { exports: {} }, ao = { exports: {} }, no = { exports: {} }, xf;
function cr() {
  return xf || (xf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      if (n === null || n === !0 || n === !1)
        return NaN;
      var r = Number(n);
      return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
    }
    e.exports = t.default;
  })(no, no.exports)), no.exports;
}
var Tf;
function Zx() {
  return Tf || (Tf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ cr()), r = a(/* @__PURE__ */ ja()), i = a(/* @__PURE__ */ Zt());
    function o(u, s) {
      (0, i.default)(2, arguments);
      var l = (0, r.default)(u).getTime(), c = (0, n.default)(s);
      return new Date(l + c);
    }
    e.exports = t.default;
  })(ao, ao.exports)), ao.exports;
}
var Df;
function Xx() {
  return Df || (Df = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ Zx()), r = a(/* @__PURE__ */ Zt()), i = a(/* @__PURE__ */ cr());
    function o(u, s) {
      (0, r.default)(2, arguments);
      var l = (0, i.default)(s);
      return (0, n.default)(u, -l);
    }
    e.exports = t.default;
  })(to, to.exports)), to.exports;
}
var ro = { exports: {} }, io = { exports: {} }, Af;
function Jx() {
  return Af || (Af = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ Zt()), i = 864e5;
    function o(u) {
      (0, r.default)(1, arguments);
      var s = (0, n.default)(u), l = s.getTime();
      s.setUTCMonth(0, 1), s.setUTCHours(0, 0, 0, 0);
      var c = s.getTime(), d = l - c;
      return Math.floor(d / i) + 1;
    }
    e.exports = t.default;
  })(io, io.exports)), io.exports;
}
var oo = { exports: {} }, lo = { exports: {} }, If;
function ic() {
  return If || (If = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ Zt());
    function i(o) {
      (0, r.default)(1, arguments);
      var u = 1, s = (0, n.default)(o), l = s.getUTCDay(), c = (l < u ? 7 : 0) + l - u;
      return s.setUTCDate(s.getUTCDate() - c), s.setUTCHours(0, 0, 0, 0), s;
    }
    e.exports = t.default;
  })(lo, lo.exports)), lo.exports;
}
var so = { exports: {} }, uo = { exports: {} }, Ef;
function Am() {
  return Ef || (Ef = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ Zt()), i = a(/* @__PURE__ */ ic());
    function o(u) {
      (0, r.default)(1, arguments);
      var s = (0, n.default)(u), l = s.getUTCFullYear(), c = /* @__PURE__ */ new Date(0);
      c.setUTCFullYear(l + 1, 0, 4), c.setUTCHours(0, 0, 0, 0);
      var d = (0, i.default)(c), f = /* @__PURE__ */ new Date(0);
      f.setUTCFullYear(l, 0, 4), f.setUTCHours(0, 0, 0, 0);
      var v = (0, i.default)(f);
      return s.getTime() >= d.getTime() ? l + 1 : s.getTime() >= v.getTime() ? l : l - 1;
    }
    e.exports = t.default;
  })(uo, uo.exports)), uo.exports;
}
var Mf;
function _x() {
  return Mf || (Mf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ Am()), r = a(/* @__PURE__ */ ic()), i = a(/* @__PURE__ */ Zt());
    function o(u) {
      (0, i.default)(1, arguments);
      var s = (0, n.default)(u), l = /* @__PURE__ */ new Date(0);
      l.setUTCFullYear(s, 0, 4), l.setUTCHours(0, 0, 0, 0);
      var c = (0, r.default)(l);
      return c;
    }
    e.exports = t.default;
  })(so, so.exports)), so.exports;
}
var Of;
function e5() {
  return Of || (Of = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ ic()), i = a(/* @__PURE__ */ _x()), o = a(/* @__PURE__ */ Zt()), u = 6048e5;
    function s(l) {
      (0, o.default)(1, arguments);
      var c = (0, n.default)(l), d = (0, r.default)(c).getTime() - (0, i.default)(c).getTime();
      return Math.round(d / u) + 1;
    }
    e.exports = t.default;
  })(oo, oo.exports)), oo.exports;
}
var co = { exports: {} }, fo = { exports: {} }, li = {}, Pf;
function ts() {
  if (Pf) return li;
  Pf = 1, Object.defineProperty(li, "__esModule", {
    value: !0
  }), li.getDefaultOptions = t, li.setDefaultOptions = a;
  var e = {};
  function t() {
    return e;
  }
  function a(n) {
    e = n;
  }
  return li;
}
var Nf;
function oc() {
  return Nf || (Nf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ Zt()), i = a(/* @__PURE__ */ cr()), o = /* @__PURE__ */ ts();
    function u(s, l) {
      var c, d, f, v, y, C, h, g;
      (0, r.default)(1, arguments);
      var p = (0, o.getDefaultOptions)(), w = (0, i.default)((c = (d = (f = (v = l == null ? void 0 : l.weekStartsOn) !== null && v !== void 0 ? v : l == null || (y = l.locale) === null || y === void 0 || (C = y.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && f !== void 0 ? f : p.weekStartsOn) !== null && d !== void 0 ? d : (h = p.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && c !== void 0 ? c : 0);
      if (!(w >= 0 && w <= 6))
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      var k = (0, n.default)(s), S = k.getUTCDay(), T = (S < w ? 7 : 0) + S - w;
      return k.setUTCDate(k.getUTCDate() - T), k.setUTCHours(0, 0, 0, 0), k;
    }
    e.exports = t.default;
  })(fo, fo.exports)), fo.exports;
}
var vo = { exports: {} }, ho = { exports: {} }, Lf;
function Im() {
  return Lf || (Lf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ Zt()), i = a(/* @__PURE__ */ oc()), o = a(/* @__PURE__ */ cr()), u = /* @__PURE__ */ ts();
    function s(l, c) {
      var d, f, v, y, C, h, g, p;
      (0, r.default)(1, arguments);
      var w = (0, n.default)(l), k = w.getUTCFullYear(), S = (0, u.getDefaultOptions)(), T = (0, o.default)((d = (f = (v = (y = c == null ? void 0 : c.firstWeekContainsDate) !== null && y !== void 0 ? y : c == null || (C = c.locale) === null || C === void 0 || (h = C.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && v !== void 0 ? v : S.firstWeekContainsDate) !== null && f !== void 0 ? f : (g = S.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && d !== void 0 ? d : 1);
      if (!(T >= 1 && T <= 7))
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      var A = /* @__PURE__ */ new Date(0);
      A.setUTCFullYear(k + 1, 0, T), A.setUTCHours(0, 0, 0, 0);
      var F = (0, i.default)(A, c), Z = /* @__PURE__ */ new Date(0);
      Z.setUTCFullYear(k, 0, T), Z.setUTCHours(0, 0, 0, 0);
      var O = (0, i.default)(Z, c);
      return w.getTime() >= F.getTime() ? k + 1 : w.getTime() >= O.getTime() ? k : k - 1;
    }
    e.exports = t.default;
  })(ho, ho.exports)), ho.exports;
}
var Bf;
function t5() {
  return Bf || (Bf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var n = a(/* @__PURE__ */ Im()), r = a(/* @__PURE__ */ Zt()), i = a(/* @__PURE__ */ oc()), o = a(/* @__PURE__ */ cr()), u = /* @__PURE__ */ ts();
    function s(l, c) {
      var d, f, v, y, C, h, g, p;
      (0, r.default)(1, arguments);
      var w = (0, u.getDefaultOptions)(), k = (0, o.default)((d = (f = (v = (y = c == null ? void 0 : c.firstWeekContainsDate) !== null && y !== void 0 ? y : c == null || (C = c.locale) === null || C === void 0 || (h = C.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && v !== void 0 ? v : w.firstWeekContainsDate) !== null && f !== void 0 ? f : (g = w.locale) === null || g === void 0 || (p = g.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && d !== void 0 ? d : 1), S = (0, n.default)(l, c), T = /* @__PURE__ */ new Date(0);
      T.setUTCFullYear(S, 0, k), T.setUTCHours(0, 0, 0, 0);
      var A = (0, i.default)(T, c);
      return A;
    }
    e.exports = t.default;
  })(vo, vo.exports)), vo.exports;
}
var Rf;
function a5() {
  return Rf || (Rf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var n = a(/* @__PURE__ */ ja()), r = a(/* @__PURE__ */ oc()), i = a(/* @__PURE__ */ t5()), o = a(/* @__PURE__ */ Zt()), u = 6048e5;
    function s(l, c) {
      (0, o.default)(1, arguments);
      var d = (0, n.default)(l), f = (0, r.default)(d, c).getTime() - (0, i.default)(d, c).getTime();
      return Math.round(f / u) + 1;
    }
    e.exports = t.default;
  })(co, co.exports)), co.exports;
}
var go = { exports: {} }, Ff;
function Em() {
  return Ff || (Ff = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      for (var i = n < 0 ? "-" : "", o = Math.abs(n).toString(); o.length < r; )
        o = "0" + o;
      return i + o;
    }
    e.exports = t.default;
  })(go, go.exports)), go.exports;
}
var mo = { exports: {} }, zf;
function n5() {
  return zf || (zf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ Em()), r = {
      // Year
      y: function(u, s) {
        var l = u.getUTCFullYear(), c = l > 0 ? l : 1 - l;
        return (0, n.default)(s === "yy" ? c % 100 : c, s.length);
      },
      // Month
      M: function(u, s) {
        var l = u.getUTCMonth();
        return s === "M" ? String(l + 1) : (0, n.default)(l + 1, 2);
      },
      // Day of the month
      d: function(u, s) {
        return (0, n.default)(u.getUTCDate(), s.length);
      },
      // AM or PM
      a: function(u, s) {
        var l = u.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch (s) {
          case "a":
          case "aa":
            return l.toUpperCase();
          case "aaa":
            return l;
          case "aaaaa":
            return l[0];
          case "aaaa":
          default:
            return l === "am" ? "a.m." : "p.m.";
        }
      },
      // Hour [1-12]
      h: function(u, s) {
        return (0, n.default)(u.getUTCHours() % 12 || 12, s.length);
      },
      // Hour [0-23]
      H: function(u, s) {
        return (0, n.default)(u.getUTCHours(), s.length);
      },
      // Minute
      m: function(u, s) {
        return (0, n.default)(u.getUTCMinutes(), s.length);
      },
      // Second
      s: function(u, s) {
        return (0, n.default)(u.getUTCSeconds(), s.length);
      },
      // Fraction of second
      S: function(u, s) {
        var l = s.length, c = u.getUTCMilliseconds(), d = Math.floor(c * Math.pow(10, l - 3));
        return (0, n.default)(d, s.length);
      }
    }, i = r;
    t.default = i, e.exports = t.default;
  })(mo, mo.exports)), mo.exports;
}
var Yf;
function r5() {
  return Yf || (Yf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ Jx()), r = a(/* @__PURE__ */ e5()), i = a(/* @__PURE__ */ Am()), o = a(/* @__PURE__ */ a5()), u = a(/* @__PURE__ */ Im()), s = a(/* @__PURE__ */ Em()), l = a(/* @__PURE__ */ n5()), c = {
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }, d = {
      // Era
      G: function(g, p, w) {
        var k = g.getUTCFullYear() > 0 ? 1 : 0;
        switch (p) {
          // AD, BC
          case "G":
          case "GG":
          case "GGG":
            return w.era(k, {
              width: "abbreviated"
            });
          // A, B
          case "GGGGG":
            return w.era(k, {
              width: "narrow"
            });
          // Anno Domini, Before Christ
          case "GGGG":
          default:
            return w.era(k, {
              width: "wide"
            });
        }
      },
      // Year
      y: function(g, p, w) {
        if (p === "yo") {
          var k = g.getUTCFullYear(), S = k > 0 ? k : 1 - k;
          return w.ordinalNumber(S, {
            unit: "year"
          });
        }
        return l.default.y(g, p);
      },
      // Local week-numbering year
      Y: function(g, p, w, k) {
        var S = (0, u.default)(g, k), T = S > 0 ? S : 1 - S;
        if (p === "YY") {
          var A = T % 100;
          return (0, s.default)(A, 2);
        }
        return p === "Yo" ? w.ordinalNumber(T, {
          unit: "year"
        }) : (0, s.default)(T, p.length);
      },
      // ISO week-numbering year
      R: function(g, p) {
        var w = (0, i.default)(g);
        return (0, s.default)(w, p.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function(g, p) {
        var w = g.getUTCFullYear();
        return (0, s.default)(w, p.length);
      },
      // Quarter
      Q: function(g, p, w) {
        var k = Math.ceil((g.getUTCMonth() + 1) / 3);
        switch (p) {
          // 1, 2, 3, 4
          case "Q":
            return String(k);
          // 01, 02, 03, 04
          case "QQ":
            return (0, s.default)(k, 2);
          // 1st, 2nd, 3rd, 4th
          case "Qo":
            return w.ordinalNumber(k, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "QQQ":
            return w.quarter(k, {
              width: "abbreviated",
              context: "formatting"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "QQQQQ":
            return w.quarter(k, {
              width: "narrow",
              context: "formatting"
            });
          // 1st quarter, 2nd quarter, ...
          case "QQQQ":
          default:
            return w.quarter(k, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone quarter
      q: function(g, p, w) {
        var k = Math.ceil((g.getUTCMonth() + 1) / 3);
        switch (p) {
          // 1, 2, 3, 4
          case "q":
            return String(k);
          // 01, 02, 03, 04
          case "qq":
            return (0, s.default)(k, 2);
          // 1st, 2nd, 3rd, 4th
          case "qo":
            return w.ordinalNumber(k, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "qqq":
            return w.quarter(k, {
              width: "abbreviated",
              context: "standalone"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "qqqqq":
            return w.quarter(k, {
              width: "narrow",
              context: "standalone"
            });
          // 1st quarter, 2nd quarter, ...
          case "qqqq":
          default:
            return w.quarter(k, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Month
      M: function(g, p, w) {
        var k = g.getUTCMonth();
        switch (p) {
          case "M":
          case "MM":
            return l.default.M(g, p);
          // 1st, 2nd, ..., 12th
          case "Mo":
            return w.ordinalNumber(k + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "MMM":
            return w.month(k, {
              width: "abbreviated",
              context: "formatting"
            });
          // J, F, ..., D
          case "MMMMM":
            return w.month(k, {
              width: "narrow",
              context: "formatting"
            });
          // January, February, ..., December
          case "MMMM":
          default:
            return w.month(k, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone month
      L: function(g, p, w) {
        var k = g.getUTCMonth();
        switch (p) {
          // 1, 2, ..., 12
          case "L":
            return String(k + 1);
          // 01, 02, ..., 12
          case "LL":
            return (0, s.default)(k + 1, 2);
          // 1st, 2nd, ..., 12th
          case "Lo":
            return w.ordinalNumber(k + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "LLL":
            return w.month(k, {
              width: "abbreviated",
              context: "standalone"
            });
          // J, F, ..., D
          case "LLLLL":
            return w.month(k, {
              width: "narrow",
              context: "standalone"
            });
          // January, February, ..., December
          case "LLLL":
          default:
            return w.month(k, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Local week of year
      w: function(g, p, w, k) {
        var S = (0, o.default)(g, k);
        return p === "wo" ? w.ordinalNumber(S, {
          unit: "week"
        }) : (0, s.default)(S, p.length);
      },
      // ISO week of year
      I: function(g, p, w) {
        var k = (0, r.default)(g);
        return p === "Io" ? w.ordinalNumber(k, {
          unit: "week"
        }) : (0, s.default)(k, p.length);
      },
      // Day of the month
      d: function(g, p, w) {
        return p === "do" ? w.ordinalNumber(g.getUTCDate(), {
          unit: "date"
        }) : l.default.d(g, p);
      },
      // Day of year
      D: function(g, p, w) {
        var k = (0, n.default)(g);
        return p === "Do" ? w.ordinalNumber(k, {
          unit: "dayOfYear"
        }) : (0, s.default)(k, p.length);
      },
      // Day of week
      E: function(g, p, w) {
        var k = g.getUTCDay();
        switch (p) {
          // Tue
          case "E":
          case "EE":
          case "EEE":
            return w.day(k, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "EEEEE":
            return w.day(k, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "EEEEEE":
            return w.day(k, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "EEEE":
          default:
            return w.day(k, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Local day of week
      e: function(g, p, w, k) {
        var S = g.getUTCDay(), T = (S - k.weekStartsOn + 8) % 7 || 7;
        switch (p) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case "e":
            return String(T);
          // Padded numerical value
          case "ee":
            return (0, s.default)(T, 2);
          // 1st, 2nd, ..., 7th
          case "eo":
            return w.ordinalNumber(T, {
              unit: "day"
            });
          case "eee":
            return w.day(S, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "eeeee":
            return w.day(S, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "eeeeee":
            return w.day(S, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "eeee":
          default:
            return w.day(S, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone local day of week
      c: function(g, p, w, k) {
        var S = g.getUTCDay(), T = (S - k.weekStartsOn + 8) % 7 || 7;
        switch (p) {
          // Numerical value (same as in `e`)
          case "c":
            return String(T);
          // Padded numerical value
          case "cc":
            return (0, s.default)(T, p.length);
          // 1st, 2nd, ..., 7th
          case "co":
            return w.ordinalNumber(T, {
              unit: "day"
            });
          case "ccc":
            return w.day(S, {
              width: "abbreviated",
              context: "standalone"
            });
          // T
          case "ccccc":
            return w.day(S, {
              width: "narrow",
              context: "standalone"
            });
          // Tu
          case "cccccc":
            return w.day(S, {
              width: "short",
              context: "standalone"
            });
          // Tuesday
          case "cccc":
          default:
            return w.day(S, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // ISO day of week
      i: function(g, p, w) {
        var k = g.getUTCDay(), S = k === 0 ? 7 : k;
        switch (p) {
          // 2
          case "i":
            return String(S);
          // 02
          case "ii":
            return (0, s.default)(S, p.length);
          // 2nd
          case "io":
            return w.ordinalNumber(S, {
              unit: "day"
            });
          // Tue
          case "iii":
            return w.day(k, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "iiiii":
            return w.day(k, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "iiiiii":
            return w.day(k, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "iiii":
          default:
            return w.day(k, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM or PM
      a: function(g, p, w) {
        var k = g.getUTCHours(), S = k / 12 >= 1 ? "pm" : "am";
        switch (p) {
          case "a":
          case "aa":
            return w.dayPeriod(S, {
              width: "abbreviated",
              context: "formatting"
            });
          case "aaa":
            return w.dayPeriod(S, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "aaaaa":
            return w.dayPeriod(S, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return w.dayPeriod(S, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM, PM, midnight, noon
      b: function(g, p, w) {
        var k = g.getUTCHours(), S;
        switch (k === 12 ? S = c.noon : k === 0 ? S = c.midnight : S = k / 12 >= 1 ? "pm" : "am", p) {
          case "b":
          case "bb":
            return w.dayPeriod(S, {
              width: "abbreviated",
              context: "formatting"
            });
          case "bbb":
            return w.dayPeriod(S, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "bbbbb":
            return w.dayPeriod(S, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return w.dayPeriod(S, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function(g, p, w) {
        var k = g.getUTCHours(), S;
        switch (k >= 17 ? S = c.evening : k >= 12 ? S = c.afternoon : k >= 4 ? S = c.morning : S = c.night, p) {
          case "B":
          case "BB":
          case "BBB":
            return w.dayPeriod(S, {
              width: "abbreviated",
              context: "formatting"
            });
          case "BBBBB":
            return w.dayPeriod(S, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return w.dayPeriod(S, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Hour [1-12]
      h: function(g, p, w) {
        if (p === "ho") {
          var k = g.getUTCHours() % 12;
          return k === 0 && (k = 12), w.ordinalNumber(k, {
            unit: "hour"
          });
        }
        return l.default.h(g, p);
      },
      // Hour [0-23]
      H: function(g, p, w) {
        return p === "Ho" ? w.ordinalNumber(g.getUTCHours(), {
          unit: "hour"
        }) : l.default.H(g, p);
      },
      // Hour [0-11]
      K: function(g, p, w) {
        var k = g.getUTCHours() % 12;
        return p === "Ko" ? w.ordinalNumber(k, {
          unit: "hour"
        }) : (0, s.default)(k, p.length);
      },
      // Hour [1-24]
      k: function(g, p, w) {
        var k = g.getUTCHours();
        return k === 0 && (k = 24), p === "ko" ? w.ordinalNumber(k, {
          unit: "hour"
        }) : (0, s.default)(k, p.length);
      },
      // Minute
      m: function(g, p, w) {
        return p === "mo" ? w.ordinalNumber(g.getUTCMinutes(), {
          unit: "minute"
        }) : l.default.m(g, p);
      },
      // Second
      s: function(g, p, w) {
        return p === "so" ? w.ordinalNumber(g.getUTCSeconds(), {
          unit: "second"
        }) : l.default.s(g, p);
      },
      // Fraction of second
      S: function(g, p) {
        return l.default.S(g, p);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function(g, p, w, k) {
        var S = k._originalDate || g, T = S.getTimezoneOffset();
        if (T === 0)
          return "Z";
        switch (p) {
          // Hours and optional minutes
          case "X":
            return v(T);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return y(T);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimiter
          default:
            return y(T, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function(g, p, w, k) {
        var S = k._originalDate || g, T = S.getTimezoneOffset();
        switch (p) {
          // Hours and optional minutes
          case "x":
            return v(T);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return y(T);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimiter
          default:
            return y(T, ":");
        }
      },
      // Timezone (GMT)
      O: function(g, p, w, k) {
        var S = k._originalDate || g, T = S.getTimezoneOffset();
        switch (p) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + f(T, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + y(T, ":");
        }
      },
      // Timezone (specific non-location)
      z: function(g, p, w, k) {
        var S = k._originalDate || g, T = S.getTimezoneOffset();
        switch (p) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return "GMT" + f(T, ":");
          // Long
          case "zzzz":
          default:
            return "GMT" + y(T, ":");
        }
      },
      // Seconds timestamp
      t: function(g, p, w, k) {
        var S = k._originalDate || g, T = Math.floor(S.getTime() / 1e3);
        return (0, s.default)(T, p.length);
      },
      // Milliseconds timestamp
      T: function(g, p, w, k) {
        var S = k._originalDate || g, T = S.getTime();
        return (0, s.default)(T, p.length);
      }
    };
    function f(h, g) {
      var p = h > 0 ? "-" : "+", w = Math.abs(h), k = Math.floor(w / 60), S = w % 60;
      if (S === 0)
        return p + String(k);
      var T = g;
      return p + String(k) + T + (0, s.default)(S, 2);
    }
    function v(h, g) {
      if (h % 60 === 0) {
        var p = h > 0 ? "-" : "+";
        return p + (0, s.default)(Math.abs(h) / 60, 2);
      }
      return y(h, g);
    }
    function y(h, g) {
      var p = g || "", w = h > 0 ? "-" : "+", k = Math.abs(h), S = (0, s.default)(Math.floor(k / 60), 2), T = (0, s.default)(k % 60, 2);
      return w + S + p + T;
    }
    var C = d;
    t.default = C, e.exports = t.default;
  })(ro, ro.exports)), ro.exports;
}
var po = { exports: {} }, Hf;
function i5() {
  return Hf || (Hf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = function(s, l) {
      switch (s) {
        case "P":
          return l.date({
            width: "short"
          });
        case "PP":
          return l.date({
            width: "medium"
          });
        case "PPP":
          return l.date({
            width: "long"
          });
        case "PPPP":
        default:
          return l.date({
            width: "full"
          });
      }
    }, n = function(s, l) {
      switch (s) {
        case "p":
          return l.time({
            width: "short"
          });
        case "pp":
          return l.time({
            width: "medium"
          });
        case "ppp":
          return l.time({
            width: "long"
          });
        case "pppp":
        default:
          return l.time({
            width: "full"
          });
      }
    }, r = function(s, l) {
      var c = s.match(/(P+)(p+)?/) || [], d = c[1], f = c[2];
      if (!f)
        return a(s, l);
      var v;
      switch (d) {
        case "P":
          v = l.dateTime({
            width: "short"
          });
          break;
        case "PP":
          v = l.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          v = l.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          v = l.dateTime({
            width: "full"
          });
          break;
      }
      return v.replace("{{date}}", a(d, l)).replace("{{time}}", n(f, l));
    }, i = {
      p: n,
      P: r
    }, o = i;
    t.default = o, e.exports = t.default;
  })(po, po.exports)), po.exports;
}
var yo = { exports: {} }, qf;
function Mm() {
  return qf || (qf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      var r = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
      return r.setUTCFullYear(n.getFullYear()), n.getTime() - r.getTime();
    }
    e.exports = t.default;
  })(yo, yo.exports)), yo.exports;
}
var yr = {}, Wf;
function o5() {
  if (Wf) return yr;
  Wf = 1, Object.defineProperty(yr, "__esModule", {
    value: !0
  }), yr.isProtectedDayOfYearToken = a, yr.isProtectedWeekYearToken = n, yr.throwProtectedError = r;
  var e = ["D", "DD"], t = ["YY", "YYYY"];
  function a(i) {
    return e.indexOf(i) !== -1;
  }
  function n(i) {
    return t.indexOf(i) !== -1;
  }
  function r(i, o, u) {
    if (i === "YYYY")
      throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(o, "`) for formatting years to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "YY")
      throw new RangeError("Use `yy` instead of `YY` (in `".concat(o, "`) for formatting years to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "D")
      throw new RangeError("Use `d` instead of `D` (in `".concat(o, "`) for formatting days of the month to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "DD")
      throw new RangeError("Use `dd` instead of `DD` (in `".concat(o, "`) for formatting days of the month to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
  return yr;
}
var bo = { exports: {} }, wo = { exports: {} }, Co = { exports: {} }, Uf;
function l5() {
  return Uf || (Uf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    }, n = function(o, u, s) {
      var l, c = a[o];
      return typeof c == "string" ? l = c : u === 1 ? l = c.one : l = c.other.replace("{{count}}", u.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + l : l + " ago" : l;
    }, r = n;
    t.default = r, e.exports = t.default;
  })(Co, Co.exports)), Co.exports;
}
var ko = { exports: {} }, $o = { exports: {} }, Kf;
function s5() {
  return Kf || (Kf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = r.width ? String(r.width) : n.defaultWidth, o = n.formats[i] || n.formats[n.defaultWidth];
        return o;
      };
    }
    e.exports = t.default;
  })($o, $o.exports)), $o.exports;
}
var Vf;
function u5() {
  return Vf || (Vf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ s5()), r = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    }, i = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    }, o = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    }, u = {
      date: (0, n.default)({
        formats: r,
        defaultWidth: "full"
      }),
      time: (0, n.default)({
        formats: i,
        defaultWidth: "full"
      }),
      dateTime: (0, n.default)({
        formats: o,
        defaultWidth: "full"
      })
    }, s = u;
    t.default = s, e.exports = t.default;
  })(ko, ko.exports)), ko.exports;
}
var So = { exports: {} }, jf;
function c5() {
  return jf || (jf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    }, n = function(o, u, s, l) {
      return a[o];
    }, r = n;
    t.default = r, e.exports = t.default;
  })(So, So.exports)), So.exports;
}
var xo = { exports: {} }, To = { exports: {} }, Gf;
function d5() {
  return Gf || (Gf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function(r, i) {
        var o = i != null && i.context ? String(i.context) : "standalone", u;
        if (o === "formatting" && n.formattingValues) {
          var s = n.defaultFormattingWidth || n.defaultWidth, l = i != null && i.width ? String(i.width) : s;
          u = n.formattingValues[l] || n.formattingValues[s];
        } else {
          var c = n.defaultWidth, d = i != null && i.width ? String(i.width) : n.defaultWidth;
          u = n.values[d] || n.values[c];
        }
        var f = n.argumentCallback ? n.argumentCallback(r) : r;
        return u[f];
      };
    }
    e.exports = t.default;
  })(To, To.exports)), To.exports;
}
var Qf;
function f5() {
  return Qf || (Qf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ d5()), r = {
      narrow: ["B", "A"],
      abbreviated: ["BC", "AD"],
      wide: ["Before Christ", "Anno Domini"]
    }, i = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
    }, o = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }, u = {
      narrow: ["S", "M", "T", "W", "T", "F", "S"],
      short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    }, s = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      }
    }, l = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      }
    }, c = function(y, C) {
      var h = Number(y), g = h % 100;
      if (g > 20 || g < 10)
        switch (g % 10) {
          case 1:
            return h + "st";
          case 2:
            return h + "nd";
          case 3:
            return h + "rd";
        }
      return h + "th";
    }, d = {
      ordinalNumber: c,
      era: (0, n.default)({
        values: r,
        defaultWidth: "wide"
      }),
      quarter: (0, n.default)({
        values: i,
        defaultWidth: "wide",
        argumentCallback: function(y) {
          return y - 1;
        }
      }),
      month: (0, n.default)({
        values: o,
        defaultWidth: "wide"
      }),
      day: (0, n.default)({
        values: u,
        defaultWidth: "wide"
      }),
      dayPeriod: (0, n.default)({
        values: s,
        defaultWidth: "wide",
        formattingValues: l,
        defaultFormattingWidth: "wide"
      })
    }, f = d;
    t.default = f, e.exports = t.default;
  })(xo, xo.exports)), xo.exports;
}
var Do = { exports: {} }, Ao = { exports: {} }, Zf;
function v5() {
  return Zf || (Zf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(i) {
      return function(o) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = u.width, l = s && i.matchPatterns[s] || i.matchPatterns[i.defaultMatchWidth], c = o.match(l);
        if (!c)
          return null;
        var d = c[0], f = s && i.parsePatterns[s] || i.parsePatterns[i.defaultParseWidth], v = Array.isArray(f) ? r(f, function(h) {
          return h.test(d);
        }) : n(f, function(h) {
          return h.test(d);
        }), y;
        y = i.valueCallback ? i.valueCallback(v) : v, y = u.valueCallback ? u.valueCallback(y) : y;
        var C = o.slice(d.length);
        return {
          value: y,
          rest: C
        };
      };
    }
    function n(i, o) {
      for (var u in i)
        if (i.hasOwnProperty(u) && o(i[u]))
          return u;
    }
    function r(i, o) {
      for (var u = 0; u < i.length; u++)
        if (o(i[u]))
          return u;
    }
    e.exports = t.default;
  })(Ao, Ao.exports)), Ao.exports;
}
var Io = { exports: {} }, Xf;
function h5() {
  return Xf || (Xf = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function(r) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.match(n.matchPattern);
        if (!o) return null;
        var u = o[0], s = r.match(n.parsePattern);
        if (!s) return null;
        var l = n.valueCallback ? n.valueCallback(s[0]) : s[0];
        l = i.valueCallback ? i.valueCallback(l) : l;
        var c = r.slice(u.length);
        return {
          value: l,
          rest: c
        };
      };
    }
    e.exports = t.default;
  })(Io, Io.exports)), Io.exports;
}
var Jf;
function g5() {
  return Jf || (Jf = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ v5()), r = a(/* @__PURE__ */ h5()), i = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, u = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    }, s = {
      any: [/^b/i, /^(a|c)/i]
    }, l = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    }, c = {
      any: [/1/i, /2/i, /3/i, /4/i]
    }, d = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    }, f = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    }, v = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    }, y = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    }, C = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    }, h = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    }, g = {
      ordinalNumber: (0, r.default)({
        matchPattern: i,
        parsePattern: o,
        valueCallback: function(k) {
          return parseInt(k, 10);
        }
      }),
      era: (0, n.default)({
        matchPatterns: u,
        defaultMatchWidth: "wide",
        parsePatterns: s,
        defaultParseWidth: "any"
      }),
      quarter: (0, n.default)({
        matchPatterns: l,
        defaultMatchWidth: "wide",
        parsePatterns: c,
        defaultParseWidth: "any",
        valueCallback: function(k) {
          return k + 1;
        }
      }),
      month: (0, n.default)({
        matchPatterns: d,
        defaultMatchWidth: "wide",
        parsePatterns: f,
        defaultParseWidth: "any"
      }),
      day: (0, n.default)({
        matchPatterns: v,
        defaultMatchWidth: "wide",
        parsePatterns: y,
        defaultParseWidth: "any"
      }),
      dayPeriod: (0, n.default)({
        matchPatterns: C,
        defaultMatchWidth: "any",
        parsePatterns: h,
        defaultParseWidth: "any"
      })
    }, p = g;
    t.default = p, e.exports = t.default;
  })(Do, Do.exports)), Do.exports;
}
var _f;
function m5() {
  return _f || (_f = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ l5()), r = a(/* @__PURE__ */ u5()), i = a(/* @__PURE__ */ c5()), o = a(/* @__PURE__ */ f5()), u = a(/* @__PURE__ */ g5()), s = {
      code: "en-US",
      formatDistance: n.default,
      formatLong: r.default,
      formatRelative: i.default,
      localize: o.default,
      match: u.default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    }, l = s;
    t.default = l, e.exports = t.default;
  })(wo, wo.exports)), wo.exports;
}
var ev;
function p5() {
  return ev || (ev = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ m5()), r = n.default;
    t.default = r, e.exports = t.default;
  })(bo, bo.exports)), bo.exports;
}
var tv;
function y5() {
  return tv || (tv = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = w;
    var n = a(/* @__PURE__ */ Qx()), r = a(/* @__PURE__ */ Xx()), i = a(/* @__PURE__ */ ja()), o = a(/* @__PURE__ */ r5()), u = a(/* @__PURE__ */ i5()), s = a(/* @__PURE__ */ Mm()), l = /* @__PURE__ */ o5(), c = a(/* @__PURE__ */ cr()), d = a(/* @__PURE__ */ Zt()), f = /* @__PURE__ */ ts(), v = a(/* @__PURE__ */ p5()), y = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, C = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, h = /^'([^]*?)'?$/, g = /''/g, p = /[a-zA-Z]/;
    function w(S, T, A) {
      var F, Z, O, z, U, x, I, E, P, R, K, J, q, se, fe, ne, ae, ve;
      (0, d.default)(2, arguments);
      var Ae = String(T), Te = (0, f.getDefaultOptions)(), Le = (F = (Z = A == null ? void 0 : A.locale) !== null && Z !== void 0 ? Z : Te.locale) !== null && F !== void 0 ? F : v.default, ze = (0, c.default)((O = (z = (U = (x = A == null ? void 0 : A.firstWeekContainsDate) !== null && x !== void 0 ? x : A == null || (I = A.locale) === null || I === void 0 || (E = I.options) === null || E === void 0 ? void 0 : E.firstWeekContainsDate) !== null && U !== void 0 ? U : Te.firstWeekContainsDate) !== null && z !== void 0 ? z : (P = Te.locale) === null || P === void 0 || (R = P.options) === null || R === void 0 ? void 0 : R.firstWeekContainsDate) !== null && O !== void 0 ? O : 1);
      if (!(ze >= 1 && ze <= 7))
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      var _e = (0, c.default)((K = (J = (q = (se = A == null ? void 0 : A.weekStartsOn) !== null && se !== void 0 ? se : A == null || (fe = A.locale) === null || fe === void 0 || (ne = fe.options) === null || ne === void 0 ? void 0 : ne.weekStartsOn) !== null && q !== void 0 ? q : Te.weekStartsOn) !== null && J !== void 0 ? J : (ae = Te.locale) === null || ae === void 0 || (ve = ae.options) === null || ve === void 0 ? void 0 : ve.weekStartsOn) !== null && K !== void 0 ? K : 0);
      if (!(_e >= 0 && _e <= 6))
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      if (!Le.localize)
        throw new RangeError("locale must contain localize property");
      if (!Le.formatLong)
        throw new RangeError("locale must contain formatLong property");
      var tt = (0, i.default)(S);
      if (!(0, n.default)(tt))
        throw new RangeError("Invalid time value");
      var Xe = (0, s.default)(tt), et = (0, r.default)(tt, Xe), pe = {
        firstWeekContainsDate: ze,
        weekStartsOn: _e,
        locale: Le,
        _originalDate: tt
      }, me = Ae.match(C).map(function(he) {
        var V = he[0];
        if (V === "p" || V === "P") {
          var Se = u.default[V];
          return Se(he, Le.formatLong);
        }
        return he;
      }).join("").match(y).map(function(he) {
        if (he === "''")
          return "'";
        var V = he[0];
        if (V === "'")
          return k(he);
        var Se = o.default[V];
        if (Se)
          return !(A != null && A.useAdditionalWeekYearTokens) && (0, l.isProtectedWeekYearToken)(he) && (0, l.throwProtectedError)(he, T, String(S)), !(A != null && A.useAdditionalDayOfYearTokens) && (0, l.isProtectedDayOfYearToken)(he) && (0, l.throwProtectedError)(he, T, String(S)), Se(et, he, Le.localize, pe);
        if (V.match(p))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + V + "`");
        return he;
      }).join("");
      return me;
    }
    function k(S) {
      var T = S.match(h);
      return T ? T[1].replace(g, "'") : S;
    }
    e.exports = t.default;
  })(Zi, Zi.exports)), Zi.exports;
}
var b5 = /* @__PURE__ */ y5();
const w5 = /* @__PURE__ */ es(b5);
function av(e, t, a) {
  var n = $5(e, a.timeZone, a.locale);
  return n.formatToParts ? C5(n, t) : k5(n, t);
}
function C5(e, t) {
  for (var a = e.formatToParts(t), n = a.length - 1; n >= 0; --n)
    if (a[n].type === "timeZoneName")
      return a[n].value;
}
function k5(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(a);
  return n ? n[0].substr(1) : "";
}
function $5(e, t, a) {
  if (a && !a.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(a ? [a.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function S5(e, t) {
  var a = A5(t);
  return a.formatToParts ? T5(a, e) : D5(a, e);
}
var x5 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function T5(e, t) {
  try {
    for (var a = e.formatToParts(t), n = [], r = 0; r < a.length; r++) {
      var i = x5[a[r].type];
      i >= 0 && (n[i] = parseInt(a[r].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function D5(e, t) {
  var a = e.format(t), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var xs = {};
function A5(e) {
  if (!xs[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    xs[e] = a ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return xs[e];
}
function Om(e, t, a, n, r, i, o) {
  var u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(e, t, a), u.setUTCHours(n, r, i, o), u;
}
var nv = 36e5, I5 = 6e4, Ts = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function lc(e, t, a) {
  var n, r;
  if (!e || (n = Ts.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = Ts.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), rv(i) ? -(i * nv) : NaN;
  if (n = Ts.timezoneHHMM.exec(e), n) {
    i = parseInt(n[2], 10);
    var o = parseInt(n[3], 10);
    return rv(i, o) ? (r = Math.abs(i) * nv + o * I5, n[1] === "+" ? -r : r) : NaN;
  }
  if (O5(e)) {
    t = new Date(t || Date.now());
    var u = a ? t : E5(t), s = fu(u, e), l = a ? s : M5(t, s, e);
    return -l;
  }
  return NaN;
}
function E5(e) {
  return Om(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function fu(e, t) {
  var a = S5(e, t), n = Om(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), r = e.getTime(), i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, n - r;
}
function M5(e, t, a) {
  var n = e.getTime(), r = n - t, i = fu(new Date(r), a);
  if (t === i)
    return t;
  r -= i - t;
  var o = fu(new Date(r), a);
  return i === o ? i : Math.max(i, o);
}
function rv(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var iv = {};
function O5(e) {
  if (iv[e]) return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), iv[e] = !0, !0;
  } catch {
    return !1;
  }
}
var P5 = 60 * 1e3, N5 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, a, n) {
    var r = Ds(n.timeZone, e);
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return ov(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Tr(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimeter
      default:
        return Tr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, a, n) {
    var r = Ds(n.timeZone, e);
    switch (t) {
      // Hours and optional minutes
      case "x":
        return ov(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Tr(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimeter
      default:
        return Tr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, a, n) {
    var r = Ds(n.timeZone, e);
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + L5(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Tr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, a, n) {
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return av("short", e, n);
      // Long
      case "zzzz":
      default:
        return av("long", e, n);
    }
  }
};
function Ds(e, t) {
  var a = e ? lc(e, t, !0) / P5 : t.getTimezoneOffset();
  if (Number.isNaN(a))
    throw new RangeError("Invalid time zone specified: " + e);
  return a;
}
function gl(e, t) {
  for (var a = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return a + n;
}
function Tr(e, t) {
  var a = t || "", n = e > 0 ? "-" : "+", r = Math.abs(e), i = gl(Math.floor(r / 60), 2), o = gl(Math.floor(r % 60), 2);
  return n + i + a + o;
}
function ov(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + gl(Math.abs(e) / 60, 2);
  }
  return Tr(e, t);
}
function L5(e, t) {
  var a = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return a + String(r);
  var o = t;
  return a + String(r) + o + gl(i, 2);
}
var B5 = /* @__PURE__ */ cr();
const R5 = /* @__PURE__ */ es(B5);
var F5 = /* @__PURE__ */ Mm();
const lv = /* @__PURE__ */ es(F5);
var z5 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, As = 36e5, sv = 6e4, Y5 = 2, jt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: z5
};
function Pm(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, n = a.additionalDigits == null ? Y5 : R5(a.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = H5(e), i = q5(r.date, n), o = i.year, u = i.restDateString, s = W5(u, o);
  if (isNaN(s))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    var l = s.getTime(), c = 0, d;
    if (r.time && (c = U5(r.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || a.timeZone) {
      if (d = lc(r.timeZone || a.timeZone, new Date(l + c)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = lv(new Date(l + c)), d = lv(new Date(l + c + d));
    return new Date(l + c + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function H5(e) {
  var t = {}, a = jt.dateTimePattern.exec(e), n;
  if (a ? (t.date = a[1], n = a[3]) : (a = jt.datePattern.exec(e), a ? (t.date = a[1], n = a[2]) : (t.date = null, n = e)), n) {
    var r = jt.timeZone.exec(n);
    r ? (t.time = n.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = n;
  }
  return t;
}
function q5(e, t) {
  var a = jt.YYY[t], n = jt.YYYYY[t], r;
  if (r = jt.YYYY.exec(e) || n.exec(e), r) {
    var i = r[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (r = jt.YY.exec(e) || a.exec(e), r) {
    var o = r[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function W5(e, t) {
  if (t === null)
    return null;
  var a, n, r, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (a = jt.MM.exec(e), a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, cv(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = jt.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(a[1], 10);
    return j5(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = jt.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10);
    return cv(t, r, u) ? (n.setUTCFullYear(t, r, u), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = jt.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, dv(t, i) ? uv(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = jt.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    var s = parseInt(a[2], 10) - 1;
    return dv(t, i, s) ? uv(t, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function U5(e) {
  var t, a, n;
  if (t = jt.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), Is(a) ? a % 24 * As : NaN;
  if (t = jt.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Is(a, n) ? a % 24 * As + n * sv : NaN;
  if (t = jt.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return Is(a, n, r) ? a % 24 * As + n * sv + r * 1e3 : NaN;
  }
  return null;
}
function uv(e, t, a) {
  t = t || 0, a = a || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var r = n.getUTCDay() || 7, i = t * 7 + a + 1 - r;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var K5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], V5 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Nm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function cv(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var n = Nm(e);
    if (n && a > V5[t] || !n && a > K5[t])
      return !1;
  }
  return !0;
}
function j5(e, t) {
  if (t < 1)
    return !1;
  var a = Nm(e);
  return !(a && t > 366 || !a && t > 365);
}
function dv(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function Is(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
var G5 = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function Q5(e, t, a) {
  var n = String(t), r = a || {}, i = n.match(G5);
  if (i) {
    var o = Pm(r.originalDate || e, r);
    n = i.reduce(function(u, s) {
      if (s[0] === "'")
        return u;
      var l = u.indexOf(s), c = u[l - 1] === "'", d = u.replace(
        s,
        "'" + N5[s[0]](o, s, null, r) + "'"
      );
      return c ? d.substring(0, l - 1) + d.substring(l + 1) : d;
    }, n);
  }
  return w5(e, n, r);
}
var Eo = { exports: {} }, Mo = { exports: {} }, fv;
function Z5() {
  return fv || (fv = 1, (function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      if (n == null)
        throw new TypeError("assign requires that input parameter not be null or undefined");
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
      return n;
    }
    e.exports = t.default;
  })(Mo, Mo.exports)), Mo.exports;
}
var vv;
function X5() {
  return vv || (vv = 1, (function(e, t) {
    var a = St().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var n = a(/* @__PURE__ */ Z5());
    function r(i) {
      return (0, n.default)({}, i);
    }
    e.exports = t.default;
  })(Eo, Eo.exports)), Eo.exports;
}
var J5 = /* @__PURE__ */ X5();
const _5 = /* @__PURE__ */ es(J5);
function e3(e, t, a) {
  var n = Pm(e, a), r = lc(t, n, !0), i = new Date(n.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
}
function Es(e, t, a, n) {
  var r = _5(n);
  return r.timeZone = t, r.originalDate = e, Q5(e3(e, t), a, r);
}
function $n(e, t) {
  z1(`Invalid prop: validator check failed for prop "${e}". ${t}`);
}
const t3 = { class: "k-segmented-control" }, a3 = ["data-testid", "disabled", "onClick"], n3 = /* @__PURE__ */ oe({
  __name: "KSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: { default: "small" },
    disabled: { type: Boolean }
  },
  emits: ["click", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = (d) => d.every((f) => f.value !== void 0), n = (d) => {
      const f = [];
      return d.forEach((v) => f.push(v.value + "")), f;
    }, r = (d) => {
      const f = n(d), v = new Set(f);
      return f.length === v.size;
    }, i = (d) => d.map((f) => ({
      label: typeof f == "string" ? f : f.label || f.value + "",
      value: typeof f == "string" ? f.toLocaleLowerCase().replace(" ", "-") : f.value,
      disabled: typeof f == "string" ? !1 : f.disabled
    })), o = (d) => {
      const f = typeof d[0] == "string", v = i(d), y = r(v);
      return f ? y && a(v) : y;
    };
    ie(() => e.options, (d) => {
      o(d) || $n("options", "The options prop must be an array of unique strings or objects with a unique value property.");
    }, { immediate: !0 });
    const u = t, s = b(() => i(e.options)), l = (d) => !!d.disabled || e.disabled, c = (d) => {
      u("click", d.value), u("update:modelValue", d.value);
    };
    return (d, f) => (m(), $("div", t3, [
      (m(!0), $(Ee, null, Fe(s.value, (v) => (m(), $("button", {
        key: `${v.value}-option`,
        class: ce(["segmented-control-button", [e.size, { selected: e.modelValue === v.value }]]),
        "data-testid": `${v.value}-option`,
        disabled: l(v),
        type: "button",
        onClick: (y) => c(v)
      }, [
        W(d.$slots, "option-label", { option: v }, () => [
          be(re(v.label), 1)
        ], !0)
      ], 10, a3))), 128))
    ]));
  }
}), Lm = /* @__PURE__ */ Pe(n3, [["__scopeId", "data-v-e4688e7a"]]);
var ta = "top", wa = "bottom", Ca = "right", aa = "left", sc = "auto", Hi = [ta, wa, Ca, aa], Yr = "start", Mi = "end", r3 = "clippingParents", Bm = "viewport", si = "popper", i3 = "reference", hv = /* @__PURE__ */ Hi.reduce(function(e, t) {
  return e.concat([t + "-" + Yr, t + "-" + Mi]);
}, []), Rm = /* @__PURE__ */ [].concat(Hi, [sc]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Yr, t + "-" + Mi]);
}, []), o3 = "beforeRead", l3 = "read", s3 = "afterRead", u3 = "beforeMain", c3 = "main", d3 = "afterMain", f3 = "beforeWrite", v3 = "write", h3 = "afterWrite", g3 = [o3, l3, s3, u3, c3, d3, f3, v3, h3];
function qa(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function da(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function ar(e) {
  var t = da(e).Element;
  return e instanceof t || e instanceof Element;
}
function ga(e) {
  var t = da(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function uc(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = da(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function m3(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(a) {
    var n = t.styles[a] || {}, r = t.attributes[a] || {}, i = t.elements[a];
    !ga(i) || !qa(i) || (Object.assign(i.style, n), Object.keys(r).forEach(function(o) {
      var u = r[o];
      u === !1 ? i.removeAttribute(o) : i.setAttribute(o, u === !0 ? "" : u);
    }));
  });
}
function p3(e) {
  var t = e.state, a = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, a.popper), t.styles = a, t.elements.arrow && Object.assign(t.elements.arrow.style, a.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var r = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : a[n]), u = o.reduce(function(s, l) {
        return s[l] = "", s;
      }, {});
      !ga(r) || !qa(r) || (Object.assign(r.style, u), Object.keys(i).forEach(function(s) {
        r.removeAttribute(s);
      }));
    });
  };
}
const y3 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: m3,
  effect: p3,
  requires: ["computeStyles"]
};
function Fa(e) {
  return e.split("-")[0];
}
var Zn = Math.max, ml = Math.min, Hr = Math.round;
function vu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Fm() {
  return !/^((?!chrome|android).)*safari/i.test(vu());
}
function qr(e, t, a) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  var n = e.getBoundingClientRect(), r = 1, i = 1;
  t && ga(e) && (r = e.offsetWidth > 0 && Hr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Hr(n.height) / e.offsetHeight || 1);
  var o = ar(e) ? da(e) : window, u = o.visualViewport, s = !Fm() && a, l = (n.left + (s && u ? u.offsetLeft : 0)) / r, c = (n.top + (s && u ? u.offsetTop : 0)) / i, d = n.width / r, f = n.height / i;
  return {
    width: d,
    height: f,
    top: c,
    right: l + d,
    bottom: c + f,
    left: l,
    x: l,
    y: c
  };
}
function cc(e) {
  var t = qr(e), a = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - a) <= 1 && (a = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: a,
    height: n
  };
}
function zm(e, t) {
  var a = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (a && uc(a)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function sn(e) {
  return da(e).getComputedStyle(e);
}
function b3(e) {
  return ["table", "td", "th"].indexOf(qa(e)) >= 0;
}
function Rn(e) {
  return ((ar(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function as(e) {
  return qa(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (uc(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Rn(e)
  );
}
function gv(e) {
  return !ga(e) || // https://github.com/popperjs/popper-core/issues/837
  sn(e).position === "fixed" ? null : e.offsetParent;
}
function w3(e) {
  var t = /firefox/i.test(vu()), a = /Trident/i.test(vu());
  if (a && ga(e)) {
    var n = sn(e);
    if (n.position === "fixed")
      return null;
  }
  var r = as(e);
  for (uc(r) && (r = r.host); ga(r) && ["html", "body"].indexOf(qa(r)) < 0; ) {
    var i = sn(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function qi(e) {
  for (var t = da(e), a = gv(e); a && b3(a) && sn(a).position === "static"; )
    a = gv(a);
  return a && (qa(a) === "html" || qa(a) === "body" && sn(a).position === "static") ? t : a || w3(e) || t;
}
function dc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function wi(e, t, a) {
  return Zn(e, ml(t, a));
}
function C3(e, t, a) {
  var n = wi(e, t, a);
  return n > a ? a : n;
}
function Ym() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Hm(e) {
  return Object.assign({}, Ym(), e);
}
function qm(e, t) {
  return t.reduce(function(a, n) {
    return a[n] = e, a;
  }, {});
}
var k3 = function(t, a) {
  return t = typeof t == "function" ? t(Object.assign({}, a.rects, {
    placement: a.placement
  })) : t, Hm(typeof t != "number" ? t : qm(t, Hi));
};
function $3(e) {
  var t, a = e.state, n = e.name, r = e.options, i = a.elements.arrow, o = a.modifiersData.popperOffsets, u = Fa(a.placement), s = dc(u), l = [aa, Ca].indexOf(u) >= 0, c = l ? "height" : "width";
  if (!(!i || !o)) {
    var d = k3(r.padding, a), f = cc(i), v = s === "y" ? ta : aa, y = s === "y" ? wa : Ca, C = a.rects.reference[c] + a.rects.reference[s] - o[s] - a.rects.popper[c], h = o[s] - a.rects.reference[s], g = qi(i), p = g ? s === "y" ? g.clientHeight || 0 : g.clientWidth || 0 : 0, w = C / 2 - h / 2, k = d[v], S = p - f[c] - d[y], T = p / 2 - f[c] / 2 + w, A = wi(k, T, S), F = s;
    a.modifiersData[n] = (t = {}, t[F] = A, t.centerOffset = A - T, t);
  }
}
function S3(e) {
  var t = e.state, a = e.options, n = a.element, r = n === void 0 ? "[data-popper-arrow]" : n;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || zm(t.elements.popper, r) && (t.elements.arrow = r));
}
const x3 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: $3,
  effect: S3,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Wr(e) {
  return e.split("-")[1];
}
var T3 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function D3(e, t) {
  var a = e.x, n = e.y, r = t.devicePixelRatio || 1;
  return {
    x: Hr(a * r) / r || 0,
    y: Hr(n * r) / r || 0
  };
}
function mv(e) {
  var t, a = e.popper, n = e.popperRect, r = e.placement, i = e.variation, o = e.offsets, u = e.position, s = e.gpuAcceleration, l = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = o.x, v = f === void 0 ? 0 : f, y = o.y, C = y === void 0 ? 0 : y, h = typeof c == "function" ? c({
    x: v,
    y: C
  }) : {
    x: v,
    y: C
  };
  v = h.x, C = h.y;
  var g = o.hasOwnProperty("x"), p = o.hasOwnProperty("y"), w = aa, k = ta, S = window;
  if (l) {
    var T = qi(a), A = "clientHeight", F = "clientWidth";
    if (T === da(a) && (T = Rn(a), sn(T).position !== "static" && u === "absolute" && (A = "scrollHeight", F = "scrollWidth")), T = T, r === ta || (r === aa || r === Ca) && i === Mi) {
      k = wa;
      var Z = d && T === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        T[A]
      );
      C -= Z - n.height, C *= s ? 1 : -1;
    }
    if (r === aa || (r === ta || r === wa) && i === Mi) {
      w = Ca;
      var O = d && T === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        T[F]
      );
      v -= O - n.width, v *= s ? 1 : -1;
    }
  }
  var z = Object.assign({
    position: u
  }, l && T3), U = c === !0 ? D3({
    x: v,
    y: C
  }, da(a)) : {
    x: v,
    y: C
  };
  if (v = U.x, C = U.y, s) {
    var x;
    return Object.assign({}, z, (x = {}, x[k] = p ? "0" : "", x[w] = g ? "0" : "", x.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + C + "px)" : "translate3d(" + v + "px, " + C + "px, 0)", x));
  }
  return Object.assign({}, z, (t = {}, t[k] = p ? C + "px" : "", t[w] = g ? v + "px" : "", t.transform = "", t));
}
function A3(e) {
  var t = e.state, a = e.options, n = a.gpuAcceleration, r = n === void 0 ? !0 : n, i = a.adaptive, o = i === void 0 ? !0 : i, u = a.roundOffsets, s = u === void 0 ? !0 : u, l = {
    placement: Fa(t.placement),
    variation: Wr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, mv(Object.assign({}, l, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, mv(Object.assign({}, l, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const I3 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: A3,
  data: {}
};
var Oo = {
  passive: !0
};
function E3(e) {
  var t = e.state, a = e.instance, n = e.options, r = n.scroll, i = r === void 0 ? !0 : r, o = n.resize, u = o === void 0 ? !0 : o, s = da(t.elements.popper), l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && l.forEach(function(c) {
    c.addEventListener("scroll", a.update, Oo);
  }), u && s.addEventListener("resize", a.update, Oo), function() {
    i && l.forEach(function(c) {
      c.removeEventListener("scroll", a.update, Oo);
    }), u && s.removeEventListener("resize", a.update, Oo);
  };
}
const M3 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: E3,
  data: {}
};
var O3 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Uo(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return O3[t];
  });
}
var P3 = {
  start: "end",
  end: "start"
};
function pv(e) {
  return e.replace(/start|end/g, function(t) {
    return P3[t];
  });
}
function fc(e) {
  var t = da(e), a = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: a,
    scrollTop: n
  };
}
function vc(e) {
  return qr(Rn(e)).left + fc(e).scrollLeft;
}
function N3(e, t) {
  var a = da(e), n = Rn(e), r = a.visualViewport, i = n.clientWidth, o = n.clientHeight, u = 0, s = 0;
  if (r) {
    i = r.width, o = r.height;
    var l = Fm();
    (l || !l && t === "fixed") && (u = r.offsetLeft, s = r.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: u + vc(e),
    y: s
  };
}
function L3(e) {
  var t, a = Rn(e), n = fc(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = Zn(a.scrollWidth, a.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = Zn(a.scrollHeight, a.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), u = -n.scrollLeft + vc(e), s = -n.scrollTop;
  return sn(r || a).direction === "rtl" && (u += Zn(a.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: u,
    y: s
  };
}
function hc(e) {
  var t = sn(e), a = t.overflow, n = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(a + r + n);
}
function Wm(e) {
  return ["html", "body", "#document"].indexOf(qa(e)) >= 0 ? e.ownerDocument.body : ga(e) && hc(e) ? e : Wm(as(e));
}
function Ci(e, t) {
  var a;
  t === void 0 && (t = []);
  var n = Wm(e), r = n === ((a = e.ownerDocument) == null ? void 0 : a.body), i = da(n), o = r ? [i].concat(i.visualViewport || [], hc(n) ? n : []) : n, u = t.concat(o);
  return r ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(Ci(as(o)))
  );
}
function hu(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function B3(e, t) {
  var a = qr(e, !1, t === "fixed");
  return a.top = a.top + e.clientTop, a.left = a.left + e.clientLeft, a.bottom = a.top + e.clientHeight, a.right = a.left + e.clientWidth, a.width = e.clientWidth, a.height = e.clientHeight, a.x = a.left, a.y = a.top, a;
}
function yv(e, t, a) {
  return t === Bm ? hu(N3(e, a)) : ar(t) ? B3(t, a) : hu(L3(Rn(e)));
}
function R3(e) {
  var t = Ci(as(e)), a = ["absolute", "fixed"].indexOf(sn(e).position) >= 0, n = a && ga(e) ? qi(e) : e;
  return ar(n) ? t.filter(function(r) {
    return ar(r) && zm(r, n) && qa(r) !== "body";
  }) : [];
}
function F3(e, t, a, n) {
  var r = t === "clippingParents" ? R3(e) : [].concat(t), i = [].concat(r, [a]), o = i[0], u = i.reduce(function(s, l) {
    var c = yv(e, l, n);
    return s.top = Zn(c.top, s.top), s.right = ml(c.right, s.right), s.bottom = ml(c.bottom, s.bottom), s.left = Zn(c.left, s.left), s;
  }, yv(e, o, n));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function Um(e) {
  var t = e.reference, a = e.element, n = e.placement, r = n ? Fa(n) : null, i = n ? Wr(n) : null, o = t.x + t.width / 2 - a.width / 2, u = t.y + t.height / 2 - a.height / 2, s;
  switch (r) {
    case ta:
      s = {
        x: o,
        y: t.y - a.height
      };
      break;
    case wa:
      s = {
        x: o,
        y: t.y + t.height
      };
      break;
    case Ca:
      s = {
        x: t.x + t.width,
        y: u
      };
      break;
    case aa:
      s = {
        x: t.x - a.width,
        y: u
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var l = r ? dc(r) : null;
  if (l != null) {
    var c = l === "y" ? "height" : "width";
    switch (i) {
      case Yr:
        s[l] = s[l] - (t[c] / 2 - a[c] / 2);
        break;
      case Mi:
        s[l] = s[l] + (t[c] / 2 - a[c] / 2);
        break;
    }
  }
  return s;
}
function Oi(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, r = n === void 0 ? e.placement : n, i = a.strategy, o = i === void 0 ? e.strategy : i, u = a.boundary, s = u === void 0 ? r3 : u, l = a.rootBoundary, c = l === void 0 ? Bm : l, d = a.elementContext, f = d === void 0 ? si : d, v = a.altBoundary, y = v === void 0 ? !1 : v, C = a.padding, h = C === void 0 ? 0 : C, g = Hm(typeof h != "number" ? h : qm(h, Hi)), p = f === si ? i3 : si, w = e.rects.popper, k = e.elements[y ? p : f], S = F3(ar(k) ? k : k.contextElement || Rn(e.elements.popper), s, c, o), T = qr(e.elements.reference), A = Um({
    reference: T,
    element: w,
    placement: r
  }), F = hu(Object.assign({}, w, A)), Z = f === si ? F : T, O = {
    top: S.top - Z.top + g.top,
    bottom: Z.bottom - S.bottom + g.bottom,
    left: S.left - Z.left + g.left,
    right: Z.right - S.right + g.right
  }, z = e.modifiersData.offset;
  if (f === si && z) {
    var U = z[r];
    Object.keys(O).forEach(function(x) {
      var I = [Ca, wa].indexOf(x) >= 0 ? 1 : -1, E = [ta, wa].indexOf(x) >= 0 ? "y" : "x";
      O[x] += U[E] * I;
    });
  }
  return O;
}
function z3(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, r = a.boundary, i = a.rootBoundary, o = a.padding, u = a.flipVariations, s = a.allowedAutoPlacements, l = s === void 0 ? Rm : s, c = Wr(n), d = c ? u ? hv : hv.filter(function(y) {
    return Wr(y) === c;
  }) : Hi, f = d.filter(function(y) {
    return l.indexOf(y) >= 0;
  });
  f.length === 0 && (f = d);
  var v = f.reduce(function(y, C) {
    return y[C] = Oi(e, {
      placement: C,
      boundary: r,
      rootBoundary: i,
      padding: o
    })[Fa(C)], y;
  }, {});
  return Object.keys(v).sort(function(y, C) {
    return v[y] - v[C];
  });
}
function Y3(e) {
  if (Fa(e) === sc)
    return [];
  var t = Uo(e);
  return [pv(e), t, pv(t)];
}
function H3(e) {
  var t = e.state, a = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var r = a.mainAxis, i = r === void 0 ? !0 : r, o = a.altAxis, u = o === void 0 ? !0 : o, s = a.fallbackPlacements, l = a.padding, c = a.boundary, d = a.rootBoundary, f = a.altBoundary, v = a.flipVariations, y = v === void 0 ? !0 : v, C = a.allowedAutoPlacements, h = t.options.placement, g = Fa(h), p = g === h, w = s || (p || !y ? [Uo(h)] : Y3(h)), k = [h].concat(w).reduce(function(ae, ve) {
      return ae.concat(Fa(ve) === sc ? z3(t, {
        placement: ve,
        boundary: c,
        rootBoundary: d,
        padding: l,
        flipVariations: y,
        allowedAutoPlacements: C
      }) : ve);
    }, []), S = t.rects.reference, T = t.rects.popper, A = /* @__PURE__ */ new Map(), F = !0, Z = k[0], O = 0; O < k.length; O++) {
      var z = k[O], U = Fa(z), x = Wr(z) === Yr, I = [ta, wa].indexOf(U) >= 0, E = I ? "width" : "height", P = Oi(t, {
        placement: z,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: l
      }), R = I ? x ? Ca : aa : x ? wa : ta;
      S[E] > T[E] && (R = Uo(R));
      var K = Uo(R), J = [];
      if (i && J.push(P[U] <= 0), u && J.push(P[R] <= 0, P[K] <= 0), J.every(function(ae) {
        return ae;
      })) {
        Z = z, F = !1;
        break;
      }
      A.set(z, J);
    }
    if (F)
      for (var q = y ? 3 : 1, se = function(ve) {
        var Ae = k.find(function(Te) {
          var Le = A.get(Te);
          if (Le)
            return Le.slice(0, ve).every(function(ze) {
              return ze;
            });
        });
        if (Ae)
          return Z = Ae, "break";
      }, fe = q; fe > 0; fe--) {
        var ne = se(fe);
        if (ne === "break") break;
      }
    t.placement !== Z && (t.modifiersData[n]._skip = !0, t.placement = Z, t.reset = !0);
  }
}
const q3 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: H3,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function bv(e, t, a) {
  return a === void 0 && (a = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - a.y,
    right: e.right - t.width + a.x,
    bottom: e.bottom - t.height + a.y,
    left: e.left - t.width - a.x
  };
}
function wv(e) {
  return [ta, Ca, wa, aa].some(function(t) {
    return e[t] >= 0;
  });
}
function W3(e) {
  var t = e.state, a = e.name, n = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, o = Oi(t, {
    elementContext: "reference"
  }), u = Oi(t, {
    altBoundary: !0
  }), s = bv(o, n), l = bv(u, r, i), c = wv(s), d = wv(l);
  t.modifiersData[a] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: l,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const U3 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: W3
};
function K3(e, t, a) {
  var n = Fa(e), r = [aa, ta].indexOf(n) >= 0 ? -1 : 1, i = typeof a == "function" ? a(Object.assign({}, t, {
    placement: e
  })) : a, o = i[0], u = i[1];
  return o = o || 0, u = (u || 0) * r, [aa, Ca].indexOf(n) >= 0 ? {
    x: u,
    y: o
  } : {
    x: o,
    y: u
  };
}
function V3(e) {
  var t = e.state, a = e.options, n = e.name, r = a.offset, i = r === void 0 ? [0, 0] : r, o = Rm.reduce(function(c, d) {
    return c[d] = K3(d, t.rects, i), c;
  }, {}), u = o[t.placement], s = u.x, l = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += l), t.modifiersData[n] = o;
}
const j3 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: V3
};
function G3(e) {
  var t = e.state, a = e.name;
  t.modifiersData[a] = Um({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const Q3 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: G3,
  data: {}
};
function Z3(e) {
  return e === "x" ? "y" : "x";
}
function X3(e) {
  var t = e.state, a = e.options, n = e.name, r = a.mainAxis, i = r === void 0 ? !0 : r, o = a.altAxis, u = o === void 0 ? !1 : o, s = a.boundary, l = a.rootBoundary, c = a.altBoundary, d = a.padding, f = a.tether, v = f === void 0 ? !0 : f, y = a.tetherOffset, C = y === void 0 ? 0 : y, h = Oi(t, {
    boundary: s,
    rootBoundary: l,
    padding: d,
    altBoundary: c
  }), g = Fa(t.placement), p = Wr(t.placement), w = !p, k = dc(g), S = Z3(k), T = t.modifiersData.popperOffsets, A = t.rects.reference, F = t.rects.popper, Z = typeof C == "function" ? C(Object.assign({}, t.rects, {
    placement: t.placement
  })) : C, O = typeof Z == "number" ? {
    mainAxis: Z,
    altAxis: Z
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Z), z = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, U = {
    x: 0,
    y: 0
  };
  if (T) {
    if (i) {
      var x, I = k === "y" ? ta : aa, E = k === "y" ? wa : Ca, P = k === "y" ? "height" : "width", R = T[k], K = R + h[I], J = R - h[E], q = v ? -F[P] / 2 : 0, se = p === Yr ? A[P] : F[P], fe = p === Yr ? -F[P] : -A[P], ne = t.elements.arrow, ae = v && ne ? cc(ne) : {
        width: 0,
        height: 0
      }, ve = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ym(), Ae = ve[I], Te = ve[E], Le = wi(0, A[P], ae[P]), ze = w ? A[P] / 2 - q - Le - Ae - O.mainAxis : se - Le - Ae - O.mainAxis, _e = w ? -A[P] / 2 + q + Le + Te + O.mainAxis : fe + Le + Te + O.mainAxis, tt = t.elements.arrow && qi(t.elements.arrow), Xe = tt ? k === "y" ? tt.clientTop || 0 : tt.clientLeft || 0 : 0, et = (x = z == null ? void 0 : z[k]) != null ? x : 0, pe = R + ze - et - Xe, me = R + _e - et, he = wi(v ? ml(K, pe) : K, R, v ? Zn(J, me) : J);
      T[k] = he, U[k] = he - R;
    }
    if (u) {
      var V, Se = k === "x" ? ta : aa, Be = k === "x" ? wa : Ca, Me = T[S], Ve = S === "y" ? "height" : "width", wt = Me + h[Se], vt = Me - h[Be], Je = [ta, aa].indexOf(g) !== -1, lt = (V = z == null ? void 0 : z[S]) != null ? V : 0, xt = Je ? wt : Me - A[Ve] - F[Ve] - lt + O.altAxis, Lt = Je ? Me + A[Ve] + F[Ve] - lt - O.altAxis : vt, Xt = v && Je ? C3(xt, Me, Lt) : wi(v ? xt : wt, Me, v ? Lt : vt);
      T[S] = Xt, U[S] = Xt - Me;
    }
    t.modifiersData[n] = U;
  }
}
const J3 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: X3,
  requiresIfExists: ["offset"]
};
function _3(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function eT(e) {
  return e === da(e) || !ga(e) ? fc(e) : _3(e);
}
function tT(e) {
  var t = e.getBoundingClientRect(), a = Hr(t.width) / e.offsetWidth || 1, n = Hr(t.height) / e.offsetHeight || 1;
  return a !== 1 || n !== 1;
}
function aT(e, t, a) {
  a === void 0 && (a = !1);
  var n = ga(t), r = ga(t) && tT(t), i = Rn(t), o = qr(e, r, a), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !a) && ((qa(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  hc(i)) && (u = eT(t)), ga(t) ? (s = qr(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = vc(i))), {
    x: o.left + u.scrollLeft - s.x,
    y: o.top + u.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function nT(e) {
  var t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    a.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(u) {
      if (!a.has(u)) {
        var s = t.get(u);
        s && r(s);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    a.has(i.name) || r(i);
  }), n;
}
function rT(e) {
  var t = nT(e);
  return g3.reduce(function(a, n) {
    return a.concat(t.filter(function(r) {
      return r.phase === n;
    }));
  }, []);
}
function iT(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(a) {
      Promise.resolve().then(function() {
        t = void 0, a(e());
      });
    })), t;
  };
}
function oT(e) {
  var t = e.reduce(function(a, n) {
    var r = a[n.name];
    return a[n.name] = r ? Object.assign({}, r, n, {
      options: Object.assign({}, r.options, n.options),
      data: Object.assign({}, r.data, n.data)
    }) : n, a;
  }, {});
  return Object.keys(t).map(function(a) {
    return t[a];
  });
}
var Cv = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function kv() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function lT(e) {
  e === void 0 && (e = {});
  var t = e, a = t.defaultModifiers, n = a === void 0 ? [] : a, r = t.defaultOptions, i = r === void 0 ? Cv : r;
  return function(u, s, l) {
    l === void 0 && (l = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Cv, i),
      modifiersData: {},
      elements: {
        reference: u,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, v = {
      state: c,
      setOptions: function(g) {
        var p = typeof g == "function" ? g(c.options) : g;
        C(), c.options = Object.assign({}, i, c.options, p), c.scrollParents = {
          reference: ar(u) ? Ci(u) : u.contextElement ? Ci(u.contextElement) : [],
          popper: Ci(s)
        };
        var w = rT(oT([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = w.filter(function(k) {
          return k.enabled;
        }), y(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var g = c.elements, p = g.reference, w = g.popper;
          if (kv(p, w)) {
            c.rects = {
              reference: aT(p, qi(w), c.options.strategy === "fixed"),
              popper: cc(w)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(O) {
              return c.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var k = 0; k < c.orderedModifiers.length; k++) {
              if (c.reset === !0) {
                c.reset = !1, k = -1;
                continue;
              }
              var S = c.orderedModifiers[k], T = S.fn, A = S.options, F = A === void 0 ? {} : A, Z = S.name;
              typeof T == "function" && (c = T({
                state: c,
                options: F,
                name: Z,
                instance: v
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: iT(function() {
        return new Promise(function(h) {
          v.forceUpdate(), h(c);
        });
      }),
      destroy: function() {
        C(), f = !0;
      }
    };
    if (!kv(u, s))
      return v;
    v.setOptions(l).then(function(h) {
      !f && l.onFirstUpdate && l.onFirstUpdate(h);
    });
    function y() {
      c.orderedModifiers.forEach(function(h) {
        var g = h.name, p = h.options, w = p === void 0 ? {} : p, k = h.effect;
        if (typeof k == "function") {
          var S = k({
            state: c,
            name: g,
            instance: v,
            options: w
          }), T = function() {
          };
          d.push(S || T);
        }
      });
    }
    function C() {
      d.forEach(function(h) {
        return h();
      }), d = [];
    }
    return v;
  };
}
var sT = [M3, Q3, I3, y3, j3, q3, J3, x3, U3], uT = /* @__PURE__ */ lT({
  defaultModifiers: sT
}), cT = Object.defineProperty, dT = (e, t, a) => t in e ? cT(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, Ne = (e, t, a) => (dT(e, typeof t != "symbol" ? t + "" : t, a), a), Po = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Km(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var fT = Object.prototype, vT = fT.hasOwnProperty;
function hT(e, t) {
  return e != null && vT.call(e, t);
}
var gT = hT, mT = Array.isArray, Ia = mT, pT = typeof Po == "object" && Po && Po.Object === Object && Po, Vm = pT, yT = Vm, bT = typeof self == "object" && self && self.Object === Object && self, wT = yT || bT || Function("return this")(), Ga = wT, CT = Ga, kT = CT.Symbol, ns = kT, $v = ns, jm = Object.prototype, $T = jm.hasOwnProperty, ST = jm.toString, ui = $v ? $v.toStringTag : void 0;
function xT(e) {
  var t = $T.call(e, ui), a = e[ui];
  try {
    e[ui] = void 0;
    var n = !0;
  } catch {
  }
  var r = ST.call(e);
  return n && (t ? e[ui] = a : delete e[ui]), r;
}
var TT = xT, DT = Object.prototype, AT = DT.toString;
function IT(e) {
  return AT.call(e);
}
var ET = IT, Sv = ns, MT = TT, OT = ET, PT = "[object Null]", NT = "[object Undefined]", xv = Sv ? Sv.toStringTag : void 0;
function LT(e) {
  return e == null ? e === void 0 ? NT : PT : xv && xv in Object(e) ? MT(e) : OT(e);
}
var Qa = LT;
function BT(e) {
  return e != null && typeof e == "object";
}
var Ea = BT, RT = Qa, FT = Ea, zT = "[object Symbol]";
function YT(e) {
  return typeof e == "symbol" || FT(e) && RT(e) == zT;
}
var gc = YT, HT = Ia, qT = gc, WT = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, UT = /^\w*$/;
function KT(e, t) {
  if (HT(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || qT(e) ? !0 : UT.test(e) || !WT.test(e) || t != null && e in Object(t);
}
var mc = KT;
function VT(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var gn = VT, jT = Qa, GT = gn, QT = "[object AsyncFunction]", ZT = "[object Function]", XT = "[object GeneratorFunction]", JT = "[object Proxy]";
function _T(e) {
  if (!GT(e))
    return !1;
  var t = jT(e);
  return t == ZT || t == XT || t == QT || t == JT;
}
var dr = _T, eD = Ga, tD = eD["__core-js_shared__"], aD = tD, Ms = aD, Tv = (function() {
  var e = /[^.]+$/.exec(Ms && Ms.keys && Ms.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function nD(e) {
  return !!Tv && Tv in e;
}
var rD = nD, iD = Function.prototype, oD = iD.toString;
function lD(e) {
  if (e != null) {
    try {
      return oD.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Gm = lD, sD = dr, uD = rD, cD = gn, dD = Gm, fD = /[\\^$.*+?()[\]{}|]/g, vD = /^\[object .+?Constructor\]$/, hD = Function.prototype, gD = Object.prototype, mD = hD.toString, pD = gD.hasOwnProperty, yD = RegExp(
  "^" + mD.call(pD).replace(fD, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function bD(e) {
  if (!cD(e) || uD(e))
    return !1;
  var t = sD(e) ? yD : vD;
  return t.test(dD(e));
}
var wD = bD;
function CD(e, t) {
  return e == null ? void 0 : e[t];
}
var kD = CD, $D = wD, SD = kD;
function xD(e, t) {
  var a = SD(e, t);
  return $D(a) ? a : void 0;
}
var fr = xD, TD = fr, DD = TD(Object, "create"), rs = DD, Dv = rs;
function AD() {
  this.__data__ = Dv ? Dv(null) : {}, this.size = 0;
}
var ID = AD;
function ED(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var MD = ED, OD = rs, PD = "__lodash_hash_undefined__", ND = Object.prototype, LD = ND.hasOwnProperty;
function BD(e) {
  var t = this.__data__;
  if (OD) {
    var a = t[e];
    return a === PD ? void 0 : a;
  }
  return LD.call(t, e) ? t[e] : void 0;
}
var RD = BD, FD = rs, zD = Object.prototype, YD = zD.hasOwnProperty;
function HD(e) {
  var t = this.__data__;
  return FD ? t[e] !== void 0 : YD.call(t, e);
}
var qD = HD, WD = rs, UD = "__lodash_hash_undefined__";
function KD(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = WD && t === void 0 ? UD : t, this;
}
var VD = KD, jD = ID, GD = MD, QD = RD, ZD = qD, XD = VD;
function Qr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Qr.prototype.clear = jD;
Qr.prototype.delete = GD;
Qr.prototype.get = QD;
Qr.prototype.has = ZD;
Qr.prototype.set = XD;
var JD = Qr;
function _D() {
  this.__data__ = [], this.size = 0;
}
var e8 = _D;
function t8(e, t) {
  return e === t || e !== e && t !== t;
}
var Zr = t8, a8 = Zr;
function n8(e, t) {
  for (var a = e.length; a--; )
    if (a8(e[a][0], t))
      return a;
  return -1;
}
var is = n8, r8 = is, i8 = Array.prototype, o8 = i8.splice;
function l8(e) {
  var t = this.__data__, a = r8(t, e);
  if (a < 0)
    return !1;
  var n = t.length - 1;
  return a == n ? t.pop() : o8.call(t, a, 1), --this.size, !0;
}
var s8 = l8, u8 = is;
function c8(e) {
  var t = this.__data__, a = u8(t, e);
  return a < 0 ? void 0 : t[a][1];
}
var d8 = c8, f8 = is;
function v8(e) {
  return f8(this.__data__, e) > -1;
}
var h8 = v8, g8 = is;
function m8(e, t) {
  var a = this.__data__, n = g8(a, e);
  return n < 0 ? (++this.size, a.push([e, t])) : a[n][1] = t, this;
}
var p8 = m8, y8 = e8, b8 = s8, w8 = d8, C8 = h8, k8 = p8;
function Xr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Xr.prototype.clear = y8;
Xr.prototype.delete = b8;
Xr.prototype.get = w8;
Xr.prototype.has = C8;
Xr.prototype.set = k8;
var os = Xr, $8 = fr, S8 = Ga, x8 = $8(S8, "Map"), pc = x8, Av = JD, T8 = os, D8 = pc;
function A8() {
  this.size = 0, this.__data__ = {
    hash: new Av(),
    map: new (D8 || T8)(),
    string: new Av()
  };
}
var I8 = A8;
function E8(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var M8 = E8, O8 = M8;
function P8(e, t) {
  var a = e.__data__;
  return O8(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
var ls = P8, N8 = ls;
function L8(e) {
  var t = N8(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var B8 = L8, R8 = ls;
function F8(e) {
  return R8(this, e).get(e);
}
var z8 = F8, Y8 = ls;
function H8(e) {
  return Y8(this, e).has(e);
}
var q8 = H8, W8 = ls;
function U8(e, t) {
  var a = W8(this, e), n = a.size;
  return a.set(e, t), this.size += a.size == n ? 0 : 1, this;
}
var K8 = U8, V8 = I8, j8 = B8, G8 = z8, Q8 = q8, Z8 = K8;
function Jr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Jr.prototype.clear = V8;
Jr.prototype.delete = j8;
Jr.prototype.get = G8;
Jr.prototype.has = Q8;
Jr.prototype.set = Z8;
var yc = Jr, Qm = yc, X8 = "Expected a function";
function bc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(X8);
  var a = function() {
    var n = arguments, r = t ? t.apply(this, n) : n[0], i = a.cache;
    if (i.has(r))
      return i.get(r);
    var o = e.apply(this, n);
    return a.cache = i.set(r, o) || i, o;
  };
  return a.cache = new (bc.Cache || Qm)(), a;
}
bc.Cache = Qm;
var J8 = bc, _8 = J8, eA = 500;
function tA(e) {
  var t = _8(e, function(n) {
    return a.size === eA && a.clear(), n;
  }), a = t.cache;
  return t;
}
var aA = tA, nA = aA, rA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, iA = /\\(\\)?/g, oA = nA(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(rA, function(a, n, r, i) {
    t.push(r ? i.replace(iA, "$1") : n || a);
  }), t;
}), lA = oA;
function sA(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = Array(n); ++a < n; )
    r[a] = t(e[a], a, e);
  return r;
}
var uA = sA, Iv = ns, cA = uA, dA = Ia, fA = gc, Ev = Iv ? Iv.prototype : void 0, Mv = Ev ? Ev.toString : void 0;
function Zm(e) {
  if (typeof e == "string")
    return e;
  if (dA(e))
    return cA(e, Zm) + "";
  if (fA(e))
    return Mv ? Mv.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var vA = Zm, hA = vA;
function gA(e) {
  return e == null ? "" : hA(e);
}
var mA = gA, pA = Ia, yA = mc, bA = lA, wA = mA;
function CA(e, t) {
  return pA(e) ? e : yA(e, t) ? [e] : bA(wA(e));
}
var Xm = CA, kA = Qa, $A = Ea, SA = "[object Arguments]";
function xA(e) {
  return $A(e) && kA(e) == SA;
}
var TA = xA, Ov = TA, DA = Ea, Jm = Object.prototype, AA = Jm.hasOwnProperty, IA = Jm.propertyIsEnumerable, EA = Ov(/* @__PURE__ */ (function() {
  return arguments;
})()) ? Ov : function(e) {
  return DA(e) && AA.call(e, "callee") && !IA.call(e, "callee");
}, wc = EA, MA = 9007199254740991, OA = /^(?:0|[1-9]\d*)$/;
function PA(e, t) {
  var a = typeof e;
  return t = t ?? MA, !!t && (a == "number" || a != "symbol" && OA.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Cc = PA, NA = 9007199254740991;
function LA(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= NA;
}
var kc = LA, BA = gc;
function RA(e) {
  if (typeof e == "string" || BA(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var ss = RA, FA = Xm, zA = wc, YA = Ia, HA = Cc, qA = kc, WA = ss;
function UA(e, t, a) {
  t = FA(t, e);
  for (var n = -1, r = t.length, i = !1; ++n < r; ) {
    var o = WA(t[n]);
    if (!(i = e != null && a(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != r ? i : (r = e == null ? 0 : e.length, !!r && qA(r) && HA(o, r) && (YA(e) || zA(e)));
}
var _m = UA, KA = gT, VA = _m;
function jA(e, t) {
  return e != null && VA(e, t, KA);
}
var ep = jA, GA = Qa, QA = Ea, ZA = "[object Date]";
function XA(e) {
  return QA(e) && GA(e) == ZA;
}
var JA = XA;
function _A(e) {
  return function(t) {
    return e(t);
  };
}
var tp = _A, Pi = {}, eI = {
  get exports() {
    return Pi;
  },
  set exports(e) {
    Pi = e;
  }
};
(function(e, t) {
  var a = Vm, n = t && !t.nodeType && t, r = n && !0 && e && !e.nodeType && e, i = r && r.exports === n, o = i && a.process, u = (function() {
    try {
      var s = r && r.require && r.require("util").types;
      return s || o && o.binding && o.binding("util");
    } catch {
    }
  })();
  e.exports = u;
})(eI, Pi);
var tI = JA, aI = tp, Pv = Pi, Nv = Pv && Pv.isDate, nI = Nv ? aI(Nv) : tI, rI = nI, iI = Qa, oI = Ia, lI = Ea, sI = "[object String]";
function uI(e) {
  return typeof e == "string" || !oI(e) && lI(e) && iI(e) == sI;
}
var La = uI;
function cI(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length; ++a < n; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
var ap = cI, dI = os;
function fI() {
  this.__data__ = new dI(), this.size = 0;
}
var vI = fI;
function hI(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
var gI = hI;
function mI(e) {
  return this.__data__.get(e);
}
var pI = mI;
function yI(e) {
  return this.__data__.has(e);
}
var bI = yI, wI = os, CI = pc, kI = yc, $I = 200;
function SI(e, t) {
  var a = this.__data__;
  if (a instanceof wI) {
    var n = a.__data__;
    if (!CI || n.length < $I - 1)
      return n.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new kI(n);
  }
  return a.set(e, t), this.size = a.size, this;
}
var xI = SI, TI = os, DI = vI, AI = gI, II = pI, EI = bI, MI = xI;
function _r(e) {
  var t = this.__data__ = new TI(e);
  this.size = t.size;
}
_r.prototype.clear = DI;
_r.prototype.delete = AI;
_r.prototype.get = II;
_r.prototype.has = EI;
_r.prototype.set = MI;
var $c = _r, OI = "__lodash_hash_undefined__";
function PI(e) {
  return this.__data__.set(e, OI), this;
}
var NI = PI;
function LI(e) {
  return this.__data__.has(e);
}
var BI = LI, RI = yc, FI = NI, zI = BI;
function pl(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new RI(); ++t < a; )
    this.add(e[t]);
}
pl.prototype.add = pl.prototype.push = FI;
pl.prototype.has = zI;
var YI = pl;
function HI(e, t) {
  return e.has(t);
}
var qI = HI, WI = YI, UI = ap, KI = qI, VI = 1, jI = 2;
function GI(e, t, a, n, r, i) {
  var o = a & VI, u = e.length, s = t.length;
  if (u != s && !(o && s > u))
    return !1;
  var l = i.get(e), c = i.get(t);
  if (l && c)
    return l == t && c == e;
  var d = -1, f = !0, v = a & jI ? new WI() : void 0;
  for (i.set(e, t), i.set(t, e); ++d < u; ) {
    var y = e[d], C = t[d];
    if (n)
      var h = o ? n(C, y, d, t, e, i) : n(y, C, d, e, t, i);
    if (h !== void 0) {
      if (h)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!UI(t, function(g, p) {
        if (!KI(v, p) && (y === g || r(y, g, a, n, i)))
          return v.push(p);
      })) {
        f = !1;
        break;
      }
    } else if (!(y === C || r(y, C, a, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var np = GI, QI = Ga, ZI = QI.Uint8Array, rp = ZI;
function XI(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n, r) {
    a[++t] = [r, n];
  }), a;
}
var JI = XI;
function _I(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n) {
    a[++t] = n;
  }), a;
}
var e4 = _I, Lv = ns, Bv = rp, t4 = Zr, a4 = np, n4 = JI, r4 = e4, i4 = 1, o4 = 2, l4 = "[object Boolean]", s4 = "[object Date]", u4 = "[object Error]", c4 = "[object Map]", d4 = "[object Number]", f4 = "[object RegExp]", v4 = "[object Set]", h4 = "[object String]", g4 = "[object Symbol]", m4 = "[object ArrayBuffer]", p4 = "[object DataView]", Rv = Lv ? Lv.prototype : void 0, Os = Rv ? Rv.valueOf : void 0;
function y4(e, t, a, n, r, i, o) {
  switch (a) {
    case p4:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case m4:
      return !(e.byteLength != t.byteLength || !i(new Bv(e), new Bv(t)));
    case l4:
    case s4:
    case d4:
      return t4(+e, +t);
    case u4:
      return e.name == t.name && e.message == t.message;
    case f4:
    case h4:
      return e == t + "";
    case c4:
      var u = n4;
    case v4:
      var s = n & i4;
      if (u || (u = r4), e.size != t.size && !s)
        return !1;
      var l = o.get(e);
      if (l)
        return l == t;
      n |= o4, o.set(e, t);
      var c = a4(u(e), u(t), n, r, i, o);
      return o.delete(e), c;
    case g4:
      if (Os)
        return Os.call(e) == Os.call(t);
  }
  return !1;
}
var b4 = y4;
function w4(e, t) {
  for (var a = -1, n = t.length, r = e.length; ++a < n; )
    e[r + a] = t[a];
  return e;
}
var C4 = w4, k4 = C4, $4 = Ia;
function S4(e, t, a) {
  var n = t(e);
  return $4(e) ? n : k4(n, a(e));
}
var x4 = S4;
function T4(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++a < n; ) {
    var o = e[a];
    t(o, a, e) && (i[r++] = o);
  }
  return i;
}
var D4 = T4;
function A4() {
  return [];
}
var I4 = A4, E4 = D4, M4 = I4, O4 = Object.prototype, P4 = O4.propertyIsEnumerable, Fv = Object.getOwnPropertySymbols, N4 = Fv ? function(e) {
  return e == null ? [] : (e = Object(e), E4(Fv(e), function(t) {
    return P4.call(e, t);
  }));
} : M4, L4 = N4;
function B4(e, t) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = t(a);
  return n;
}
var R4 = B4, Ur = {}, F4 = {
  get exports() {
    return Ur;
  },
  set exports(e) {
    Ur = e;
  }
};
function z4() {
  return !1;
}
var Y4 = z4;
(function(e, t) {
  var a = Ga, n = Y4, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, u = o ? a.Buffer : void 0, s = u ? u.isBuffer : void 0, l = s || n;
  e.exports = l;
})(F4, Ur);
var H4 = Qa, q4 = kc, W4 = Ea, U4 = "[object Arguments]", K4 = "[object Array]", V4 = "[object Boolean]", j4 = "[object Date]", G4 = "[object Error]", Q4 = "[object Function]", Z4 = "[object Map]", X4 = "[object Number]", J4 = "[object Object]", _4 = "[object RegExp]", eE = "[object Set]", tE = "[object String]", aE = "[object WeakMap]", nE = "[object ArrayBuffer]", rE = "[object DataView]", iE = "[object Float32Array]", oE = "[object Float64Array]", lE = "[object Int8Array]", sE = "[object Int16Array]", uE = "[object Int32Array]", cE = "[object Uint8Array]", dE = "[object Uint8ClampedArray]", fE = "[object Uint16Array]", vE = "[object Uint32Array]", pt = {};
pt[iE] = pt[oE] = pt[lE] = pt[sE] = pt[uE] = pt[cE] = pt[dE] = pt[fE] = pt[vE] = !0;
pt[U4] = pt[K4] = pt[nE] = pt[V4] = pt[rE] = pt[j4] = pt[G4] = pt[Q4] = pt[Z4] = pt[X4] = pt[J4] = pt[_4] = pt[eE] = pt[tE] = pt[aE] = !1;
function hE(e) {
  return W4(e) && q4(e.length) && !!pt[H4(e)];
}
var gE = hE, mE = gE, pE = tp, zv = Pi, Yv = zv && zv.isTypedArray, yE = Yv ? pE(Yv) : mE, Sc = yE, bE = R4, wE = wc, CE = Ia, kE = Ur, $E = Cc, SE = Sc, xE = Object.prototype, TE = xE.hasOwnProperty;
function DE(e, t) {
  var a = CE(e), n = !a && wE(e), r = !a && !n && kE(e), i = !a && !n && !r && SE(e), o = a || n || r || i, u = o ? bE(e.length, String) : [], s = u.length;
  for (var l in e)
    (t || TE.call(e, l)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (l == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (l == "offset" || l == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (l == "buffer" || l == "byteLength" || l == "byteOffset") || // Skip index properties.
    $E(l, s))) && u.push(l);
  return u;
}
var ip = DE, AE = Object.prototype;
function IE(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || AE;
  return e === a;
}
var xc = IE;
function EE(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var op = EE, ME = op, OE = ME(Object.keys, Object), PE = OE, NE = xc, LE = PE, BE = Object.prototype, RE = BE.hasOwnProperty;
function FE(e) {
  if (!NE(e))
    return LE(e);
  var t = [];
  for (var a in Object(e))
    RE.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
var zE = FE, YE = dr, HE = kc;
function qE(e) {
  return e != null && HE(e.length) && !YE(e);
}
var Wi = qE, WE = ip, UE = zE, KE = Wi;
function VE(e) {
  return KE(e) ? WE(e) : UE(e);
}
var Tc = VE, jE = x4, GE = L4, QE = Tc;
function ZE(e) {
  return jE(e, QE, GE);
}
var XE = ZE, Hv = XE, JE = 1, _E = Object.prototype, eM = _E.hasOwnProperty;
function tM(e, t, a, n, r, i) {
  var o = a & JE, u = Hv(e), s = u.length, l = Hv(t), c = l.length;
  if (s != c && !o)
    return !1;
  for (var d = s; d--; ) {
    var f = u[d];
    if (!(o ? f in t : eM.call(t, f)))
      return !1;
  }
  var v = i.get(e), y = i.get(t);
  if (v && y)
    return v == t && y == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var h = o; ++d < s; ) {
    f = u[d];
    var g = e[f], p = t[f];
    if (n)
      var w = o ? n(p, g, f, t, e, i) : n(g, p, f, e, t, i);
    if (!(w === void 0 ? g === p || r(g, p, a, n, i) : w)) {
      C = !1;
      break;
    }
    h || (h = f == "constructor");
  }
  if (C && !h) {
    var k = e.constructor, S = t.constructor;
    k != S && "constructor" in e && "constructor" in t && !(typeof k == "function" && k instanceof k && typeof S == "function" && S instanceof S) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var aM = tM, nM = fr, rM = Ga, iM = nM(rM, "DataView"), oM = iM, lM = fr, sM = Ga, uM = lM(sM, "Promise"), cM = uM, dM = fr, fM = Ga, vM = dM(fM, "Set"), hM = vM, gM = fr, mM = Ga, pM = gM(mM, "WeakMap"), yM = pM, gu = oM, mu = pc, pu = cM, yu = hM, bu = yM, lp = Qa, ei = Gm, qv = "[object Map]", bM = "[object Object]", Wv = "[object Promise]", Uv = "[object Set]", Kv = "[object WeakMap]", Vv = "[object DataView]", wM = ei(gu), CM = ei(mu), kM = ei(pu), $M = ei(yu), SM = ei(bu), Wn = lp;
(gu && Wn(new gu(new ArrayBuffer(1))) != Vv || mu && Wn(new mu()) != qv || pu && Wn(pu.resolve()) != Wv || yu && Wn(new yu()) != Uv || bu && Wn(new bu()) != Kv) && (Wn = function(e) {
  var t = lp(e), a = t == bM ? e.constructor : void 0, n = a ? ei(a) : "";
  if (n)
    switch (n) {
      case wM:
        return Vv;
      case CM:
        return qv;
      case kM:
        return Wv;
      case $M:
        return Uv;
      case SM:
        return Kv;
    }
  return t;
});
var xM = Wn, Ps = $c, TM = np, DM = b4, AM = aM, jv = xM, Gv = Ia, Qv = Ur, IM = Sc, EM = 1, Zv = "[object Arguments]", Xv = "[object Array]", No = "[object Object]", MM = Object.prototype, Jv = MM.hasOwnProperty;
function OM(e, t, a, n, r, i) {
  var o = Gv(e), u = Gv(t), s = o ? Xv : jv(e), l = u ? Xv : jv(t);
  s = s == Zv ? No : s, l = l == Zv ? No : l;
  var c = s == No, d = l == No, f = s == l;
  if (f && Qv(e)) {
    if (!Qv(t))
      return !1;
    o = !0, c = !1;
  }
  if (f && !c)
    return i || (i = new Ps()), o || IM(e) ? TM(e, t, a, n, r, i) : DM(e, t, s, a, n, r, i);
  if (!(a & EM)) {
    var v = c && Jv.call(e, "__wrapped__"), y = d && Jv.call(t, "__wrapped__");
    if (v || y) {
      var C = v ? e.value() : e, h = y ? t.value() : t;
      return i || (i = new Ps()), r(C, h, a, n, i);
    }
  }
  return f ? (i || (i = new Ps()), AM(e, t, a, n, r, i)) : !1;
}
var PM = OM, NM = PM, _v = Ea;
function sp(e, t, a, n, r) {
  return e === t ? !0 : e == null || t == null || !_v(e) && !_v(t) ? e !== e && t !== t : NM(e, t, a, n, sp, r);
}
var up = sp, LM = $c, BM = up, RM = 1, FM = 2;
function zM(e, t, a, n) {
  var r = a.length, i = r, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); r--; ) {
    var u = a[r];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++r < i; ) {
    u = a[r];
    var s = u[0], l = e[s], c = u[1];
    if (o && u[2]) {
      if (l === void 0 && !(s in e))
        return !1;
    } else {
      var d = new LM();
      if (n)
        var f = n(l, c, s, e, t, d);
      if (!(f === void 0 ? BM(c, l, RM | FM, n, d) : f))
        return !1;
    }
  }
  return !0;
}
var YM = zM, HM = gn;
function qM(e) {
  return e === e && !HM(e);
}
var cp = qM, WM = cp, UM = Tc;
function KM(e) {
  for (var t = UM(e), a = t.length; a--; ) {
    var n = t[a], r = e[n];
    t[a] = [n, r, WM(r)];
  }
  return t;
}
var VM = KM;
function jM(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
var dp = jM, GM = YM, QM = VM, ZM = dp;
function XM(e) {
  var t = QM(e);
  return t.length == 1 && t[0][2] ? ZM(t[0][0], t[0][1]) : function(a) {
    return a === e || GM(a, e, t);
  };
}
var JM = XM, _M = Xm, eO = ss;
function tO(e, t) {
  t = _M(t, e);
  for (var a = 0, n = t.length; e != null && a < n; )
    e = e[eO(t[a++])];
  return a && a == n ? e : void 0;
}
var fp = tO, aO = fp;
function nO(e, t, a) {
  var n = e == null ? void 0 : aO(e, t);
  return n === void 0 ? a : n;
}
var Gn = nO;
function rO(e, t) {
  return e != null && t in Object(e);
}
var iO = rO, oO = iO, lO = _m;
function sO(e, t) {
  return e != null && lO(e, t, oO);
}
var uO = sO, cO = up, dO = Gn, fO = uO, vO = mc, hO = cp, gO = dp, mO = ss, pO = 1, yO = 2;
function bO(e, t) {
  return vO(e) && hO(t) ? gO(mO(e), t) : function(a) {
    var n = dO(a, e);
    return n === void 0 && n === t ? fO(a, e) : cO(t, n, pO | yO);
  };
}
var wO = bO;
function CO(e) {
  return e;
}
var Dc = CO;
function kO(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var $O = kO, SO = fp;
function xO(e) {
  return function(t) {
    return SO(t, e);
  };
}
var TO = xO, DO = $O, AO = TO, IO = mc, EO = ss;
function MO(e) {
  return IO(e) ? DO(EO(e)) : AO(e);
}
var OO = MO, PO = JM, NO = wO, LO = Dc, BO = Ia, RO = OO;
function FO(e) {
  return typeof e == "function" ? e : e == null ? LO : typeof e == "object" ? BO(e) ? NO(e[0], e[1]) : PO(e) : RO(e);
}
var vp = FO;
function zO(e) {
  return function(t, a, n) {
    for (var r = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var s = o[e ? u : ++r];
      if (a(i[s], s, i) === !1)
        break;
    }
    return t;
  };
}
var YO = zO, HO = YO, qO = HO(), hp = qO, WO = hp, UO = Tc;
function KO(e, t) {
  return e && WO(e, t, UO);
}
var gp = KO, VO = Wi;
function jO(e, t) {
  return function(a, n) {
    if (a == null)
      return a;
    if (!VO(a))
      return e(a, n);
    for (var r = a.length, i = t ? r : -1, o = Object(a); (t ? i-- : ++i < r) && n(o[i], i, o) !== !1; )
      ;
    return a;
  };
}
var GO = jO, QO = gp, ZO = GO, XO = ZO(QO), JO = XO, _O = JO;
function e7(e, t) {
  var a;
  return _O(e, function(n, r, i) {
    return a = t(n, r, i), !a;
  }), !!a;
}
var t7 = e7, a7 = Zr, n7 = Wi, r7 = Cc, i7 = gn;
function o7(e, t, a) {
  if (!i7(a))
    return !1;
  var n = typeof t;
  return (n == "number" ? n7(a) && r7(t, a.length) : n == "string" && t in a) ? a7(a[t], e) : !1;
}
var Ac = o7, l7 = ap, s7 = vp, u7 = t7, c7 = Ia, d7 = Ac;
function f7(e, t, a) {
  var n = c7(e) ? l7 : u7;
  return a && d7(e, t, a) && (t = void 0), n(e, s7(t));
}
var v7 = f7, h7 = Qa, g7 = Ea, m7 = "[object Boolean]";
function p7(e) {
  return e === !0 || e === !1 || g7(e) && h7(e) == m7;
}
var y7 = p7, b7 = Qa, w7 = Ea, C7 = "[object Number]";
function k7(e) {
  return typeof e == "number" || w7(e) && b7(e) == C7;
}
var Aa = k7, $7 = fr, S7 = (function() {
  try {
    var e = $7(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})(), mp = S7, eh = mp;
function x7(e, t, a) {
  t == "__proto__" && eh ? eh(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
var us = x7, T7 = us, D7 = Zr, A7 = Object.prototype, I7 = A7.hasOwnProperty;
function E7(e, t, a) {
  var n = e[t];
  (!(I7.call(e, t) && D7(n, a)) || a === void 0 && !(t in e)) && T7(e, t, a);
}
var M7 = E7, O7 = us, P7 = gp, N7 = vp;
function L7(e, t) {
  var a = {};
  return t = N7(t), P7(e, function(n, r, i) {
    O7(a, r, t(n, r, i));
  }), a;
}
var B7 = L7;
function R7(e, t, a) {
  switch (a.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, a[0]);
    case 2:
      return e.call(t, a[0], a[1]);
    case 3:
      return e.call(t, a[0], a[1], a[2]);
  }
  return e.apply(t, a);
}
var pp = R7, F7 = pp, th = Math.max;
function z7(e, t, a) {
  return t = th(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, r = -1, i = th(n.length - t, 0), o = Array(i); ++r < i; )
      o[r] = n[t + r];
    r = -1;
    for (var u = Array(t + 1); ++r < t; )
      u[r] = n[r];
    return u[t] = a(o), F7(e, this, u);
  };
}
var Y7 = z7;
function H7(e) {
  return function() {
    return e;
  };
}
var q7 = H7, W7 = q7, ah = mp, U7 = Dc, K7 = ah ? function(e, t) {
  return ah(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: W7(t),
    writable: !0
  });
} : U7, V7 = K7, j7 = 800, G7 = 16, Q7 = Date.now;
function Z7(e) {
  var t = 0, a = 0;
  return function() {
    var n = Q7(), r = G7 - (n - a);
    if (a = n, r > 0) {
      if (++t >= j7)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var X7 = Z7, J7 = V7, _7 = X7, eP = _7(J7), tP = eP, aP = Dc, nP = Y7, rP = tP;
function iP(e, t) {
  return rP(nP(e, t, aP), e + "");
}
var Ic = iP;
function oP(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var lP = oP, sP = gn, uP = xc, cP = lP, dP = Object.prototype, fP = dP.hasOwnProperty;
function vP(e) {
  if (!sP(e))
    return cP(e);
  var t = uP(e), a = [];
  for (var n in e)
    n == "constructor" && (t || !fP.call(e, n)) || a.push(n);
  return a;
}
var hP = vP, gP = ip, mP = hP, pP = Wi;
function yP(e) {
  return pP(e) ? gP(e, !0) : mP(e);
}
var Ec = yP, bP = Ic, wP = Zr, CP = Ac, kP = Ec, yp = Object.prototype, $P = yp.hasOwnProperty, SP = bP(function(e, t) {
  e = Object(e);
  var a = -1, n = t.length, r = n > 2 ? t[2] : void 0;
  for (r && CP(t[0], t[1], r) && (n = 1); ++a < n; )
    for (var i = t[a], o = kP(i), u = -1, s = o.length; ++u < s; ) {
      var l = o[u], c = e[l];
      (c === void 0 || wP(c, yp[l]) && !$P.call(e, l)) && (e[l] = i[l]);
    }
  return e;
}), nh = SP, xP = us, TP = Zr;
function DP(e, t, a) {
  (a !== void 0 && !TP(e[t], a) || a === void 0 && !(t in e)) && xP(e, t, a);
}
var bp = DP, yl = {}, AP = {
  get exports() {
    return yl;
  },
  set exports(e) {
    yl = e;
  }
};
(function(e, t) {
  var a = Ga, n = t && !t.nodeType && t, r = n && !0 && e && !e.nodeType && e, i = r && r.exports === n, o = i ? a.Buffer : void 0, u = o ? o.allocUnsafe : void 0;
  function s(l, c) {
    if (c)
      return l.slice();
    var d = l.length, f = u ? u(d) : new l.constructor(d);
    return l.copy(f), f;
  }
  e.exports = s;
})(AP, yl);
var rh = rp;
function IP(e) {
  var t = new e.constructor(e.byteLength);
  return new rh(t).set(new rh(e)), t;
}
var EP = IP, MP = EP;
function OP(e, t) {
  var a = t ? MP(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.length);
}
var PP = OP;
function NP(e, t) {
  var a = -1, n = e.length;
  for (t || (t = Array(n)); ++a < n; )
    t[a] = e[a];
  return t;
}
var LP = NP, BP = gn, ih = Object.create, RP = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!BP(t))
      return {};
    if (ih)
      return ih(t);
    e.prototype = t;
    var a = new e();
    return e.prototype = void 0, a;
  };
})(), FP = RP, zP = op, YP = zP(Object.getPrototypeOf, Object), wp = YP, HP = FP, qP = wp, WP = xc;
function UP(e) {
  return typeof e.constructor == "function" && !WP(e) ? HP(qP(e)) : {};
}
var KP = UP, VP = Wi, jP = Ea;
function GP(e) {
  return jP(e) && VP(e);
}
var QP = GP, ZP = Qa, XP = wp, JP = Ea, _P = "[object Object]", e9 = Function.prototype, t9 = Object.prototype, Cp = e9.toString, a9 = t9.hasOwnProperty, n9 = Cp.call(Object);
function r9(e) {
  if (!JP(e) || ZP(e) != _P)
    return !1;
  var t = XP(e);
  if (t === null)
    return !0;
  var a = a9.call(t, "constructor") && t.constructor;
  return typeof a == "function" && a instanceof a && Cp.call(a) == n9;
}
var i9 = r9;
function o9(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var kp = o9, l9 = M7, s9 = us;
function u9(e, t, a, n) {
  var r = !a;
  a || (a = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var u = t[i], s = n ? n(a[u], e[u], u, a, e) : void 0;
    s === void 0 && (s = e[u]), r ? s9(a, u, s) : l9(a, u, s);
  }
  return a;
}
var c9 = u9, d9 = c9, f9 = Ec;
function v9(e) {
  return d9(e, f9(e));
}
var h9 = v9, oh = bp, g9 = yl, m9 = PP, p9 = LP, y9 = KP, lh = wc, sh = Ia, b9 = QP, w9 = Ur, C9 = dr, k9 = gn, $9 = i9, S9 = Sc, uh = kp, x9 = h9;
function T9(e, t, a, n, r, i, o) {
  var u = uh(e, a), s = uh(t, a), l = o.get(s);
  if (l) {
    oh(e, a, l);
    return;
  }
  var c = i ? i(u, s, a + "", e, t, o) : void 0, d = c === void 0;
  if (d) {
    var f = sh(s), v = !f && w9(s), y = !f && !v && S9(s);
    c = s, f || v || y ? sh(u) ? c = u : b9(u) ? c = p9(u) : v ? (d = !1, c = g9(s, !0)) : y ? (d = !1, c = m9(s, !0)) : c = [] : $9(s) || lh(s) ? (c = u, lh(u) ? c = x9(u) : (!k9(u) || C9(u)) && (c = y9(s))) : d = !1;
  }
  d && (o.set(s, c), r(c, s, n, i, o), o.delete(s)), oh(e, a, c);
}
var D9 = T9, A9 = $c, I9 = bp, E9 = hp, M9 = D9, O9 = gn, P9 = Ec, N9 = kp;
function $p(e, t, a, n, r) {
  e !== t && E9(t, function(i, o) {
    if (r || (r = new A9()), O9(i))
      M9(e, t, o, a, $p, n, r);
    else {
      var u = n ? n(N9(e, o), i, o + "", e, t, r) : void 0;
      u === void 0 && (u = i), I9(e, o, u);
    }
  }, P9);
}
var Sp = $p, L9 = Sp, ch = gn;
function xp(e, t, a, n, r, i) {
  return ch(e) && ch(t) && (i.set(t, e), L9(e, t, void 0, xp, i), i.delete(t)), e;
}
var B9 = xp, R9 = Ic, F9 = Ac;
function z9(e) {
  return R9(function(t, a) {
    var n = -1, r = a.length, i = r > 1 ? a[r - 1] : void 0, o = r > 2 ? a[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (r--, i) : void 0, o && F9(a[0], a[1], o) && (i = r < 3 ? void 0 : i, r = 1), t = Object(t); ++n < r; ) {
      var u = a[n];
      u && e(t, u, n, i);
    }
    return t;
  });
}
var Y9 = z9, H9 = Sp, q9 = Y9, W9 = q9(function(e, t, a, n) {
  H9(e, t, a, n);
}), U9 = W9, K9 = pp, V9 = Ic, j9 = B9, G9 = U9, Q9 = V9(function(e) {
  return e.push(void 0, j9), K9(G9, void 0, e);
}), Ni = Q9;
function Z9(e) {
  return e && e.length ? e[0] : void 0;
}
var Tp = Z9;
function X9(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Ir = X9;
const J9 = (e) => Object.prototype.toString.call(e).slice(8, -1), Nr = (e) => rI(e) && !isNaN(e.getTime()), un = (e) => J9(e) === "Object", Dp = ep, dh = (e, t) => v7(t, (a) => ep(e, a)), ut = (e, t, a = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${a}${e}`;
  return e;
}, ma = (e) => Array.isArray(e), an = (e) => ma(e) && e.length > 0, bl = (e) => e == null ? null : document && La(e) ? document.querySelector(e) : e.$el ?? e, Sn = (e, t, a, n = void 0) => {
  e.removeEventListener(t, a, n);
}, xn = (e, t, a, n = void 0) => (e.addEventListener(t, a, n), () => Sn(e, t, a, n)), Ko = (e, t) => !!e && !!t && (e === t || e.contains(t)), Lo = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, Ap = (e, ...t) => {
  const a = {};
  let n;
  for (n in e)
    t.includes(n) || (a[n] = e[n]);
  return a;
}, Ip = (e, t) => {
  const a = {};
  return t.forEach((n) => {
    n in e && (a[n] = e[n]);
  }), a;
};
function _9(e, t, a) {
  return Math.min(Math.max(e, t), a);
}
var wl = {}, e6 = {
  get exports() {
    return wl;
  },
  set exports(e) {
    wl = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var r = Number(n);
    return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
  }
  e.exports = t.default;
})(e6, wl);
const t6 = /* @__PURE__ */ Km(wl);
var Cl = {}, a6 = {
  get exports() {
    return Cl;
  },
  set exports(e) {
    Cl = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    var r = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return r.setUTCFullYear(n.getFullYear()), n.getTime() - r.getTime();
  }
  e.exports = t.default;
})(a6, Cl);
const fh = /* @__PURE__ */ Km(Cl);
function n6(e, t) {
  var a = l6(t);
  return a.formatToParts ? i6(a, e) : o6(a, e);
}
var r6 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function i6(e, t) {
  try {
    for (var a = e.formatToParts(t), n = [], r = 0; r < a.length; r++) {
      var i = r6[a[r].type];
      i >= 0 && (n[i] = parseInt(a[r].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function o6(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var Ns = {};
function l6(e) {
  if (!Ns[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Ns[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Ns[e];
}
function Ep(e, t, a, n, r, i, o) {
  var u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(e, t, a), u.setUTCHours(n, r, i, o), u;
}
var vh = 36e5, s6 = 6e4, Ls = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function u6(e, t, a) {
  var n, r;
  if (!e || (n = Ls.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = Ls.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), hh(i) ? -(i * vh) : NaN;
  if (n = Ls.timezoneHHMM.exec(e), n) {
    i = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return hh(i, o) ? (r = Math.abs(i) * vh + o * s6, i > 0 ? -r : r) : NaN;
  }
  if (f6(e)) {
    t = new Date(t || Date.now());
    var u = c6(t), s = wu(u, e), l = d6(t, s, e);
    return -l;
  }
  return NaN;
}
function c6(e) {
  return Ep(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function wu(e, t) {
  var a = n6(e, t), n = Ep(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), r = e.getTime(), i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, n - r;
}
function d6(e, t, a) {
  var n = e.getTime(), r = n - t, i = wu(new Date(r), a);
  if (t === i)
    return t;
  r -= i - t;
  var o = wu(new Date(r), a);
  return i === o ? i : Math.max(i, o);
}
function hh(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var gh = {};
function f6(e) {
  if (gh[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), gh[e] = !0, !0;
  } catch {
    return !1;
  }
}
var v6 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const h6 = v6;
var Bs = 36e5, mh = 6e4, g6 = 2, Gt = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: h6
};
function m6(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, n = a.additionalDigits == null ? g6 : t6(a.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = p6(e), i = y6(r.date, n), o = i.year, u = i.restDateString, s = b6(u, o);
  if (isNaN(s))
    return /* @__PURE__ */ new Date(NaN);
  if (s) {
    var l = s.getTime(), c = 0, d;
    if (r.time && (c = w6(r.time), isNaN(c)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || a.timeZone) {
      if (d = u6(r.timeZone || a.timeZone, new Date(l + c)), isNaN(d))
        return /* @__PURE__ */ new Date(NaN);
    } else
      d = fh(new Date(l + c)), d = fh(new Date(l + c + d));
    return new Date(l + c + d);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function p6(e) {
  var t = {}, a = Gt.dateTimePattern.exec(e), n;
  if (a ? (t.date = a[1], n = a[3]) : (a = Gt.datePattern.exec(e), a ? (t.date = a[1], n = a[2]) : (t.date = null, n = e)), n) {
    var r = Gt.timeZone.exec(n);
    r ? (t.time = n.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = n;
  }
  return t;
}
function y6(e, t) {
  var a = Gt.YYY[t], n = Gt.YYYYY[t], r;
  if (r = Gt.YYYY.exec(e) || n.exec(e), r) {
    var i = r[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (r = Gt.YY.exec(e) || a.exec(e), r) {
    var o = r[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function b6(e, t) {
  if (t === null)
    return null;
  var a, n, r, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (a = Gt.MM.exec(e), a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, yh(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = Gt.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(a[1], 10);
    return $6(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Gt.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10);
    return yh(t, r, u) ? (n.setUTCFullYear(t, r, u), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Gt.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, bh(t, i) ? ph(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = Gt.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    var s = parseInt(a[2], 10) - 1;
    return bh(t, i, s) ? ph(t, i, s) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function w6(e) {
  var t, a, n;
  if (t = Gt.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), Rs(a) ? a % 24 * Bs : NaN;
  if (t = Gt.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Rs(a, n) ? a % 24 * Bs + n * mh : NaN;
  if (t = Gt.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return Rs(a, n, r) ? a % 24 * Bs + n * mh + r * 1e3 : NaN;
  }
  return null;
}
function ph(e, t, a) {
  t = t || 0, a = a || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var r = n.getUTCDay() || 7, i = t * 7 + a + 1 - r;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var C6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], k6 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Mp(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function yh(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var n = Mp(e);
    if (n && a > k6[t] || !n && a > C6[t])
      return !1;
  }
  return !0;
}
function $6(e, t) {
  if (t < 1)
    return !1;
  var a = Mp(e);
  return !(a && t > 366 || !a && t > 365);
}
function bh(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function Rs(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
function Ut(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Vo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Vo = function(a) {
    return typeof a;
  } : Vo = function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Vo(e);
}
function mn(e) {
  Ut(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Vo(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function ti(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var S6 = {};
function Mc() {
  return S6;
}
function nr(e, t) {
  var a, n, r, i, o, u, s, l;
  Ut(1, arguments);
  var c = Mc(), d = ti((a = (n = (r = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : c.weekStartsOn) !== null && n !== void 0 ? n : (s = c.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(d >= 0 && d <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = mn(e), v = f.getDay(), y = (v < d ? 7 : 0) + v - d;
  return f.setDate(f.getDate() - y), f.setHours(0, 0, 0, 0), f;
}
function wh(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var x6 = 6048e5;
function T6(e, t, a) {
  Ut(2, arguments);
  var n = nr(e, a), r = nr(t, a), i = n.getTime() - wh(n), o = r.getTime() - wh(r);
  return Math.round((i - o) / x6);
}
function D6(e) {
  Ut(1, arguments);
  var t = mn(e), a = t.getMonth();
  return t.setFullYear(t.getFullYear(), a + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function A6(e) {
  Ut(1, arguments);
  var t = mn(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function I6(e, t) {
  return Ut(1, arguments), T6(D6(e), A6(e), t) + 1;
}
function E6(e, t) {
  var a, n, r, i, o, u, s, l;
  Ut(1, arguments);
  var c = mn(e), d = c.getFullYear(), f = Mc(), v = ti((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = f.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var y = /* @__PURE__ */ new Date(0);
  y.setFullYear(d + 1, 0, v), y.setHours(0, 0, 0, 0);
  var C = nr(y, t), h = /* @__PURE__ */ new Date(0);
  h.setFullYear(d, 0, v), h.setHours(0, 0, 0, 0);
  var g = nr(h, t);
  return c.getTime() >= C.getTime() ? d + 1 : c.getTime() >= g.getTime() ? d : d - 1;
}
function M6(e, t) {
  var a, n, r, i, o, u, s, l;
  Ut(1, arguments);
  var c = Mc(), d = ti((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : c.firstWeekContainsDate) !== null && n !== void 0 ? n : (s = c.locale) === null || s === void 0 || (l = s.options) === null || l === void 0 ? void 0 : l.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = E6(e, t), v = /* @__PURE__ */ new Date(0);
  v.setFullYear(f, 0, d), v.setHours(0, 0, 0, 0);
  var y = nr(v, t);
  return y;
}
var O6 = 6048e5;
function P6(e, t) {
  Ut(1, arguments);
  var a = mn(e), n = nr(a, t).getTime() - M6(a, t).getTime();
  return Math.round(n / O6) + 1;
}
function kl(e) {
  return Ut(1, arguments), nr(e, {
    weekStartsOn: 1
  });
}
function N6(e) {
  Ut(1, arguments);
  var t = mn(e), a = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(a + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var r = kl(n), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0);
  var o = kl(i);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= o.getTime() ? a : a - 1;
}
function L6(e) {
  Ut(1, arguments);
  var t = N6(e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  var n = kl(a);
  return n;
}
var B6 = 6048e5;
function R6(e) {
  Ut(1, arguments);
  var t = mn(e), a = kl(t).getTime() - L6(t).getTime();
  return Math.round(a / B6) + 1;
}
function Vt(e, t) {
  Ut(2, arguments);
  var a = mn(e), n = ti(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && a.setDate(a.getDate() + n), a);
}
function $l(e, t) {
  Ut(2, arguments);
  var a = mn(e), n = ti(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return a;
  var r = a.getDate(), i = new Date(a.getTime());
  i.setMonth(a.getMonth() + n + 1, 0);
  var o = i.getDate();
  return r >= o ? i : (a.setFullYear(i.getFullYear(), i.getMonth(), r), a);
}
function Ch(e, t) {
  Ut(2, arguments);
  var a = ti(t);
  return $l(e, a * 12);
}
const F6 = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function z6({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: a
}, n) {
  const r = [], {
    firstDayOfWeek: i,
    firstWeekday: o,
    isoWeeknumbers: u,
    weeknumbers: s,
    numDays: l,
    numWeeks: c
  } = e, d = o + (o < i ? Ht : 0) - i;
  let f = !0, v = !1, y = !1, C = 0;
  const h = new Intl.DateTimeFormat(n.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let g = t.numDays - d + 1, p = t.numDays - g + 1, w = Math.floor((g - 1) / Ht + 1), k = 1, S = t.numWeeks, T = 1, A = t.month, F = t.year;
  const Z = /* @__PURE__ */ new Date(), O = Z.getDate(), z = Z.getMonth() + 1, U = Z.getFullYear();
  for (let x = 1; x <= MN; x++) {
    for (let I = 1, E = i; I <= Ht; I++, E += E === Ht ? 1 - Ht : 1) {
      f && E === o && (g = 1, p = e.numDays, w = Math.floor((g - 1) / Ht + 1), k = Math.floor((l - g) / Ht + 1), S = 1, T = c, A = e.month, F = e.year, f = !1, v = !0);
      const P = n.getDateFromParams(F, A, g, 0, 0, 0, 0), R = n.getDateFromParams(F, A, g, 12, 0, 0, 0), K = n.getDateFromParams(
        F,
        A,
        g,
        23,
        59,
        59,
        999
      ), J = P, q = `${ut(F, 4)}-${ut(A, 2)}-${ut(g, 2)}`, se = I, fe = Ht - I, ne = s[x - 1], ae = u[x - 1], ve = g === O && A === z && F === U, Ae = v && g === 1, Te = v && g === l, Le = x === 1, ze = x === c, _e = I === 1, tt = I === Ht, Xe = Wp(F, A, g);
      r.push({
        locale: n,
        id: q,
        position: ++C,
        label: g.toString(),
        ariaLabel: h.format(new Date(F, A - 1, g)),
        day: g,
        dayFromEnd: p,
        weekday: E,
        weekdayPosition: se,
        weekdayPositionFromEnd: fe,
        weekdayOrdinal: w,
        weekdayOrdinalFromEnd: k,
        week: S,
        weekFromEnd: T,
        weekPosition: x,
        weeknumber: ne,
        isoWeeknumber: ae,
        month: A,
        year: F,
        date: J,
        startDate: P,
        endDate: K,
        noonDate: R,
        dayIndex: Xe,
        isToday: ve,
        isFirstDay: Ae,
        isLastDay: Te,
        isDisabled: !v,
        isFocusable: !v,
        isFocused: !1,
        inMonth: v,
        inPrevMonth: f,
        inNextMonth: y,
        onTop: Le,
        onBottom: ze,
        onLeft: _e,
        onRight: tt,
        classes: [
          `id-${q}`,
          `day-${g}`,
          `day-from-end-${p}`,
          `weekday-${E}`,
          `weekday-position-${se}`,
          `weekday-ordinal-${w}`,
          `weekday-ordinal-from-end-${k}`,
          `week-${S}`,
          `week-from-end-${T}`,
          {
            "is-today": ve,
            "is-first-day": Ae,
            "is-last-day": Te,
            "in-month": v,
            "in-prev-month": f,
            "in-next-month": y,
            "on-top": Le,
            "on-bottom": ze,
            "on-left": _e,
            "on-right": tt
          }
        ]
      }), v && Te ? (v = !1, y = !0, g = 1, p = l, w = 1, k = Math.floor((l - g) / Ht + 1), S = 1, T = a.numWeeks, A = a.month, F = a.year) : (g++, p--, w = Math.floor((g - 1) / Ht + 1), k = Math.floor((l - g) / Ht + 1));
    }
    S++, T--;
  }
  return r;
}
function Y6(e, t, a, n) {
  const r = e.reduce((i, o, u) => {
    const s = Math.floor(u / 7);
    let l = i[s];
    return l || (l = {
      id: `week-${s + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: t ? o.weeknumber : a ? o.isoWeeknumber : void 0,
      days: []
    }, i[s] = l), l.days.push(o), i;
  }, Array(e.length / Ht));
  return r.forEach((i) => {
    const o = i.days[0], u = i.days[i.days.length - 1];
    o.month === u.month ? i.title = `${n.formatDate(o.date, "MMMM YYYY")}` : o.year === u.year ? i.title = `${n.formatDate(
      o.date,
      "MMM"
    )} - ${n.formatDate(u.date, "MMM YYYY")}` : i.title = `${n.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${n.formatDate(u.date, "MMM YYYY")}`;
  }), r;
}
function H6(e, t) {
  return e.days.map((a) => ({
    label: t.formatDate(a.date, t.masks.weekdays),
    weekday: a.weekday
  }));
}
function q6(e, t) {
  return `${t}.${ut(e, 2)}`;
}
function Op(e, t, a) {
  return Ip(
    a.getDateParts(a.toDate(e)),
    F6[t]
  );
}
function Pp({ day: e, week: t, month: a, year: n }, r, i, o) {
  if (i === "daily" && e) {
    const u = new Date(n, a - 1, e), s = Vt(u, r);
    return {
      day: s.getDate(),
      month: s.getMonth() + 1,
      year: s.getFullYear()
    };
  } else if (i === "weekly" && t) {
    const s = o.getMonthParts(a, n).firstDayOfMonth, l = Vt(s, (t - 1 + r) * 7), c = o.getDateParts(l);
    return {
      week: c.week,
      month: c.month,
      year: c.year
    };
  } else {
    const u = new Date(n, a - 1, 1), s = $l(u, r);
    return {
      month: s.getMonth() + 1,
      year: s.getFullYear()
    };
  }
}
function Ba(e) {
  return e != null && e.month != null && e.year != null;
}
function Cu(e, t) {
  return !Ba(e) || !Ba(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function Sl(e, t) {
  return !Ba(e) || !Ba(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function W6(e, t, a) {
  return (e || !1) && !Cu(e, t) && !Sl(e, a);
}
function U6(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function K6(e, t, a, n) {
  if (!Ba(e) || !Ba(t))
    return [];
  const r = [];
  for (; !Sl(e, t); )
    r.push(e), e = Pp(e, 1, a, n);
  return r;
}
function Np(e) {
  const { day: t, week: a, month: n, year: r } = e;
  let i = `${r}-${ut(n, 2)}`;
  return a && (i = `${i}-w${a}`), t && (i = `${i}-${ut(t, 2)}`), i;
}
function V6(e, t) {
  const { month: a, year: n, showWeeknumbers: r, showIsoWeeknumbers: i } = e, o = new Date(n, a - 1, 15), u = t.getMonthParts(a, n), s = t.getPrevMonthParts(a, n), l = t.getNextMonthParts(a, n), c = z6({ monthComps: u, prevMonthComps: s, nextMonthComps: l }, t), d = Y6(c, r, i, t), f = H6(d[0], t);
  return {
    id: Np(e),
    month: a,
    year: n,
    monthTitle: t.formatDate(o, t.masks.title),
    shortMonthLabel: t.formatDate(o, "MMM"),
    monthLabel: t.formatDate(o, "MMMM"),
    shortYearLabel: n.toString().substring(2),
    yearLabel: n.toString(),
    monthComps: u,
    prevMonthComps: s,
    nextMonthComps: l,
    days: c,
    weeks: d,
    weekdays: f
  };
}
function j6(e, t) {
  const { day: a, week: n, view: r, trimWeeks: i } = e, o = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (r) {
    case "daily": {
      let u = o.days.find((l) => l.inMonth);
      a ? u = o.days.find((l) => l.day === a && l.inMonth) || u : n && (u = o.days.find((l) => l.week === n && l.inMonth));
      const s = o.weeks[u.week - 1];
      o.viewWeeks = [s], o.viewDays = [u], o.week = u.week, o.weekTitle = s.title, o.day = u.day, o.dayTitle = u.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = n || 1;
      const u = o.weeks[o.week - 1];
      o.viewWeeks = [u], o.viewDays = u.days, o.weekTitle = u.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        i ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class kh {
  constructor(t, a, n) {
    Ne(this, "keys", []), Ne(this, "store", {}), this.size = t, this.createKey = a, this.createItem = n;
  }
  get(...t) {
    const a = this.createKey(...t);
    return this.store[a];
  }
  getOrSet(...t) {
    const a = this.createKey(...t);
    if (this.store[a])
      return this.store[a];
    const n = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const r = this.keys.shift();
      r != null && delete this.store[r];
    }
    return this.keys.push(a), this.store[a] = n, n;
  }
}
class Lr {
  constructor(t, a = new xl()) {
    Ne(this, "order"), Ne(this, "locale"), Ne(this, "start", null), Ne(this, "end", null), Ne(this, "repeat", null);
    var n;
    this.locale = a;
    const { start: r, end: i, span: o, order: u, repeat: s } = t;
    Nr(r) && (this.start = a.getDateParts(r)), Nr(i) ? this.end = a.getDateParts(i) : this.start != null && o && (this.end = a.getDateParts(Vt(this.start.date, o - 1))), this.order = u ?? 0, s && (this.repeat = new Tl(
      {
        from: (n = this.start) == null ? void 0 : n.date,
        ...s
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, a) {
    return (ma(t) ? t : [t]).filter((n) => n).map((n) => Lr.from(n, a));
  }
  static from(t, a) {
    if (t instanceof Lr)
      return t;
    const n = {
      start: null,
      end: null
    };
    return t != null && (ma(t) ? (n.start = t[0] ?? null, n.end = t[1] ?? null) : un(t) ? Object.assign(n, t) : (n.start = t, n.end = t)), n.start != null && (n.start = new Date(n.start)), n.end != null && (n.end = new Date(n.end)), new Lr(n, a);
  }
  get opts() {
    const { order: t, locale: a } = this;
    return { order: t, locale: a };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: a } = this;
    return t && a && t.year === a.year && t.month === a.month && t.day === a.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var a, n;
    return ((a = this.start) == null ? void 0 : a.dayIndex) === t.dayIndex || !!((n = this.repeat) != null && n.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var a, n;
    return this.intersectsDayRange(
      ((a = t.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      ((n = t.end) == null ? void 0 : n.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, a) {
    return !(this.start && this.start.dayIndex > a || this.end && this.end.dayIndex < t);
  }
}
class G6 {
  constructor() {
    Ne(this, "records", {});
  }
  render(t, a, n) {
    var r, i, o, u;
    let s = null;
    const l = n[0].dayIndex, c = n[n.length - 1].dayIndex;
    return a.hasRepeat ? n.forEach((d) => {
      var f, v;
      if (a.startsOnDay(d)) {
        const y = a.daySpan < 1 / 0 ? a.daySpan : 1;
        s = {
          startDay: d.dayIndex,
          startTime: ((f = a.start) == null ? void 0 : f.time) ?? 0,
          endDay: d.dayIndex + y - 1,
          endTime: ((v = a.end) == null ? void 0 : v.time) ?? jo
        }, this.getRangeRecords(t).push(s);
      }
    }) : a.intersectsDayRange(l, c) && (s = {
      startDay: ((r = a.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      startTime: ((i = a.start) == null ? void 0 : i.time) ?? -1 / 0,
      endDay: ((o = a.end) == null ? void 0 : o.dayIndex) ?? 1 / 0,
      endTime: ((u = a.end) == null ? void 0 : u.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(s)), s;
  }
  getRangeRecords(t) {
    let a = this.records[t.key];
    return a || (a = {
      ranges: [],
      data: t
    }, this.records[t.key] = a), a.ranges;
  }
  getCell(t, a) {
    return this.getCells(a).find((i) => i.data.key === t);
  }
  cellExists(t, a) {
    const n = this.records[t];
    return n == null ? !1 : n.ranges.some(
      (r) => r.startDay <= a && r.endDay >= a
    );
  }
  getCells(t) {
    const a = Object.values(this.records), n = [], { dayIndex: r } = t;
    return a.forEach(({ data: i, ranges: o }) => {
      o.filter((u) => u.startDay <= r && u.endDay >= r).forEach((u) => {
        const s = r === u.startDay, l = r === u.endDay, c = s ? u.startTime : 0, d = new Date(t.startDate.getTime() + c), f = l ? u.endTime : jo, v = new Date(t.endDate.getTime() + f), y = c === 0 && f === jo, C = i.order || 0;
        n.push({
          ...u,
          data: i,
          onStart: s,
          onEnd: l,
          startTime: c,
          startDate: d,
          endTime: f,
          endDate: v,
          allDay: y,
          order: C
        });
      });
    }), n.sort((i, o) => i.order - o.order), n;
  }
}
const cn = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
cn.en = cn["en-US"];
cn.es = cn["es-ES"];
cn.no = cn.nb;
cn.zh = cn["zh-CN"];
const Q6 = Object.entries(cn).reduce(
  (e, [t, { dow: a, L: n }]) => (e[t] = {
    id: t,
    firstDayOfWeek: a,
    masks: { L: n }
  }, e),
  {}
), Z6 = "MMMM YYYY", X6 = "W", J6 = "MMM", _6 = "h A", eN = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], tN = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], aN = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], nN = [
  "h:mm A"
], rN = [
  "HH:mm"
], iN = "WWW, MMM D, YYYY", oN = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], lN = "iso", sN = "YYYY-MM-DDTHH:mm:ss.SSSZ", uN = {
  title: Z6,
  weekdays: X6,
  navMonths: J6,
  hours: _6,
  input: eN,
  inputDateTime: tN,
  inputDateTime24hr: aN,
  inputTime: nN,
  inputTime24hr: rN,
  dayPopover: iN,
  data: oN,
  model: lN,
  iso: sN
}, cN = 300, dN = 60, fN = 80, vN = {
  maxSwipeTime: cN,
  minHorizontalSwipeDistance: dN,
  maxVerticalSwipeDistance: fN
}, hN = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: vN,
  masks: uN,
  locales: Q6,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, ku = jr(hN), gN = b(() => B7(ku.locales, (e) => (e.masks = Ni(e.masks, ku.masks), e))), Ln = (e) => typeof window < "u" && Dp(window.__vcalendar__, e) ? Gn(window.__vcalendar__, e) : Gn(ku, e), mN = 12, pN = 5;
function yN(e, t) {
  const a = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  La(e) ? n = e : Dp(e, "id") && (n = e.id), n = (n || a).toLowerCase();
  const r = Object.keys(t), i = (s) => r.find((l) => l.toLowerCase() === s);
  n = i(n) || i(n.substring(0, 2)) || a;
  const o = {
    ...t["en-IE"],
    ...t[n],
    id: n,
    monthCacheSize: mN,
    pageCacheSize: pN
  };
  return un(e) ? Ni(e, o) : o;
}
class xl {
  constructor(t = void 0, a) {
    Ne(this, "id"), Ne(this, "daysInWeek"), Ne(this, "firstDayOfWeek"), Ne(this, "masks"), Ne(this, "timezone"), Ne(this, "hourLabels"), Ne(this, "dayNames"), Ne(this, "dayNamesShort"), Ne(this, "dayNamesShorter"), Ne(this, "dayNamesNarrow"), Ne(this, "monthNames"), Ne(this, "monthNamesShort"), Ne(this, "relativeTimeNames"), Ne(this, "amPm", ["am", "pm"]), Ne(this, "monthCache"), Ne(this, "pageCache");
    const { id: n, firstDayOfWeek: r, masks: i, monthCacheSize: o, pageCacheSize: u } = yN(t, gN.value);
    this.monthCache = new kh(
      o,
      YN,
      HN
    ), this.pageCache = new kh(u, Np, V6), this.id = n, this.daysInWeek = Ht, this.firstDayOfWeek = _9(r, 1, Ht), this.masks = i, this.timezone = a || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Fs("long", this.id), this.dayNamesShort = Fs("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((s) => s.substring(0, 2)), this.dayNamesNarrow = Fs("narrow", this.id), this.monthNames = Ah("long", this.id), this.monthNamesShort = Ah("short", this.id), this.relativeTimeNames = UN(this.id);
  }
  formatDate(t, a) {
    return QN(t, a, this);
  }
  parseDate(t, a) {
    return Ih(t, a, this);
  }
  toDate(t, a = {}) {
    const n = /* @__PURE__ */ new Date(NaN);
    let r = n;
    const { fillDate: i, mask: o, patch: u, rules: s } = a;
    if (Aa(t) ? (a.type = "number", r = /* @__PURE__ */ new Date(+t)) : La(t) ? (a.type = "string", r = t ? Ih(t, o || "iso", this) : n) : Nr(t) ? (a.type = "date", r = new Date(t.getTime())) : Oc(t) && (a.type = "object", r = this.getDateFromParts(t)), r && (u || s)) {
      let l = this.getDateParts(r);
      if (u && i != null) {
        const c = this.getDateParts(this.toDate(i));
        l = this.getDateParts(
          this.toDate({ ...c, ...Ip(l, EN[u]) })
        );
      }
      s && (l = GN(l, s)), r = this.getDateFromParts(l);
    }
    return r || n;
  }
  toDateOrNull(t, a = {}) {
    const n = this.toDate(t, a);
    return isNaN(n.getTime()) ? null : n;
  }
  fromDate(t, { type: a, mask: n } = {}) {
    switch (a) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, n || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return Lr.from(t, this);
  }
  ranges(t) {
    return Lr.fromMany(t, this);
  }
  getDateParts(t) {
    return zN(t, this);
  }
  getDateFromParts(t) {
    return Kp(t, this.timezone);
  }
  getDateFromParams(t, a, n, r, i, o, u) {
    return this.getDateFromParts({
      year: t,
      month: a,
      day: n,
      hours: r,
      minutes: i,
      seconds: o,
      milliseconds: u
    });
  }
  getPage(t) {
    const a = this.pageCache.getOrSet(t, this);
    return j6(t, a);
  }
  getMonthParts(t, a) {
    const { firstDayOfWeek: n } = this;
    return this.monthCache.getOrSet(t, a, n);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, a) {
    return t === 1 ? this.getMonthParts(12, a - 1) : this.getMonthParts(t - 1, a);
  }
  getNextMonthParts(t, a) {
    return t === 12 ? this.getMonthParts(1, a + 1) : this.getMonthParts(t + 1, a);
  }
  getHourLabels() {
    return WN().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var Dr = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(Dr || {}), Lp = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Lp || {}), Bp = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Bp || {}), Rp = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(Rp || {});
class bN {
  constructor(t, a, n) {
    Ne(this, "validated", !0), this.type = t, this.interval = a, this.from = n, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: a } = t;
    switch (this.type) {
      case "days":
        return Pc(this.from.date, a) % this.interval === 0;
      case "weeks":
        return RN(this.from.date, a) % this.interval === 0;
      case "months":
        return FN(this.from.date, a) % this.interval === 0;
      case "years":
        return Up(this.from.date, a) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class ai {
  constructor(t, a, n, r) {
    Ne(this, "components", []), this.type = t, this.validator = n, this.getter = r, this.components = this.normalizeComponents(a);
  }
  static create(t, a) {
    switch (t) {
      case "days":
        return new wN(a);
      case "weekdays":
        return new CN(a);
      case "weeks":
        return new kN(a);
      case "months":
        return new $N(a);
      case "years":
        return new SN(a);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!ma(t))
      return [];
    const a = [];
    return t.forEach((n) => {
      if (!this.validator(n)) {
        console.error(
          `Component value ${n} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      a.push(n);
    }), a;
  }
  passes(t) {
    return this.getter(t).some((r) => this.components.includes(r));
  }
}
class wN extends ai {
  constructor(t) {
    super(
      "days",
      t,
      DN,
      ({ day: a, dayFromEnd: n }) => [a, -n]
    );
  }
}
class CN extends ai {
  constructor(t) {
    super(
      "weekdays",
      t,
      $u,
      ({ weekday: a }) => [a]
    );
  }
}
class kN extends ai {
  constructor(t) {
    super(
      "weeks",
      t,
      AN,
      ({ week: a, weekFromEnd: n }) => [a, -n]
    );
  }
}
class $N extends ai {
  constructor(t) {
    super("months", t, IN, ({ month: a }) => [
      a
    ]);
  }
}
class SN extends ai {
  constructor(t) {
    super("years", t, Aa, ({ year: a }) => [a]);
  }
}
class xN {
  constructor(t, a) {
    Ne(this, "components"), this.type = t, this.components = this.normalizeComponents(a);
  }
  normalizeArrayConfig(t) {
    const a = [];
    return t.forEach((n, r) => {
      if (Aa(n)) {
        if (r === 0)
          return;
        if (!$h(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!$u(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else ma(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  normalizeComponents(t) {
    const a = [];
    return t.forEach((n, r) => {
      if (Aa(n)) {
        if (r === 0)
          return;
        if (!$h(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!$u(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else ma(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  passes(t) {
    const { weekday: a, weekdayOrdinal: n, weekdayOrdinalFromEnd: r } = t;
    return this.components.some(
      ([i, o]) => (i === n || i === -r) && a === o
    );
  }
}
class TN {
  constructor(t) {
    Ne(this, "type", "function"), Ne(this, "validated", !0), this.fn = t, dr(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class Tl {
  constructor(t, a = {}, n) {
    Ne(this, "validated", !0), Ne(this, "config"), Ne(this, "type", Dr.Any), Ne(this, "from"), Ne(this, "until"), Ne(this, "rules", []), Ne(this, "locale", new xl()), this.parent = n, a.locale && (this.locale = a.locale), this.config = t, dr(t) ? (this.type = Dr.All, this.rules = [new TN(t)]) : ma(t) ? (this.type = Dr.Any, this.rules = t.map((r) => new Tl(r, a, this))) : un(t) ? (this.type = Dr.All, this.from = t.from ? this.locale.getDateParts(t.from) : n == null ? void 0 : n.from, this.until = t.until ? this.locale.getDateParts(t.until) : n == null ? void 0 : n.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const a = [];
    if (t.every && (La(t.every) && (t.every = [1, `${t.every}s`]), ma(t.every))) {
      const [n = 1, r = Lp.Days] = t.every;
      a.push(new bN(r, n, this.from));
    }
    return Object.values(Bp).forEach((n) => {
      n in t && a.push(ai.create(n, t[n]));
    }), Object.values(Rp).forEach((n) => {
      n in t && a.push(new xN(n, t[n]));
    }), t.on != null && (ma(t.on) || (t.on = [t.on]), a.push(
      new Tl(t.on, { locale: this.locale }, this.parent)
    )), a;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === Dr.Any ? this.rules.some((a) => a.passes(t)) : this.rules.every((a) => a.passes(t)) : !0;
  }
}
function DN(e) {
  return Aa(e) ? e >= 1 && e <= 31 : !1;
}
function $u(e) {
  return Aa(e) ? e >= 1 && e <= 7 : !1;
}
function AN(e) {
  return Aa(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function IN(e) {
  return Aa(e) ? e >= 1 && e <= 12 : !1;
}
function $h(e) {
  return !(!Aa(e) || e < -5 || e > 5 || e === 0);
}
const EN = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, Ht = 7, MN = 6, Fp = 1e3, zp = Fp * 60, Yp = zp * 60, jo = Yp * 24, ON = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], PN = ["L", "iso"], hi = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, Hp = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, NN = /\[([^]*?)\]/gm, Sh = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return ut(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return ut(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return ut(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return ut(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return ut(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return ut(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return ut(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return ut(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return ut(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return ut(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${ut(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${ut(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${ut(Math.floor(Math.abs(t) / 60), 2)}:${ut(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, wn = /\d\d?/, LN = /\d{3}/, BN = /\d{4}/, ci = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, xh = () => {
}, Th = (e) => (t, a, n) => {
  const r = n[e].indexOf(
    a.charAt(0).toUpperCase() + a.substr(1).toLowerCase()
  );
  ~r && (t.month = r);
}, ft = {
  D: [
    wn,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(wn.source + ci.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [wn, xh],
  W: [ci, xh],
  M: [
    wn,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [ci, Th("monthNamesShort")],
  MMMM: [ci, Th("monthNames")],
  YY: [
    wn,
    (e, t) => {
      const n = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? n - 1 : n}${t}`;
    }
  ],
  YYYY: [
    BN,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    LN,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    wn,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    wn,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    wn,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    ci,
    (e, t, a) => {
      const n = t.toLowerCase();
      n === a.amPm[0] ? e.isPm = !1 : n === a.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const a = `${t}`.match(/([+-]|\d\d)/gi);
      if (a) {
        const n = +a[1] * 60 + parseInt(a[2], 10);
        e.timezoneOffset = a[0] === "+" ? n : -n;
      }
    }
  ]
};
ft.DD = ft.D;
ft.dd = ft.d;
ft.WWWW = ft.WWW = ft.WW = ft.W;
ft.MM = ft.M;
ft.mm = ft.m;
ft.hh = ft.H = ft.HH = ft.h;
ft.ss = ft.s;
ft.A = ft.a;
ft.ZZZZ = ft.ZZZ = ft.ZZ = ft.Z;
function qp(e, t) {
  return (an(e) && e || [
    La(e) && e || "YYYY-MM-DD"
  ]).map(
    (a) => PN.reduce(
      (n, r) => n.replace(r, t.masks[r] || ""),
      a
    )
  );
}
function Oc(e) {
  return un(e) && "year" in e && "month" in e && "day" in e;
}
function Dh(e, t = 1) {
  const a = e.getDay() + 1, n = a >= t ? t - a : -(7 - (t - a));
  return Vt(e, n);
}
function Wp(e, t, a) {
  const n = Date.UTC(e, t - 1, a);
  return Pc(/* @__PURE__ */ new Date(0), new Date(n));
}
function Pc(e, t) {
  return Math.round((t.getTime() - e.getTime()) / jo);
}
function RN(e, t) {
  return Math.ceil(Pc(Dh(e), Dh(t)) / 7);
}
function Up(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function FN(e, t) {
  return Up(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function Kp(e, t = "") {
  const a = /* @__PURE__ */ new Date(), {
    year: n = a.getFullYear(),
    month: r = a.getMonth() + 1,
    day: i = a.getDate(),
    hours: o = 0,
    minutes: u = 0,
    seconds: s = 0,
    milliseconds: l = 0
  } = e;
  if (t) {
    const c = `${ut(n, 4)}-${ut(r, 2)}-${ut(i, 2)}T${ut(
      o,
      2
    )}:${ut(u, 2)}:${ut(s, 2)}.${ut(l, 3)}`;
    return m6(c, { timeZone: t });
  }
  return new Date(n, r - 1, i, o, u, s, l);
}
function zN(e, t) {
  let a = new Date(e.getTime());
  t.timezone && (a = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), a.setMilliseconds(e.getMilliseconds()));
  const n = a.getMilliseconds(), r = a.getSeconds(), i = a.getMinutes(), o = a.getHours(), u = n + r * Fp + i * zp + o * Yp, s = a.getMonth() + 1, l = a.getFullYear(), c = t.getMonthParts(s, l), d = a.getDate(), f = c.numDays - d + 1, v = a.getDay() + 1, y = Math.floor((d - 1) / 7 + 1), C = Math.floor((c.numDays - d) / 7 + 1), h = Math.ceil(
    (d + Math.abs(c.firstWeekday - c.firstDayOfWeek)) / 7
  ), g = c.numWeeks - h + 1, p = c.weeknumbers[h], w = Wp(l, s, d);
  return {
    milliseconds: n,
    seconds: r,
    minutes: i,
    hours: o,
    time: u,
    day: d,
    dayFromEnd: f,
    weekday: v,
    weekdayOrdinal: y,
    weekdayOrdinalFromEnd: C,
    week: h,
    weekFromEnd: g,
    weeknumber: p,
    month: s,
    year: l,
    date: a,
    dateTime: a.getTime(),
    dayIndex: w,
    timezoneOffset: 0,
    isValid: !0
  };
}
function YN(e, t, a) {
  return `${t}-${e}-${a}`;
}
function HN(e, t, a) {
  const n = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, r = new Date(t, e - 1, 1), i = r.getDay() + 1, o = e === 2 && n ? 29 : ON[e - 1], u = a - 1, s = I6(r, {
    weekStartsOn: u
  }), l = [], c = [];
  for (let d = 0; d < s; d++) {
    const f = Vt(r, d * 7);
    l.push(P6(f, { weekStartsOn: u })), c.push(R6(f));
  }
  return {
    firstDayOfWeek: a,
    firstDayOfMonth: r,
    inLeapYear: n,
    firstWeekday: i,
    numDays: o,
    numWeeks: s,
    month: e,
    year: t,
    weeknumbers: l,
    isoWeeknumbers: c
  };
}
function qN() {
  const e = [];
  for (let r = 0; r < Ht; r++)
    e.push(
      Kp({
        year: 2020,
        month: 1,
        day: 5 + r,
        hours: 12
      })
    );
  return e;
}
function Fs(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return qN().map((n) => a.format(n));
}
function WN() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function UN(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], a = new Intl.RelativeTimeFormat(e);
  return t.reduce((n, r) => {
    const i = a.formatToParts(100, r);
    return n[r] = i[1].unit, n;
  }, {});
}
function Vp() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function Ah(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Vp().map((n) => a.format(n));
}
function KN(e, t, a) {
  return Aa(t) ? t === e : ma(t) ? t.includes(e) : dr(t) ? t(e, a) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function gi(e, t, a) {
  const n = [], [r, i, o] = t;
  for (let u = r; u <= i; u++)
    (a == null || KN(u, a, e)) && n.push({
      value: u,
      label: ut(u, o)
    });
  return n;
}
function VN(e, t) {
  return {
    milliseconds: gi(
      e,
      hi.milliseconds,
      t.milliseconds
    ),
    seconds: gi(e, hi.seconds, t.seconds),
    minutes: gi(e, hi.minutes, t.minutes),
    hours: gi(e, hi.hours, t.hours)
  };
}
function jN(e, t, a, n) {
  const i = gi(e, t, n).reduce((o, u) => {
    if (u.disabled)
      return o;
    if (isNaN(o))
      return u.value;
    const s = Math.abs(o - a);
    return Math.abs(u.value - a) < s ? u.value : o;
  }, NaN);
  return isNaN(i) ? a : i;
}
function GN(e, t) {
  const a = { ...e };
  return Object.entries(t).forEach(([n, r]) => {
    const i = hi[n], o = e[n];
    a[n] = jN(
      e,
      i,
      o,
      r
    );
  }), a;
}
function Ih(e, t, a) {
  return qp(t, a).map((r) => {
    if (typeof r != "string")
      throw new Error("Invalid mask");
    let i = e;
    if (i.length > 1e3)
      return !1;
    let o = !0;
    const u = {};
    if (r.replace(Hp, (c) => {
      if (ft[c]) {
        const d = ft[c], f = i.search(d[0]);
        ~f ? i.replace(d[0], (v) => (d[1](u, v, a), i = i.substr(f + v.length), v)) : o = !1;
      }
      return ft[c] ? "" : c.slice(1, c.length - 1);
    }), !o)
      return !1;
    const s = /* @__PURE__ */ new Date();
    u.hours != null && (u.isPm === !0 && +u.hours != 12 ? u.hours = +u.hours + 12 : u.isPm === !1 && +u.hours == 12 && (u.hours = 0));
    let l;
    return u.timezoneOffset != null ? (u.minutes = +(u.minutes || 0) - +u.timezoneOffset, l = new Date(
      Date.UTC(
        u.year || s.getFullYear(),
        u.month || 0,
        u.day || 1,
        u.hours || 0,
        u.minutes || 0,
        u.seconds || 0,
        u.milliseconds || 0
      )
    )) : l = a.getDateFromParts({
      year: u.year || s.getFullYear(),
      month: (u.month || 0) + 1,
      day: u.day || 1,
      hours: u.hours || 0,
      minutes: u.minutes || 0,
      seconds: u.seconds || 0,
      milliseconds: u.milliseconds || 0
    }), l;
  }).find((r) => r) || new Date(e);
}
function QN(e, t, a) {
  if (e == null)
    return "";
  let n = qp(t, a)[0];
  /Z$/.test(n) && (a.timezone = "utc");
  const r = [];
  n = n.replace(NN, (o, u) => (r.push(u), "??"));
  const i = a.getDateParts(e);
  return n = n.replace(
    Hp,
    (o) => o in Sh ? Sh[o](i, a) : o.slice(1, o.length - 1)
  ), n.replace(/\?\?/g, () => r.shift());
}
let ZN = 0;
class jp {
  constructor(t, a, n) {
    Ne(this, "key", ""), Ne(this, "hashcode", ""), Ne(this, "highlight", null), Ne(this, "content", null), Ne(this, "dot", null), Ne(this, "bar", null), Ne(this, "event", null), Ne(this, "popover", null), Ne(this, "customData", null), Ne(this, "ranges"), Ne(this, "hasRanges", !1), Ne(this, "order", 0), Ne(this, "pinPage", !1), Ne(this, "maxRepeatSpan", 0), Ne(this, "locale");
    const { dates: r } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++ZN), this.locale = n, a.normalizeGlyphs(this), this.ranges = n.ranges(r ?? []), this.hasRanges = !!an(this.ranges), this.maxRepeatSpan = this.ranges.filter((i) => i.hasRepeat).map((i) => i.daySpan).reduce((i, o) => Math.max(i, o), 0);
  }
  intersectsRange({ start: t, end: a }) {
    if (t == null || a == null)
      return !1;
    const n = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of n)
      if (o.intersectsDayRange(t.dayIndex, a.dayIndex))
        return !0;
    const r = this.ranges.filter((o) => o.hasRepeat);
    if (!r.length)
      return !1;
    let i = t;
    for (this.maxRepeatSpan > 1 && (i = this.locale.getDateParts(Vt(i.date, -this.maxRepeatSpan))); i.dayIndex <= a.dayIndex; ) {
      for (const o of r)
        if (o.startsOnDay(i))
          return !0;
      i = this.locale.getDateParts(Vt(i.date, 1));
    }
    return !1;
  }
}
function Su(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function Li(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Gp(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function Qp(e) {
  const { visibility: t } = e, a = t === "click", n = t === "hover", r = t === "hover-focus", i = t === "focus";
  e.autoHide = !a;
  let o = !1, u = !1;
  const s = (y) => {
    a && (Gp({
      ...e,
      target: e.target || y.currentTarget
    }), y.stopPropagation());
  }, l = (y) => {
    o || (o = !0, (n || r) && Su({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, c = () => {
    o && (o = !1, (n || r && !u) && Li(e));
  }, d = (y) => {
    u || (u = !0, (i || r) && Su({
      ...e,
      target: e.target || y.currentTarget
    }));
  }, f = (y) => {
    u && !Ko(y.currentTarget, y.relatedTarget) && (u = !1, (i || r && !o) && Li(e));
  }, v = {};
  switch (e.visibility) {
    case "click":
      v.click = s;
      break;
    case "hover":
      v.mousemove = l, v.mouseleave = c;
      break;
    case "focus":
      v.focusin = d, v.focusout = f;
      break;
    case "hover-focus":
      v.mousemove = l, v.mouseleave = c, v.focusin = d, v.focusout = f;
      break;
  }
  return v;
}
const Eh = (e) => {
  const t = bl(e);
  if (t == null)
    return;
  const a = t.popoverHandlers;
  !a || !a.length || (a.forEach((n) => n()), delete t.popoverHandlers);
}, Mh = (e, t) => {
  const a = bl(e);
  if (a == null)
    return;
  const n = [], r = Qp(t);
  Object.entries(r).forEach(([i, o]) => {
    n.push(xn(a, i, o));
  }), a.popoverHandlers = n;
}, Zp = {
  mounted(e, t) {
    const { value: a } = t;
    a && Mh(e, a);
  },
  updated(e, t) {
    const { oldValue: a, value: n } = t, r = a == null ? void 0 : a.visibility, i = n == null ? void 0 : n.visibility;
    r !== i && (r && (Eh(e), i || Li(a)), i && Mh(e, n));
  },
  unmounted(e) {
    Eh(e);
  }
}, XN = (e, t, {
  maxSwipeTime: a,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: r
}) => {
  if (!e || !e.addEventListener || !dr(t))
    return null;
  let i = 0, o = 0, u = null, s = !1;
  function l(d) {
    const f = d.changedTouches[0];
    i = f.screenX, o = f.screenY, u = (/* @__PURE__ */ new Date()).getTime(), s = !0;
  }
  function c(d) {
    if (!s || !u)
      return;
    s = !1;
    const f = d.changedTouches[0], v = f.screenX - i, y = f.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - u < a && Math.abs(v) >= n && Math.abs(y) <= r) {
      const h = { toLeft: !1, toRight: !1 };
      v < 0 ? h.toLeft = !0 : h.toRight = !0, t(h);
    }
  }
  return xn(e, "touchstart", l, { passive: !0 }), xn(e, "touchend", c, { passive: !0 }), () => {
    Sn(e, "touchstart", l), Sn(e, "touchend", c);
  };
}, Go = {}, JN = (e, t = 10) => {
  Go[e] = Date.now() + t;
}, _N = (e, t) => {
  if (e in Go) {
    const a = Go[e];
    if (Date.now() < a)
      return;
    delete Go[e];
  }
  t();
};
function Xp() {
  return typeof window < "u";
}
function eL(e) {
  return Xp() && e in window;
}
function tL(e) {
  const t = N(!1), a = b(() => t.value ? "dark" : "light");
  let n, r;
  function i(v) {
    t.value = v.matches;
  }
  function o() {
    eL("matchMedia") && (n = window.matchMedia("(prefers-color-scheme: dark)"), n.addEventListener("change", i), t.value = n.matches);
  }
  function u() {
    const { selector: v = ":root", darkClass: y = "dark" } = e.value, C = document.querySelector(v);
    t.value = C.classList.contains(y);
  }
  function s(v) {
    const { selector: y = ":root", darkClass: C = "dark" } = v;
    if (Xp() && y && C) {
      const h = document.querySelector(y);
      h && (r = new MutationObserver(u), r.observe(h, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = h.classList.contains(C));
    }
  }
  function l() {
    d();
    const v = typeof e.value;
    v === "string" && e.value.toLowerCase() === "system" ? o() : v === "object" ? s(e.value) : t.value = !!e.value;
  }
  const c = ie(() => e.value, () => l(), {
    immediate: !0
  });
  function d() {
    n && (n.removeEventListener("change", i), n = void 0), r && (r.disconnect(), r = void 0);
  }
  function f() {
    d(), c();
  }
  return ya(() => f()), {
    isDark: t,
    displayMode: a,
    cleanup: f
  };
}
const aL = ["base", "start", "end", "startEnd"], nL = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], rL = { base: {}, start: {}, end: {} };
function Nc(e, t, a = rL) {
  let n = e, r = {};
  t === !0 || La(t) ? (n = La(t) ? t : n, r = { ...a }) : un(t) && (dh(t, aL) ? r = { ...t } : r = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const i = Ni(
    r,
    { start: r.startEnd, end: r.startEnd },
    a
  );
  return Object.entries(i).forEach(([o, u]) => {
    let s = n;
    u === !0 || La(u) ? (s = La(u) ? u : s, i[o] = { color: s }) : un(u) && (dh(u, nL) ? i[o] = { ...u } : i[o] = {}), Ni(i[o], { color: s });
  }), i;
}
class iL {
  constructor() {
    Ne(this, "type", "highlight");
  }
  normalizeConfig(t, a) {
    return Nc(t, a, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: a, onEnd: n }, r) {
    const { key: i, highlight: o } = t;
    if (!o)
      return;
    const { highlights: u } = r, { base: s, start: l, end: c } = o;
    a && n ? u.push({
      ...l,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${l.color}`,
      class: [`vc-highlight vc-highlight-bg-${l.fillMode}`, l.class],
      contentClass: [
        `vc-attr vc-highlight-content-${l.fillMode} vc-${l.color}`,
        l.contentClass
      ]
    }) : a ? (u.push({
      ...s,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${s.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${s.fillMode}`,
        s.class
      ]
    }), u.push({
      ...l,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${l.color}`,
      class: [`vc-highlight vc-highlight-bg-${l.fillMode}`, l.class],
      contentClass: [
        `vc-attr vc-highlight-content-${l.fillMode} vc-${l.color}`,
        l.contentClass
      ]
    })) : n ? (u.push({
      ...s,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${s.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${s.fillMode}`,
        s.class
      ]
    }), u.push({
      ...c,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${c.color}`,
      class: [`vc-highlight vc-highlight-bg-${c.fillMode}`, c.class],
      contentClass: [
        `vc-attr vc-highlight-content-${c.fillMode} vc-${c.color}`,
        c.contentClass
      ]
    })) : u.push({
      ...s,
      key: `${i}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${s.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${s.fillMode}`,
        s.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${s.fillMode} vc-${s.color}`,
        s.contentClass
      ]
    });
  }
}
class Lc {
  constructor(t, a) {
    Ne(this, "type", ""), Ne(this, "collectionType", ""), this.type = t, this.collectionType = a;
  }
  normalizeConfig(t, a) {
    return Nc(t, a);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: a, onEnd: n }, r) {
    const { key: i } = t, o = t[this.type];
    if (!i || !o)
      return;
    const u = r[this.collectionType], { base: s, start: l, end: c } = o;
    a ? u.push({
      ...l,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${l.color} vc-attr`,
        l.class
      ]
    }) : n ? u.push({
      ...c,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${c.color} vc-attr`,
        c.class
      ]
    }) : u.push({
      ...s,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${s.color} vc-attr`,
        s.class
      ]
    });
  }
}
class oL extends Lc {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, a) {
    return Nc("base", a);
  }
}
class lL extends Lc {
  constructor() {
    super("dot", "dots");
  }
}
class sL extends Lc {
  constructor() {
    super("bar", "bars");
  }
}
class uL {
  constructor(t) {
    Ne(this, "color"), Ne(this, "renderers", [
      new oL(),
      new iL(),
      new lL(),
      new sL()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((a) => {
      const n = a.type;
      t[n] != null && (t[n] = a.normalizeConfig(this.color, t[n]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((a) => {
      a.prepareRender(t);
    }), t;
  }
  render(t, a) {
    this.renderers.forEach((n) => {
      n.render(t, a);
    });
  }
}
const Jp = Symbol("__vc_base_context__"), _p = {
  color: {
    type: String,
    default: () => Ln("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => Ln("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function e1(e) {
  const t = b(() => e.color ?? ""), a = b(() => e.isDark ?? !1), { displayMode: n } = tL(a), r = b(() => new uL(t.value)), i = b(() => {
    if (e.locale instanceof xl)
      return e.locale;
    const f = un(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new xl(f, e.timezone);
  }), o = b(() => i.value.masks), u = b(() => e.minDate), s = b(() => e.maxDate), l = b(() => {
    const f = e.disabledDates ? [...e.disabledDates] : [];
    return u.value != null && f.push({
      start: null,
      end: Vt(i.value.toDate(u.value), -1)
    }), s.value != null && f.push({
      start: Vt(i.value.toDate(s.value), 1),
      end: null
    }), i.value.ranges(f);
  }), c = b(() => new jp(
    {
      key: "disabled",
      dates: l.value,
      order: 100
    },
    r.value,
    i.value
  )), d = {
    color: t,
    isDark: a,
    displayMode: n,
    theme: r,
    locale: i,
    masks: o,
    minDate: u,
    maxDate: s,
    disabledDates: l,
    disabledAttribute: c
  };
  return Ri(Jp, d), d;
}
function cL(e) {
  return Bi(Jp, () => e1(e), !0);
}
function t1(e) {
  return `__vc_slot_${e}__`;
}
function a1(e, t = {}) {
  Object.keys(e).forEach((a) => {
    Ri(t1(t[a] ?? a), e[a]);
  });
}
function n1(e) {
  return Bi(t1(e), null);
}
const dL = {
  ..._p,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => Ln("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => Ln("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, fL = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], r1 = Symbol("__vc_calendar_context__");
function vL(e, { slots: t, emit: a }) {
  const n = N(null), r = N(null), i = N((/* @__PURE__ */ new Date()).getDate()), o = N(!1), u = N(Symbol()), s = N(Symbol()), l = N(e.view), c = N([]), d = N("");
  let f = null, v = null;
  a1(t);
  const {
    theme: y,
    color: C,
    displayMode: h,
    locale: g,
    masks: p,
    minDate: w,
    maxDate: k,
    disabledAttribute: S,
    disabledDates: T
  } = cL(e), A = b(() => e.rows * e.columns), F = b(() => e.step || A.value), Z = b(() => Tp(c.value) ?? null), O = b(() => Ir(c.value) ?? null), z = b(
    () => e.minPage || (w.value ? fe(w.value) : null)
  ), U = b(
    () => e.maxPage || (k.value ? fe(k.value) : null)
  ), x = b(() => e.navVisibility), I = b(() => !!e.showWeeknumbers), E = b(() => !!e.showIsoWeeknumbers), P = b(() => l.value === "monthly"), R = b(() => l.value === "weekly"), K = b(() => l.value === "daily"), J = () => {
    o.value = !0, a("transition-start");
  }, q = () => {
    o.value = !1, a("transition-end"), f && (f.resolve(!0), f = null);
  }, se = (Q, M, j = l.value) => Pp(Q, M, j, g.value), fe = (Q) => Op(Q, l.value, g.value), ne = (Q) => {
    !S.value || !ze.value || (Q.isDisabled = ze.value.cellExists(
      S.value.key,
      Q.dayIndex
    ));
  }, ae = (Q) => {
    Q.isFocusable = Q.inMonth && Q.day === i.value;
  }, ve = (Q, M) => {
    for (const j of Q)
      for (const ge of j.days)
        if (M(ge) === !1)
          return;
  }, Ae = b(
    () => c.value.reduce((Q, M) => (Q.push(...M.viewDays), Q), [])
  ), Te = b(() => {
    const Q = [];
    return (e.attributes || []).forEach((M, j) => {
      !M || !M.dates || Q.push(
        new jp(
          {
            ...M,
            order: M.order || 0
          },
          y.value,
          g.value
        )
      );
    }), S.value && Q.push(S.value), Q;
  }), Le = b(() => an(Te.value)), ze = b(() => {
    const Q = new G6();
    return Te.value.forEach((M) => {
      M.ranges.forEach((j) => {
        Q.render(M, j, Ae.value);
      });
    }), Q;
  }), _e = b(() => Ae.value.reduce((Q, M) => (Q[M.dayIndex] = { day: M, cells: [] }, Q[M.dayIndex].cells.push(...ze.value.getCells(M)), Q), {})), tt = (Q, M) => {
    const j = e.showWeeknumbers || e.showIsoWeeknumbers;
    return j == null ? "" : y7(j) ? j ? "left" : "" : j.startsWith("right") ? M > 1 ? "right" : j : Q > 1 ? "left" : j;
  }, Xe = () => {
    var Q, M;
    if (!Le.value)
      return null;
    const j = Te.value.find((nt) => nt.pinPage) || Te.value[0];
    if (!j || !j.hasRanges)
      return null;
    const [ge] = j.ranges, $e = ((Q = ge.start) == null ? void 0 : Q.date) || ((M = ge.end) == null ? void 0 : M.date);
    return $e ? fe($e) : null;
  }, et = () => {
    if (Ba(Z.value))
      return Z.value;
    const Q = Xe();
    return Ba(Q) ? Q : fe(/* @__PURE__ */ new Date());
  }, pe = (Q, M = {}) => {
    const { view: j = l.value, position: ge = 1, force: $e } = M, nt = ge > 0 ? 1 - ge : -(A.value + ge);
    let Tt = se(Q, nt, j), Nt = se(Tt, A.value - 1, j);
    return $e || (Cu(Tt, z.value) ? Tt = z.value : Sl(Nt, U.value) && (Tt = se(U.value, 1 - A.value)), Nt = se(Tt, A.value - 1)), { fromPage: Tt, toPage: Nt };
  }, me = (Q, M, j = "") => {
    if (j === "none" || j === "fade")
      return j;
    if ((Q == null ? void 0 : Q.view) !== (M == null ? void 0 : M.view))
      return "fade";
    const ge = Sl(M, Q), $e = Cu(M, Q);
    return !ge && !$e ? "fade" : j === "slide-v" ? $e ? "slide-down" : "slide-up" : $e ? "slide-right" : "slide-left";
  }, he = (Q = {}) => new Promise((M, j) => {
    const { position: ge = 1, force: $e = !1, transition: nt } = Q, Tt = Ba(Q.page) ? Q.page : et(), { fromPage: Nt } = pe(Tt, {
      position: ge,
      force: $e
    }), Ot = [];
    for (let Ma = 0; Ma < A.value; Ma++) {
      const yn = se(Nt, Ma), Ct = Ma + 1, le = Math.ceil(Ct / e.columns), Ce = e.rows - le + 1, ke = Ct % e.columns || e.columns, je = e.columns - ke + 1, B = tt(ke, je);
      Ot.push(
        g.value.getPage({
          ...yn,
          view: l.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: Ct,
          row: le,
          rowFromEnd: Ce,
          column: ke,
          columnFromEnd: je,
          showWeeknumbers: I.value,
          showIsoWeeknumbers: E.value,
          weeknumberPosition: B
        })
      );
    }
    d.value = me(
      c.value[0],
      Ot[0],
      nt
    ), c.value = Ot, d.value && d.value !== "none" ? f = {
      resolve: M,
      reject: j
    } : M(!0);
  }), V = (Q) => {
    const M = Z.value ?? fe(/* @__PURE__ */ new Date());
    return se(M, Q);
  }, Se = (Q, M = {}) => {
    const j = Ba(Q) ? Q : fe(Q);
    return Object.assign(
      M,
      pe(j, {
        ...M,
        force: !0
      })
    ), K6(
      M.fromPage,
      M.toPage,
      l.value,
      g.value
    ).map(($e) => W6($e, z.value, U.value)).some(($e) => $e);
  }, Be = (Q, M = {}) => Se(V(Q), M), Me = b(() => Be(-F.value)), Ve = b(() => Be(F.value)), wt = async (Q, M = {}) => !M.force && !Se(Q, M) ? !1 : (M.fromPage && !U6(M.fromPage, Z.value) && (Li({ id: u.value, hideDelay: 0 }), M.view && (JN("view", 10), l.value = M.view), await he({
    ...M,
    page: M.fromPage,
    position: 1,
    force: !0
  }), a("did-move", c.value)), !0), vt = (Q, M = {}) => wt(V(Q), M), Je = () => vt(-F.value), lt = () => vt(F.value), xt = (Q) => {
    const M = P.value ? ".in-month" : "", j = `.id-${g.value.getDayId(Q)}${M}`, ge = `${j}.vc-focusable, ${j} .vc-focusable`, $e = n.value;
    if ($e) {
      const nt = $e.querySelector(ge);
      if (nt)
        return nt.focus(), !0;
    }
    return !1;
  }, Lt = async (Q, M = {}) => xt(Q) ? !0 : (await wt(Q, M), xt(Q)), Xt = (Q, M) => {
    i.value = Q.day, a("dayclick", Q, M);
  }, ra = (Q, M) => {
    a("daymouseenter", Q, M);
  }, Jt = (Q, M) => {
    a("daymouseleave", Q, M);
  }, Mt = (Q, M) => {
    i.value = Q.day, r.value = Q, Q.isFocused = !0, a("dayfocusin", Q, M);
  }, ue = (Q, M) => {
    r.value = null, Q.isFocused = !1, a("dayfocusout", Q, M);
  }, He = (Q, M) => {
    a("daykeydown", Q, M);
    const j = Q.noonDate;
    let ge = null;
    switch (M.key) {
      case "ArrowLeft": {
        ge = Vt(j, -1);
        break;
      }
      case "ArrowRight": {
        ge = Vt(j, 1);
        break;
      }
      case "ArrowUp": {
        ge = Vt(j, -7);
        break;
      }
      case "ArrowDown": {
        ge = Vt(j, 7);
        break;
      }
      case "Home": {
        ge = Vt(j, -Q.weekdayPosition + 1);
        break;
      }
      case "End": {
        ge = Vt(j, Q.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        M.altKey ? ge = Ch(j, -1) : ge = $l(j, -1);
        break;
      }
      case "PageDown": {
        M.altKey ? ge = Ch(j, 1) : ge = $l(j, 1);
        break;
      }
    }
    ge && (M.preventDefault(), Lt(ge).catch());
  }, _ = (Q) => {
    const M = r.value;
    M != null && He(M, Q);
  }, de = (Q, M) => {
    a("weeknumberclick", Q, M);
  };
  he({
    page: e.initialPage,
    position: e.initialPagePosition
  }), it(() => {
    !e.disablePageSwipe && n.value && (v = XN(
      n.value,
      ({ toLeft: Q = !1, toRight: M = !1 }) => {
        Q ? lt() : M && Je();
      },
      Ln("touch")
    ));
  }), ya(() => {
    c.value = [], v && v();
  }), ie(
    () => g.value,
    () => {
      he();
    }
  ), ie(
    () => A.value,
    () => he()
  ), ie(
    () => e.view,
    () => l.value = e.view
  ), ie(
    () => l.value,
    () => {
      _N("view", () => {
        he();
      }), a("update:view", l.value);
    }
  ), ie(
    () => i.value,
    () => {
      ve(c.value, (Q) => ae(Q));
    }
  ), Lu(() => {
    a("update:pages", c.value), ve(c.value, (Q) => {
      ne(Q), ae(Q);
    });
  });
  const Ie = {
    emit: a,
    containerRef: n,
    focusedDay: r,
    inTransition: o,
    navPopoverId: u,
    dayPopoverId: s,
    view: l,
    pages: c,
    transitionName: d,
    theme: y,
    color: C,
    displayMode: h,
    locale: g,
    masks: p,
    attributes: Te,
    disabledAttribute: S,
    disabledDates: T,
    attributeContext: ze,
    days: Ae,
    dayCells: _e,
    count: A,
    step: F,
    firstPage: Z,
    lastPage: O,
    canMovePrev: Me,
    canMoveNext: Ve,
    minPage: z,
    maxPage: U,
    isMonthly: P,
    isWeekly: R,
    isDaily: K,
    navVisibility: x,
    showWeeknumbers: I,
    showIsoWeeknumbers: E,
    getDateAddress: fe,
    canMove: Se,
    canMoveBy: Be,
    move: wt,
    moveBy: vt,
    movePrev: Je,
    moveNext: lt,
    onTransitionBeforeEnter: J,
    onTransitionAfterEnter: q,
    tryFocusDate: xt,
    focusDate: Lt,
    onKeydown: _,
    onDayKeydown: He,
    onDayClick: Xt,
    onDayMouseenter: ra,
    onDayMouseleave: Jt,
    onDayFocusin: Mt,
    onDayFocusout: ue,
    onWeeknumberClick: de
  };
  return Ri(r1, Ie), Ie;
}
function vr() {
  const e = Bi(r1);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const hL = oe({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let a;
    const n = N();
    let r = null, i = null;
    const o = jr({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function u(q) {
      q && (o.direction = q.split("-")[0]);
    }
    function s({ placement: q, options: se }) {
      u(q || (se == null ? void 0 : se.placement));
    }
    const l = b(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: s
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: s
    })), c = b(() => {
      const q = o.direction === "left" || o.direction === "right";
      let se = "";
      if (o.placement) {
        const fe = o.placement.split("-");
        fe.length > 1 && (se = fe[1]);
      }
      return ["start", "top", "left"].includes(se) ? q ? "top" : "left" : ["end", "bottom", "right"].includes(se) ? q ? "bottom" : "right" : q ? "middle" : "center";
    });
    function d() {
      i && (i.destroy(), i = null);
    }
    function f() {
      ht(() => {
        const q = bl(o.target);
        !q || !n.value || (i && i.state.elements.reference !== q && d(), i ? i.update() : i = uT(
          q,
          n.value,
          l.value
        ));
      });
    }
    function v(q) {
      Object.assign(o, Ap(q, "force"));
    }
    function y(q, se) {
      clearTimeout(a), q > 0 ? a = setTimeout(se, q) : se();
    }
    function C(q) {
      return !q || !i ? !1 : bl(q) === i.state.elements.reference;
    }
    async function h(q = {}) {
      o.force || (q.force && (o.force = !0), y(q.showDelay ?? e.showDelay, () => {
        o.isVisible && (o.force = !1), v({
          ...q,
          isVisible: !0
        }), f();
      }));
    }
    function g(q = {}) {
      i && (q.target && !C(q.target) || o.force || (q.force && (o.force = !0), y(q.hideDelay ?? e.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function p(q = {}) {
      q.target != null && (o.isVisible && C(q.target) ? g(q) : h(q));
    }
    function w(q) {
      if (!i)
        return;
      const se = i.state.elements.reference;
      if (!n.value || !se)
        return;
      const fe = q.target;
      Ko(n.value, fe) || Ko(se, fe) || g({ force: !0 });
    }
    function k(q) {
      (q.key === "Esc" || q.key === "Escape") && g();
    }
    function S({ detail: q }) {
      !q.id || q.id !== e.id || h(q);
    }
    function T({ detail: q }) {
      !q.id || q.id !== e.id || g(q);
    }
    function A({ detail: q }) {
      !q.id || q.id !== e.id || p(q);
    }
    function F() {
      xn(document, "keydown", k), xn(document, "click", w), xn(document, "show-popover", S), xn(document, "hide-popover", T), xn(document, "toggle-popover", A);
    }
    function Z() {
      Sn(document, "keydown", k), Sn(document, "click", w), Sn(document, "show-popover", S), Sn(document, "hide-popover", T), Sn(document, "toggle-popover", A);
    }
    function O(q) {
      t("before-show", q);
    }
    function z(q) {
      o.force = !1, t("after-show", q);
    }
    function U(q) {
      t("before-hide", q);
    }
    function x(q) {
      o.force = !1, d(), t("after-hide", q);
    }
    function I(q) {
      q.stopPropagation();
    }
    function E() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && h();
    }
    function P() {
      if (o.isHovered = !1, !i)
        return;
      const q = i.state.elements.reference;
      o.autoHide && !o.isFocused && (!q || q !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && g();
    }
    function R() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && h();
    }
    function K(q) {
      ["focus", "hover-focus"].includes(o.visibility) && (!q.relatedTarget || !Ko(n.value, q.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && g());
    }
    function J() {
      r != null && (r.disconnect(), r = null);
    }
    return ie(
      () => n.value,
      (q) => {
        J(), q && (r = new ResizeObserver(() => {
          i && i.update();
        }), r.observe(q));
      }
    ), ie(() => o.placement, u, {
      immediate: !0
    }), it(() => {
      F();
    }), ya(() => {
      d(), J(), Z();
    }), {
      ...lg(o),
      popoverRef: n,
      alignment: c,
      hide: g,
      setupPopper: f,
      beforeEnter: O,
      afterEnter: z,
      beforeLeave: U,
      afterLeave: x,
      onClick: I,
      onMouseOver: E,
      onMouseLeave: P,
      onFocusIn: R,
      onFocusOut: K
    };
  }
}), Fn = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, r] of t)
    a[n] = r;
  return a;
};
function gL(e, t, a, n, r, i) {
  return m(), $("div", {
    class: ce(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...o) => e.onClick && e.onClick(...o)),
    onMouseover: t[1] || (t[1] = (...o) => e.onMouseOver && e.onMouseOver(...o)),
    onMouseleave: t[2] || (t[2] = (...o) => e.onMouseLeave && e.onMouseLeave(...o)),
    onFocusin: t[3] || (t[3] = (...o) => e.onFocusIn && e.onFocusIn(...o)),
    onFocusout: t[4] || (t[4] = (...o) => e.onFocusOut && e.onFocusOut(...o))
  }, [
    G(ea, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: L(() => [
        e.isVisible ? (m(), $("div", Re({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          W(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            be(re(e.data), 1)
          ]),
          Y("span", {
            class: ce([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : H("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Bc = /* @__PURE__ */ Fn(hL, [["render", gL]]), mL = { class: "vc-day-popover-row" }, pL = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, yL = { class: "vc-day-popover-row-label" }, bL = /* @__PURE__ */ oe({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, a = b(() => {
      const { content: n, highlight: r, dot: i, bar: o, popover: u } = t.attribute;
      return u && u.hideIndicator ? null : n ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
      } : r ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${r.base.color}`
      } : i ? {
        class: `vc-dot vc-attr vc-${i.base.color}`
      } : o ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${o.base.color}`
      } : null;
    });
    return (n, r) => (m(), $("div", mL, [
      D(a) ? (m(), $("div", pL, [
        Y("span", {
          class: ce(D(a).class)
        }, null, 2)
      ])) : H("", !0),
      Y("div", yL, [
        W(n.$slots, "default", {}, () => [
          be(re(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), wL = {
  inheritAttrs: !1
}, va = /* @__PURE__ */ oe({
  ...wL,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const a = n1(e.name);
    return (n, r) => D(a) ? (m(), X(Ye(D(a)), la(Re({ key: 0 }, n.$attrs)), null, 16)) : W(n.$slots, "default", { key: 1 });
  }
}), CL = { class: "vc-day-popover-container" }, kL = {
  key: 0,
  class: "vc-day-popover-header"
}, $L = /* @__PURE__ */ oe({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: a, color: n, masks: r, locale: i } = vr();
    function o(s, l) {
      return i.value.formatDate(s, l);
    }
    function u(s) {
      return i.value.formatDate(s.date, r.value.dayPopover);
    }
    return (s, l) => (m(), X(Bc, {
      id: D(t),
      class: ce([`vc-${D(n)}`, `vc-${D(a)}`])
    }, {
      default: L(({ data: { day: c, attributes: d }, hide: f }) => [
        G(va, {
          name: "day-popover",
          day: c,
          "day-title": u(c),
          attributes: d,
          format: o,
          masks: D(r),
          hide: f
        }, {
          default: L(() => [
            Y("div", CL, [
              D(r).dayPopover ? (m(), $("div", kL, re(u(c)), 1)) : H("", !0),
              (m(!0), $(Ee, null, Fe(d, (v) => (m(), X(bL, {
                key: v.key,
                attribute: v
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), SL = {}, xL = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, TL = /* @__PURE__ */ Y("polyline", { points: "9 18 15 12 9 6" }, null, -1), DL = [
  TL
];
function AL(e, t) {
  return m(), $("svg", xL, DL);
}
const IL = /* @__PURE__ */ Fn(SL, [["render", AL]]), EL = {}, ML = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, OL = /* @__PURE__ */ Y("polyline", { points: "15 18 9 12 15 6" }, null, -1), PL = [
  OL
];
function NL(e, t) {
  return m(), $("svg", ML, PL);
}
const LL = /* @__PURE__ */ Fn(EL, [["render", NL]]), BL = {}, RL = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, FL = /* @__PURE__ */ Y("polyline", { points: "6 9 12 15 18 9" }, null, -1), zL = [
  FL
];
function YL(e, t) {
  return m(), $("svg", RL, zL);
}
const HL = /* @__PURE__ */ Fn(BL, [["render", YL]]), qL = {}, WL = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, UL = /* @__PURE__ */ Y("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), KL = [
  UL
];
function VL(e, t) {
  return m(), $("svg", WL, KL);
}
const jL = /* @__PURE__ */ Fn(qL, [["render", VL]]), GL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: HL,
  IconChevronLeft: LL,
  IconChevronRight: IL,
  IconClock: jL
}, Symbol.toStringTag, { value: "Module" })), Kr = /* @__PURE__ */ oe({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, a = b(() => t.width || t.size), n = b(() => t.height || t.size), r = b(() => GL[`Icon${t.name}`]);
    return (i, o) => (m(), X(Ye(D(r)), {
      width: D(a),
      height: D(n),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), QL = ["disabled"], ZL = {
  key: 1,
  class: "vc-title-wrapper"
}, XL = {
  type: "button",
  class: "vc-title"
}, JL = ["disabled"], i1 = /* @__PURE__ */ oe({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: a,
      navVisibility: n,
      canMovePrev: r,
      movePrev: i,
      canMoveNext: o,
      moveNext: u
    } = vr(), s = b(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), l = b(() => {
      const { page: C } = t;
      return {
        id: a.value,
        visibility: n.value,
        placement: s.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: C },
        isInteractive: !0
      };
    }), c = b(() => t.page.titlePosition.includes("left")), d = b(() => t.page.titlePosition.includes("right")), f = b(() => t.layout ? t.layout : c.value ? "tu-pn" : d.value ? "pn-tu" : "p-tu-n;"), v = b(() => ({
      prev: f.value.includes("p") && !t.hideArrows,
      title: f.value.includes("t") && !t.hideTitle,
      next: f.value.includes("n") && !t.hideArrows
    })), y = b(() => ({ gridTemplateColumns: f.value.split("").map((h) => {
      switch (h) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (C, h) => (m(), $("div", {
      class: ce(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: Oe(D(y))
    }, [
      D(v).prev ? (m(), $("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !D(r),
        onClick: h[0] || (h[0] = //@ts-ignore
        (...g) => D(i) && D(i)(...g)),
        onKeydown: h[1] || (h[1] = ct(
          //@ts-ignore
          (...g) => D(i) && D(i)(...g),
          ["space", "enter"]
        ))
      }, [
        G(va, {
          name: "header-prev-button",
          disabled: !D(r)
        }, {
          default: L(() => [
            G(Kr, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, QL)) : H("", !0),
      D(v).title ? (m(), $("div", ZL, [
        G(va, { name: "header-title-wrapper" }, {
          default: L(() => [
            pa((m(), $("button", XL, [
              G(va, {
                name: "header-title",
                title: e.page.title
              }, {
                default: L(() => [
                  Y("span", null, re(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [D(Zp), D(l)]
            ])
          ]),
          _: 1
        })
      ])) : H("", !0),
      D(v).next ? (m(), $("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !D(o),
        onClick: h[2] || (h[2] = //@ts-ignore
        (...g) => D(u) && D(u)(...g)),
        onKeydown: h[3] || (h[3] = ct(
          //@ts-ignore
          (...g) => D(u) && D(u)(...g),
          ["space", "enter"]
        ))
      }, [
        G(va, {
          name: "header-next-button",
          disabled: !D(o)
        }, {
          default: L(() => [
            G(Kr, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, JL)) : H("", !0)
    ], 6));
  }
}), o1 = Symbol("__vc_page_context__");
function _L(e) {
  const { locale: t, getDateAddress: a, canMove: n } = vr();
  function r(u, s) {
    const { month: l, year: c } = a(/* @__PURE__ */ new Date());
    return Vp().map((d, f) => {
      const v = f + 1;
      return {
        month: v,
        year: u,
        id: q6(v, u),
        label: t.value.formatDate(d, s),
        ariaLabel: t.value.formatDate(d, "MMMM"),
        isActive: v === e.value.month && u === e.value.year,
        isCurrent: v === l && u === c,
        isDisabled: !n(
          { month: v, year: u },
          { position: e.value.position }
        )
      };
    });
  }
  function i(u, s) {
    const { year: l } = a(/* @__PURE__ */ new Date()), { position: c } = e.value, d = [];
    for (let f = u; f <= s; f += 1) {
      const v = [...Array(12).keys()].some(
        (y) => n({ month: y + 1, year: f }, { position: c })
      );
      d.push({
        year: f,
        id: f.toString(),
        label: f.toString(),
        ariaLabel: f.toString(),
        isActive: f === e.value.year,
        isCurrent: f === l,
        isDisabled: !v
      });
    }
    return d;
  }
  const o = { page: e, getMonthItems: r, getYearItems: i };
  return Ri(o1, o), o;
}
function l1() {
  const e = Bi(o1);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const eB = { class: "vc-nav-header" }, tB = ["disabled"], aB = ["disabled"], nB = { class: "vc-nav-items" }, rB = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], iB = /* @__PURE__ */ oe({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: a } = vr(), { page: n, getMonthItems: r, getYearItems: i } = l1(), o = N(!0), u = 12, s = N(n.value.year), l = N(f(n.value.year)), c = N(null);
    function d() {
      setTimeout(() => {
        if (c.value == null)
          return;
        const fe = c.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        fe && fe.focus();
      }, 10);
    }
    function f(fe) {
      return Math.floor(fe / u);
    }
    function v() {
      o.value = !o.value;
    }
    function y(fe) {
      return fe * u;
    }
    function C(fe) {
      return u * (fe + 1) - 1;
    }
    function h() {
      R.value && (o.value && p(), k());
    }
    function g() {
      K.value && (o.value && w(), S());
    }
    function p() {
      s.value--;
    }
    function w() {
      s.value++;
    }
    function k() {
      l.value--;
    }
    function S() {
      l.value++;
    }
    const T = b(
      () => r(s.value, t.value.navMonths).map((fe) => ({
        ...fe,
        click: () => a(
          { month: fe.month, year: fe.year },
          { position: n.value.position }
        )
      }))
    ), A = b(
      () => r(s.value - 1, t.value.navMonths)
    ), F = b(
      () => A.value.some((fe) => !fe.isDisabled)
    ), Z = b(
      () => r(s.value + 1, t.value.navMonths)
    ), O = b(
      () => Z.value.some((fe) => !fe.isDisabled)
    ), z = b(
      () => i(
        y(l.value),
        C(l.value)
      ).map((fe) => ({
        ...fe,
        click: () => {
          s.value = fe.year, o.value = !0, d();
        }
      }))
    ), U = b(
      () => i(
        y(l.value - 1),
        C(l.value - 1)
      )
    ), x = b(
      () => U.value.some((fe) => !fe.isDisabled)
    ), I = b(
      () => i(
        y(l.value + 1),
        C(l.value + 1)
      )
    ), E = b(
      () => I.value.some((fe) => !fe.isDisabled)
    ), P = b(
      () => o.value ? T.value : z.value
    ), R = b(
      () => o.value ? F.value : x.value
    ), K = b(
      () => o.value ? O.value : E.value
    ), J = b(() => Tp(z.value.map((fe) => fe.year))), q = b(() => Ir(z.value.map((fe) => fe.year))), se = b(() => o.value ? s.value : `${J.value} - ${q.value}`);
    return Lu(() => {
      s.value = n.value.year, d();
    }), ie(
      () => s.value,
      (fe) => l.value = f(fe)
    ), it(() => d()), (fe, ne) => (m(), $("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: c
    }, [
      Y("div", eB, [
        Y("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !D(R),
          onClick: h,
          onKeydown: ne[0] || (ne[0] = (ae) => D(Lo)(ae, h))
        }, [
          G(va, {
            name: "nav-prev-button",
            move: h,
            disabled: !D(R)
          }, {
            default: L(() => [
              G(Kr, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, tB),
        Y("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: v,
          onKeydown: ne[1] || (ne[1] = (ae) => D(Lo)(ae, v))
        }, re(D(se)), 33),
        Y("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !D(K),
          onClick: g,
          onKeydown: ne[2] || (ne[2] = (ae) => D(Lo)(ae, g))
        }, [
          G(va, {
            name: "nav-next-button",
            move: g,
            disabled: !D(K)
          }, {
            default: L(() => [
              G(Kr, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, aB)
      ]),
      Y("div", nB, [
        (m(!0), $(Ee, null, Fe(D(P), (ae) => (m(), $("button", {
          key: ae.label,
          type: "button",
          "data-id": ae.id,
          "aria-label": ae.ariaLabel,
          class: ce(["vc-nav-item vc-focus", [
            ae.isActive ? "is-active" : ae.isCurrent ? "is-current" : ""
          ]]),
          disabled: ae.isDisabled,
          onClick: ae.click,
          onKeydown: (ve) => D(Lo)(ve, ae.click)
        }, re(ae.label), 43, rB))), 128))
      ])
    ], 512));
  }
}), s1 = /* @__PURE__ */ oe({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return _L(Ho(e, "page")), (a, n) => W(a.$slots, "default");
  }
}), oB = /* @__PURE__ */ oe({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: a, displayMode: n } = vr();
    return (r, i) => (m(), X(Bc, {
      id: D(t),
      class: ce(["vc-nav-popover-container", `vc-${D(a)}`, `vc-${D(n)}`])
    }, {
      default: L(({ data: o }) => [
        G(s1, {
          page: o.page
        }, {
          default: L(() => [
            G(va, { name: "nav" }, {
              default: L(() => [
                G(iB)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), lB = oe({
  directives: { popover: Zp },
  components: { CalendarSlot: va },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: a,
      attributeContext: n,
      dayPopoverId: r,
      onDayClick: i,
      onDayMouseenter: o,
      onDayMouseleave: u,
      onDayFocusin: s,
      onDayFocusout: l,
      onDayKeydown: c
    } = vr(), d = b(() => e.day), f = b(() => n.value.getCells(d.value)), v = b(
      () => f.value.map((E) => E.data)
    ), y = b(() => ({
      ...d.value,
      attributes: v.value,
      attributeCells: f.value
    }));
    function C({ data: E }, { popovers: P }) {
      const { key: R, customData: K, popover: J } = E;
      if (!J)
        return;
      const q = nh(
        {
          key: R,
          customData: K,
          attribute: E
        },
        { ...J },
        {
          visibility: J.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !J.label
        }
      );
      P.splice(0, 0, q);
    }
    const h = b(() => {
      const E = {
        ...a.value.prepareRender({}),
        popovers: []
      };
      return f.value.forEach((P) => {
        a.value.render(P, E), C(P, E);
      }), E;
    }), g = b(() => h.value.highlights), p = b(() => !!an(g.value)), w = b(() => h.value.content), k = b(() => h.value.dots), S = b(() => !!an(k.value)), T = b(() => h.value.bars), A = b(() => !!an(T.value)), F = b(() => h.value.popovers), Z = b(
      () => F.value.map((E) => E.attribute)
    ), O = n1("day-content"), z = b(() => [
      "vc-day",
      ...d.value.classes,
      { "vc-day-box-center-center": !O },
      { "is-not-in-month": !e.day.inMonth }
    ]), U = b(() => {
      let E;
      d.value.isFocusable ? E = "0" : E = "-1";
      const P = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": d.value.isDisabled },
        Gn(Ir(g.value), "contentClass"),
        Gn(Ir(w.value), "class") || ""
      ], R = {
        ...Gn(Ir(g.value), "contentStyle"),
        ...Gn(Ir(w.value), "style")
      };
      return {
        class: P,
        style: R,
        tabindex: E,
        "aria-label": d.value.ariaLabel,
        "aria-disabled": !!d.value.isDisabled,
        role: "button"
      };
    }), x = b(() => ({
      click(E) {
        i(y.value, E);
      },
      mouseenter(E) {
        o(y.value, E);
      },
      mouseleave(E) {
        u(y.value, E);
      },
      focusin(E) {
        s(y.value, E);
      },
      focusout(E) {
        l(y.value, E);
      },
      keydown(E) {
        c(y.value, E);
      }
    })), I = b(() => an(F.value) ? nh(
      {
        id: r.value,
        data: { day: d, attributes: Z.value }
      },
      ...F.value
    ) : null);
    return {
      attributes: v,
      attributeCells: f,
      bars: T,
      dayClasses: z,
      dayContentProps: U,
      dayContentEvents: x,
      dayPopover: I,
      glyphs: h,
      dots: k,
      hasDots: S,
      hasBars: A,
      highlights: g,
      hasHighlights: p,
      locale: t,
      popovers: F
    };
  }
}), sB = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, uB = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, cB = { class: "vc-dots" }, dB = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, fB = { class: "vc-bars" };
function vB(e, t, a, n, r, i) {
  const o = qt("CalendarSlot"), u = Y1("popover");
  return m(), $("div", {
    class: ce(e.dayClasses)
  }, [
    e.hasHighlights ? (m(), $("div", sB, [
      (m(!0), $(Ee, null, Fe(e.highlights, ({ key: s, wrapperClass: l, class: c, style: d }) => (m(), $("div", {
        key: s,
        class: ce(l)
      }, [
        Y("div", {
          class: ce(c),
          style: Oe(d)
        }, null, 6)
      ], 2))), 128))
    ])) : H("", !0),
    G(o, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: L(() => [
        pa((m(), $("div", Re(e.dayContentProps, Bl(e.dayContentEvents, !0)), [
          be(re(e.day.label), 1)
        ], 16)), [
          [u, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (m(), $("div", uB, [
      Y("div", cB, [
        (m(!0), $(Ee, null, Fe(e.dots, ({ key: s, class: l, style: c }) => (m(), $("span", {
          key: s,
          class: ce(l),
          style: Oe(c)
        }, null, 6))), 128))
      ])
    ])) : H("", !0),
    e.hasBars ? (m(), $("div", dB, [
      Y("div", fB, [
        (m(!0), $(Ee, null, Fe(e.bars, ({ key: s, class: l, style: c }) => (m(), $("span", {
          key: s,
          class: ce(l),
          style: Oe(c)
        }, null, 6))), 128))
      ])
    ])) : H("", !0)
  ], 2);
}
const hB = /* @__PURE__ */ Fn(lB, [["render", vB]]), gB = { class: "vc-weekdays" }, mB = ["onClick"], pB = {
  inheritAttrs: !1
}, yB = /* @__PURE__ */ oe({
  ...pB,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = l1(), { onWeeknumberClick: a } = vr();
    return (n, r) => (m(), $("div", {
      class: ce([
        "vc-pane",
        `row-${D(t).row}`,
        `row-from-end-${D(t).rowFromEnd}`,
        `column-${D(t).column}`,
        `column-from-end-${D(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      G(i1, {
        page: D(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      Y("div", {
        class: ce(["vc-weeks", {
          [`vc-show-weeknumbers-${D(t).weeknumberPosition}`]: D(t).weeknumberPosition
        }])
      }, [
        Y("div", gB, [
          (m(!0), $(Ee, null, Fe(D(t).weekdays, ({ weekday: i, label: o }, u) => (m(), $("div", {
            key: u,
            class: ce(`vc-weekday vc-weekday-${i}`)
          }, re(o), 3))), 128))
        ]),
        (m(!0), $(Ee, null, Fe(D(t).viewWeeks, (i) => (m(), $("div", {
          key: `weeknumber-${i.weeknumber}`,
          class: "vc-week"
        }, [
          D(t).weeknumberPosition ? (m(), $("div", {
            key: 0,
            class: ce(["vc-weeknumber", `is-${D(t).weeknumberPosition}`])
          }, [
            Y("span", {
              class: ce(["vc-weeknumber-content"]),
              onClick: (o) => D(a)(i, o)
            }, re(i.weeknumberDisplay), 9, mB)
          ], 2)) : H("", !0),
          (m(!0), $(Ee, null, Fe(i.days, (o) => (m(), X(hB, {
            key: o.id,
            day: o
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), bB = oe({
  components: {
    CalendarHeader: i1,
    CalendarPage: yB,
    CalendarNavPopover: oB,
    CalendarDayPopover: $L,
    CalendarPageProvider: s1,
    CalendarSlot: va
  },
  props: dL,
  emit: fL,
  setup(e, { emit: t, slots: a }) {
    return vL(e, { emit: t, slots: a });
  }
}), wB = { class: "vc-pane-header-wrapper" };
function CB(e, t, a, n, r, i) {
  const o = qt("CalendarHeader"), u = qt("CalendarPage"), s = qt("CalendarSlot"), l = qt("CalendarPageProvider"), c = qt("CalendarDayPopover"), d = qt("CalendarNavPopover");
  return m(), $(Ee, null, [
    Y("div", Re({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = Ke(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      Y("div", {
        class: ce(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        Y("div", wB, [
          e.firstPage ? (m(), X(o, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : H("", !0)
        ]),
        G(ea, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: L(() => [
            (m(), $("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: Oe({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (m(!0), $(Ee, null, Fe(e.pages, (f) => (m(), X(l, {
                key: f.id,
                page: f
              }, {
                default: L(() => [
                  G(s, {
                    name: "page",
                    page: f
                  }, {
                    default: L(() => [
                      G(u)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        G(s, { name: "footer" })
      ], 2)
    ], 16),
    G(c),
    G(d)
  ], 64);
}
const kB = /* @__PURE__ */ Fn(bB, [["render", CB]]), u1 = Symbol("__vc_date_picker_context__"), $B = {
  ..._p,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => Ln("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => Ln("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, SB = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function xB(e, { emit: t, slots: a }) {
  a1(a, { footer: "dp-footer" });
  const n = e1(e), { locale: r, masks: i, disabledAttribute: o } = n, u = N(!1), s = N(Symbol()), l = N(null), c = N(null), d = N(["", ""]), f = N(null), v = N(null);
  let y, C, h = !0;
  const g = b(() => e.isRange || e.modelModifiers.range === !0), p = b(
    () => g.value && l.value != null ? l.value.start : null
  ), w = b(
    () => g.value && l.value != null ? l.value.end : null
  ), k = b(() => e.mode.toLowerCase() === "date"), S = b(
    () => e.mode.toLowerCase() === "datetime"
  ), T = b(() => e.mode.toLowerCase() === "time"), A = b(() => !!c.value), F = b(() => {
    let M = "date";
    e.modelModifiers.number && (M = "number"), e.modelModifiers.string && (M = "string");
    const j = i.value.modelValue || "iso";
    return ne({ type: M, mask: j });
  }), Z = b(
    () => Be(c.value ?? l.value)
  ), O = b(() => T.value ? e.is24hr ? i.value.inputTime24hr : i.value.inputTime : S.value ? e.is24hr ? i.value.inputDateTime24hr : i.value.inputDateTime : i.value.input), z = b(() => /[Hh]/g.test(O.value)), U = b(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(O.value)
  ), x = b(() => {
    if (z.value && U.value)
      return "dateTime";
    if (U.value)
      return "date";
    if (z.value)
      return "time";
  }), I = b(() => {
    var M;
    const j = ((M = f.value) == null ? void 0 : M.$el.previousElementSibling) ?? void 0;
    return Ni({}, e.popover, Ln("datePicker.popover"), {
      target: j
    });
  }), E = b(
    () => Qp({
      ...I.value,
      id: s.value
    })
  ), P = b(() => g.value ? {
    start: d.value[0],
    end: d.value[1]
  } : d.value[0]), R = b(() => {
    const M = ["start", "end"].map((j) => ({
      input: he(j),
      change: V(j),
      keyup: Se,
      ...e.popover && E.value
    }));
    return g.value ? {
      start: M[0],
      end: M[1]
    } : M[0];
  }), K = b(() => {
    if (!Te(l.value))
      return null;
    const M = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: l.value,
      pinPage: !0
    }, { dot: j, bar: ge, highlight: $e, content: nt } = M;
    return !j && !ge && !$e && !nt && (M.highlight = !0), M;
  }), J = b(() => {
    if (!g.value || !Te(c.value))
      return null;
    const M = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: c.value
    }, { dot: j, bar: ge, highlight: $e, content: nt } = M;
    return !j && !ge && !$e && !nt && (M.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), M;
  }), q = b(() => {
    const M = ma(e.attributes) ? [...e.attributes] : [];
    return J.value ? M.unshift(J.value) : K.value && M.unshift(K.value), M;
  }), se = b(() => ne(
    e.rules === "auto" ? fe() : e.rules ?? {}
  ));
  function fe() {
    const M = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, j = k.value ? 0 : e.timeAccuracy;
    return [0, 1].map((ge) => {
      switch (j) {
        case 0:
          return {
            hours: M.hr[ge],
            minutes: M.min[ge],
            seconds: M.sec[ge],
            milliseconds: M.ms[ge]
          };
        case 1:
          return {
            minutes: M.min[ge],
            seconds: M.sec[ge],
            milliseconds: M.ms[ge]
          };
        case 3:
          return { milliseconds: M.ms[ge] };
        case 4:
          return {};
        default:
          return { seconds: M.sec[ge], milliseconds: M.ms[ge] };
      }
    });
  }
  function ne(M) {
    return ma(M) ? M.length === 1 ? [M[0], M[0]] : M : [M, M];
  }
  function ae(M) {
    return ne(M).map(
      (j, ge) => ({
        ...j,
        rules: se.value[ge]
      })
    );
  }
  function ve(M) {
    return M == null ? !1 : Aa(M) ? !isNaN(M) : Nr(M) ? !isNaN(M.getTime()) : La(M) ? M !== "" : Oc(M);
  }
  function Ae(M) {
    return un(M) && "start" in M && "end" in M && ve(M.start ?? null) && ve(M.end ?? null);
  }
  function Te(M) {
    return Ae(M) || ve(M);
  }
  function Le(M, j) {
    if (M == null && j == null)
      return !0;
    if (M == null || j == null)
      return !1;
    const ge = Nr(M), $e = Nr(j);
    return ge && $e ? M.getTime() === j.getTime() : ge || $e ? !1 : Le(M.start, j.start) && Le(M.end, j.end);
  }
  function ze(M) {
    return !Te(M) || !o.value ? !1 : o.value.intersectsRange(r.value.range(M));
  }
  function _e(M, j, ge, $e) {
    if (!Te(M))
      return null;
    if (Ae(M)) {
      const nt = r.value.toDate(M.start, {
        ...j[0],
        fillDate: p.value ?? void 0,
        patch: ge
      }), Tt = r.value.toDate(M.end, {
        ...j[1],
        fillDate: w.value ?? void 0,
        patch: ge
      });
      return ue({ start: nt, end: Tt }, $e);
    }
    return r.value.toDateOrNull(M, {
      ...j[0],
      fillDate: l.value,
      patch: ge
    });
  }
  function tt(M, j) {
    return Ae(M) ? {
      start: r.value.fromDate(M.start, j[0]),
      end: r.value.fromDate(M.end, j[1])
    } : g.value ? null : r.value.fromDate(M, j[0]);
  }
  function Xe(M, j = {}) {
    return clearTimeout(y), new Promise((ge) => {
      const { debounce: $e = 0, ...nt } = j;
      $e > 0 ? y = window.setTimeout(() => {
        ge(et(M, nt));
      }, $e) : ge(et(M, nt));
    });
  }
  function et(M, {
    config: j = F.value,
    patch: ge = "dateTime",
    clearIfEqual: $e = !1,
    formatInput: nt = !0,
    hidePopover: Tt = !1,
    dragging: Nt = A.value,
    targetPriority: Ot,
    moveToValue: Ma = !1
  } = {}) {
    const yn = ae(j);
    let Ct = _e(
      M,
      yn,
      ge,
      Ot
    );
    if (ze(Ct)) {
      if (Nt)
        return null;
      Ct = l.value, Tt = !1;
    } else Ct == null && e.isRequired ? Ct = l.value : (
      // Clear value if same value was passed
      Ct != null && Le(l.value, Ct) && $e && (Ct = null)
    );
    const Ce = Nt ? c : l, ke = !Le(Ce.value, Ct);
    Ce.value = Ct, Nt || (c.value = null);
    const je = tt(
      Ct,
      F.value
    );
    return ke && (h = !1, t(Nt ? "drag" : "update:modelValue", je), ht(() => h = !0)), Tt && !Nt && Jt(), nt && pe(), Ma && ht(() => de(Ot ?? "start")), je;
  }
  function pe() {
    ht(() => {
      const M = ae({
        type: "string",
        mask: O.value
      }), j = tt(
        c.value ?? l.value,
        M
      );
      g.value ? d.value = [j && j.start, j && j.end] : d.value = [j, ""];
    });
  }
  function me(M, j, ge) {
    d.value.splice(j === "start" ? 0 : 1, 1, M);
    const $e = g.value ? {
      start: d.value[0],
      end: d.value[1] || d.value[0]
    } : M, nt = {
      type: "string",
      mask: O.value
    };
    Xe($e, {
      ...ge,
      config: nt,
      patch: x.value,
      targetPriority: j,
      moveToValue: !0
    });
  }
  function he(M) {
    return (j) => {
      e.updateOnInput && me(j.currentTarget.value, M, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function V(M) {
    return (j) => {
      me(j.currentTarget.value, M, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function Se(M) {
    M.key === "Escape" && Xe(l.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function Be(M) {
    return g.value ? [
      M && M.start ? r.value.getDateParts(M.start) : null,
      M && M.end ? r.value.getDateParts(M.end) : null
    ] : [M ? r.value.getDateParts(M) : null];
  }
  function Me() {
    c.value = null, pe();
  }
  function Ve(M) {
    t("popover-will-show", M);
  }
  function wt(M) {
    t("popover-did-show", M);
  }
  function vt(M) {
    Me(), t("popover-will-hide", M);
  }
  function Je(M) {
    t("popover-did-hide", M);
  }
  function lt(M) {
    const j = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (g.value) {
      const ge = !A.value;
      ge ? C = { start: M.startDate, end: M.endDate } : C != null && (C.end = M.date), Xe(C, {
        ...j,
        dragging: ge
      });
    } else
      Xe(M.date, {
        ...j,
        clearIfEqual: !e.isRequired
      });
  }
  function xt(M, j) {
    lt(M), t("dayclick", M, j);
  }
  function Lt(M, j) {
    switch (j.key) {
      case " ":
      case "Enter": {
        lt(M), j.preventDefault();
        break;
      }
      case "Escape":
        Jt();
    }
    t("daykeydown", M, j);
  }
  function Xt(M, j) {
    !A.value || C == null || (C.end = M.date, Xe(ue(C), {
      patch: "date",
      formatInput: !0
    }));
  }
  function ra(M = {}) {
    Su({
      ...I.value,
      ...M,
      isInteractive: !0,
      id: s.value
    });
  }
  function Jt(M = {}) {
    Li({
      hideDelay: 10,
      force: !0,
      ...I.value,
      ...M,
      id: s.value
    });
  }
  function Mt(M) {
    Gp({
      ...I.value,
      ...M,
      isInteractive: !0,
      id: s.value
    });
  }
  function ue(M, j) {
    const { start: ge, end: $e } = M;
    if (ge > $e)
      switch (j) {
        case "start":
          return { start: ge, end: ge };
        case "end":
          return { start: $e, end: $e };
        default:
          return { start: $e, end: ge };
      }
    return { start: ge, end: $e };
  }
  async function He(M, j = {}) {
    return v.value == null ? !1 : v.value.move(M, j);
  }
  async function _(M, j = {}) {
    return v.value == null ? !1 : v.value.moveBy(M, j);
  }
  async function de(M, j = {}) {
    const ge = l.value;
    if (v.value == null || !Te(ge))
      return !1;
    const $e = M !== "end", nt = $e ? 1 : -1, Tt = Ae(ge) ? $e ? ge.start : ge.end : ge, Nt = Op(Tt, "monthly", r.value);
    return v.value.move(Nt, { position: nt, ...j });
  }
  ie(
    () => e.isRange,
    (M) => {
      M && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), ie(
    () => g.value,
    () => {
      et(null, { formatInput: !0 });
    }
  ), ie(
    () => O.value,
    () => pe()
  ), ie(
    () => e.modelValue,
    (M) => {
      h && et(M, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), ie(
    () => se.value,
    () => {
      un(e.rules) && et(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), ie(
    () => e.timezone,
    () => {
      et(l.value, { formatInput: !0 });
    }
  );
  const Ie = ne(F.value);
  l.value = _e(
    e.modelValue ?? null,
    Ie,
    "dateTime"
  ), it(() => {
    et(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), ht(() => u.value = !0);
  const Q = {
    ...n,
    showCalendar: u,
    datePickerPopoverId: s,
    popoverRef: f,
    popoverEvents: E,
    calendarRef: v,
    isRange: g,
    isTimeMode: T,
    isDateTimeMode: S,
    is24hr: Ho(e, "is24hr"),
    hideTimeHeader: Ho(e, "hideTimeHeader"),
    timeAccuracy: Ho(e, "timeAccuracy"),
    isDragging: A,
    inputValue: P,
    inputEvents: R,
    dateParts: Z,
    attributes: q,
    rules: se,
    move: He,
    moveBy: _,
    moveToValue: de,
    updateValue: Xe,
    showPopover: ra,
    hidePopover: Jt,
    togglePopover: Mt,
    onDayClick: xt,
    onDayKeydown: Lt,
    onDayMouseEnter: Xt,
    onPopoverBeforeShow: Ve,
    onPopoverAfterShow: wt,
    onPopoverBeforeHide: vt,
    onPopoverAfterHide: Je
  };
  return Ri(u1, Q), Q;
}
function Rc() {
  const e = Bi(u1);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const TB = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], DB = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function AB(e) {
  const t = Rc(), {
    locale: a,
    isRange: n,
    isTimeMode: r,
    dateParts: i,
    rules: o,
    is24hr: u,
    hideTimeHeader: s,
    timeAccuracy: l,
    updateValue: c
  } = t;
  function d(U) {
    U = Object.assign(v.value, U);
    let x = null;
    if (n.value) {
      const I = f.value ? U : i.value[0], E = f.value ? i.value[1] : U;
      x = { start: I, end: E };
    } else
      x = U;
    c(x, {
      patch: "time",
      targetPriority: f.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const f = b(() => e.position === 0), v = b(
    () => i.value[e.position] || { isValid: !1 }
  ), y = b(() => Oc(v.value)), C = b(() => !!v.value.isValid), h = b(() => !s.value && C.value), g = b(() => {
    if (!y.value)
      return null;
    let U = a.value.toDate(v.value);
    return v.value.hours === 24 && (U = new Date(U.getTime() - 1)), U;
  }), p = b({
    get() {
      return v.value.hours;
    },
    set(U) {
      d({ hours: U });
    }
  }), w = b({
    get() {
      return v.value.minutes;
    },
    set(U) {
      d({ minutes: U });
    }
  }), k = b({
    get() {
      return v.value.seconds;
    },
    set(U) {
      d({ seconds: U });
    }
  }), S = b({
    get() {
      return v.value.milliseconds;
    },
    set(U) {
      d({ milliseconds: U });
    }
  }), T = b({
    get() {
      return v.value.hours < 12;
    },
    set(U) {
      U = String(U).toLowerCase() == "true";
      let x = p.value;
      U && x >= 12 ? x -= 12 : !U && x < 12 && (x += 12), d({ hours: x });
    }
  }), A = b(
    () => VN(v.value, o.value[e.position])
  ), F = b(() => TB.filter(
    (U) => A.value.hours.some((x) => x.value === U.value)
  )), Z = b(() => DB.filter(
    (U) => A.value.hours.some((x) => x.value === U.value)
  )), O = b(() => u.value ? A.value.hours : T.value ? F.value : Z.value), z = b(() => {
    const U = [];
    return an(F.value) && U.push({ value: !0, label: "AM" }), an(Z.value) && U.push({ value: !1, label: "PM" }), U;
  });
  return {
    ...t,
    showHeader: h,
    timeAccuracy: l,
    parts: v,
    isValid: C,
    date: g,
    hours: p,
    minutes: w,
    seconds: k,
    milliseconds: S,
    options: A,
    hourOptions: O,
    isAM: T,
    isAMOptions: z,
    is24hr: u
  };
}
const IB = ["value"], EB = ["value", "disabled"], MB = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, OB = {
  inheritAttrs: !1
}, di = /* @__PURE__ */ oe({
  ...OB,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, a = b(() => {
      const n = t.options.find((r) => r.value === t.modelValue);
      return n == null ? void 0 : n.label;
    });
    return (n, r) => (m(), $("div", {
      class: ce(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      Y("select", Re(n.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: r[0] || (r[0] = (i) => n.$emit("update:modelValue", i.target.value))
      }), [
        (m(!0), $(Ee, null, Fe(e.options, (i) => (m(), $("option", {
          key: i.value,
          value: i.value,
          disabled: i.disabled
        }, re(i.label), 9, EB))), 128))
      ], 16, IB),
      e.showIcon ? (m(), X(Kr, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : H("", !0),
      e.fitContent ? (m(), $("div", MB, re(D(a)), 1)) : H("", !0)
    ], 2));
  }
}), PB = {
  key: 0,
  class: "vc-time-header"
}, NB = { class: "vc-time-weekday" }, LB = { class: "vc-time-month" }, BB = { class: "vc-time-day" }, RB = { class: "vc-time-year" }, FB = { class: "vc-time-select-group" }, zB = /* @__PURE__ */ Y("span", { class: "vc-time-colon" }, ":", -1), YB = /* @__PURE__ */ Y("span", { class: "vc-time-colon" }, ":", -1), HB = /* @__PURE__ */ Y("span", { class: "vc-time-decimal" }, ".", -1), Oh = /* @__PURE__ */ oe({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const n = AB(e);
    t(n);
    const {
      locale: r,
      isValid: i,
      date: o,
      hours: u,
      minutes: s,
      seconds: l,
      milliseconds: c,
      options: d,
      hourOptions: f,
      isTimeMode: v,
      isAM: y,
      isAMOptions: C,
      is24hr: h,
      showHeader: g,
      timeAccuracy: p
    } = n;
    return (w, k) => (m(), $("div", {
      class: ce(["vc-time-picker", [{ "vc-invalid": !D(i), "vc-attached": !D(v) }]])
    }, [
      G(va, { name: "time-header" }, {
        default: L(() => [
          D(g) && D(o) ? (m(), $("div", PB, [
            Y("span", NB, re(D(r).formatDate(D(o), "WWW")), 1),
            Y("span", LB, re(D(r).formatDate(D(o), "MMM")), 1),
            Y("span", BB, re(D(r).formatDate(D(o), "D")), 1),
            Y("span", RB, re(D(r).formatDate(D(o), "YYYY")), 1)
          ])) : H("", !0)
        ]),
        _: 1
      }),
      Y("div", FB, [
        G(Kr, {
          name: "Clock",
          size: "17"
        }),
        G(di, {
          modelValue: D(u),
          "onUpdate:modelValue": k[0] || (k[0] = (S) => kr(u) ? u.value = S : null),
          modelModifiers: { number: !0 },
          options: D(f),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        D(p) > 1 ? (m(), $(Ee, { key: 0 }, [
          zB,
          G(di, {
            modelValue: D(s),
            "onUpdate:modelValue": k[1] || (k[1] = (S) => kr(s) ? s.value = S : null),
            modelModifiers: { number: !0 },
            options: D(d).minutes,
            class: "vc-time-select-minutes",
            "align-left": D(p) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : H("", !0),
        D(p) > 2 ? (m(), $(Ee, { key: 1 }, [
          YB,
          G(di, {
            modelValue: D(l),
            "onUpdate:modelValue": k[2] || (k[2] = (S) => kr(l) ? l.value = S : null),
            modelModifiers: { number: !0 },
            options: D(d).seconds,
            class: "vc-time-select-seconds",
            "align-left": D(p) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : H("", !0),
        D(p) > 3 ? (m(), $(Ee, { key: 2 }, [
          HB,
          G(di, {
            modelValue: D(c),
            "onUpdate:modelValue": k[3] || (k[3] = (S) => kr(c) ? c.value = S : null),
            modelModifiers: { number: !0 },
            options: D(d).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : H("", !0),
        D(h) ? H("", !0) : (m(), X(di, {
          key: 3,
          modelValue: D(y),
          "onUpdate:modelValue": k[4] || (k[4] = (S) => kr(y) ? y.value = S : null),
          options: D(C)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), c1 = /* @__PURE__ */ oe({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: a,
      color: n,
      displayMode: r,
      isDateTimeMode: i,
      isTimeMode: o,
      isRange: u,
      onDayClick: s,
      onDayMouseEnter: l,
      onDayKeydown: c
    } = Rc(), d = u.value ? [0, 1] : [0];
    return (f, v) => D(o) ? (m(), $("div", {
      key: 0,
      class: ce(`vc-container vc-bordered vc-${D(n)} vc-${D(r)}`)
    }, [
      (m(!0), $(Ee, null, Fe(D(d), (y) => (m(), X(Oh, {
        key: y,
        position: y
      }, null, 8, ["position"]))), 128))
    ], 2)) : (m(), X(kB, {
      key: 1,
      attributes: D(t),
      ref_key: "calendarRef",
      ref: a,
      onDayclick: D(s),
      onDaymouseenter: D(l),
      onDaykeydown: D(c)
    }, {
      footer: L(() => [
        D(i) ? (m(!0), $(Ee, { key: 0 }, Fe(D(d), (y) => (m(), X(Oh, {
          key: y,
          position: y
        }, null, 8, ["position"]))), 128)) : H("", !0),
        G(va, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), qB = {
  inheritAttrs: !1
}, WB = /* @__PURE__ */ oe({
  ...qB,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: a,
      displayMode: n,
      popoverRef: r,
      onPopoverBeforeShow: i,
      onPopoverAfterShow: o,
      onPopoverBeforeHide: u,
      onPopoverAfterHide: s
    } = Rc();
    return (l, c) => (m(), X(Bc, {
      id: D(t),
      placement: "bottom-start",
      class: ce(`vc-date-picker-content vc-${D(a)} vc-${D(n)}`),
      ref_key: "popoverRef",
      ref: r,
      onBeforeShow: D(i),
      onAfterShow: D(o),
      onBeforeHide: D(u),
      onAfterHide: D(s)
    }, {
      default: L(() => [
        G(c1, la(Oa(l.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), UB = oe({
  inheritAttrs: !1,
  emits: SB,
  props: $B,
  components: { DatePickerBase: c1, DatePickerPopover: WB },
  setup(e, t) {
    const a = xB(e, t), n = jr(Ap(a, "calendarRef", "popoverRef"));
    return { ...a, slotCtx: n };
  }
});
function KB(e, t, a, n, r, i) {
  const o = qt("DatePickerPopover"), u = qt("DatePickerBase");
  return e.$slots.default ? (m(), $(Ee, { key: 0 }, [
    W(e.$slots, "default", la(Oa(e.slotCtx))),
    G(o, la(Oa(e.$attrs)), null, 16)
  ], 64)) : (m(), X(u, la(Re({ key: 1 }, e.$attrs)), null, 16));
}
const Ph = /* @__PURE__ */ Fn(UB, [["render", KB]]), VB = { class: "calendar-wrapper" }, jB = {
  key: 2,
  class: "time-wrapper"
}, GB = { class: "time-input" }, QB = ["for"], ZB = { key: 0 }, XB = { key: 1 }, JB = ["id"], _B = ["for"], eR = { key: 0 }, tR = ["id"], aR = {
  key: 0,
  class: "help-text"
}, nR = /* @__PURE__ */ oe({
  __name: "CalendarWrapper",
  props: /* @__PURE__ */ _s({
    isRange: { type: Boolean },
    kDatePickerMode: {},
    maxDate: { default: void 0 },
    minDate: { default: void 0 },
    errorMessage: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {},
    error: { type: Boolean, default: !1 },
    errorModifiers: {}
  }),
  emits: ["update:modelValue", "update:error"],
  setup(e, { expose: t }) {
    const a = e, n = eu(e, "modelValue"), r = eu(e, "error"), i = N(Yt(/* @__PURE__ */ new Date(), "HH:mm:ss")), o = N(Yt(/* @__PURE__ */ new Date(), "HH:mm:ss")), u = N({
      start: Yt(/* @__PURE__ */ new Date(), "HH:mm:ss"),
      end: Yt(/* @__PURE__ */ new Date(), "HH:mm:ss")
    }), s = yt(), l = b(() => a.isRange && n.value && "start" in n.value && n.value.start instanceof Date ? { year: n.value.start.getFullYear(), month: n.value.start.getMonth() + 1 } : n.value instanceof Date ? { year: n.value.getFullYear(), month: n.value.getMonth() + 1 } : a.maxDate && Vx(a.maxDate, jx()) ? { year: a.maxDate.getFullYear(), month: a.maxDate.getMonth() + 1 } : { year: (/* @__PURE__ */ new Date()).getFullYear(), month: (/* @__PURE__ */ new Date()).getMonth() + 1 }), c = b(() => ({
      borderless: !0,
      color: "blue",
      dragAttribute: C,
      expanded: !0,
      initialPage: l.value,
      maxDate: a.maxDate,
      minDate: a.minDate,
      mode: "date",
      modelConfig: y,
      selectAttribute: h,
      transparent: !0
    })), d = b(() => ["time", "dateTime", "relativeDateTime"].includes(a.kDatePickerMode)), f = (k, S) => k > S, v = () => {
      if (n.value && d.value)
        if (a.isRange && n.value.start && n.value.end) {
          const k = n.value;
          i.value = Yt(k.start, "HH:mm"), o.value = Yt(k.end, "HH:mm");
        } else n.value instanceof Date ? i.value = Yt(n.value, "HH:mm") : i.value = Yt(/* @__PURE__ */ new Date(), "HH:mm");
    };
    it(() => {
      v(), u.value.start = i.value, u.value.end = o.value;
    });
    const y = { type: "number" }, C = {
      key: "select-drag",
      highlight: {
        start: { contentClass: "vcal-day-drag-start" },
        base: { contentClass: "vcal-day-drag-base" },
        end: { contentClass: "vcal-day-drag-end" }
      }
    }, h = {
      key: "select-calendar",
      highlight: {
        start: { contentClass: "vcal-day-start" },
        base: { contentClass: "vcal-day-base" },
        end: { contentClass: "vcal-day-end" }
      }
    };
    ie(() => i.value, (k) => {
      if (k) {
        if (n.value && a.isRange && "start" in n.value && n.value.start instanceof Date && "end" in n.value && n.value.end instanceof Date) {
          const S = /* @__PURE__ */ new Date(), T = k.split(":");
          S.setHours(parseInt(T[0], 10), parseInt(T[1], 10), 0, 0), n.value.start.setHours(S.getHours(), S.getMinutes(), 0, 0), r.value = f(n.value.start, n.value.end);
        } else if (n.value instanceof Date) {
          const S = /* @__PURE__ */ new Date(), T = k.split(":");
          S.setHours(parseInt(T[0], 10), parseInt(T[1], 10), 0, 0), n.value.setHours(S.getHours(), S.getMinutes(), S.getSeconds(), 0);
        }
      }
    }), ie(() => o.value, (k) => {
      if (k && n.value && a.isRange && "end" in n.value && n.value.end instanceof Date && "start" in n.value && n.value.start instanceof Date) {
        const S = /* @__PURE__ */ new Date(), T = k.split(":");
        S.setHours(parseInt(T[0], 10), parseInt(T[1], 10), 0, 0), n.value.end.setHours(S.getHours(), S.getMinutes(), 0, 0), r.value = f(n.value.start, n.value.end);
      }
    }), ie(() => n.value, () => {
      n.value && a.isRange && "start" in n.value && n.value.start instanceof Date && "end" in n.value && n.value.end instanceof Date ? (i.value = Yt(n.value.start, "HH:mm"), o.value = Yt(n.value.end, "HH:mm"), r.value = f(n.value.start, n.value.end)) : n.value instanceof Date && (i.value = Yt(n.value, "HH:mm"));
    }, { immediate: !0, deep: !0 });
    const g = (k) => {
      const S = n.value;
      return a.isRange && S && k in S && S[k] instanceof Date;
    }, p = () => {
      i.value = u.value.start, o.value = u.value.end;
    }, w = (k) => {
      try {
        return Yt(k, "EEE MMM d yyyy");
      } catch (S) {
        console.warn("Error formatting date:", S);
      }
    };
    return t({
      resetTime: p,
      initTimeInputs: v
    }), (k, S) => (m(), $("div", VB, [
      e.isRange ? (m(), X(D(Ph), Re({ key: 0 }, c.value, {
        modelValue: n.value,
        "onUpdate:modelValue": S[0] || (S[0] = (T) => n.value = T),
        modelModifiers: { range: !0 }
      }), null, 16, ["modelValue"])) : (m(), X(D(Ph), Re({ key: 1 }, c.value, {
        modelValue: n.value,
        "onUpdate:modelValue": S[1] || (S[1] = (T) => n.value = T)
      }), null, 16, ["modelValue"])),
      d.value ? (m(), $("div", jB, [
        Y("div", GB, [
          Y("label", {
            class: "time-input-label",
            for: `time-input-start-${D(s)}`
          }, [
            g("start") ? (m(), $("span", ZB, re(w(n.value.start)), 1)) : n.value && n.value instanceof Date ? (m(), $("span", XB, re(w(n.value)), 1)) : H("", !0)
          ], 8, QB),
          pa(Y("input", {
            id: `time-input-start-${D(s)}`,
            "onUpdate:modelValue": S[2] || (S[2] = (T) => i.value = T),
            class: ce(["time-input-start", { "input-error": r.value }]),
            "data-testid": "time-input-start",
            step: 60,
            type: "time"
          }, null, 10, JB), [
            [tu, i.value]
          ]),
          Y("label", {
            class: "time-input-label",
            for: `time-input-end-${D(s)}`
          }, [
            g("end") ? (m(), $("span", eR, re(D(Yt)(n.value.end, "EEE MMM d yyyy")), 1)) : H("", !0)
          ], 8, _B),
          e.isRange ? pa((m(), $("input", {
            key: 0,
            id: `time-input-end-${D(s)}`,
            "onUpdate:modelValue": S[3] || (S[3] = (T) => o.value = T),
            class: ce(["time-input-end", { "input-error": r.value }]),
            "data-testid": "time-input-end",
            step: 60,
            type: "time"
          }, null, 10, tR)), [
            [tu, o.value]
          ]) : H("", !0)
        ]),
        G(ea, {
          mode: "out-in",
          name: "kongponents-fade-transition"
        }, {
          default: L(() => [
            r.value && e.errorMessage ? (m(), $("div", aR, re(e.errorMessage), 1)) : H("", !0)
          ]),
          _: 1
        })
      ])) : H("", !0)
    ]));
  }
}), rR = /* @__PURE__ */ Pe(nR, [["__scopeId", "data-v-da706d8e"]]), iR = ["tabindex"], oR = ["innerHTML"], lR = {
  key: 1,
  class: "range-display"
}, sR = {
  key: 3,
  class: "relative-periods-container"
}, uR = { class: "timeframe-section-title" }, cR = { class: "timeframe-buttons" }, dR = { class: "datetime-picker-footer-container" }, fR = /* @__PURE__ */ oe({
  __name: "KDateTimePicker",
  props: {
    clearButton: { type: Boolean },
    icon: { type: Boolean, default: !0 },
    modelValue: { default: () => ({ start: null, end: null }) },
    maxDate: { default: () => {
    } },
    minDate: { default: () => {
    } },
    mode: {},
    placeholder: { default: "Select a time range" },
    range: { type: Boolean },
    timePeriods: { default: () => [] },
    width: { default: "100%" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    popoverPlacement: { default: "bottom-start" },
    invalidTimeErrorMessage: { default: "Start time cannot exceed end time." }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    var x, I;
    const a = t, n = N(null), r = b(() => e.mode !== Fl.Relative), i = b(() => V1.includes(e.mode) && !e.range), o = b(() => e.timePeriods.length > 0), u = b(() => p.tabName === "custom" || !o.value), s = N(!0), l = N(!1), c = N(0), d = {
      start: null,
      end: null
    }, f = N(e.modelValue.start || null), v = N(e.modelValue || d), y = i.value ? f : v, C = dt("calendarWrapperRef"), h = b(() => ({
      width: It(e.width)
    })), g = Intl.DateTimeFormat().resolvedOptions().timeZone, p = jr({
      abbreviatedDisplay: e.placeholder,
      fullRangeDisplay: "",
      popoverOpen: !1,
      selectedRange: { start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date() },
      previouslySelectedRange: { start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date() },
      selectedTimeframe: (x = e.timePeriods[0]) == null ? void 0 : x.values[0],
      previouslySelectedTimeframe: (I = e.timePeriods[0]) == null ? void 0 : I.values[0],
      tabName: "relative"
    }), w = (E) => {
      if (!E) return;
      const P = i.value ? !E.start : !E.start || !E.end, R = (E == null ? void 0 : E.start) || /* @__PURE__ */ new Date(), K = (E == null ? void 0 : E.end) || null;
      s.value = !!P, !i.value && E && E.start && E.end ? (v.value.start = R, v.value.end = K) : E && E.start && (f.value = R), p.selectedRange = p.previouslySelectedRange = {
        start: R,
        end: K
      };
    }, k = (E, P = !1) => {
      if (p.selectedTimeframe = p.previouslySelectedTimeframe = E, p.selectedRange = {
        timePeriodsKey: p.selectedTimeframe.key
      }, p.selectedTimeframe.start && p.selectedTimeframe.end) {
        const R = new Date(p.selectedTimeframe.start()), K = new Date(p.selectedTimeframe.end());
        p.fullRangeDisplay = T({ start: R, end: K }, !1), p.selectedRange.start = R, p.selectedRange.end = K;
      } else
        p.fullRangeDisplay = "";
      s.value = !1, P && A();
    }, S = () => {
      var E;
      v.value = d, f.value = null, p.abbreviatedDisplay = e.placeholder, p.fullRangeDisplay = "", o.value && (p.selectedTimeframe = (E = e.timePeriods[0]) == null ? void 0 : E.values[0]), p.selectedRange = p.previouslySelectedRange = d, a("change", p.selectedRange), a("update:modelValue", p.selectedRange);
    }, T = (E, P) => {
      const { start: R, end: K } = E;
      let J = "PP hh:mm a";
      const q = Es(R, g, "(z)");
      return !r.value && o.value ? J = "PP hh:mm a" : G1.includes(e.mode) && (J = "PP"), i.value ? `${Yt(R, J)} ${q}` : P ? `<div>${Yt(R, J)} -&nbsp;</div><div>${Es(K, g, J)} ${q}</div>` : `${Yt(R, J)} - ${Es(K, g, J)} ${q}`;
    }, A = async () => {
      var E;
      i.value ? p.selectedRange.start && (a("change", { start: p.selectedRange.start, end: null }), a("update:modelValue", { start: p.selectedRange.start, end: null })) : (a("change", p.selectedRange), a("update:modelValue", p.selectedRange)), (E = n.value) == null || E.hidePopover(), F();
    }, F = () => {
      var E;
      u.value && ((E = p.selectedRange) != null && E.start) ? p.abbreviatedDisplay = T(p.selectedRange, !0) : o.value && !u.value && (p.abbreviatedDisplay = p.selectedTimeframe.display);
    }, Z = (E) => E.charAt(0).toUpperCase() + E.slice(1), O = (E) => p.selectedTimeframe.key === E.key ? "primary" : "secondary";
    ie(f, (E, P) => {
      E !== void 0 && E !== P && w({ start: E, end: null });
    }, { immediate: !0 }), ie(v, (E, P) => {
      E !== void 0 && E !== P && w(E);
    }, { immediate: !0 }), ie(() => p.tabName, (E, P) => {
      P !== void 0 && E === "relative" ? k(p.previouslySelectedTimeframe) : P !== void 0 && E === "custom" && w(p.previouslySelectedRange);
    }), ie(() => e.modelValue, () => {
      if (j1.includes(e.mode) && e.modelValue.timePeriodsKey) {
        p.tabName = "relative", s.value = !1;
        for (const E of e.timePeriods) {
          const P = E.values.find((R) => R.key === e.modelValue.timePeriodsKey);
          if (P) {
            k(P), F();
            break;
          }
        }
      } else
        p.tabName = "custom", w(e.modelValue), (e.modelValue.start && e.modelValue.end || i.value && e.modelValue.start) && F();
      c.value++;
    }, { immediate: !0 });
    const z = () => {
      p.popoverOpen = !1, C.value && C.value.resetTime();
    }, U = () => {
      p.popoverOpen = !0, C.value && C.value.initTimeInputs();
    };
    return (E, P) => (m(), $("div", {
      class: ce(["k-datetime-picker", { "set-min-width": o.value }]),
      style: Oe(h.value)
    }, [
      G(or, {
        ref_key: "kPop",
        ref: n,
        disabled: e.disabled || e.readonly,
        "hide-caret": "",
        "hide-close-icon": "",
        offset: D(Yl),
        placement: e.popoverPlacement,
        width: "auto",
        onClose: z,
        onOpen: U
      }, {
        content: L(() => [
          o.value && r.value ? (m(), X(Lm, {
            key: 0,
            modelValue: p.tabName,
            "onUpdate:modelValue": P[0] || (P[0] = (R) => p.tabName = R),
            class: "datetime-picker-toggle",
            "data-testid": "datetime-picker-toggle",
            options: [
              { label: "Relative", value: "relative" },
              { label: "Custom", value: "custom" }
            ],
            onClick: P[1] || (P[1] = (R) => p.tabName = R)
          }, null, 8, ["modelValue"])) : H("", !0),
          !u.value && p.fullRangeDisplay ? (m(), $("p", lR, re(p.fullRangeDisplay), 1)) : H("", !0),
          r.value && u.value ? (m(), X(rR, {
            key: c.value,
            ref: "calendarWrapperRef",
            modelValue: D(y),
            "onUpdate:modelValue": P[2] || (P[2] = (R) => kr(y) ? y.value = R : null),
            error: l.value,
            "onUpdate:error": P[3] || (P[3] = (R) => l.value = R),
            "error-message": e.invalidTimeErrorMessage,
            "is-range": !i.value,
            "k-date-picker-mode": e.mode,
            "max-date": e.maxDate,
            "min-date": e.minDate
          }, null, 8, ["modelValue", "error", "error-message", "is-range", "k-date-picker-mode", "max-date", "min-date"])) : o.value && !i.value ? (m(), $("div", sR, [
            (m(!0), $(Ee, null, Fe(e.timePeriods, (R, K) => (m(), $("div", {
              key: `section-${String(R.section || K)}`,
              class: "timeframe-section"
            }, [
              Y("div", uR, re(R.section), 1),
              Y("div", cR, [
                (m(!0), $(Ee, null, Fe(R.values, (J, q) => (m(), X(rt, {
                  key: `time-${q}`,
                  appearance: O(J),
                  class: "timeframe-button",
                  "data-testid": `select-timeframe-${J.key}`,
                  onClick: (se) => k(J, !0)
                }, {
                  default: L(() => [
                    be(re(Z(J.timeframeText)), 1)
                  ]),
                  _: 2
                }, 1032, ["appearance", "data-testid", "onClick"]))), 128))
              ])
            ]))), 128))
          ])) : H("", !0)
        ]),
        footer: L(() => [
          Y("div", dR, [
            e.clearButton ? (m(), X(rt, {
              key: 0,
              appearance: "tertiary",
              class: "action-button",
              "data-testid": "datetime-picker-clear",
              onClick: P[4] || (P[4] = (R) => S())
            }, {
              default: L(() => [...P[6] || (P[6] = [
                be(" Clear ", -1)
              ])]),
              _: 1
            })) : H("", !0),
            u.value ? (m(), X(rt, {
              key: 1,
              appearance: "tertiary",
              class: "action-button",
              "data-testid": "datetime-picker-submit",
              disabled: s.value || l.value,
              onClick: P[5] || (P[5] = (R) => A())
            }, {
              default: L(() => [...P[7] || (P[7] = [
                be(" Apply ", -1)
              ])]),
              _: 1
            }, 8, ["disabled"])) : H("", !0)
          ])
        ]),
        default: L(() => [
          Y("div", {
            class: ce(["datetime-picker-trigger-wrapper", { disabled: e.disabled }])
          }, [
            Y("div", {
              class: ce(["datetime-picker-trigger", { disabled: e.disabled, readonly: e.readonly }]),
              "data-testid": "datetime-picker-trigger",
              role: "button",
              style: Oe(h.value),
              tabindex: e.disabled ? -1 : 0
            }, [
              Y("div", {
                class: ce(["datetime-picker-display", { "has-icon": e.icon, disabled: e.disabled }]),
                "data-testid": "datetime-picker-display",
                innerHTML: p.abbreviatedDisplay
              }, null, 10, oR)
            ], 14, iR),
            e.icon ? (m(), X(D(ty), {
              key: 0,
              class: "calendar-icon",
              color: `var(--kui-color-text-neutral, ${D(Ya)})`,
              decorative: "",
              size: D(Qt)
            }, null, 8, ["color", "size"])) : H("", !0)
          ], 2)
        ]),
        _: 1
      }, 8, ["disabled", "offset", "placement"])
    ], 6));
  }
}), vR = /* @__PURE__ */ Pe(fR, [["__scopeId", "data-v-c88a3995"]]), hR = ["role"], gR = { class: "file-upload-input-wrapper" }, mR = {
  key: 1,
  class: "file-upload-dropzone-wrapper"
}, pR = ["aria-disabled", "aria-labelledby", "tabindex"], yR = {
  "aria-hidden": "true",
  class: "dropzone-icon"
}, bR = { key: 0 }, wR = { key: 1 }, CR = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KFileUpload",
  props: {
    labelAttributes: { default: () => ({}) },
    label: { default: "" },
    help: {},
    buttonText: { default: "Select file" },
    placeholder: { default: "" },
    accept: {},
    maxFileSize: { default: null },
    error: { type: Boolean },
    errorMessage: { default: "" },
    disabled: { type: Boolean },
    appearance: { default: "input" }
  },
  emits: ["file-added", "file-removed", "error"],
  setup(e, { emit: t }) {
    const a = t, n = $t(), r = na(), { stripRequiredLabel: i } = Bn(), o = yt(), u = b(() => r.id ? String(r.id) : o), s = b(() => {
      const E = { ...r };
      return delete E.id, E;
    }), l = dt("input"), c = b(() => {
      var E;
      return !!((E = e.labelAttributes) != null && E.info || n["label-tooltip"]);
    }), d = b(() => i(e.label, f.value)), f = b(() => (r == null ? void 0 : r.required) !== void 0 && String(r == null ? void 0 : r.required) !== "false"), v = b(() => I.value ? "Drag & drop a file" : "No file selected"), y = N(!1), C = b(() => {
      if (y.value) {
        let E = "bytes", P = h.value;
        return h.value >= 1024 && h.value < 1024 * 1024 && (P = h.value / 1024, E = "KB"), h.value >= 1024 * 1024 && (P = h.value / (1024 * 1024), E = "MB"), `File size must be less than ${P}${E}.`;
      }
      return "";
    }), h = b(() => e.maxFileSize || e.maxFileSize === 0 ? e.maxFileSize : 5 * 1024 * 1024), g = b(() => O.value || y.value || e.error), p = N(0), w = N(""), k = N(null), S = dt("dropzone"), T = (E) => {
      var J, q, se, fe, ne;
      O.value = !1;
      const P = E.target.files, R = (J = P[0]) == null ? void 0 : J.size;
      Number(R) > h.value && (p.value++, y.value = !0, a("error", P));
      const K = (se = (q = l.value) == null ? void 0 : q.$el) == null ? void 0 : se.querySelector("input");
      P.length ? (k.value = P, w.value = P[0].name || "", a("file-added", P)) : (K.files = k.value, w.value = ((ne = (fe = k.value) == null ? void 0 : fe[0]) == null ? void 0 : ne.name) || "");
    }, A = () => {
      var P, R;
      if (w.value) {
        F();
        return;
      }
      const E = (R = (P = l.value) == null ? void 0 : P.$el) == null ? void 0 : R.querySelector("input");
      E && E.click();
    }, F = () => {
      k.value = null, w.value = "", p.value++, y.value = !1, a("file-removed");
    }, Z = N(!1), O = N(!1), z = (E) => !e.accept || !Array.isArray(e.accept) || !e.accept.length ? !0 : e.accept.some((P) => {
      if (P.startsWith("."))
        return E.name.toLowerCase().endsWith(P.toLowerCase());
      if (P.endsWith("/*")) {
        const R = P.slice(0, -2);
        return E.type.startsWith(R);
      } else
        return E.type === P;
    }), U = b(() => O.value ? `Unsupported file type. Please upload one of the following: ${e.accept.join(", ")}` : ""), x = (E) => {
      var P, R, K, J, q;
      if (!e.disabled) {
        I.value ? (P = S.value) == null || P.focus() : (K = (R = l.value) == null ? void 0 : R.input) == null || K.focus(), Z.value = !1;
        const se = (J = E.dataTransfer) == null ? void 0 : J.files;
        if (se && se.length) {
          const fe = (q = se[0]) == null ? void 0 : q.size;
          if (Number(fe) > h.value) {
            p.value++, y.value = !0, a("error", se);
            return;
          }
          z(se[0]) ? (O.value = !1, k.value = se, w.value = se[0].name || "", a("file-added", se)) : (O.value = !0, a("error", se));
        }
      }
    }, I = b(() => e.appearance === "dropzone");
    return ie(() => r.id, () => {
      p.value++;
    }, { immediate: !0 }), (E, P) => (m(), $("div", Re({ class: "k-file-upload" }, s.value, {
      role: e.disabled ? void 0 : "region",
      onDragleave: P[0] || (P[0] = Ke((R) => Z.value = !1, ["prevent"])),
      onDragover: P[1] || (P[1] = Ke((R) => Z.value = !0, ["prevent"])),
      onDrop: Ke(x, ["prevent"])
    }), [
      e.label ? (m(), X(Ka, Re({ key: 0 }, e.labelAttributes, {
        id: I.value ? `file-upload-dropzone-label-${u.value}` : void 0,
        for: u.value,
        required: f.value
      }), kt({
        default: L(() => [
          be(re(d.value) + " ", 1)
        ]),
        _: 2
      }, [
        c.value ? {
          name: "tooltip",
          fn: L(() => [
            W(E.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["id", "for", "required"])) : H("", !0),
      pa(Y("div", gR, [
        I.value ? H("", !0) : (m(), $("span", {
          key: p.value,
          class: ce(["file-upload-input-text", { placeholder: !w.value, "has-icon": E.$slots.icon, disabled: e.disabled }])
        }, re(w.value ? w.value : e.placeholder || v.value), 3)),
        (m(), X(Nn, {
          id: u.value,
          key: p.value,
          ref: "input",
          accept: e.accept,
          class: ce(["upload-input", { dragging: Z.value && !e.disabled }]),
          disabled: e.disabled,
          error: g.value,
          "error-message": e.errorMessage || U.value || C.value,
          help: e.help,
          hidden: I.value,
          placeholder: e.placeholder || v.value,
          title: "",
          type: "file",
          onChange: T
        }, kt({ _: 2 }, [
          E.$slots.icon && !I.value ? {
            name: "before",
            fn: L(() => [
              W(E.$slots, "icon", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0,
          I.value ? void 0 : {
            name: "after",
            fn: L(() => [
              G(rt, {
                appearance: "tertiary",
                class: "file-upload-button",
                "data-testid": "file-upload-button",
                disabled: e.disabled,
                size: "small",
                onClick: A
              }, {
                default: L(() => [
                  be(re(w.value ? "Clear" : e.buttonText), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            key: "1"
          }
        ]), 1032, ["id", "accept", "class", "disabled", "error", "error-message", "help", "hidden", "placeholder"]))
      ], 512), [
        [Xn, !I.value]
      ]),
      I.value ? (m(), $("div", mR, [
        Y("div", {
          ref: "dropzone",
          "aria-disabled": e.disabled ? "true" : void 0,
          "aria-labelledby": e.label ? `file-upload-dropzone-label-${u.value}` : void 0,
          class: ce(["dropzone", {
            dragging: Z.value && !e.disabled,
            disabled: e.disabled,
            error: g.value,
            "has-file": !!w.value
          }]),
          "data-testid": "file-upload-dropzone",
          role: "button",
          tabindex: e.disabled ? -1 : 0,
          onClick: A
        }, [
          Y("div", yR, [
            W(E.$slots, "icon", {}, () => [
              w.value ? (m(), X(D(wy), {
                key: 0,
                decorative: ""
              })) : (m(), X(D(qy), {
                key: 1,
                decorative: ""
              }))
            ], !0)
          ]),
          w.value ? (m(), $("span", bR, re(w.value), 1)) : (m(), $("span", wR, re(e.placeholder || v.value), 1)),
          G(rt, {
            appearance: "tertiary",
            class: "file-upload-button",
            "data-testid": "file-upload-button",
            disabled: e.disabled,
            onClick: Ke(A, ["stop"])
          }, {
            default: L(() => [
              be(re(w.value ? "Clear" : e.buttonText), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          W(E.$slots, "dropzone-footer", {}, void 0, !0)
        ], 10, pR),
        g.value || e.help ? (m(), $("p", {
          key: 0,
          class: ce(["help-text", { error: g.value }])
        }, re(g.value && (e.errorMessage || U.value || C.value) || e.help), 3)) : H("", !0)
      ])) : H("", !0)
    ], 16, hR));
  }
}), kR = /* @__PURE__ */ Pe(CR, [["__scopeId", "data-v-6b3f8b7f"]]), $R = ["id", "checked", "disabled"], SR = ["aria-checked", "aria-labelledby", "tabindex"], xR = {
  inheritAttrs: !1
}, TR = /* @__PURE__ */ oe({
  ...xR,
  __name: "KInputSwitch",
  props: {
    modelValue: { type: Boolean },
    size: { default: "small" },
    label: { default: "" },
    disabled: { type: Boolean },
    disabledTooltipText: { default: "" },
    tooltipAttributes: { default: () => ({}) },
    labelBefore: { type: Boolean }
  },
  emits: ["change", "input", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = na(), r = N(null), i = yt(), o = b(() => n.id ? String(n.id) : i), u = b(() => {
      if (e.disabled !== void 0 && e.disabled !== !1)
        return n;
      const c = Object.assign({}, n);
      return delete c.class, delete c.disabled, c;
    }), s = (c) => {
      var d;
      e.disabled || (c.type === "click" || c.type === "keyup" && c.code === "Space") && ((d = r.value) == null || d.click());
    }, l = (c) => {
      e.modelValue !== c.target.checked && (a("update:modelValue", c.target.checked), a("change", c.target.checked), a("input", c.target.checked));
    };
    return (c, d) => {
      const f = qt("KTooltip"), v = qt("KLabel");
      return m(), $("div", {
        class: ce(["k-input-switch", [e.size, { "label-before": e.labelBefore, disabled: e.disabled }, c.$attrs.class]])
      }, [
        Y("input", Re(u.value, {
          id: o.value,
          ref_key: "switchInputElement",
          ref: r,
          checked: e.modelValue,
          disabled: e.disabled,
          tabindex: "-1",
          type: "checkbox",
          onInput: l
        }), null, 16, $R),
        G(f, Re(e.disabled && e.disabledTooltipText ? e.tooltipAttributes : {}, {
          class: "switch-control-wrapper",
          text: e.disabled ? e.disabledTooltipText : ""
        }), {
          default: L(() => [
            Y("span", {
              "aria-checked": e.modelValue,
              "aria-labelledby": o.value,
              class: ce(["switch-control", { checked: e.modelValue, disabled: e.disabled }]),
              "data-testid": "switch-control",
              role: "checkbox",
              tabindex: e.disabled ? -1 : 0,
              onClick: s,
              onKeydown: d[0] || (d[0] = ct(Ke(() => {
              }, ["prevent"]), ["space"])),
              onKeyup: ct(s, ["space"])
            }, [...d[1] || (d[1] = [
              Y("span", { class: "switch-control-enabled-bar" }, null, -1)
            ])], 42, SR)
          ]),
          _: 1
        }, 16, ["text"]),
        e.label || c.$slots.label ? (m(), X(v, {
          key: 0,
          for: o.value
        }, {
          default: L(() => [
            W(c.$slots, "label", {}, () => [
              be(re(e.label), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["for"])) : H("", !0)
      ], 2);
    };
  }
}), DR = /* @__PURE__ */ Pe(TR, [["__scopeId", "data-v-5e43199b"]]);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var d1 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Dl = /* @__PURE__ */ d1.join(","), f1 = typeof Element > "u", rr = f1 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Al = !f1 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Il = function e(t, a) {
  var n;
  a === void 0 && (a = !0);
  var r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "inert"), i = r === "" || r === "true", o = i || a && t && e(t.parentNode);
  return o;
}, AR = function(t) {
  var a, n = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "contenteditable");
  return n === "" || n === "true";
}, v1 = function(t, a, n) {
  if (Il(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(Dl));
  return a && rr.call(t, Dl) && r.unshift(t), r = r.filter(n), r;
}, h1 = function e(t, a, n) {
  for (var r = [], i = Array.from(t); i.length; ) {
    var o = i.shift();
    if (!Il(o, !1))
      if (o.tagName === "SLOT") {
        var u = o.assignedElements(), s = u.length ? u : o.children, l = e(s, !0, n);
        n.flatten ? r.push.apply(r, l) : r.push({
          scopeParent: o,
          candidates: l
        });
      } else {
        var c = rr.call(o, Dl);
        c && n.filter(o) && (a || !t.includes(o)) && r.push(o);
        var d = o.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(o), f = !Il(d, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
        if (d && f) {
          var v = e(d === !0 ? o.children : d.children, !0, n);
          n.flatten ? r.push.apply(r, v) : r.push({
            scopeParent: o,
            candidates: v
          });
        } else
          i.unshift.apply(i, o.children);
      }
  }
  return r;
}, g1 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Kn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || AR(t)) && !g1(t) ? 0 : t.tabIndex;
}, IR = function(t, a) {
  var n = Kn(t);
  return n < 0 && a && !g1(t) ? 0 : n;
}, ER = function(t, a) {
  return t.tabIndex === a.tabIndex ? t.documentOrder - a.documentOrder : t.tabIndex - a.tabIndex;
}, m1 = function(t) {
  return t.tagName === "INPUT";
}, MR = function(t) {
  return m1(t) && t.type === "hidden";
}, OR = function(t) {
  var a = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return a;
}, PR = function(t, a) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === a)
      return t[n];
}, NR = function(t) {
  if (!t.name)
    return !0;
  var a = t.form || Al(t), n = function(u) {
    return a.querySelectorAll('input[type="radio"][name="' + u + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = n(window.CSS.escape(t.name));
  else
    try {
      r = n(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var i = PR(r, t.form);
  return !i || i === t;
}, LR = function(t) {
  return m1(t) && t.type === "radio";
}, BR = function(t) {
  return LR(t) && !NR(t);
}, RR = function(t) {
  var a, n = t && Al(t), r = (a = n) === null || a === void 0 ? void 0 : a.host, i = !1;
  if (n && n !== t) {
    var o, u, s;
    for (i = !!((o = r) !== null && o !== void 0 && (u = o.ownerDocument) !== null && u !== void 0 && u.contains(r) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !i && r; ) {
      var l, c, d;
      n = Al(r), r = (l = n) === null || l === void 0 ? void 0 : l.host, i = !!((c = r) !== null && c !== void 0 && (d = c.ownerDocument) !== null && d !== void 0 && d.contains(r));
    }
  }
  return i;
}, Nh = function(t) {
  var a = t.getBoundingClientRect(), n = a.width, r = a.height;
  return n === 0 && r === 0;
}, FR = function(t, a) {
  var n = a.displayCheck, r = a.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = rr.call(t, "details>summary:first-of-type"), o = i ? t.parentElement : t;
  if (rr.call(o, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof r == "function") {
      for (var u = t; t; ) {
        var s = t.parentElement, l = Al(t);
        if (s && !s.shadowRoot && r(s) === !0)
          return Nh(t);
        t.assignedSlot ? t = t.assignedSlot : !s && l !== t.ownerDocument ? t = l.host : t = s;
      }
      t = u;
    }
    if (RR(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return Nh(t);
  return !1;
}, zR = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var a = t.parentElement; a; ) {
      if (a.tagName === "FIELDSET" && a.disabled) {
        for (var n = 0; n < a.children.length; n++) {
          var r = a.children.item(n);
          if (r.tagName === "LEGEND")
            return rr.call(a, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      a = a.parentElement;
    }
  return !1;
}, El = function(t, a) {
  return !(a.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Il(a) || MR(a) || FR(a, t) || // For a details element with a summary, the summary element gets the focus
  OR(a) || zR(a));
}, xu = function(t, a) {
  return !(BR(a) || Kn(a) < 0 || !El(t, a));
}, YR = function(t) {
  var a = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(a) || a >= 0);
}, HR = function e(t) {
  var a = [], n = [];
  return t.forEach(function(r, i) {
    var o = !!r.scopeParent, u = o ? r.scopeParent : r, s = IR(u, o), l = o ? e(r.candidates) : u;
    s === 0 ? o ? a.push.apply(a, l) : a.push(u) : n.push({
      documentOrder: i,
      tabIndex: s,
      item: r,
      isScope: o,
      content: l
    });
  }), n.sort(ER).reduce(function(r, i) {
    return i.isScope ? r.push.apply(r, i.content) : r.push(i.content), r;
  }, []).concat(a);
}, qR = function(t, a) {
  a = a || {};
  var n;
  return a.getShadowRoot ? n = h1([t], a.includeContainer, {
    filter: xu.bind(null, a),
    flatten: !1,
    getShadowRoot: a.getShadowRoot,
    shadowRootFilter: YR
  }) : n = v1(t, a.includeContainer, xu.bind(null, a)), HR(n);
}, WR = function(t, a) {
  a = a || {};
  var n;
  return a.getShadowRoot ? n = h1([t], a.includeContainer, {
    filter: El.bind(null, a),
    flatten: !0,
    getShadowRoot: a.getShadowRoot
  }) : n = v1(t, a.includeContainer, El.bind(null, a)), n;
}, br = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return rr.call(t, Dl) === !1 ? !1 : xu(a, t);
}, UR = /* @__PURE__ */ d1.concat("iframe").join(","), zs = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return rr.call(t, UR) === !1 ? !1 : El(a, t);
};
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Tu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, n = Array(t); a < t; a++) n[a] = e[a];
  return n;
}
function KR(e) {
  if (Array.isArray(e)) return Tu(e);
}
function VR(e, t, a) {
  return (t = XR(t)) in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function jR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function GR() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Lh(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function Bh(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lh(Object(a), !0).forEach(function(n) {
      VR(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Lh(Object(a)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(a, n));
    });
  }
  return e;
}
function QR(e) {
  return KR(e) || jR(e) || JR(e) || GR();
}
function ZR(e, t) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var n = a.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function XR(e) {
  var t = ZR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function JR(e, t) {
  if (e) {
    if (typeof e == "string") return Tu(e, t);
    var a = {}.toString.call(e).slice(8, -1);
    return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? Array.from(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? Tu(e, t) : void 0;
  }
}
var Rh = {
  activateTrap: function(t, a) {
    if (t.length > 0) {
      var n = t[t.length - 1];
      n !== a && n._setPausedState(!0);
    }
    var r = t.indexOf(a);
    r === -1 || t.splice(r, 1), t.push(a);
  },
  deactivateTrap: function(t, a) {
    var n = t.indexOf(a);
    n !== -1 && t.splice(n, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, _R = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, eF = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, ki = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, tF = function(t) {
  return ki(t) && !t.shiftKey;
}, aF = function(t) {
  return ki(t) && t.shiftKey;
}, Fh = function(t) {
  return setTimeout(t, 0);
}, fi = function(t) {
  for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++)
    n[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, Bo = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, nF = [], rF = function(t, a) {
  var n = (a == null ? void 0 : a.document) || document, r = (a == null ? void 0 : a.trapStack) || nF, i = Bh({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: tF,
    isKeyBackward: aF
  }, a), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, u, s = function(x, I, E) {
    return x && x[I] !== void 0 ? x[I] : i[E || I];
  }, l = function(x, I) {
    var E = typeof (I == null ? void 0 : I.composedPath) == "function" ? I.composedPath() : void 0;
    return o.containerGroups.findIndex(function(P) {
      var R = P.container, K = P.tabbableNodes;
      return R.contains(x) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (E == null ? void 0 : E.includes(R)) || K.find(function(J) {
        return J === x;
      });
    });
  }, c = function(x) {
    var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = I.hasFallback, P = E === void 0 ? !1 : E, R = I.params, K = R === void 0 ? [] : R, J = i[x];
    if (typeof J == "function" && (J = J.apply(void 0, QR(K))), J === !0 && (J = void 0), !J) {
      if (J === void 0 || J === !1)
        return J;
      throw new Error("`".concat(x, "` was specified but was not a node, or did not return a node"));
    }
    var q = J;
    if (typeof J == "string") {
      try {
        q = n.querySelector(J);
      } catch (se) {
        throw new Error("`".concat(x, '` appears to be an invalid selector; error="').concat(se.message, '"'));
      }
      if (!q && !P)
        throw new Error("`".concat(x, "` as selector refers to no known node"));
    }
    return q;
  }, d = function() {
    var x = c("initialFocus", {
      hasFallback: !0
    });
    if (x === !1)
      return !1;
    if (x === void 0 || x && !zs(x, i.tabbableOptions))
      if (l(n.activeElement) >= 0)
        x = n.activeElement;
      else {
        var I = o.tabbableGroups[0], E = I && I.firstTabbableNode;
        x = E || c("fallbackFocus");
      }
    else x === null && (x = c("fallbackFocus"));
    if (!x)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return x;
  }, f = function() {
    if (o.containerGroups = o.containers.map(function(x) {
      var I = qR(x, i.tabbableOptions), E = WR(x, i.tabbableOptions), P = I.length > 0 ? I[0] : void 0, R = I.length > 0 ? I[I.length - 1] : void 0, K = E.find(function(se) {
        return br(se);
      }), J = E.slice().reverse().find(function(se) {
        return br(se);
      }), q = !!I.find(function(se) {
        return Kn(se) > 0;
      });
      return {
        container: x,
        tabbableNodes: I,
        focusableNodes: E,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: q,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: P,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: R,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: K,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: J,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(fe) {
          var ne = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ae = I.indexOf(fe);
          return ae < 0 ? ne ? E.slice(E.indexOf(fe) + 1).find(function(ve) {
            return br(ve);
          }) : E.slice(0, E.indexOf(fe)).reverse().find(function(ve) {
            return br(ve);
          }) : I[ae + (ne ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(x) {
      return x.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(x) {
      return x.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function(x) {
    var I = x.activeElement;
    if (I)
      return I.shadowRoot && I.shadowRoot.activeElement !== null ? v(I.shadowRoot) : I;
  }, y = function(x) {
    if (x !== !1 && x !== v(document)) {
      if (!x || !x.focus) {
        y(d());
        return;
      }
      x.focus({
        preventScroll: !!i.preventScroll
      }), o.mostRecentlyFocusedNode = x, _R(x) && x.select();
    }
  }, C = function(x) {
    var I = c("setReturnFocus", {
      params: [x]
    });
    return I || (I === !1 ? !1 : x);
  }, h = function(x) {
    var I = x.target, E = x.event, P = x.isBackward, R = P === void 0 ? !1 : P;
    I = I || Bo(E), f();
    var K = null;
    if (o.tabbableGroups.length > 0) {
      var J = l(I, E), q = J >= 0 ? o.containerGroups[J] : void 0;
      if (J < 0)
        R ? K = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : K = o.tabbableGroups[0].firstTabbableNode;
      else if (R) {
        var se = o.tabbableGroups.findIndex(function(Te) {
          var Le = Te.firstTabbableNode;
          return I === Le;
        });
        if (se < 0 && (q.container === I || zs(I, i.tabbableOptions) && !br(I, i.tabbableOptions) && !q.nextTabbableNode(I, !1)) && (se = J), se >= 0) {
          var fe = se === 0 ? o.tabbableGroups.length - 1 : se - 1, ne = o.tabbableGroups[fe];
          K = Kn(I) >= 0 ? ne.lastTabbableNode : ne.lastDomTabbableNode;
        } else ki(E) || (K = q.nextTabbableNode(I, !1));
      } else {
        var ae = o.tabbableGroups.findIndex(function(Te) {
          var Le = Te.lastTabbableNode;
          return I === Le;
        });
        if (ae < 0 && (q.container === I || zs(I, i.tabbableOptions) && !br(I, i.tabbableOptions) && !q.nextTabbableNode(I)) && (ae = J), ae >= 0) {
          var ve = ae === o.tabbableGroups.length - 1 ? 0 : ae + 1, Ae = o.tabbableGroups[ve];
          K = Kn(I) >= 0 ? Ae.firstTabbableNode : Ae.firstDomTabbableNode;
        } else ki(E) || (K = q.nextTabbableNode(I));
      }
    } else
      K = c("fallbackFocus");
    return K;
  }, g = function(x) {
    var I = Bo(x);
    if (!(l(I, x) >= 0)) {
      if (fi(i.clickOutsideDeactivates, x)) {
        u.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      fi(i.allowOutsideClick, x) || x.preventDefault();
    }
  }, p = function(x) {
    var I = Bo(x), E = l(I, x) >= 0;
    if (E || I instanceof Document)
      E && (o.mostRecentlyFocusedNode = I);
    else {
      x.stopImmediatePropagation();
      var P, R = !0;
      if (o.mostRecentlyFocusedNode)
        if (Kn(o.mostRecentlyFocusedNode) > 0) {
          var K = l(o.mostRecentlyFocusedNode), J = o.containerGroups[K].tabbableNodes;
          if (J.length > 0) {
            var q = J.findIndex(function(se) {
              return se === o.mostRecentlyFocusedNode;
            });
            q >= 0 && (i.isKeyForward(o.recentNavEvent) ? q + 1 < J.length && (P = J[q + 1], R = !1) : q - 1 >= 0 && (P = J[q - 1], R = !1));
          }
        } else
          o.containerGroups.some(function(se) {
            return se.tabbableNodes.some(function(fe) {
              return Kn(fe) > 0;
            });
          }) || (R = !1);
      else
        R = !1;
      R && (P = h({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(o.recentNavEvent)
      })), y(P || o.mostRecentlyFocusedNode || d());
    }
    o.recentNavEvent = void 0;
  }, w = function(x) {
    var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = x;
    var E = h({
      event: x,
      isBackward: I
    });
    E && (ki(x) && x.preventDefault(), y(E));
  }, k = function(x) {
    (i.isKeyForward(x) || i.isKeyBackward(x)) && w(x, i.isKeyBackward(x));
  }, S = function(x) {
    eF(x) && fi(i.escapeDeactivates, x) !== !1 && (x.preventDefault(), u.deactivate());
  }, T = function(x) {
    var I = Bo(x);
    l(I, x) >= 0 || fi(i.clickOutsideDeactivates, x) || fi(i.allowOutsideClick, x) || (x.preventDefault(), x.stopImmediatePropagation());
  }, A = function() {
    if (o.active)
      return Rh.activateTrap(r, u), o.delayInitialFocusTimer = i.delayInitialFocus ? Fh(function() {
        y(d());
      }) : y(d()), n.addEventListener("focusin", p, !0), n.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", T, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", k, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", S), u;
  }, F = function() {
    if (o.active)
      return n.removeEventListener("focusin", p, !0), n.removeEventListener("mousedown", g, !0), n.removeEventListener("touchstart", g, !0), n.removeEventListener("click", T, !0), n.removeEventListener("keydown", k, !0), n.removeEventListener("keydown", S), u;
  }, Z = function(x) {
    var I = x.some(function(E) {
      var P = Array.from(E.removedNodes);
      return P.some(function(R) {
        return R === o.mostRecentlyFocusedNode;
      });
    });
    I && y(d());
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Z) : void 0, z = function() {
    O && (O.disconnect(), o.active && !o.paused && o.containers.map(function(x) {
      O.observe(x, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return u = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(x) {
      if (o.active)
        return this;
      var I = s(x, "onActivate"), E = s(x, "onPostActivate"), P = s(x, "checkCanFocusTrap");
      P || f(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = v(n), I == null || I();
      var R = function() {
        P && f(), A(), z(), E == null || E();
      };
      return P ? (P(o.containers.concat()).then(R, R), this) : (R(), this);
    },
    deactivate: function(x) {
      if (!o.active)
        return this;
      var I = Bh({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, x);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, F(), o.active = !1, o.paused = !1, z(), Rh.deactivateTrap(r, u);
      var E = s(I, "onDeactivate"), P = s(I, "onPostDeactivate"), R = s(I, "checkCanReturnFocus"), K = s(I, "returnFocus", "returnFocusOnDeactivate");
      E == null || E();
      var J = function() {
        Fh(function() {
          K && y(C(o.nodeFocusedBeforeActivation)), P == null || P();
        });
      };
      return K && R ? (R(C(o.nodeFocusedBeforeActivation)).then(J, J), this) : (J(), this);
    },
    pause: function(x) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, x)) : this;
    },
    unpause: function(x) {
      return o.active ? (o.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, x)) : this;
    },
    updateContainerElements: function(x) {
      var I = [].concat(x).filter(Boolean);
      return o.containers = I.map(function(E) {
        return typeof E == "string" ? n.querySelector(E) : E;
      }), o.active && f(), z(), this;
    }
  }, Object.defineProperties(u, {
    _isManuallyPaused: {
      value: function() {
        return o.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(x, I) {
        if (o.paused === x)
          return this;
        if (o.paused = x, x) {
          var E = s(I, "onPause"), P = s(I, "onPostPause");
          E == null || E(), F(), z(), P == null || P();
        } else {
          var R = s(I, "onUnpause"), K = s(I, "onPostUnpause");
          R == null || R(), f(), A(), z(), K == null || K();
        }
        return this;
      }
    }
  }), u.updateContainerElements(t), u;
};
/*!
  * focus-trap-vue v4.0.3
  * (c) 2025 Eduardo San Martin Morote
  * @license MIT
  */
const iF = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, oF = oe({
  name: "FocusTrap",
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, iF),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: a }) {
    let n;
    const r = N(null), i = b(() => {
      const u = r.value;
      return u && (u instanceof HTMLElement ? u : u.$el);
    });
    function o() {
      return n || (n = rF(i.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          a("update:active", !0), a("activate");
        },
        onDeactivate: () => {
          a("update:active", !1), a("deactivate");
        },
        onPostActivate: () => a("postActivate"),
        onPostDeactivate: () => a("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return it(() => {
      ie(() => e.active, (u) => {
        u && i.value ? o().activate() : n && (n.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (n = null));
      }, { immediate: !0, flush: "post" });
    }), ya(() => {
      n && n.deactivate(), n = null;
    }), {
      activate() {
        o().activate();
      },
      deactivate() {
        n && n.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const u = t.default().filter((l) => l.type !== H1);
        return !u || !u.length || u.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), u) : q1(u[0], { ref: r });
      }
    };
  }
}), lF = ["aria-label"], sF = {
  key: 0,
  class: "modal-header"
}, uF = {
  key: 0,
  class: "modal-title"
}, cF = { class: "modal-footer" }, dF = { class: "footer-actions" }, fF = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KModal",
  props: {
    visible: { type: Boolean },
    title: { default: "" },
    actionButtonText: { default: "Submit" },
    actionButtonAppearance: { default: "primary" },
    actionButtonDisabled: { type: Boolean },
    hideCancelButton: { type: Boolean },
    cancelButtonText: { default: "Cancel" },
    cancelButtonAppearance: { default: "tertiary" },
    cancelButtonDisabled: { type: Boolean },
    tabbableOptions: { default: () => ({}) },
    maxWidth: { default: "500px" },
    maxHeight: { default: "calc(100vh - 200px)" },
    closeOnBackdropClick: { type: Boolean },
    closeOnEscape: { type: Boolean, default: !0 },
    hideCloseIcon: { type: Boolean },
    fullScreen: { type: Boolean },
    inputAutofocus: { type: Boolean },
    zIndex: { default: 1100 }
  },
  emits: ["proceed", "cancel"],
  setup(e, { emit: t }) {
    Wt((w) => ({
      v5582ddaa: w.zIndex,
      v1ae56e5d: l.value,
      ee977890: c.value
    }));
    const a = t, n = $t(), r = na(), i = /* @__PURE__ */ h0(), o = `k-modal-${yt()}-overflow-hidden`, u = N(null), s = N(null), l = b(() => e.fullScreen && !n.content ? "95%" : It(e.maxWidth)), c = b(() => e.fullScreen && !n.content ? "95vh" : It(e.maxHeight)), d = b(() => {
      const w = Object.assign({}, r);
      return delete w.class, w;
    }), f = b(() => !!e.title || !!n.title || !e.hideCloseIcon), v = (w) => {
      e.visible && e.closeOnEscape && w.key === "Escape" && y(!0);
    }, y = (w = !1, k) => {
      var S, T;
      (w || (T = (S = k == null ? void 0 : k.target) == null ? void 0 : S.classList) != null && T.contains("modal-backdrop") && e.closeOnBackdropClick && !i.text.value) && a("cancel");
    }, C = async (w) => {
      var k, S;
      w ? (await ht(), await new Promise((T) => setTimeout(T, 0)), (k = u.value) == null || k.activate()) : (S = u.value) == null || S.deactivate();
    }, h = (w) => {
      typeof document < "u" && (w ? document == null || document.addEventListener("keydown", v) : document == null || document.removeEventListener("keydown", v));
    }, g = () => {
      var k, S, T;
      const w = (T = (S = (k = u.value) == null ? void 0 : k.$el) == null ? void 0 : S.querySelector(".modal-content")) == null ? void 0 : T.querySelectorAll("input");
      w != null && w.length && Array.from(w).every((A) => !A.disabled && !A.readOnly ? (A.focus(), !1) : !0);
    };
    ie(() => e.visible, async (w) => {
      var k, S;
      w ? (await C(!0), e.inputAutofocus && g(), h(!0)) : (await C(!1), h(!1)), typeof document < "u" && ((S = (k = document == null ? void 0 : document.body) == null ? void 0 : k.classList) == null || S.toggle(o, w));
    }, { immediate: !0 }), ie(() => e.inputAutofocus, async (w) => {
      w && (await ht(), g());
    });
    const p = N(null);
    return it(() => {
      typeof document < "u" && (p.value = document.createElement("style"), p.value.textContent = `body.${o} { overflow: hidden; }`, document.head.appendChild(p.value));
    }), fn(async () => {
      await C(!1), h(!1);
    }), ya(() => {
      var w;
      (w = p.value) == null || w.remove();
    }), (w, k) => e.visible ? (m(), $("div", Re({
      key: 0,
      "aria-label": e.title,
      "aria-modal": "true",
      class: ["k-modal", [D(r).class]]
    }, d.value, { role: "dialog" }), [
      Y("div", {
        ref_key: "modalWrapperElement",
        ref: s,
        class: ce(["modal-backdrop", { "modal-full-screen": e.fullScreen && !w.$slots.content }]),
        onClick: k[3] || (k[3] = (S) => y(!1, S))
      }, [
        G(D(oF), {
          ref_key: "focusTrapElement",
          ref: u,
          active: !1,
          "fallback-focus": () => s.value,
          "tabbable-options": e.tabbableOptions
        }, {
          default: L(() => [
            Y("div", {
              class: ce(["modal-container", { "custom-content": w.$slots.content }]),
              tabindex: "-1"
            }, [
              W(w.$slots, "content", {}, () => [
                f.value ? (m(), $("div", sF, [
                  e.title || w.$slots.title ? (m(), $("div", uF, [
                    W(w.$slots, "title", {}, () => [
                      be(re(e.title), 1)
                    ], !0)
                  ])) : H("", !0),
                  e.hideCloseIcon ? H("", !0) : (m(), $("button", {
                    key: 1,
                    "aria-label": "Close",
                    class: "close-icon",
                    "data-testid": "modal-close-icon",
                    type: "button",
                    onClick: k[0] || (k[0] = (S) => w.$emit("cancel"))
                  }, [
                    G(D(ha), {
                      color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                      decorative: ""
                    }, null, 8, ["color"])
                  ]))
                ])) : H("", !0),
                Y("div", {
                  class: ce(["modal-content", { "no-header": !f.value }])
                }, [
                  W(w.$slots, "default", {}, void 0, !0)
                ], 2),
                Y("div", cF, [
                  W(w.$slots, "footer", {}, () => [
                    Y("div", dF, [
                      W(w.$slots, "footer-actions", {}, () => [
                        e.hideCancelButton ? H("", !0) : (m(), X(rt, {
                          key: 0,
                          appearance: e.cancelButtonAppearance,
                          "data-testid": "modal-cancel-button",
                          disabled: e.cancelButtonDisabled,
                          onClick: k[1] || (k[1] = (S) => w.$emit("cancel"))
                        }, {
                          default: L(() => [
                            be(re(e.cancelButtonText), 1)
                          ]),
                          _: 1
                        }, 8, ["appearance", "disabled"])),
                        G(rt, {
                          appearance: e.actionButtonAppearance,
                          "data-testid": "modal-action-button",
                          disabled: e.actionButtonDisabled,
                          onClick: k[2] || (k[2] = (S) => w.$emit("proceed"))
                        }, {
                          default: L(() => [
                            be(re(e.actionButtonText), 1)
                          ]),
                          _: 1
                        }, 8, ["appearance", "disabled"])
                      ], !0)
                    ])
                  ], !0)
                ])
              ], !0)
            ], 2)
          ]),
          _: 3
        }, 8, ["fallback-focus", "tabbable-options"])
      ], 2)
    ], 16, lF)) : H("", !0);
  }
}), p1 = /* @__PURE__ */ Pe(fF, [["__scopeId", "data-v-72f9e795"]]), vF = ["aria-label"], hF = { class: "k-modal-fullscreen-body-header" }, gF = {
  key: 0,
  class: "body-header"
}, mF = {
  key: 1,
  class: "body-header-description"
}, pF = { class: "k-modal-fullscreen-body" }, yF = { class: "k-modal-fullscreen-header" }, bF = {
  "aria-level": "2",
  class: "k-modal-fullscreen-header-description",
  role: "heading"
}, wF = { class: "k-modal-fullscreen-title" }, CF = { class: "header-icon" }, kF = { class: "header-content" }, $F = { class: "k-modal-fullscreen-action" }, SF = { class: "k-modal-fullscreen-action-buttons" }, xF = {
  key: 0,
  class: "k-modal-fullscreen-footer"
}, TF = { class: "k-modal-fullscreen-action" }, DF = { class: "k-modal-fullscreen-action-buttons" }, AF = /* @__PURE__ */ oe({
  __name: "KModalFullscreen",
  props: {
    /**
    * Set the text of the title, if using title slot
    */
    title: {
      type: String,
      required: !0
    },
    /**
    * Set the title in the body
    */
    bodyHeader: {
      type: String,
      default: ""
    },
    /**
    * Text to display as a description of the body's title
    */
    bodyHeaderDescription: {
      type: String,
      default: ""
    },
    /**
    *  Pass whether or not the modal should be visible
    */
    isVisible: {
      type: Boolean,
      default: !1
    },
    /**
    * Set the text of the close/cancel button
    */
    cancelButtonText: {
      type: String,
      default: "Cancel"
    },
    /**
    * Set the text of the action/proceed button
    */
    actionButtonText: {
      type: String,
      default: "Save"
    },
    /**
    * Set the appearance of the action/proceed button
    */
    actionButtonAppearance: {
      type: String,
      default: "primary"
    },
    /**
    * Set the appearance of the close/cancel button
    */
    cancelButtonAppearance: {
      type: String,
      default: "secondary"
    },
    /**
    * @deprecated
    * Pass the type of icon for the header on the left
    */
    iconString: {
      type: String,
      default: "kong"
    }
  },
  emits: ["canceled", "proceed"],
  setup(e, { emit: t }) {
    const a = e, n = t, r = N(null), i = b(() => !!a.isVisible);
    ie(() => a.isVisible, async () => {
      typeof document > "u" || (i.value ? (document.body.style.overflow = "hidden", await ht(), r.value && r.value.focus()) : document.body.style.overflow = "");
    });
    const o = (l) => {
      a.isVisible && (l.keyCode === 27 ? u() : l.keyCode === 13 && s());
    }, u = () => {
      n("canceled");
    }, s = () => {
      n("proceed");
    };
    return it(() => {
      document.addEventListener("keydown", o), console.warn(`The Kongponents 'KModalFullscreen' component is deprecated and will be removed in the next major release.
We suggest using 'KModal' component instead.
Docs: https://kongponents.konghq.com/components/modal.html#fullscreen`);
    }), fn(() => {
      document.removeEventListener("keydown", o);
    }), ya(() => {
      document.body.style.overflow = "";
    }), (l, c) => e.isVisible ? (m(), $("div", {
      key: 0,
      "aria-label": e.title,
      "aria-modal": "true",
      class: "k-modal-fullscreen isOpen",
      role: "dialog",
      onKeyup: [
        ct(s, ["enter"]),
        ct(u, ["esc"])
      ]
    }, [
      Y("div", {
        ref_key: "modalBodyContent",
        ref: r,
        class: ce(["k-modal-fullscreen-dialog", { "has-footer": l.$slots["footer-content"] }]),
        tabindex: "0"
      }, [
        Y("div", hF, [
          l.$slots["body-header"] || e.bodyHeader ? (m(), $("div", gF, [
            W(l.$slots, "body-header", {}, () => [
              be(re(e.bodyHeader), 1)
            ], !0)
          ])) : H("", !0),
          l.$slots["body-header-description"] || e.bodyHeaderDescription ? (m(), $("div", mF, [
            W(l.$slots, "body-header-description", {}, () => [
              be(re(e.bodyHeaderDescription), 1)
            ], !0)
          ])) : H("", !0)
        ]),
        Y("div", pF, [
          W(l.$slots, "default", {}, void 0, !0)
        ]),
        Y("div", yF, [
          Y("div", bF, [
            Y("div", wF, [
              Y("span", CF, [
                W(l.$slots, "header-icon", {}, () => [
                  G(D(Fu), { color: D(wg) }, null, 8, ["color"])
                ], !0)
              ]),
              Y("span", kF, [
                W(l.$slots, "header-content", {}, () => [
                  be(re(e.title), 1)
                ], !0)
              ])
            ]),
            Y("div", $F, [
              Y("div", SF, [
                W(l.$slots, "action-buttons", {}, () => [
                  G(rt, {
                    appearance: e.cancelButtonAppearance,
                    class: "cancel-button",
                    onClick: u
                  }, {
                    default: L(() => [
                      be(re(e.cancelButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["appearance"]),
                  G(rt, {
                    appearance: e.actionButtonAppearance,
                    class: "proceed-button",
                    onClick: s
                  }, {
                    default: L(() => [
                      be(re(e.actionButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["appearance"])
                ], !0)
              ])
            ])
          ])
        ]),
        l.$slots["footer-content"] ? (m(), $("div", xF, [
          W(l.$slots, "footer-content", {}, void 0, !0),
          Y("div", TF, [
            Y("div", DF, [
              W(l.$slots, "action-buttons", {}, () => [
                G(rt, {
                  appearance: e.actionButtonAppearance,
                  class: "proceed-button",
                  onClick: s
                }, {
                  default: L(() => [
                    be(re(e.actionButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["appearance"])
              ], !0)
            ])
          ])
        ])) : H("", !0)
      ], 2)
    ], 40, vF)) : H("", !0);
  }
}), IF = /* @__PURE__ */ Pe(AF, [["__scopeId", "data-v-ff332793"]]), EF = ["aria-selected", "data-testid"], MF = { class: "multiselect-item-container" }, OF = ["disabled", "value"], PF = { class: "multiselect-item-label" }, NF = /* @__PURE__ */ oe({
  __name: "KMultiselectItem",
  props: {
    item: {}
  },
  emits: ["selected", "arrow-down", "arrow-up"],
  setup(e, { emit: t }) {
    const a = t, n = () => {
      e.item.disabled || a("selected", e.item);
    };
    return (r, i) => (m(), $("div", {
      key: e.item.key,
      "aria-selected": e.item.selected,
      class: "multiselect-item",
      "data-testid": `multiselect-item-${e.item.value}`,
      role: "option"
    }, [
      Y("div", MF, [
        Y("button", {
          class: ce({ selected: e.item.selected }),
          disabled: e.item.disabled === !0 ? !0 : void 0,
          type: "button",
          value: e.item.value,
          onClick: n,
          onKeydown: [
            i[0] || (i[0] = ct(Ke((o) => r.$emit("arrow-down"), ["prevent"]), ["down"])),
            i[1] || (i[1] = ct(Ke((o) => r.$emit("arrow-up"), ["prevent"]), ["up"]))
          ]
        }, [
          Y("span", PF, [
            W(r.$slots, "content", {}, () => [
              be(re(e.item.label), 1)
            ], !0)
          ])
        ], 42, OF)
      ])
    ], 8, EF));
  }
}), Qo = /* @__PURE__ */ Pe(NF, [["__scopeId", "data-v-e01a7f81"]]), LF = {
  ref: "itemsContainer",
  "aria-live": "polite",
  class: "multiselect-items-container"
}, BF = { class: "multiselect-group-title" }, RF = { class: "select-item-description" }, zh = ".multiselect-item button:not(:disabled)", FF = /* @__PURE__ */ oe({
  __name: "KMultiselectItems",
  props: {
    items: { default: () => [] },
    itemCreationEnabled: { type: Boolean },
    filterString: { default: "" },
    itemCreationValid: { type: Boolean, default: !0 }
  },
  emits: ["selected", "add-item"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = (d) => n("selected", d), i = b(() => {
      var d;
      return (d = e.items) == null ? void 0 : d.filter((f) => !f.group);
    }), o = b(() => {
      var d, f;
      return [...new Set((f = (d = e.items) == null ? void 0 : d.filter((v) => v.group)) == null ? void 0 : f.map((v) => v.group))].sort((v, y) => v.toLowerCase().localeCompare(y.toLowerCase()));
    }), u = (d) => {
      var f;
      return (f = e.items) == null ? void 0 : f.filter((v) => v.group === d);
    }, s = dt("itemsContainer"), l = (d) => {
      var y;
      const f = s.value;
      if (!f)
        return;
      const v = f.querySelectorAll(zh);
      (y = v[d === "down" ? 0 : v.length - 1]) == null || y.focus();
    }, c = ({ target: d, key: f }) => {
      var v;
      if (f === "ArrowDown" || f === "ArrowUp") {
        const y = (v = s.value) == null ? void 0 : v.querySelectorAll(zh);
        if (y != null && y.length) {
          const C = [...y].indexOf(d), h = f === "ArrowDown" ? C + 1 : C - 1, g = y[h];
          g == null || g.focus();
        }
      }
    };
    return t({ setFocus: l }), (d, f) => (m(), $("div", LF, [
      (m(!0), $(Ee, null, Fe(i.value, (v, y) => (m(), X(Qo, {
        key: `${v.key ? v.key : y}-item`,
        item: v,
        onKeydown: c,
        onSelected: r
      }, {
        content: L(() => [
          W(d.$slots, "content", { item: v }, void 0, !0)
        ]),
        _: 2
      }, 1032, ["item"]))), 128)),
      (m(!0), $(Ee, null, Fe(o.value, (v) => (m(), $("div", {
        key: `${v}-group`,
        class: "multiselect-group"
      }, [
        Y("span", BF, re(v), 1),
        (m(!0), $(Ee, null, Fe(u(v), (y, C) => (m(), X(Qo, {
          key: `${y.key ? y.key : v + "-" + C + "-item"}`,
          item: y,
          onKeydown: c,
          onSelected: r
        }, {
          content: L(() => [
            W(d.$slots, "content", { item: y }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["item"]))), 128))
      ]))), 128)),
      e.itemCreationEnabled ? (m(), X(Qo, {
        key: "multiselect-add-item",
        class: "multiselect-add-item",
        "data-testid": "multiselect-add-item",
        item: { label: `${e.filterString} (Add new value)`, value: "add_item", disabled: !e.itemCreationValid },
        onKeydown: c,
        onSelected: f[0] || (f[0] = (v) => d.$emit("add-item"))
      }, {
        content: L(() => [
          Y("div", RF, [
            be(re(e.filterString) + " ", 1),
            f[1] || (f[1] = Y("span", { class: "select-item-new-indicator" }, "(Add new value)", -1))
          ])
        ]),
        _: 1
      }, 8, ["item"])) : H("", !0)
    ], 512));
  }
}), zF = /* @__PURE__ */ Pe(FF, [["__scopeId", "data-v-a2ee6e0d"]]);
function Du(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function YF(e, t) {
  let a;
  return (...n) => {
    clearTimeout(a), a = window == null ? void 0 : window.setTimeout(() => {
      e(...n);
    }, t);
  };
}
const Yh = (e) => {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}, y1 = 15, b1 = (e, t) => e.pageSize ? e.pageSize : t.initialPageSize ? t.initialPageSize : t.pageSizes && Array.isArray(t.pageSizes) && t.pageSizes.length ? t.pageSizes[0] : y1, HF = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let qF = (e = 21) => {
  let t = "", a = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += HF[a[e] & 63];
  return t;
};
const cs = () => qF(), WF = { "data-testid": "multiselect-container" }, UF = ["id", "tabindex"], KF = { key: 0 }, VF = {
  key: 1,
  class: "expanded-selection-empty"
}, jF = { class: "multiselect-selection-badge-label" }, GF = ["aria-label", "onClick"], QF = { class: "multiselect-icons-container" }, ZF = {
  key: 0,
  class: "multiselect-input-wrapper"
}, XF = {
  key: 2,
  class: "multiselect-empty",
  "data-propagate-clicks": "false"
}, JF = {
  key: 1,
  class: "help-text"
}, _F = {
  key: 2,
  "aria-hidden": "true",
  class: "staging-area"
}, ez = { class: "multiselect-selection-badge-label" }, tz = 36, az = "Filter...", nz = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KMultiselect",
  props: {
    modelValue: { default: () => [] },
    label: { default: "" },
    help: { default: "" },
    error: { type: Boolean },
    labelAttributes: { default: () => ({}) },
    placeholder: { default: "" },
    searchPlaceholder: { default: "" },
    kpopAttributes: { default: () => ({}) },
    dropdownMaxHeight: { default: "300px" },
    width: { default: "100%" },
    selectedRowCount: { default: 1 },
    collapsedContext: { type: Boolean },
    items: { default: () => [] },
    filterFunction: { type: Function, default: (e) => e.items.filter((t) => {
      var a, n;
      return (n = t.label) == null ? void 0 : n.toLowerCase().includes((a = e.query) == null ? void 0 : a.toLowerCase());
    }) },
    autosuggest: { type: Boolean },
    enableItemCreation: { type: Boolean },
    loading: { type: Boolean },
    dropdownFooterText: { default: "" },
    dropdownFooterTextPosition: { default: "sticky" },
    itemCreationValidator: { type: Function, default: () => !0 }
  },
  emits: ["selected", "input", "change", "update:modelValue", "query-change", "item-added", "item-removed"],
  setup(e, { emit: t }) {
    Wt((_) => ({
      v43ca70d7: Le.value
    }));
    const a = (_) => {
      const de = [];
      return _.forEach((Ie) => de.push(Ie.value)), de;
    }, n = (_) => {
      const de = a(_), Ie = new Set(de);
      return de.length === Ie.size;
    }, r = na(), i = $t(), { cloneDeep: o, stripRequiredLabel: u } = Bn();
    ie(() => e.items, (_) => {
      !_.length || _.every((Ie) => Ie.label !== void 0 && Ie.value !== void 0) && n(_) || console.warn("KMultiselect: Items must have a label & value and value must be unique");
    }, { immediate: !0 });
    const s = t, l = dt("kMultiselectItems"), c = b(() => r.required !== void 0 && String(r.required) !== "false"), d = b(() => u(e.label, c.value)), f = b(() => {
      var _, de;
      return !!((_ = e.labelAttributes) != null && _.help || (de = e.labelAttributes) != null && de.info || i["label-tooltip"]);
    }), v = (_) => ne.value || ae.value || _ != null && _.disabled ? "neutral" : e.error ? "danger" : "info", y = {
      hideCaret: !0,
      placement: "bottom-start",
      popoverTimeout: 0,
      popoverClasses: "k-multiselect-popover multiselect-popover"
    }, C = N(0), h = N(0), g = yt(), p = b(() => r.id ? String(r.id) : g), w = yt(), k = dt("multiselectElement"), S = dt("multiselectDropdownInputElement"), T = dt("multiselectSelectionsStagingElement"), A = b(() => e.selectedRowCount * tz), F = N(""), Z = b(() => !(!F.value || z.value.filter((_) => _.label === F.value).length)), O = N(null), z = N([]), U = N([]), x = N([]), I = N([]), E = N([]), P = /* @__PURE__ */ new Set(), R = N([]), K = N([]), J = b(() => K.value.map((_) => _.label).join(", ")), q = N(!1), se = N(!1), fe = N(!1), ne = b(() => (r == null ? void 0 : r.disabled) !== void 0 && String(r == null ? void 0 : r.disabled) !== "false"), ae = b(() => (r == null ? void 0 : r.readonly) !== void 0 && String(r == null ? void 0 : r.readonly) !== "false"), ve = b({
      get() {
        return e.modelValue;
      },
      set(_) {
        const de = z.value.filter((Ie) => _.includes(Ie.value));
        de.length ? Se(de) : _.length || Je();
      }
    }), Ae = b(() => {
      const _ = { ...r };
      return delete _.class, _;
    }), Te = b(() => {
      var _;
      return {
        ...y,
        ...e.kpopAttributes,
        popoverClasses: `${y.popoverClasses} ${((_ = e.kpopAttributes) == null ? void 0 : _.popoverClasses) ?? ""} ${e.dropdownFooterText || i["dropdown-footer-text"] ? "has-dropdown-footer" : ""}`,
        width: Mt.value + "px",
        maxWidth: Mt.value + "px",
        disabled: r.disabled !== void 0 && String(r.disabled) !== "false" || r.readonly !== void 0 && String(r.readonly) !== "false"
      };
    }), Le = b(() => It(e.dropdownMaxHeight)), ze = b(() => ({ ...Te.value })), _e = b(() => {
      const _ = e.width ? e.width : "300";
      return It(_);
    }), tt = b(() => ({
      width: _e.value
    })), Xe = b(() => ({
      width: Mt.value + "px"
    })), et = b(() => {
      if (x.value.length === 0) {
        if (!e.collapsedContext && e.placeholder)
          return e.placeholder;
        if (e.collapsedContext && e.searchPlaceholder)
          return e.searchPlaceholder;
      }
      return x.value.length === 1 ? `${x.value.length} item selected` : `${x.value.length} items selected`;
    }), pe = b(() => e.autosuggest ? z.value : e.filterFunction({ items: z.value, query: F.value })), me = (_) => {
      var de;
      (ne.value || ((de = _ == null ? void 0 : _.target) == null ? void 0 : de.dataset.propagateClicks) === "false") && _.stopPropagation();
    }, he = async (_, de, Ie) => {
      var Q, M;
      if (_) {
        if (!de.value) {
          F.value = "", Ie(), vt(), await ht();
          const j = (M = (Q = S.value) == null ? void 0 : Q.$el) == null ? void 0 : M.querySelector("input");
          j == null || j.focus({ preventScroll: !0 });
        }
      } else
        de.value && (F.value = "", Ie());
    }, V = () => {
      setTimeout(() => {
        const _ = T.value;
        if (e.collapsedContext) {
          h.value++;
          return;
        }
        if (_) {
          if (_.clientHeight > A.value) {
            const Ie = Array.from(_.querySelectorAll(".multiselect-selection-badge")).filter((j) => j.offsetTop >= A.value), Q = I.value.length - Ie.length, M = I.value.splice(Q, Ie.length);
            for (const j of M)
              P.has(j.value) || (P.add(j.value), E.value.push(j));
          }
          h.value++;
        }
      }, 0);
    }, Se = (_) => {
      _.forEach((de) => {
        var Q;
        const Ie = ((Q = z.value.filter((M) => M.value === de.value)) == null ? void 0 : Q[0]) || null;
        Ie.selected = !0, x.value.filter((M) => M.value === Ie.value).length || (x.value.push(Ie), I.value.push(Ie));
      }), V();
    }, Be = (_, de = !1) => {
      const Ie = new Set(_.map((Q) => Q.value));
      x.value = x.value.filter((Q) => !Ie.has(Q.value)), I.value = I.value.filter((Q) => !Ie.has(Q.value)), E.value = E.value.filter((Q) => !Ie.has(Q.value)), _.forEach((Q) => {
        if (P.delete(Q.value), Q.selected = !1, E.value.length) {
          const M = E.value.pop();
          M && (I.value.push(M), P.delete(M.value));
        }
        e.enableItemCreation && Q.custom && (z.value = z.value.filter((M) => M.value !== Q.value), s("item-removed", Q));
      }), de && V();
    }, Me = (_, de) => {
      var j, ge;
      let Ie = !1, Q = de ? _ : ((j = z.value.filter(($e) => $e.value === _.value)) == null ? void 0 : j[0]) || null;
      if (e.enableItemCreation && (Q != null && Q.custom) && (Ie = !0), Q === null && (Q = ((ge = x.value.filter(($e) => $e.value === _.value)) == null ? void 0 : ge[0]) || null), Q === null)
        return;
      if (Q.selected) {
        if (x.value = x.value.filter(($e) => $e.value !== _.value), I.value.filter(($e) => $e.value === _.value).length ? I.value = I.value.filter(($e) => $e.value !== _.value) : P.delete(_.value) && (E.value = E.value.filter(($e) => $e.value !== _.value)), Q.selected = !1, E.value.length) {
          const $e = E.value.pop();
          $e && (I.value.push($e), P.delete($e.value));
        }
        Ie && (z.value = z.value.filter(($e) => $e.value !== _.value), s("item-removed", _));
      } else
        Q.selected = !0, x.value.push(Q), I.value.push(Q), de && (Q.custom = !0, z.value.push(Q));
      V();
      const M = x.value.map(($e) => $e.value);
      s("selected", x.value), s("change", Q), s("update:modelValue", M);
    }, Ve = (_) => {
      e.enableItemCreation && wt(), _.preventDefault();
    }, wt = () => {
      var Ie;
      if (!e.enableItemCreation || !F.value || !Z.value || !e.itemCreationValidator(F.value))
        return;
      const _ = z.value.length + 1, de = {
        label: F.value.trim(),
        value: cs(),
        key: `${(Ie = Du(F.value.trim()).replace(/ /gi, "-")) == null ? void 0 : Ie.replace(/[^a-z0-9-_]/gi, "")}-${_}`
      };
      s("item-added", de), Me(de, !0), F.value = "";
    }, vt = () => {
      const _ = pe.value.filter((j) => j.selected), de = pe.value.filter((j) => !j.selected), Ie = [..._, ...de], Q = Ie.filter((j) => !j.group), M = Ie.filter((j) => j.group).sort((j, ge) => j.group.toLowerCase().localeCompare(ge.group.toLowerCase()));
      U.value = [...Q, ...M];
    }, Je = () => {
      z.value.forEach((de) => {
        de.disabled || (de.selected = !1, de.custom && s("item-removed", de));
      }), z.value = z.value.filter((de) => !(de.custom && !de.disabled)), x.value = x.value.filter((de) => de.disabled), I.value = I.value.filter((de) => de.disabled), E.value = E.value.filter((de) => (de.disabled || P.delete(de.value), de.disabled)), F.value = "", V();
      const _ = x.value.map((de) => de.value);
      s("selected", x.value), s("update:modelValue", _), s("query-change", "");
    }, lt = (_) => {
      F.value = _.trim(), s("query-change", _.trim());
    }, xt = (_, de) => {
      var Ie;
      _.keyCode === 27 && (de.value = !1), (_.key === "ArrowDown" || _.key === "ArrowUp") && ((Ie = l.value) == null || Ie.setFocus(_.key === "ArrowDown" ? "down" : "up"));
    }, Lt = () => {
      var _;
      (_ = O.value) == null || _.showPopover();
    }, Xt = (_) => {
      var de;
      (_.key === "ArrowDown" || _.key === "ArrowUp") && ((de = l.value) == null || de.setFocus(_.key === "ArrowDown" ? "down" : "up"));
    }, ra = async () => {
      fe.value = !0, Jt();
    }, Jt = () => {
      q.value || (q.value = !0, s("query-change", ""));
    };
    ie(h, () => {
      setTimeout(() => {
        const _ = T.value;
        if (e.collapsedContext) {
          R.value = o(I.value), K.value = [], C.value++;
          return;
        }
        if (_)
          if (_.clientHeight > A.value) {
            const Ie = I.value.pop();
            Ie && !P.has(Ie.value) && (E.value.push(Ie), P.add(Ie.value)), h.value++;
          } else
            R.value = o(I.value), K.value = o(E.value), C.value++;
      }, 0);
    }), ie(C, async () => {
      O.value && typeof O.value.updatePopper == "function" && (await ht(), O.value.updatePopper());
    }), ie(pe, () => {
      vt();
    }), ie(ve, (_, de) => {
      if (JSON.stringify(_) !== JSON.stringify(de)) {
        if (!_.length) {
          Je();
          return;
        }
        const Ie = new Set(de), Q = new Set(_), M = z.value.filter((ge) => Q.has(ge.value)), j = x.value.filter((ge) => !Q.has(ge.value) && Ie.has(ge.value));
        j.length && Be(j), M.length && Se(M);
      }
    }), ie(() => e.items, (_, de) => {
      var Ie, Q;
      if (JSON.stringify(_) !== JSON.stringify(de)) {
        z.value = o(e.items);
        for (let M = 0; M < z.value.length; M++) {
          z.value[M].selected === void 0 && (z.value[M].selected = !1);
          let j = `${(Q = (Ie = z.value[M].label) == null ? void 0 : Ie.replace(/ /gi, "-")) == null ? void 0 : Q.replace(/[^a-z0-9-_]/gi, "")}-${M}`;
          if (j.includes("undefined") && (j = `multiselect-item-label-${M}`), z.value[M].key = j, e.modelValue.includes(z.value[M].value) || z.value[M].selected) {
            const ge = z.value[M];
            ge.selected = !0, x.value.filter(($e) => $e.value === ge.value).length || x.value.push(ge), I.value.filter(($e) => $e.value === ge.value).length || I.value.push(ge);
          }
        }
        V(), O.value && typeof O.value.updatePopper == "function" && ht(() => {
          O.value.updatePopper();
        });
      }
    }, { deep: !0, immediate: !0 });
    const Mt = N(300), ue = async () => {
      var _;
      Mt.value = 300, await ht(), Mt.value = ((_ = k.value) == null ? void 0 : _.clientWidth) || 300, V();
    }, He = N();
    return it(() => {
      $a("resize", ue), He.value = lr.create(ue), He.value.observe(k.value);
    }), fn(() => {
      He.value && k.value && He.value.unobserve(k.value);
    }), (_, de) => {
      const Ie = qt("KTooltip");
      return m(), $("div", {
        class: ce(["k-multiselect", [_.$attrs.class, { "multiselect-error": e.error }]]),
        style: Oe(tt.value)
      }, [
        e.label ? (m(), X(Ka, Re({ key: 0 }, e.labelAttributes, {
          "data-testid": e.labelAttributes["data-testid"] ? e.labelAttributes["data-testid"] : "multiselect-label",
          for: p.value,
          required: c.value
        }), kt({
          default: L(() => [
            be(re(d.value) + " ", 1)
          ]),
          _: 2
        }, [
          f.value ? {
            name: "tooltip",
            fn: L(() => [
              W(_.$slots, "label-tooltip", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["data-testid", "for", "required"])) : H("", !0),
        Y("div", WF, [
          G(Rl, null, {
            default: L(({ isToggled: Q, toggle: M }) => [
              G(or, Re({
                ref_key: "popper",
                ref: O,
                "hide-close-icon": "",
                offset: D(Yl)
              }, ze.value, {
                onClose: () => he(!1, Q, M),
                onOpen: () => he(!0, Q, M)
              }), {
                content: L(() => [
                  Y("div", {
                    class: "multiselect-list",
                    onClick: de[7] || (de[7] = Ke(() => {
                    }, ["stop"])),
                    onMouseenter: de[8] || (de[8] = () => se.value = !0),
                    onMouseleave: de[9] || (de[9] = () => se.value = !1)
                  }, [
                    !e.collapsedContext && !ae.value ? (m(), $("div", ZF, [
                      G(Nn, {
                        ref: "multiselectDropdownInputElement",
                        autocapitalize: "off",
                        autocomplete: "off",
                        autocorrect: "off",
                        class: "multiselect-dropdown-input",
                        "data-testid": "multiselect-dropdown-input",
                        "model-value": F.value,
                        placeholder: e.searchPlaceholder || az,
                        spellcheck: "false",
                        type: "text",
                        onClick: de[5] || (de[5] = Ke(() => {
                        }, ["stop"])),
                        onFocus: Jt,
                        onKeydown: ct(Ve, ["enter"]),
                        onKeyup: [
                          Xt,
                          de[6] || (de[6] = ct(Ke(() => {
                          }, ["stop"]), ["enter"]))
                        ],
                        "onUpdate:modelValue": lt
                      }, null, 8, ["model-value", "placeholder"])
                    ])) : H("", !0),
                    G(zF, {
                      ref: "kMultiselectItems",
                      "filter-string": F.value,
                      "item-creation-enabled": e.enableItemCreation && Z.value,
                      "item-creation-valid": e.itemCreationValidator(F.value),
                      items: U.value,
                      onAddItem: wt,
                      onSelected: Me
                    }, {
                      content: L(({ item: j }) => [
                        W(_.$slots, "item-template", {
                          class: "multiselect-item",
                          item: j
                        }, void 0, !0)
                      ]),
                      _: 3
                    }, 8, ["filter-string", "item-creation-enabled", "item-creation-valid", "items"]),
                    !U.value.length && !_.$slots.empty && !e.enableItemCreation ? (m(), X(Qo, {
                      key: "multiselect-empty-item",
                      class: "multiselect-empty-item",
                      "data-testid": "multiselect-empty-item",
                      item: { label: "No results", value: "no_results", disabled: !0 }
                    })) : H("", !0),
                    _.$slots.empty && !e.loading && !U.value.length ? (m(), $("div", XF, [
                      W(_.$slots, "empty", {}, void 0, !0)
                    ])) : H("", !0)
                  ], 32),
                  e.dropdownFooterText || _.$slots["dropdown-footer-text"] ? (m(), $("div", {
                    key: 0,
                    class: ce(["dropdown-footer", `dropdown-footer-${e.dropdownFooterTextPosition}`]),
                    "data-testid": "dropdown-footer"
                  }, [
                    W(_.$slots, "dropdown-footer-text", {}, () => [
                      be(re(e.dropdownFooterText), 1)
                    ], !0)
                  ], 2)) : H("", !0)
                ]),
                default: L(() => [
                  Y("div", Re({
                    id: p.value,
                    ref: "multiselectElement",
                    class: ["multiselect-trigger", { focused: fe.value, hovered: se.value, disabled: ne.value, readonly: ae.value }],
                    "data-testid": "multiselect-trigger",
                    role: "listbox",
                    tabindex: ne.value || ae.value || e.collapsedContext ? -1 : 0
                  }, Ae.value, {
                    onClick: me,
                    onKeydown: [
                      ct(Lt, ["enter"]),
                      ct(Lt, ["space"])
                    ]
                  }), [
                    e.collapsedContext ? (m(), $("div", KF, [
                      G(Nn, {
                        autocapitalize: "off",
                        autocomplete: "off",
                        autocorrect: "off",
                        class: ce(["multiselect-input", { "is-readonly": ae.value }]),
                        "data-testid": "multiselect-input",
                        disabled: ne.value,
                        "model-value": F.value,
                        placeholder: et.value,
                        readonly: ae.value ? !0 : void 0,
                        spellcheck: "false",
                        type: "text",
                        onBlur: de[0] || (de[0] = () => fe.value = !1),
                        onClick: (j) => {
                          Q.value && j.stopPropagation();
                        },
                        onFocus: ra,
                        onKeydown: ct(Ve, ["enter"]),
                        onKeyup: (j) => xt(j, Q),
                        onMouseenter: de[1] || (de[1] = () => se.value = !0),
                        onMouseleave: de[2] || (de[2] = () => se.value = !1),
                        "onUpdate:modelValue": lt
                      }, null, 8, ["class", "disabled", "model-value", "placeholder", "readonly", "onClick", "onKeyup"])
                    ])) : x.value.length ? (m(), $("div", {
                      key: 2,
                      class: "selection-badges-container",
                      "data-testid": "selection-badges-container",
                      style: Oe(Xe.value)
                    }, [
                      (m(!0), $(Ee, null, Fe(R.value, (j, ge) => (m(), X(vi, {
                        key: `${D(w)}-${j.key ? j.key : ge}-badge-${C.value}`,
                        appearance: v(j),
                        class: "multiselect-selection-badge",
                        "icon-before": !1,
                        tooltip: j.label,
                        "truncation-tooltip": "",
                        onClick: de[3] || (de[3] = Ke(() => {
                        }, ["stop"]))
                      }, kt({
                        default: L(() => [
                          W(_.$slots, "item-badge-icon", { item: j }, void 0, !0),
                          Y("span", jF, re(j.label), 1)
                        ]),
                        _: 2
                      }, [
                        j.selected && !j.disabled && !ne.value && !ae.value ? {
                          name: "icon",
                          fn: L(() => [
                            Y("button", {
                              "aria-label": `Unselect ${j.label}`,
                              class: "badge-dismiss-button",
                              "data-testid": "badge-dismiss-button",
                              type: "button",
                              onClick: ($e) => Me(j)
                            }, [
                              G(D(ha), { decorative: "" })
                            ], 8, GF)
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["appearance", "tooltip"]))), 128)),
                      K.value.length ? (m(), X(Ie, {
                        key: 0,
                        class: "hidden-selection-count-tooltip",
                        "max-width": "300",
                        text: J.value
                      }, {
                        default: L(() => [
                          G(vi, {
                            appearance: v(),
                            class: "hidden-selection-count",
                            "data-testid": "hidden-selection-count",
                            onClick: de[4] || (de[4] = Ke(() => {
                            }, ["stop"]))
                          }, {
                            default: L(() => [
                              be(" +" + re(K.value.length), 1)
                            ]),
                            _: 1
                          }, 8, ["appearance"])
                        ]),
                        _: 1
                      }, 8, ["text"])) : H("", !0)
                    ], 4)) : (m(), $("div", VF, re(et.value), 1)),
                    Y("div", QF, [
                      !e.loading && x.value.length && Q.value ? (m(), $("button", {
                        key: 0,
                        "aria-label": "Clear",
                        class: "multiselect-clear-icon",
                        "data-testid": "multiselect-clear-icon",
                        type: "button",
                        onClick: Je
                      }, [
                        G(D(ha), { size: D(Qt) }, null, 8, ["size"])
                      ])) : e.loading ? (m(), X(D(Fi), {
                        key: 1,
                        class: "multiselect-loading-icon",
                        size: D(Qt),
                        title: "Loading"
                      }, null, 8, ["size"])) : (m(), X(D(zl), {
                        key: 2,
                        class: "multiselect-chevron-icon",
                        decorative: "",
                        size: D(Qt)
                      }, null, 8, ["size"]))
                    ])
                  ], 16, UF)
                ]),
                _: 2
              }, 1040, ["offset", "onClose", "onOpen"])
            ]),
            _: 3
          })
        ]),
        e.help ? (m(), $("p", JF, re(e.help), 1)) : H("", !0),
        e.collapsedContext ? H("", !0) : (m(), $("div", _F, [
          (m(), $("div", {
            key: h.value,
            ref: "multiselectSelectionsStagingElement",
            class: "selection-badges-container staging",
            style: Oe(Xe.value),
            tabindex: "-1"
          }, [
            (m(!0), $(Ee, null, Fe(I.value, (Q, M) => (m(), X(vi, {
              key: `${D(w)}-${Q.key ? Q.key : M}-badge`,
              "aria-hidden": "true",
              class: "multiselect-selection-badge",
              "icon-before": !1
            }, kt({
              default: L(() => [
                W(_.$slots, "item-badge-icon", { item: Q }, void 0, !0),
                Y("span", ez, re(Q.label), 1)
              ]),
              _: 2
            }, [
              Q.selected && !Q.disabled && !ne.value && !ae.value ? {
                name: "icon",
                fn: L(() => [
                  G(D(ha), { "aria-hidden": "true" })
                ]),
                key: "0"
              } : void 0
            ]), 1024))), 128)),
            G(vi, {
              "aria-hidden": "true",
              class: "hidden-selection-count"
            }, {
              default: L(() => [
                be(" +" + re(E.value.length), 1)
              ]),
              _: 1
            })
          ], 4))
        ]))
      ], 6);
    };
  }
}), rz = /* @__PURE__ */ Pe(nz, [["__scopeId", "data-v-edc1b59c"]]), iz = {
  key: 0,
  class: "prompt-content"
}, oz = { class: "prompt-message" }, lz = {
  key: 1,
  class: "prompt-confirmation-container"
}, sz = { class: "prompt-confirmation-text" }, uz = { class: "confirmation-text" }, cz = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KPrompt",
  props: {
    visible: { type: Boolean },
    title: { default: "" },
    message: { default: "" },
    actionButtonText: { default: "Confirm" },
    actionButtonAppearance: { default: "primary" },
    actionButtonDisabled: { type: Boolean },
    cancelButtonText: { default: "Cancel" },
    cancelButtonAppearance: { default: "tertiary" },
    cancelButtonDisabled: { type: Boolean },
    confirmationText: { default: "" },
    confirmationPrompt: { default: "Type {confirmationText} to confirm your action." },
    modalAttributes: { default: () => ({}) },
    errorMessage: { default: "You must enter the text as indicated above to confirm." }
  },
  emits: ["proceed", "cancel"],
  setup(e, { emit: t }) {
    const a = t, n = $t(), r = na(), i = b(() => {
      const d = Object.assign({}, r);
      return delete d["tabbable-options"], delete d["max-width"], delete d["max-height"], delete d["close-on-backdrop-click"], delete d["input-autofocus"], delete d["hide-close-icon"], delete d["hide-cancel-button"], delete d["full-screen"], d;
    }), o = N(""), u = N(!1), s = b(() => e.actionButtonDisabled ? !0 : e.confirmationText ? e.confirmationText !== o.value : !1), l = b(() => e.confirmationPrompt.split("{confirmationText}")), c = () => {
      s.value ? u.value = !0 : a("proceed");
    };
    return ie(() => e.visible, (d) => {
      d || (o.value = "", u.value = !1);
    }), ie(o, (d) => {
      d && d === e.confirmationText && (u.value = !1);
    }), (d, f) => (m(), X(p1, Re({ ...i.value, ...e.modalAttributes }, {
      "action-button-appearance": e.actionButtonAppearance,
      "action-button-disabled": s.value,
      "action-button-text": e.actionButtonText,
      "cancel-button-appearance": e.cancelButtonAppearance,
      "cancel-button-disabled": e.cancelButtonDisabled,
      "cancel-button-text": e.cancelButtonText,
      class: "k-prompt",
      "input-autofocus": e.modalAttributes.inputAutofocus === void 0 ? !0 : e.modalAttributes.inputAutofocus,
      title: e.title || "Confirm your action",
      visible: e.visible,
      onCancel: f[1] || (f[1] = (v) => a("cancel")),
      onProceed: f[2] || (f[2] = (v) => a("proceed"))
    }), kt({
      default: L(() => [
        n.default || e.message ? (m(), $("div", iz, [
          W(d.$slots, "default", {}, () => [
            Y("p", oz, re(e.message), 1)
          ], !0)
        ])) : H("", !0),
        e.confirmationText ? (m(), $("div", lz, [
          Y("p", sz, [
            be(re(l.value[0]) + " ", 1),
            Y("span", uz, '"' + re(e.confirmationText) + '"', 1),
            be(" " + re(l.value[1] ? l.value[1] : ""), 1)
          ]),
          G(Nn, {
            modelValue: o.value,
            "onUpdate:modelValue": f[0] || (f[0] = (v) => o.value = v),
            "aria-label": `${l.value[0]}'${e.confirmationText}'${l.value[1] ? l.value[1] : ""}`,
            autocapitalize: "off",
            autocomplete: "off",
            "data-testid": "confirmation-input",
            error: u.value,
            "error-message": e.errorMessage,
            onKeydown: ct(Ke(c, ["prevent"]), ["enter"])
          }, null, 8, ["modelValue", "aria-label", "error", "error-message", "onKeydown"])
        ])) : H("", !0)
      ]),
      _: 2
    }, [
      n.title ? {
        name: "title",
        fn: L(() => [
          W(d.$slots, "title", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["action-button-appearance", "action-button-disabled", "action-button-text", "cancel-button-appearance", "cancel-button-disabled", "cancel-button-text", "input-autofocus", "title", "visible"]));
  }
}), dz = /* @__PURE__ */ Pe(cz, [["__scopeId", "data-v-6fbede40"]]), fz = ["id", "aria-checked", "checked", "disabled", "tabindex"], vz = {
  key: 0,
  class: "radio-description"
}, hz = ["data-testid", "for", "tabindex"], gz = {
  key: 0,
  class: "card-content-wrapper"
}, mz = {
  key: 1,
  class: "card-label-container"
}, pz = {
  key: 0,
  class: "radio-label"
}, yz = {
  key: 1,
  class: "radio-description"
}, bz = {
  inheritAttrs: !1
}, wz = /* @__PURE__ */ oe({
  ...bz,
  __name: "KRadio",
  props: {
    modelValue: {},
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    description: { default: "" },
    selectedValue: {},
    error: { type: Boolean },
    card: { type: Boolean },
    cardRadioVisible: { type: Boolean, default: !0 },
    cardOrientation: { default: "vertical" },
    type: { default: "" }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    ie(() => e.labelAttributes, (g) => {
      g.help && console.warn("KRadio: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { deep: !0, immediate: !0 }), ie(() => e.type, (g) => {
      g && console.warn("KRadio: `type` prop is deprecated. Please use `card` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kradio");
    }, { immediate: !0 });
    const a = t, n = $t(), r = na(), i = yt(), o = b(() => r.id ? String(r.id) : i), u = b(() => (r == null ? void 0 : r.disabled) !== void 0 && String(r == null ? void 0 : r.disabled) !== "false"), s = b(() => !!(e.label || n.default)), l = b(() => s.value && (!!e.description || !!n.description)), c = b(() => !!e.label && (!!e.description || !!n.description)), d = b(() => !!n.tooltip), f = b(() => e.selectedValue === e.modelValue), v = () => {
      a("change", e.selectedValue), a("update:modelValue", e.selectedValue);
    }, y = b(() => {
      const g = { ...r };
      return delete g.class, g;
    }), C = b(() => ({
      disabled: u.value,
      "radio-card": e.card || e.type === "card",
      "input-error": e.error,
      checked: f.value,
      "has-description": l.value,
      "card-horizontal": e.card && e.cardOrientation === "horizontal",
      // Add vertical class for `vertical` or an invalid prop value
      "card-vertical": e.card && e.cardOrientation !== "horizontal"
    })), h = b(() => e.card && r["data-testid"] ? `${r["data-testid"]}-label` : void 0);
    return (g, p) => {
      const w = qt("KTooltip");
      return m(), $("div", {
        class: ce(["k-radio", [
          g.$attrs.class ? g.$attrs.class : "",
          C.value
        ]])
      }, [
        Y("input", Re({ id: o.value }, y.value, {
          "aria-checked": f.value,
          checked: f.value,
          class: ["radio-input", { hidden: e.card && !e.cardRadioVisible }],
          disabled: u.value,
          tabindex: e.card || u.value || f.value ? -1 : 0,
          type: "radio",
          onClick: v
        }), null, 16, fz),
        !e.card && (e.label || g.$slots.default) ? (m(), $("div", {
          key: 0,
          class: ce(["radio-label-wrapper", { "has-description": l.value }])
        }, [
          G(Ka, Re(e.labelAttributes, {
            class: "radio-label",
            for: o.value
          }), kt({
            default: L(() => [
              W(g.$slots, "default", {}, () => [
                be(re(e.label), 1)
              ], !0)
            ]),
            _: 2
          }, [
            d.value ? {
              name: "tooltip",
              fn: L(() => [
                W(g.$slots, "tooltip", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["for"]),
          l.value ? (m(), $("div", vz, [
            W(g.$slots, "description", {}, () => [
              Y("p", null, re(e.description), 1)
            ], !0)
          ])) : H("", !0)
        ], 2)) : e.label || g.$slots.default ? (m(), $("label", {
          key: 1,
          class: ce(["radio-card-wrapper radio-label-wrapper", { "has-label": e.label, "has-description": c.value, "show-radio": e.cardRadioVisible }]),
          "data-testid": h.value,
          for: o.value,
          tabindex: u.value || f.value ? -1 : 0,
          onKeydown: p[0] || (p[0] = ct(Ke(() => {
          }, ["prevent"]), ["space"])),
          onKeyup: ct(v, ["space"])
        }, [
          g.$slots.default ? (m(), $("span", gz, [
            W(g.$slots, "default", {}, void 0, !0)
          ])) : H("", !0),
          e.label || c.value ? (m(), $("span", mz, [
            e.label ? (m(), $("span", pz, [
              be(re(e.label) + " ", 1),
              n.tooltip ? (m(), X(w, {
                key: 0,
                class: "label-tooltip"
              }, {
                content: L(() => [
                  W(g.$slots, "tooltip", {}, void 0, !0)
                ]),
                default: L(() => [
                  G(D(En), {
                    class: "tooltip-trigger-icon",
                    color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                    tabindex: "0"
                  }, null, 8, ["color"])
                ]),
                _: 3
              })) : H("", !0)
            ])) : H("", !0),
            c.value ? (m(), $("span", yz, [
              W(g.$slots, "description", {}, () => [
                be(re(e.description), 1)
              ], !0)
            ])) : H("", !0)
          ])) : H("", !0)
        ], 42, hz)) : H("", !0)
      ], 2);
    };
  }
}), Cz = /* @__PURE__ */ Pe(wz, [["__scopeId", "data-v-3fb0c380"]]), kz = ["aria-selected", "data-testid"], $z = { class: "select-item-container" }, Sz = ["disabled", "value"], xz = { class: "select-item-label" }, Tz = /* @__PURE__ */ oe({
  __name: "KSelectItem",
  props: {
    item: {}
  },
  emits: ["selected", "arrow-down", "arrow-up"],
  setup(e, { emit: t }) {
    const a = t, n = (r) => {
      if (e.item.disabled) {
        r.stopPropagation();
        return;
      }
      a("selected", e.item);
    };
    return (r, i) => (m(), $("div", {
      key: e.item.key,
      "aria-selected": e.item.selected,
      class: "select-item",
      "data-testid": `select-item-${e.item.value}`,
      role: "option"
    }, [
      Y("div", $z, [
        Y("button", {
          class: ce({ selected: e.item.selected }),
          disabled: e.item.disabled === !0 ? !0 : void 0,
          type: "button",
          value: e.item.value,
          onClick: n,
          onKeydown: [
            i[0] || (i[0] = ct(Ke((o) => r.$emit("arrow-down"), ["prevent"]), ["down"])),
            i[1] || (i[1] = ct(Ke((o) => r.$emit("arrow-up"), ["prevent"]), ["up"]))
          ]
        }, [
          Y("span", xz, [
            W(r.$slots, "content", {}, () => [
              be(re(e.item.label), 1)
            ], !0)
          ])
        ], 42, Sz)
      ])
    ], 8, kz));
  }
}), Zo = /* @__PURE__ */ Pe(Tz, [["__scopeId", "data-v-11bc36aa"]]), Dz = { ref: "itemsContainer" }, Az = { class: "select-group-title" }, Iz = { class: "select-item-description" }, Hh = ".select-item button:not(:disabled)", Ez = '.select-item[aria-selected="true"] button:not(:disabled)', Mz = /* @__PURE__ */ oe({
  __name: "KSelectItems",
  props: {
    items: { default: () => [] },
    itemCreationEnabled: { type: Boolean },
    filterString: { default: "" },
    itemCreationValid: { type: Boolean, default: !0 }
  },
  emits: ["selected", "add-item"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = (d) => n("selected", d), i = b(() => {
      var d;
      return (d = e.items) == null ? void 0 : d.filter((f) => !f.group);
    }), o = b(() => {
      var d, f;
      return [...new Set((f = (d = e.items) == null ? void 0 : d.filter((v) => v.group)) == null ? void 0 : f.map((v) => v.group))].sort((v, y) => v.toLowerCase().localeCompare(y.toLowerCase()));
    }), u = (d) => {
      var f;
      return (f = e.items) == null ? void 0 : f.filter((v) => v.group === d);
    }, s = dt("itemsContainer"), l = (d) => {
      var C, h;
      const f = s.value;
      if (!f)
        return;
      const v = f.querySelectorAll(Hh);
      if (!(v != null && v.length))
        return;
      const y = f.querySelector(Ez);
      if (y) {
        const g = [...v].indexOf(y);
        (C = v[d === "down" ? g + 1 : g - 1]) == null || C.focus();
      } else
        (h = v[d === "down" ? 0 : v.length - 1]) == null || h.focus();
    }, c = ({ target: d, key: f }) => {
      var v;
      if (f === "ArrowDown" || f === "ArrowUp") {
        const y = (v = s.value) == null ? void 0 : v.querySelectorAll(Hh);
        if (y != null && y.length) {
          const C = [...y].indexOf(d), h = f === "ArrowDown" ? C + 1 : C - 1, g = y[h];
          g == null || g.focus();
        }
      }
    };
    return t({ setFocus: l }), (d, f) => (m(), $("div", Dz, [
      (m(!0), $(Ee, null, Fe(i.value, (v) => (m(), X(Zo, {
        key: v.key,
        item: v,
        onKeydown: c,
        onSelected: r
      }, {
        content: L(() => [
          W(d.$slots, "content", { item: v }, void 0, !0)
        ]),
        _: 2
      }, 1032, ["item"]))), 128)),
      (m(!0), $(Ee, null, Fe(o.value, (v) => (m(), $("div", {
        key: `${v}-group`,
        class: "select-group",
        "data-propagate-clicks": "false"
      }, [
        Y("span", Az, re(v), 1),
        (m(!0), $(Ee, null, Fe(u(v), (y) => (m(), X(Zo, {
          key: y.key,
          item: y,
          onKeydown: c,
          onSelected: r
        }, {
          content: L(() => [
            W(d.$slots, "content", { item: y }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["item"]))), 128))
      ]))), 128)),
      e.itemCreationEnabled ? (m(), X(Zo, {
        key: "select-add-item",
        class: "select-add-item",
        "data-testid": "select-add-item",
        item: { label: `${e.filterString} (Add new value)`, value: "add_item", disabled: !e.itemCreationValid },
        onKeydown: c,
        onSelected: f[0] || (f[0] = (v) => d.$emit("add-item"))
      }, {
        content: L(() => [
          Y("div", Iz, [
            be(re(e.filterString) + " ", 1),
            f[1] || (f[1] = Y("span", { class: "select-item-new-indicator" }, "(Add new value)", -1))
          ])
        ]),
        _: 1
      }, 8, ["item"])) : H("", !0)
    ], 512));
  }
}), Oz = /* @__PURE__ */ Pe(Mz, [["__scopeId", "data-v-2f823fac"]]), Pz = ["id"], Nz = ["aria-live"], Lz = {
  key: 0,
  class: "select-loading",
  "data-propagate-clicks": "false",
  "data-testid": "select-loading"
}, Bz = {
  key: 1,
  class: "select-items-container",
  "data-propagate-clicks": "false"
}, Rz = {
  key: 1,
  class: "dropdown-footer dropdown-footer-static"
}, Fz = {
  key: 2,
  class: "select-empty",
  "data-propagate-clicks": "false"
}, zz = {
  key: 0,
  class: "dropdown-footer dropdown-footer-sticky"
}, Yz = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KSelect",
  props: {
    modelValue: { default: "" },
    kpopAttributes: { default: () => ({}) },
    dropdownMaxHeight: { default: "300px" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    width: { default: "100%" },
    placeholder: { default: "" },
    items: { default: () => [] },
    enableFiltering: { type: Boolean },
    filterFunction: { default: () => ((e) => {
      var t;
      return (t = e.items) == null ? void 0 : t.filter((a) => {
        var n, r;
        return (r = a.label) == null ? void 0 : r.toLowerCase().includes((n = e.query) == null ? void 0 : n.toLowerCase());
      });
    }) },
    loading: { type: Boolean },
    clearable: { type: Boolean },
    dropdownFooterText: { default: "" },
    dropdownFooterTextPosition: { default: "sticky" },
    reuseItemTemplate: { type: Boolean },
    enableItemCreation: { type: Boolean },
    itemCreationValidator: { type: Function, default: () => !0 },
    error: { type: Boolean },
    help: { default: "" }
  },
  emits: ["selected", "input", "change", "update:modelValue", "query-change", "item-added", "item-removed"],
  setup(e, { emit: t }) {
    Wt((V) => ({
      v7a089d98: U.value,
      v4d446bc6: x.value,
      v549311c9: P.value
    }));
    const { stripRequiredLabel: a } = Bn(), n = t, r = na(), i = $t(), o = yt(), u = b(() => r.id ? String(r.id) : o), s = N(!1), l = N(), c = b(() => {
      var V;
      return !!((V = e.labelAttributes) != null && V.info || i["label-tooltip"]);
    }), d = b(() => r.required !== void 0 && String(r.required) !== "false"), f = b(() => r.disabled !== void 0 && String(r.disabled) !== "false"), v = b(() => r.readonly !== void 0 && String(r.readonly) !== "false"), y = {
      popoverClasses: `k-select-popover select-popover ${e.dropdownFooterText || i["dropdown-footer-text"] ? `has-${e.dropdownFooterTextPosition}-dropdown-footer` : ""}`,
      popoverTimeout: 0,
      placement: "bottom-start",
      hideCaret: !0
    }, C = N(0), h = dt("inputElement"), g = b(() => a(e.label, d.value)), p = N(!1), w = N(""), k = b(() => {
      var V, Se;
      return !(!w.value || (Se = (V = A.value) == null ? void 0 : V.filter((Be) => Be.label === w.value)) != null && Se.length);
    }), S = yt(), T = N(null), A = N([]), F = N(!1), Z = dt("popperElement"), O = dt("selectWrapperElement"), z = b({
      get() {
        return e.modelValue;
      },
      set(V) {
        var Be;
        const Se = (Be = A.value) == null ? void 0 : Be.filter((Me) => Me.value === V);
        Se != null && Se.length ? ve(Se[0]) : V || Ae();
      }
    }), U = b(() => It(e.width || "100%")), x = N(""), I = b(() => {
      const V = { ...r };
      return delete V.class, V;
    }), E = b(() => {
      var V;
      return {
        ...y,
        ...e.kpopAttributes,
        popoverClasses: `${y.popoverClasses} ${((V = e.kpopAttributes) == null ? void 0 : V.popoverClasses) ?? ""}`,
        width: String(x.value),
        maxWidth: String(x.value),
        disabled: f.value || v.value
      };
    }), P = b(() => It(e.dropdownMaxHeight)), R = b(() => ({ ...E.value })), K = b(() => e.placeholder || r.placeholder || "Select..."), J = b(() => !f.value && e.clearable && !!T.value), q = b(() => !!(T.value && (i["selected-item-template"] || e.reuseItemTemplate && i["item-template"]))), se = b(() => {
      let V = [];
      if (!e.enableFiltering || !w.value)
        V = A.value;
      else {
        const Me = e.filterFunction({ query: w.value, items: A.value });
        V = Me === !0 ? A.value : Me;
      }
      const Se = V.filter((Me) => !Me.group), Be = V.filter((Me) => Me.group).sort((Me, Ve) => Me.group.toLowerCase().localeCompare(Ve.group.toLowerCase()));
      return [...Se, ...Be];
    }), fe = (V) => {
      if (!e.enableFiltering)
        return V.preventDefault(), !1;
    }, ne = (V) => {
      e.enableItemCreation && ae(), V.preventDefault();
    }, ae = () => {
      var Be, Me;
      if (!e.enableItemCreation || !w.value || !k.value || !e.itemCreationValidator(w.value))
        return;
      const V = (((Be = A.value) == null ? void 0 : Be.length) || 0) + 1, Se = {
        label: Du(w.value),
        value: cs(),
        key: `${(Me = Du(w.value).replace(/ /gi, "-")) == null ? void 0 : Me.replace(/[^a-z0-9-_]/gi, "")}-${V}`,
        custom: !0
      };
      n("item-added", Se), ve(Se, !0), w.value = "";
    }, ve = (V, Se) => {
      var Be, Me;
      Se && ((Be = A.value) == null || Be.push(V)), (Me = A.value) == null || Me.forEach((Ve, wt) => {
        var vt;
        Ve.key === V.key ? (Ve.selected = !0, T.value = Ve) : Ve.selected ? (Ve.selected = !1, Ve.custom && ((vt = A.value) == null || vt.splice(wt, 1), n("item-removed", Ve))) : Ve.selected = !1;
      }), p.value = !0, w.value = V.label;
    }, Ae = () => {
      var V;
      (V = A.value) == null || V.forEach((Se, Be) => {
        var Me;
        Se.selected = !1, Se.custom && ((Me = A.value) == null || Me.splice(Be, 1), n("item-removed", Se));
      }), T.value = null, w.value = "", n("input", null), n("change", null), n("update:modelValue", null);
    }, Te = dt("kSelectItems"), Le = (V, Se) => {
      var Me, Ve;
      if (V.keyCode === 27) {
        Se.value = !1;
        return;
      }
      const Be = (Me = O.value) == null ? void 0 : Me.children[0];
      !Se.value && Be && Be.click(), (V.key === "ArrowDown" || V.key === "ArrowUp") && Se.value && ((Ve = Te.value) == null || Ve.setFocus(V.key === "ArrowDown" ? "down" : "up"));
    }, ze = (V) => {
      w.value !== V && (w.value = V);
    }, _e = () => {
      F.value = !0;
    }, tt = () => {
      F.value = !1;
    }, Xe = () => {
      var V, Se, Be;
      e.enableFiltering || (Be = (Se = (V = h.value) == null ? void 0 : V.$el) == null ? void 0 : Se.querySelector("input")) == null || Be.blur();
    }, et = (V) => {
      var Se;
      (f.value || ((Se = V == null ? void 0 : V.target) == null ? void 0 : Se.dataset.propagateClicks) === "false") && V.stopPropagation();
    }, pe = (V) => {
      V();
    }, me = (V, Se) => {
      s.value = !1, T.value ? (p.value = !0, w.value = T.value.label) : w.value = "", Se && V();
    }, he = (V) => {
      s.value = !0, e.enableFiltering && (w.value = ""), V();
    };
    return ie(z, (V, Se) => {
      var Be;
      if (V !== Se) {
        const Me = (Be = A.value) == null ? void 0 : Be.filter((Ve) => Ve.value === V);
        Me != null && Me.length ? ve(Me[0]) : V || Ae();
      }
    }), ie(() => e.items, (V, Se) => {
      var Be, Me, Ve, wt, vt;
      if (JSON.stringify(V) !== JSON.stringify(Se)) {
        A.value = JSON.parse(JSON.stringify(e.items)), (Be = A.value) != null && Be.length && (T.value = null);
        for (let Je = 0; Je < ((Me = A.value) == null ? void 0 : Me.length); Je++) {
          A.value[Je].selected === void 0 && (A.value[Je].selected = !1);
          let lt = `${(wt = (Ve = A.value[Je].label) == null ? void 0 : Ve.replace(/ /gi, "-")) == null ? void 0 : wt.replace(/[^a-z0-9-_]/gi, "")}-${Je}`;
          lt.includes("undefined") && (lt = `select-item-label-${Je}`), A.value[Je].key = lt, (A.value[Je].value === e.modelValue || A.value[Je].selected) && (A.value[Je].selected = !0, T.value = A.value[Je], F.value || (p.value = !0, w.value = T.value.label)), ((vt = T.value) == null ? void 0 : vt.value) === A.value[Je].value && (A.value[Je].selected = !0);
        }
        Z.value && typeof Z.value.updatePopper == "function" && ht(() => {
          Z.value.updatePopper();
        });
      }
    }, { deep: !0, immediate: !0 }), ie(w, (V) => {
      p.value && V || (n("query-change", V), p.value = !1);
    }), ie(T, (V, Se) => {
      V && V !== Se && (n("selected", V), n("input", V.value), n("change", V), n("update:modelValue", V.value));
    }, { deep: !0 }), it(() => {
      O.value && (l.value = lr.create(() => {
        var V;
        x.value = `${(V = O.value) == null ? void 0 : V.offsetWidth}px`;
      }), l.value.observe(O.value)), $a(document, "keydown", (V) => {
        var Se, Be;
        !e.enableFiltering && ((Se = document.activeElement) == null ? void 0 : Se.tagName) === "BODY" && !F.value && s.value && (V.key === "ArrowDown" || V.key === "ArrowUp") && (V.preventDefault(), (Be = Te.value) == null || Be.setFocus(V.key === "ArrowDown" ? "down" : "up"));
      });
    }), fn(() => {
      var V;
      O.value && ((V = l.value) == null || V.unobserve(O.value));
    }), (V, Se) => (m(), $("div", {
      class: ce(["k-select", [V.$attrs.class]])
    }, [
      e.label ? (m(), X(Ka, Re({
        key: 0,
        "data-testid": "select-label"
      }, e.labelAttributes, {
        for: u.value,
        required: d.value
      }), kt({
        default: L(() => [
          be(re(g.value) + " ", 1)
        ]),
        _: 2
      }, [
        c.value ? {
          name: "tooltip",
          fn: L(() => [
            W(V.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : H("", !0),
      G(Rl, null, {
        default: L(({ toggle: Be, isToggled: Me }) => [
          G(or, Re({ ref: "popperElement" }, R.value, {
            "close-on-popover-click": "",
            "hide-close-icon": "",
            offset: D(Yl),
            onClose: () => me(Be, Me.value),
            onOpen: () => he(Be),
            onPopoverClick: () => pe(Be)
          }), {
            content: L(() => [
              Y("div", {
                "aria-live": e.enableFiltering ? "polite" : "off"
              }, [
                e.enableFiltering && e.loading ? (m(), $("div", Lz, [
                  W(V.$slots, "loading", {}, () => [
                    G(D(Fi), {
                      class: "loading-icon",
                      title: "Loading"
                    })
                  ], !0)
                ])) : (m(), $("div", Bz, [
                  G(Oz, {
                    ref: "kSelectItems",
                    "filter-string": w.value,
                    "item-creation-enabled": e.enableItemCreation && k.value,
                    "item-creation-valid": e.itemCreationValidator(w.value),
                    items: se.value,
                    onAddItem: ae,
                    onSelected: ve
                  }, {
                    content: L(({ item: Ve }) => [
                      W(V.$slots, "item-template", { item: Ve }, void 0, !0)
                    ]),
                    _: 3
                  }, 8, ["filter-string", "item-creation-enabled", "item-creation-valid", "items"]),
                  !se.value.length && !V.$slots.empty && !e.enableItemCreation ? (m(), X(Zo, {
                    key: 0,
                    item: { label: "No results", value: "no_results", disabled: !0 }
                  })) : H("", !0),
                  (e.dropdownFooterText || V.$slots["dropdown-footer-text"]) && e.dropdownFooterTextPosition === "static" ? (m(), $("div", Rz, [
                    W(V.$slots, "dropdown-footer-text", {}, () => [
                      be(re(e.dropdownFooterText), 1)
                    ], !0)
                  ])) : H("", !0)
                ])),
                !e.loading && !se.value.length && V.$slots.empty ? (m(), $("div", Fz, [
                  W(V.$slots, "empty", {}, void 0, !0)
                ])) : H("", !0)
              ], 8, Nz),
              (e.dropdownFooterText || V.$slots["dropdown-footer-text"]) && e.dropdownFooterTextPosition === "sticky" ? (m(), $("div", zz, [
                W(V.$slots, "dropdown-footer-text", {}, () => [
                  be(re(e.dropdownFooterText), 1)
                ], !0)
              ])) : H("", !0)
            ]),
            default: L(() => [
              Y("div", {
                id: D(S),
                ref: "selectWrapperElement",
                class: "select-wrapper",
                "data-testid": "select-wrapper",
                role: "listbox",
                onClick: et
              }, [
                (m(), X(Nn, Re({
                  id: u.value,
                  key: C.value,
                  ref: "inputElement",
                  autocapitalize: "off",
                  autocomplete: "off",
                  autocorrect: "off",
                  class: ["select-input", { "filtering-disabled": !e.enableFiltering, "hide-model-value": q.value && (!e.enableFiltering || !Me.value), "input-has-focus": F.value || Me.value }],
                  "data-testid": "select-input",
                  disabled: f.value,
                  error: e.error,
                  "model-value": w.value,
                  placeholder: T.value && !e.enableFiltering ? T.value.label : K.value,
                  readonly: v.value,
                  spellcheck: "false"
                }, I.value, {
                  onBlur: tt,
                  onClick: Xe,
                  onFocus: _e,
                  onKeydown: ct(ne, ["enter"]),
                  onKeypress: fe,
                  onKeyup: [
                    (Ve) => Le(Ve, Me),
                    Se[0] || (Se[0] = ct(Ke(() => {
                    }, ["stop"]), ["enter"]))
                  ],
                  "onUpdate:modelValue": ze
                }), kt({
                  after: L(() => [
                    J.value ? (m(), $("button", {
                      key: 0,
                      "aria-label": "Clear",
                      class: "clear-selection-button",
                      "data-testid": "clear-selection-icon",
                      type: "button",
                      onClick: Ae
                    }, [
                      G(D(ha), { decorative: "" })
                    ])) : H("", !0),
                    v.value ? H("", !0) : (m(), X(D(zl), {
                      key: 1,
                      class: ce(["chevron-down-icon", { disabled: f.value }]),
                      decorative: ""
                    }, null, 8, ["class"]))
                  ]),
                  _: 2
                }, [
                  i.before ? {
                    name: "before",
                    fn: L(() => [
                      W(V.$slots, "before", {}, void 0, !0)
                    ]),
                    key: "0"
                  } : void 0,
                  V.$slots["label-tooltip"] ? {
                    name: "label-tooltip",
                    fn: L(() => [
                      W(V.$slots, "label-tooltip", {}, void 0, !0)
                    ]),
                    key: "1"
                  } : void 0
                ]), 1040, ["id", "class", "disabled", "error", "model-value", "placeholder", "readonly", "onKeyup"])),
                G(ea, { name: "kongponents-fade-transition" }, {
                  default: L(() => [
                    q.value && (!e.enableFiltering || !Me.value) ? (m(), $("div", {
                      key: 0,
                      class: ce(["custom-selected-item-wrapper", { clearable: e.clearable, readonly: v.value }])
                    }, [
                      W(V.$slots, "selected-item-template", {
                        item: T.value
                      }, () => [
                        W(V.$slots, "item-template", {
                          item: T.value
                        }, void 0, !0)
                      ], !0)
                    ], 2)) : H("", !0)
                  ]),
                  _: 2
                }, 1024)
              ], 8, Pz)
            ]),
            _: 2
          }, 1040, ["offset", "onClose", "onOpen", "onPopoverClick"])
        ]),
        _: 3
      }),
      e.help ? (m(), $("p", {
        key: 1,
        class: ce(["help-text", { "select-error": e.error }])
      }, re(e.help), 3)) : H("", !0)
    ], 2));
  }
}), Hz = /* @__PURE__ */ Pe(Yz, [["__scopeId", "data-v-3209f347"]]), qz = { class: "k-slideout" }, Wz = {
  key: 0,
  ref: "slideoutContainerElement",
  class: "slideout-container",
  "data-testid": "slideout-container"
}, Uz = { class: "slideout-header" }, Kz = {
  key: 0,
  class: "slideout-title",
  "data-testid": "slideout-title"
}, Vz = { class: "slideout-content" }, jz = /* @__PURE__ */ oe({
  __name: "KSlideout",
  props: {
    visible: { type: Boolean },
    hasOverlay: { type: Boolean, default: !0 },
    offsetTop: { default: 0 },
    closeOnBlur: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    title: { default: "" },
    maxWidth: { default: "500px" },
    zIndex: { default: 9999 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    Wt((u) => ({
      fe411dca: r.value,
      v097e7e0e: u.maxWidth,
      v3afc0278: u.zIndex
    }));
    const a = t, n = dt("slideoutContainerElement"), r = b(() => It(e.offsetTop));
    u0(n, (u) => {
      u.isTrusted && e.closeOnBlur && a("close");
    });
    const i = (u, s = !1) => {
      (e.visible && u.keyCode === 27 && e.closeOnEscape || s) && a("close");
    }, o = (u) => {
      typeof document < "u" && (u ? document == null || document.addEventListener("keydown", i) : document == null || document.removeEventListener("keydown", i));
    };
    return ie(() => e.visible, async (u) => {
      o(!!u);
    }, { immediate: !0 }), ya(() => {
      o(!1);
    }), (u, s) => (m(), $("div", qz, [
      G(ea, { name: "kongponents-fade-transition" }, {
        default: L(() => [
          e.visible ? (m(), $("div", {
            key: 0,
            class: ce(["slideout-backdrop", { "backdrop-transparent": !e.hasOverlay }])
          }, null, 2)) : H("", !0)
        ]),
        _: 1
      }),
      G(ea, { name: "kongponents-slide-in-transition" }, {
        default: L(() => [
          e.visible ? (m(), $("div", Wz, [
            Y("div", Uz, [
              e.title || u.$slots.title ? (m(), $("div", Kz, [
                W(u.$slots, "title", {}, () => [
                  be(re(e.title), 1)
                ], !0)
              ])) : H("", !0),
              Y("button", {
                "aria-label": "Close",
                class: "slideout-close-icon",
                "data-testid": "slideout-close-icon",
                type: "button",
                onClick: s[0] || (s[0] = Ke((l) => u.$emit("close"), ["stop"]))
              }, [
                G(D(ha), {
                  color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                  decorative: ""
                }, null, 8, ["color"])
              ])
            ]),
            Y("div", Vz, [
              W(u.$slots, "default", {}, void 0, !0)
            ])
          ], 512)) : H("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Gz = /* @__PURE__ */ Pe(jz, [["__scopeId", "data-v-39542e53"]]), Qz = ["aria-current", "data-testid"], Zz = { class: "step-circle" }, Xz = /* @__PURE__ */ oe({
  __name: "KStep",
  props: {
    label: {},
    state: { default: "default" },
    maxLabelWidth: {}
  },
  setup(e) {
    const t = b(() => ({
      maxWidth: It(e.maxLabelWidth)
    }));
    return (a, n) => (m(), $("li", {
      "aria-current": e.state === "active" ? "step" : "false",
      class: "step",
      "data-testid": `step-${e.state}`
    }, [
      Y("div", {
        class: ce(["step-container", `${e.state}`])
      }, [
        Y("div", Zz, [
          e.state === "completed" ? (m(), X(D(oy), {
            key: 0,
            color: `var(--kui-color-text-inverse, ${D(au)})`,
            size: D(Qt),
            title: "Completed"
          }, null, 8, ["color", "size"])) : e.state === "pending" ? (m(), X(D(Fi), {
            key: 1,
            color: `var(--kui-color-text-primary, ${D(kg)})`,
            size: D(Qt),
            title: "Pending"
          }, null, 8, ["color", "size"])) : e.state === "error" ? (m(), X(D(ha), {
            key: 2,
            color: `var(--kui-color-text-inverse, ${D(au)})`,
            size: D(Qt),
            title: "Error"
          }, null, 8, ["color", "size"])) : H("", !0)
        ]),
        Y("span", {
          class: "step-label",
          style: Oe(t.value)
        }, re(e.label), 5)
      ], 2)
    ], 8, Qz));
  }
}), Jz = /* @__PURE__ */ Pe(Xz, [["__scopeId", "data-v-e91d1bd8"]]), _z = {
  key: 0,
  class: "k-stepper"
}, eY = /* @__PURE__ */ oe({
  __name: "KStepper",
  props: {
    steps: {},
    maxLabelWidth: { default: "170px" }
  },
  setup(e) {
    return (t, a) => e.steps && e.steps.length ? (m(), $("ol", _z, [
      (m(!0), $(Ee, null, Fe(e.steps, (n) => (m(), X(Jz, {
        key: `step-${n.label.replace(/ /gi, "-")}`,
        label: n.label,
        "max-label-width": e.maxLabelWidth,
        state: n.state
      }, null, 8, ["label", "max-label-width", "state"]))), 128))
    ])) : H("", !0);
  }
}), tY = /* @__PURE__ */ Pe(eY, [["__scopeId", "data-v-5d71bb60"]]), aY = { class: "table-column-visibility-menu" }, nY = { class: "apply-button-wrapper" }, rY = /* @__PURE__ */ oe({
  __name: "ColumnVisibilityMenu",
  props: {
    columns: {},
    tableId: {},
    visibilityPreferences: {},
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const a = t, n = N(!1), r = N({}), i = N(!1), o = N(), u = N(""), s = () => {
      r.value = e.columns.reduce((y, C) => (y[C.key] = e.visibilityPreferences[C.key] === void 0 ? !0 : e.visibilityPreferences[C.key], y), {}), i.value = !1;
    }, l = YF((y) => {
      u.value = y, o.value && v(o.value);
    }, 500), c = b(() => u.value ? e.columns.filter((y) => (y.label ? y.label : y.key).toLowerCase().includes(u.value.toLowerCase())) : e.columns), d = () => {
      a("update", JSON.parse(JSON.stringify(r.value))), i.value = !1, u.value = "";
    }, f = (y) => {
      n.value = y, y && o.value && ht(() => {
        o.value && v(o.value);
      }), !y && i.value && s(), y || (u.value = "");
    }, v = (y) => {
      if (!(y.scrollHeight > y.clientHeight)) {
        y.classList.remove("is-bottom-overflowing");
        return;
      }
      const h = y.scrollHeight < y.clientHeight + y.scrollTop + 1;
      y.classList.toggle("is-bottom-overflowing", !h);
    };
    return ie(() => e.visibilityPreferences, () => {
      s();
    }, { immediate: !0 }), it(() => {
      o.value && (o.value.addEventListener("scroll", (y) => {
        const C = y.currentTarget;
        v(C);
      }), v(o.value));
    }), W1(() => {
      s();
    }), (y, C) => (m(), $("div", aY, [
      G(Fr, {
        "data-testid": "table-column-visibility-menu",
        disabled: e.disabled,
        "kpop-attributes": { placement: "bottom-end" },
        onToggleDropdown: f
      }, {
        items: L(() => [
          u.value || c.value.length > 5 ? (m(), X(Nn, {
            key: 0,
            modelValue: u.value,
            "onUpdate:modelValue": C[1] || (C[1] = (h) => u.value = h),
            modelModifiers: { trim: !0 },
            autocomplete: "off",
            class: "search-input",
            "data-testid": "search-input",
            placeholder: "Search columns",
            type: "search",
            onClick: C[2] || (C[2] = Ke(() => {
            }, ["stop"])),
            onInput: D(l)
          }, kt({
            before: L(() => [
              G(D(zu), { decorative: "" })
            ]),
            _: 2
          }, [
            u.value ? {
              name: "after",
              fn: L(() => [
                G(rt, {
                  appearance: "tertiary",
                  "aria-label": "Clear search",
                  class: "clear-search",
                  "data-testid": "clear-search-button",
                  icon: "",
                  size: "small",
                  onClick: C[0] || (C[0] = Ke(() => u.value = "", ["stop"]))
                }, {
                  default: L(() => [
                    G(D(ha), { decorative: "" })
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "onInput"])) : H("", !0),
          Y("div", {
            ref_key: "menuItemsRef",
            ref: o,
            class: "menu-items-wrapper"
          }, [
            (m(!0), $(Ee, null, Fe(c.value, (h) => (m(), X(Gu, {
              key: h.key,
              class: "column-visibility-menu-item",
              "data-testid": `column-visibility-menu-item-${h.key}`,
              onClick: Ke(() => {
                r.value[h.key] = !r.value[h.key], i.value = !0;
              }, ["stop"])
            }, {
              default: L(() => [
                G(sl, {
                  modelValue: r.value[h.key],
                  "onUpdate:modelValue": (g) => r.value[h.key] = g,
                  "aria-labelledby": `${e.tableId}-${h.key}-visibility-checkbox-label`,
                  "data-testid": `column-visibility-checkbox-${h.key}`
                }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-labelledby", "data-testid"]),
                G(Ka, {
                  id: `${e.tableId}-${h.key}-visibility-checkbox-label`,
                  class: "visibility-checkbox-label",
                  title: h.label
                }, {
                  default: L(() => [
                    be(re(h.label), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "title"])
              ]),
              _: 2
            }, 1032, ["data-testid", "onClick"]))), 128))
          ], 512),
          Y("div", nY, [
            G(rt, {
              appearance: "tertiary",
              class: "apply-button",
              "data-testid": "apply-button",
              onClick: d
            }, {
              default: L(() => [...C[3] || (C[3] = [
                be(" Apply ", -1)
              ])]),
              _: 1
            })
          ])
        ]),
        default: L(() => [
          G(ba, {
            placement: "bottom-end",
            text: n.value ? void 0 : "Show/Hide Columns"
          }, {
            default: L(() => [
              G(rt, {
                appearance: "tertiary",
                "aria-label": "Show/Hide Columns",
                class: "menu-button",
                "data-testid": "column-visibility-menu-button",
                disabled: e.disabled,
                icon: "",
                size: "large"
              }, {
                default: L(() => [
                  G(D(Yy), { decorative: "" })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), w1 = /* @__PURE__ */ Pe(rY, [["__scopeId", "data-v-0033fccb"]]), iY = { class: "k-table" }, oY = {
  key: 0,
  class: "table-toolbar",
  "data-testid": "table-toolbar"
}, lY = {
  key: 0,
  class: "toolbar-default-items-container"
}, sY = {
  key: 2,
  class: "table-error-state",
  "data-testid": "table-error-state"
}, uY = {
  key: 3,
  class: "table-empty-state",
  "data-testid": "table-empty-state"
}, cY = {
  key: 4,
  class: "table-container"
}, dY = ["data-tableid"], fY = ["aria-sort", "data-testid", "onClick", "onMouseover"], vY = ["onMousedown", "onMouseover"], hY = ["aria-describedby"], gY = ["onMousedown", "onMouseover"], mY = ["role", "tabindex"], pY = /* @__PURE__ */ oe({
  __name: "KTable",
  props: {
    /**
     * Allow columns to be resized
     */
    resizeColumns: {
      type: Boolean,
      default: !1
    },
    /**
     * Used to customize the initial state of the table.
     * Column visibility/width.
     */
    tablePreferences: {
      type: Object,
      default: () => ({})
    },
    /**
     * Enable client side sort - only do this if using a fetcher
     * that returns static data
     */
    clientSort: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables hover highlighting to table rows
     */
    rowHover: {
      type: Boolean,
      default: !0
    },
    sortHandlerFunction: {
      type: Function,
      default: () => ({})
    },
    /**
     * A function that conditionally specifies row attributes on each row
     */
    rowAttrs: {
      type: Function,
      default: () => ({})
    },
    /**
     * A function that conditionally specifies cell attributes
     */
    cellAttrs: {
      type: Function,
      default: () => ({})
    },
    /**
     * A prop that enables a loading skeleton
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass in a custom empty state title
     */
    emptyStateTitle: {
      type: String,
      default: "No Data"
    },
    /**
     * A prop to pass in a custom empty state message
     */
    emptyStateMessage: {
      type: String,
      default: "There is no data to display."
    },
    /**
     * A prop to pass in a custom empty state action route
     */
    emptyStateActionRoute: {
      type: [Object, String],
      default: ""
    },
    /**
     * A prop to pass in a custom empty state action message
     */
    emptyStateActionMessage: {
      type: String,
      default: ""
    },
    emptyStateIconVariant: {
      type: String,
      default: Na.Default
    },
    /**
     * A prop that enables the error state
     */
    error: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass in a custom error state title
     */
    errorStateTitle: {
      type: String,
      default: "An error occurred"
    },
    /**
     * A prop to pass in a custom error state message
     */
    errorStateMessage: {
      type: String,
      default: "Data cannot be displayed due to an error."
    },
    /**
     * A prop to pass in a custom error state action route
     */
    errorStateActionRoute: {
      type: [Object, String],
      default: ""
    },
    /**
     * A prop to pass in a custom error state action message
     */
    errorStateActionMessage: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in a fetcher function to enable server-side search, sort
     * and pagination
     */
    fetcher: {
      type: Function,
      default: void 0,
      required: !0
    },
    /**
     * A prop to trigger a revalidate of the fetcher function. Modifying this value
     * will trigger a manual refetch of the table data.
     */
    fetcherCacheKey: {
      type: String,
      default: ""
    },
    /**
     * A prop used to uniquely identify this table in the swrv cache
     */
    cacheIdentifier: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in a search string for server-side search
     */
    searchInput: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in an array of headers for the table
     */
    headers: {
      type: Array,
      default: () => []
    },
    /**
     * A prop to pass in an object of intial params for the initial fetcher function call
     */
    initialFetcherParams: {
      type: Object,
      default: null
    },
    /**
     * A prop to pass in the number of pagination neighbors used by the pagination component
     */
    paginationNeighbors: {
      type: Number,
      default: 1
    },
    /**
     * A prop to pass in an array of page sizes used by the pagination component
     */
    paginationPageSizes: {
      type: Array,
      default: () => [15, 30, 50, 75, 100],
      validator: (e) => !!e.length && e.every((t) => typeof t == "number")
    },
    /**
     * A prop to pass the total number of items in the set for the pagination text
     */
    paginationTotalItems: {
      type: Number,
      default: null
    },
    disablePaginationPageJump: {
      type: Boolean,
      default: !1
    },
    sortable: {
      type: Boolean,
      default: !0
    },
    disablePagination: {
      type: Boolean,
      default: !1
    },
    paginationOffset: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass to hide pagination for total table records is less than or equal to pagesize
     */
    hidePaginationWhenOptional: {
      type: Boolean,
      default: !1
    },
    maxHeight: {
      type: String,
      default: "none"
    }
  },
  emits: ["cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "state"],
  setup(e, { emit: t }) {
    Wt((le) => ({
      v5d6dfa67: et.value
    }));
    const { useDebounce: a, useRequest: n, useSwrvState: r, clientSideSorter: i } = Bn(), o = e, u = t, s = na(), l = $t(), c = yt(), d = {
      pageSize: 15,
      page: 1,
      query: "",
      sortColumnKey: "",
      sortColumnOrder: "desc",
      offset: null
    }, f = N([]), v = N(), y = N([]), C = N([]), h = N(""), g = N(""), p = N(""), w = b(() => y.value.filter((le) => le.hidable).length > 0), k = b(() => !!(w.value && !o.error && !ue.value && !o.loading && f.value && f.value.length)), S = b(() => y.value.filter((le) => le.hidable)), T = b(() => k.value ? o.tablePreferences.columnVisibility || {} : {}), A = N(k.value ? o.tablePreferences.columnVisibility || {} : {}), F = N(0), Z = N(!1), O = N(1), z = N(15), U = N(""), x = N(""), I = N("desc"), E = N(null), P = N([]), R = N(!0), K = N(!1), J = N(!1), q = b(() => !!l.toolbar || k.value), se = b(() => ({
      maxHeight: It(o.maxHeight)
    })), fe = (le) => `column-${le}`, ne = (le) => `tooltip-${le}`, ae = (le) => le, ve = (le, Ce) => (ke, je) => {
      const B = /^on[^a-z]/, te = {};
      for (const ee in Ce)
        B.test(ee) && Ce[ee] && (te[ee] = Ce[ee]);
      return Object.keys(te).reduce((ee, xe) => {
        if (xe.indexOf(le) === 0) {
          const ye = xe.split(le);
          ee[ye[1]] = (Ue) => te[xe](Ue, ke, je);
        }
        return ee;
      }, {});
    }, Ae = b(() => (le, Ce) => {
      const ke = ve("onRow:", s)(Ce, "row"), je = ve("onCell:", s)(le, "cell"), B = ["a", "button", "label", "input", "select"];
      return ke.click && (K.value = !0), {
        ...ke,
        ...je,
        click(te) {
          const ee = te.target.className;
          let xe = B.includes(te.target.tagName.toLowerCase()), ye = !1;
          typeof ee == "string" || Array.isArray(ee) ? ye = ee.includes("k-popover") : typeof ee == "object" && (ye = Object.keys(ee).includes("k-popover")), te.target.closest(".popover-content") !== null && (ye = !0);
          for (let Ue = 0; Ue < B.length; Ue++)
            if (te.target.closest(B[Ue]) !== null) {
              xe = !0;
              break;
            }
          if ((!xe || te.target.hasAttribute("disabled")) && !ye && (ke.click || je.click))
            if (je.click) {
              u("cell-click", { data: le });
              const Ue = je.click(te, le, "cell");
              typeof Ue == "function" && Ue(te, le);
            } else {
              u("row-click", { data: Ce });
              const Ue = ke.click(te, Ce, "row");
              typeof Ue == "function" && Ue(te, Ce);
            }
        }
      };
    }), Te = N(o.resizeColumns ? o.tablePreferences.columnWidths || {} : {}), Le = b(() => {
      const le = {};
      for (const Ce in Te.value) {
        if (!Te.value[Ce])
          continue;
        const ke = Te.value[Ce] + "px";
        le[Ce] = {
          width: ke,
          maxWidth: ke,
          minWidth: ke
        };
      }
      return le;
    }), ze = (le, Ce) => ({
      // display the resize handle on the right side of the column if resizeColumns is enabled, hovering current column, and not the last column
      "resize-hover": tt.value === le.key && o.resizeColumns && Ce !== C.value.length - 1,
      resizable: o.resizeColumns,
      // display sort control if column is sortable, label is visible, and sorting is not disabled
      sortable: o.sortable && !le.hideLabel && !!le.sortable,
      // display active sorting styles if column is currently sorted
      "active-sort": o.sortable && !le.hideLabel && !!le.sortable && le.key === x.value,
      [I.value]: o.sortable && le.key === x.value && !le.hideLabel,
      "is-scrolled": Z.value,
      "has-tooltip": !!le.tooltip
    }), _e = b(() => h.value ? "resizing" : g.value ? "resize-hover" : p.value ? "th-hover" : ""), tt = b(() => {
      switch (_e.value) {
        case "resizing":
          return h.value;
        case "resize-hover":
          return g.value;
        case "th-hover":
          return p.value;
        default:
          return "";
      }
    }), Xe = b(() => {
      var le;
      return (le = v.value) == null ? void 0 : le.querySelectorAll("th.resizable");
    }), et = b(() => {
      var Ce;
      const le = (Ce = Xe.value) == null ? void 0 : Ce.item(0);
      if (le) {
        const ke = window == null ? void 0 : window.getComputedStyle(le);
        if (ke != null && ke.height)
          return `${parseInt(ke.height, 10)}px`;
      }
      return "auto";
    }), pe = (le, Ce) => {
      var xe;
      if (le.button !== 0)
        return;
      let ke = 0, je = 0;
      h.value = Ce;
      let B = null;
      (xe = Xe.value) == null || xe.forEach((ye) => {
        ye.getAttribute("data-testid") === `table-header-${Ce}` && (B = document == null ? void 0 : document.querySelector(`[data-tableid="${c}"] [data-testid="table-header-${Ce}"]`));
      });
      const te = (ye) => {
        const Ue = ye.clientX - ke;
        B == null || B.setAttribute("style", `width: ${je + Ue}px`), Te.value[Ce] = je + Ue;
      }, ee = () => {
        h.value = "", document == null || document.removeEventListener("mousemove", te), document == null || document.removeEventListener("mouseup", ee), Tt();
      };
      if (ke = le.clientX, B) {
        const ye = window == null ? void 0 : window.getComputedStyle(B);
        ye != null && ye.width && (je = parseInt(ye.width, 10)), document == null || document.addEventListener("mousemove", te), document == null || document.addEventListener("mouseup", ee);
      }
    }, me = N(!0), he = async () => {
      var ke, je;
      const le = o.searchInput, Ce = await o.fetcher({
        pageSize: z.value,
        page: O.value,
        query: le || U.value,
        sortColumnKey: x.value,
        sortColumnOrder: I.value,
        offset: E.value
      });
      return f.value = Ce.data, F.value = o.paginationTotalItems || Ce.total || ((ke = Ce.data) == null ? void 0 : ke.length), o.paginationOffset && ((je = Ce.pagination) != null && je.offset ? (Be.value = Ce.pagination.offset, P.value[O.value] || P.value.push(Ce.pagination.offset)) : Be.value = null, R.value = Ce.pagination && "hasNextPage" in Ce.pagination ? Ce.pagination.hasNextPage : !0), f.value.length === 0 && O.value > 1 && (O.value = 1, P.value = [null], E.value = null), me.value = !1, Ce;
    }, V = () => {
      const le = {
        ...d,
        ...o.initialFetcherParams
      };
      O.value = le.page ?? d.page, z.value = le.pageSize ?? d.pageSize, U.value = le.query ?? d.query, x.value = le.sortColumnKey ?? d.sortColumnKey, I.value = le.sortColumnOrder ?? d.sortColumnOrder, o.clientSort && x.value && I.value && i(x.value, "", I.value, f.value), o.paginationOffset && (E.value = le.offset, P.value.push(le.offset)), o.headers && o.headers.length && (y.value = o.headers), J.value = !0;
    };
    ie(() => o.headers, (le) => {
      le && le.length && (y.value = le);
    }, { deep: !0 });
    const Se = b(() => P.value[O.value - 1]), Be = N(null), Me = b(() => {
      if (!o.fetcher || !J.value)
        return "";
      let le = c;
      return o.cacheIdentifier && (le = o.cacheIdentifier), o.fetcherCacheKey && (le += `-${o.fetcherCacheKey}`), `k-table_${le}`;
    }), Ve = N(""), { debouncedFn: wt, generateDebouncedFn: vt } = a((le) => {
      Ve.value = le;
    }, 350), Je = vt(0), { data: lt, error: xt, revalidate: Lt, isValidating: Xt } = n(
      () => Me.value,
      () => he(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: ra, hasData: Jt, swrvState: Mt } = r(lt, xt, Xt), ue = N(!0), He = b(() => ({
      hasData: Jt.value,
      state: ra.value
    })), _ = b(() => ue.value ? "loading" : xt.value ? "error" : "success"), { debouncedFn: de, generateDebouncedFn: Ie } = a(Lt, 500), Q = Ie(0), M = (le) => {
      const { key: Ce, useSortHandlerFunction: ke } = le, je = x.value + "";
      O.value = 1, x.value ? Ce === x.value ? I.value === "asc" ? I.value = "desc" : I.value = "asc" : (x.value = Ce, I.value = "asc", P.value = [null]) : (x.value = Ce, I.value = "asc", P.value = [null]), o.clientSort ? ke && o.sortHandlerFunction ? o.sortHandlerFunction({
        key: Ce,
        prevKey: je,
        sortColumnOrder: I.value,
        data: f.value
      }) : i(Ce, je, I.value, f.value) : o.paginationOffset || de(), Tt();
    }, j = ({ page: le }) => {
      O.value = le;
    }, ge = ({ pageSize: le }) => {
      P.value = [null], E.value = null, z.value = le, O.value = 1, Tt();
    }, $e = (le) => {
      le && le.target && typeof le.target.scrollTop == "number" && (le.target.scrollTop > 1 ? Z.value = !0 : le.target.scrollTop === 0 && (Z.value = !Z.value));
    }, nt = b(() => ({
      pageSize: z.value,
      sortColumnKey: x.value,
      sortColumnOrder: I.value,
      ...o.resizeColumns ? { columnWidths: Te.value } : {},
      ...w.value ? { columnVisibility: A.value } : {}
    })), Tt = () => {
      _.value === "success" && u("update:table-preferences", nt.value);
    }, Nt = () => {
      O.value++, E.value = Be.value;
    }, Ot = () => {
      O.value--, E.value = Se.value;
    }, Ma = b(() => !!(o.fetcher && !o.disablePagination && !(!o.paginationOffset && o.hidePaginationWhenOptional && F.value <= o.paginationPageSizes[0]) && !(o.paginationOffset && o.hidePaginationWhenOptional && !Se.value && !Be.value && f.value.length < o.paginationPageSizes[0]))), yn = (le) => le.toLowerCase().replace(/[^[a-z0-9]/gi, "-");
    ie([A, y], (le) => {
      const Ce = le[0], je = le[1].filter((B) => Ce[B.key] !== !1);
      JSON.stringify(je) !== JSON.stringify(C.value) && (C.value = je, Tt());
    }, { deep: !0, immediate: !0 }), ie(lt, (le) => {
      le != null && le.length && !f.value.length && (f.value = le);
    }, { deep: !0, immediate: !0 }), ie(ra, () => {
      switch (ra.value) {
        case Mt.PENDING:
          ue.value = !0;
          break;
        case Mt.VALIDATING_HAS_DATA:
          ue.value = Ct.value;
          break;
        default:
          ue.value = !1;
          break;
      }
    }, { immediate: !0 }), ie([He, _], (le) => {
      var Ce;
      u("state", {
        state: le == null ? void 0 : le[1],
        // newData[tableState]
        hasData: (Ce = le == null ? void 0 : le[0]) == null ? void 0 : Ce.hasData
        // newData[stateData].hasData
      });
    }), ie(() => o.searchInput, (le) => {
      O.value !== 1 && (O.value = 1), le === "" ? Je(le) : wt(le);
    }, { immediate: !0 });
    const Ct = N(!1);
    return ie([Ve, O, z], async (le, Ce) => {
      const ke = Ce == null ? void 0 : Ce[0], je = le[0], B = le[1];
      je !== ke && B !== 1 && (O.value = 1, P.value = [null], E.value = null), J.value && !me.value && (Ct.value = !0, je !== "" && je !== ke ? await de() : await Q(), Ct.value = !1);
    }, { deep: !0, immediate: !0 }), ie(k, (le) => {
      le && (A.value = o.tablePreferences.columnVisibility || {});
    }, { immediate: !0 }), it(() => {
      console.warn(`The Kongponents 'KTable' component is deprecated and will be removed in the next major release.
We suggest using 'KTableData' component instead.
Docs: https://kongponents.konghq.com/components/table-data.html`), V();
    }), (le, Ce) => (m(), $("div", iY, [
      q.value ? (m(), $("div", oY, [
        W(le.$slots, "toolbar", { state: He.value }, void 0, !0),
        k.value ? (m(), $("div", lY, [
          G(w1, {
            columns: S.value,
            "table-id": D(c),
            "visibility-preferences": T.value,
            onUpdate: Ce[0] || (Ce[0] = (ke) => A.value = ke)
          }, null, 8, ["columns", "table-id", "visibility-preferences"])
        ])) : H("", !0)
      ])) : H("", !0),
      (ue.value || e.loading || Ct.value) && !e.error ? (m(), X(jl, {
        key: 1,
        "data-testid": "table-skeleton",
        type: "table"
      })) : e.error ? (m(), $("div", sY, [
        W(le.$slots, "error-state", {}, () => [
          G(_n, {
            "icon-variant": "error",
            message: e.errorStateMessage,
            title: e.errorStateTitle
          }, kt({ _: 2 }, [
            e.errorStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  "data-testid": yn(e.errorStateActionMessage),
                  to: e.errorStateActionRoute ? e.errorStateActionRoute : void 0,
                  onClick: Ce[1] || (Ce[1] = (ke) => le.$emit("error-action-click"))
                }, {
                  default: L(() => [
                    be(re(e.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : !e.error && !ue.value && !e.loading && !Ct.value && f.value && !f.value.length ? (m(), $("div", uY, [
        W(le.$slots, "empty-state", {}, () => [
          G(_n, {
            "icon-variant": e.emptyStateIconVariant,
            message: e.emptyStateMessage,
            title: e.emptyStateTitle
          }, kt({ _: 2 }, [
            e.emptyStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  appearance: e.searchInput ? "tertiary" : "primary",
                  "data-testid": yn(e.emptyStateActionMessage),
                  to: e.emptyStateActionRoute ? e.emptyStateActionRoute : void 0,
                  onClick: Ce[2] || (Ce[2] = (ke) => le.$emit("empty-state-action-click"))
                }, {
                  default: L(() => [
                    W(le.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + re(e.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (m(), $("div", cY, [
        Y("div", {
          class: "table-wrapper",
          style: Oe(se.value),
          onScrollPassive: $e
        }, [
          Y("table", {
            class: ce(["table", {
              "has-hover": e.rowHover,
              "is-clickable": K.value
            }]),
            "data-tableid": D(c)
          }, [
            Y("thead", {
              class: ce({ "is-scrolled": Z.value })
            }, [
              Y("tr", {
                ref_key: "headerRow",
                ref: v,
                class: ce({ "is-scrolled": Z.value })
              }, [
                (m(!0), $(Ee, null, Fe(C.value, (ke, je) => (m(), $("th", {
                  key: `table-${D(c)}-headers-${je}`,
                  "aria-sort": e.sortable && ke.key === x.value ? I.value === "asc" ? "ascending" : "descending" : void 0,
                  class: ce(["table-headers", ze(ke, je)]),
                  "data-testid": `table-header-${ke.key}`,
                  style: Oe(Le.value[ke.key]),
                  onClick: () => {
                    e.sortable && ke.sortable && (le.$emit("sort", {
                      prevKey: x.value,
                      sortColumnKey: ke.key,
                      sortColumnOrder: I.value === "asc" ? "desc" : "asc"
                      // display opposite because sortColumnOrder outdated
                    }), M(ke));
                  },
                  onMouseleave: Ce[7] || (Ce[7] = (B) => p.value = ""),
                  onMouseover: (B) => p.value = ke.key
                }, [
                  e.resizeColumns && je !== 0 ? (m(), $("div", {
                    key: 0,
                    class: "resize-handle previous",
                    onClick: Ce[3] || (Ce[3] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (B) => pe(B, C.value[je - 1].key),
                    onMouseleave: Ce[4] || (Ce[4] = (B) => g.value = ""),
                    onMouseover: (B) => g.value = C.value[je - 1].key
                  }, null, 40, vY)) : H("", !0),
                  Y("div", {
                    "aria-describedby": ke.tooltip || le.$slots[ne(ke.key)] ? `${ne(ke.key)}-${D(c)}` : void 0,
                    class: ce(["table-headers-container", { resized: h.value === ke.key }])
                  }, [
                    W(le.$slots, fe(ke.key), {
                      column: ae(ke)
                    }, () => [
                      Y("span", {
                        class: ce(["table-header-label", {
                          "sr-only": ke.hideLabel
                        }])
                      }, re(ke.label ? ke.label : ke.key), 3)
                    ], !0),
                    ke.tooltip || le.$slots[ne(ke.key)] ? (m(), X(ba, {
                      key: 0,
                      "data-testid": ne(ke.key),
                      "tooltip-id": `${ne(ke.key)}-${D(c)}`
                    }, {
                      content: L(() => [
                        W(le.$slots, ne(ke.key), {
                          column: ae(ke)
                        }, () => [
                          be(re(ke.tooltip), 1)
                        ], !0)
                      ]),
                      default: L(() => [
                        G(D(En), {
                          class: "header-tooltip-trigger",
                          color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                          size: D(Sa)
                        }, null, 8, ["color", "size"])
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "tooltip-id"])) : H("", !0),
                    e.sortable && !ke.hideLabel && ke.sortable ? (m(), X(D(Bu), {
                      key: 1,
                      class: "sort-icon",
                      color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                      size: D(Sa)
                    }, null, 8, ["color", "size"])) : H("", !0)
                  ], 10, hY),
                  e.resizeColumns && je !== C.value.length - 1 ? (m(), $("div", {
                    key: 1,
                    class: "resize-handle",
                    onClick: Ce[5] || (Ce[5] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (B) => pe(B, ke.key),
                    onMouseleave: Ce[6] || (Ce[6] = (B) => g.value = ""),
                    onMouseover: (B) => g.value = ke.key
                  }, null, 40, gY)) : H("", !0)
                ], 46, fY))), 128))
              ], 2)
            ], 2),
            Y("tbody", null, [
              (m(!0), $(Ee, null, Fe(f.value, (ke, je) => (m(), $("tr", Re({ ref_for: !0 }, e.rowAttrs(ke), {
                key: `table-${D(c)}-row-${je}`,
                role: K.value ? "link" : null,
                tabindex: K.value ? 0 : null
              }), [
                (m(!0), $(Ee, null, Fe(C.value, (B, te) => (m(), $("td", Re({ ref_for: !0 }, e.cellAttrs({ headerKey: B.key, row: ke, rowIndex: je, colIndex: te }), {
                  key: `table-${D(c)}-cell-${te}`,
                  class: {
                    "resize-hover": e.resizeColumns && tt.value === B.key && te !== C.value.length - 1
                  },
                  style: Le.value[B.key]
                }, Bl(Ae.value(ke[B.key], ke), !0)), [
                  W(le.$slots, B.key, {
                    row: ae(ke),
                    rowKey: je,
                    rowValue: ke[B.key]
                  }, () => [
                    be(re(ke[B.key]), 1)
                  ], !0)
                ], 16))), 128))
              ], 16, mY))), 128))
            ])
          ], 10, dY)
        ], 36),
        Ma.value ? (m(), X(Gl, {
          key: 0,
          class: "table-pagination",
          "current-page": O.value,
          "data-testid": "table-pagination",
          "disable-page-jump": e.disablePaginationPageJump,
          "initial-page-size": z.value,
          neighbors: e.paginationNeighbors,
          offset: e.paginationOffset,
          "offset-next-button-disabled": !Be.value || !R.value,
          "offset-previous-button-disabled": !Se.value,
          "page-sizes": e.paginationPageSizes,
          "total-count": F.value,
          onGetNextOffset: Nt,
          onGetPreviousOffset: Ot,
          onPageChange: j,
          onPageSizeChange: ge
        }, null, 8, ["current-page", "disable-page-jump", "initial-page-size", "neighbors", "offset", "offset-next-button-disabled", "offset-previous-button-disabled", "page-sizes", "total-count"])) : H("", !0)
      ]))
    ]));
  }
}), yY = /* @__PURE__ */ Pe(pY, [["__scopeId", "data-v-1e08f4e8"]]), bY = { class: "k-tabs" }, wY = {
  "aria-label": "Tabs",
  role: "tablist"
}, CY = ["id", "data-testid"], kY = ["id", "aria-labelledby"], $Y = /* @__PURE__ */ oe({
  __name: "KTabs",
  props: {
    tabs: {},
    modelValue: { default: "" },
    hidePanels: { type: Boolean },
    anchorTabindex: { default: 0 },
    beforeChange: { default: () => (() => !0) }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    var u;
    const a = t, n = N(e.modelValue ? e.modelValue : (u = e.tabs[0]) == null ? void 0 : u.hash), r = async (s) => {
      (typeof e.beforeChange != "function" || await e.beforeChange(s)) && (n.value = s, a("change", s), a("update:modelValue", s));
    }, i = (s) => s.replace("#", ""), o = (s) => s.disabled ? "-1" : typeof e.anchorTabindex == "number" && e.anchorTabindex >= -1 && e.anchorTabindex <= 32767 ? String(e.anchorTabindex) : "0";
    return ie(() => e.modelValue, (s) => {
      n.value = s;
    }), (s, l) => (m(), $("div", bY, [
      Y("ul", wY, [
        (m(!0), $(Ee, null, Fe(e.tabs, (c) => (m(), $("li", {
          id: `${c.hash.replace("#", "")}-tab`,
          key: c.hash,
          class: ce(["tab-item", { active: n.value === c.hash }]),
          "data-testid": `${c.hash.replace("#", "")}-tab`
        }, [
          G(rt, {
            appearance: "none",
            "aria-controls": e.hidePanels ? void 0 : `panel-${c.hash}`,
            "aria-selected": e.hidePanels ? void 0 : n.value === c.hash ? "true" : "false",
            class: ce(["tab-link", { disabled: c.disabled }]),
            disabled: c.disabled,
            role: "tab",
            tabindex: o(c),
            to: c.to,
            onClick: [
              (d) => c.disabled ? void 0 : r(c.hash),
              Ke((d) => c.disabled ? void 0 : r(c.hash), ["prevent"])
            ],
            onKeydown: [
              ct(Ke((d) => c.disabled ? void 0 : r(c.hash), ["prevent"]), ["enter"]),
              ct(Ke((d) => c.disabled ? void 0 : r(c.hash), ["prevent"]), ["space"])
            ]
          }, {
            default: L(() => [
              W(s.$slots, `${i(c.hash)}-anchor`, {}, () => [
                Y("span", null, re(c.title), 1)
              ])
            ]),
            _: 2
          }, 1032, ["aria-controls", "aria-selected", "class", "disabled", "tabindex", "to", "onClick", "onKeydown"])
        ], 10, CY))), 128))
      ]),
      e.hidePanels ? H("", !0) : (m(!0), $(Ee, { key: 0 }, Fe(e.tabs, (c, d) => (m(), $("div", {
        id: `panel-${d}`,
        key: c.hash,
        "aria-labelledby": `${i(c.hash)}-tab`,
        class: "tab-container",
        role: "tabpanel"
      }, [
        n.value === c.hash ? W(s.$slots, i(c.hash), { key: 0 }) : H("", !0)
      ], 8, kY))), 128))
    ]));
  }
}), SY = /* @__PURE__ */ Pe($Y, [["__scopeId", "data-v-1bf1622c"]]), xY = ["data-value"], TY = ["id", "aria-invalid", "rows", "value"], Ys = 2048, qh = km ? 0 : $m(), Wh = pS("field-sizing", "content"), DY = /* @__PURE__ */ oe({
  inheritAttrs: !1,
  __name: "KTextArea",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    characterLimit: { type: [Boolean, Number], default: () => Ys },
    rows: { default: 5 },
    error: { type: Boolean },
    resizable: { type: Boolean },
    autosize: { type: Boolean },
    help: { default: "" },
    isResizable: { type: Boolean },
    hasError: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "char-limit-exceeded"],
  setup(e, { emit: t }) {
    Wt((T) => ({
      v5b352807: T.rows
    })), ie(() => e.isResizable, (T) => {
      T && console.warn("KTextArea: `isResizable` prop is deprecated in favor of `resizable` prop. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#ktextarea");
    }, { immediate: !0 }), ie(() => e.hasError, (T) => {
      T && console.warn("KTextArea: `hasError` prop is deprecated. Please use `error` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#ktextarea");
    }, { immediate: !0 });
    const a = t, n = na(), r = $t(), { stripRequiredLabel: i } = Bn(), o = b(() => (n == null ? void 0 : n.required) !== void 0 && String(n == null ? void 0 : n.required) !== "false"), u = N(""), s = b(() => i(e.label, o.value)), l = b(() => {
      var T, A;
      return !!((T = e.labelAttributes) != null && T.help || (A = e.labelAttributes) != null && A.info || r["label-tooltip"]);
    }), c = b(() => e.error || e.hasError || h.value ? !0 : void 0), d = N(0), f = b({
      get() {
        return e.modelValue;
      },
      set(T) {
        g({ target: { value: T } });
      }
    }), v = yt(), y = b(() => n.id ? String(n.id) : v), C = b(() => {
      const T = { ...n };
      return delete T.class, T;
    }), h = b(() => typeof e.characterLimit == "boolean" ? e.characterLimit ? u.value.length > Ys : !1 : u.value.length > e.characterLimit), g = (T) => {
      var F;
      const A = JSON.parse(JSON.stringify((F = T == null ? void 0 : T.target) == null ? void 0 : F.value));
      a("input", A), a("update:modelValue", A), u.value = A;
    }, p = b(() => !h.value && !!(e.help || r.help)), w = b(() => {
      var A;
      const T = typeof e.characterLimit == "number" ? e.characterLimit : Ys;
      return h.value ? `${(A = u.value) == null ? void 0 : A.toString().length} / ${T}` : e.help;
    });
    ie(h, (T, A) => {
      T !== A && (a("char-limit-exceeded", {
        value: u.value,
        length: u.value.length,
        characterLimit: Number(e.characterLimit),
        limitExceeded: T
      }), d.value += 1);
    }), ie(f, (T, A) => {
      T !== A && g({ target: { value: T } });
    });
    const k = () => u.value ? u.value : e.modelValue, S = km ? () => {
    } : (T) => {
      const { target: A, clientX: F, clientY: Z } = T;
      if (!(A instanceof HTMLTextAreaElement))
        return;
      const { right: O, bottom: z } = A.getBoundingClientRect();
      F > O - qh && Z > z - qh && (A.style.height = "");
    };
    return (T, A) => (m(), $("div", {
      class: ce(["k-textarea", [T.$attrs.class, { "input-error": e.error || e.hasError || h.value }]])
    }, [
      e.label ? (m(), X(Ka, Re({
        key: 0,
        for: y.value
      }, e.labelAttributes, { required: o.value }), kt({
        default: L(() => [
          be(re(s.value) + " ", 1)
        ]),
        _: 2
      }, [
        l.value ? {
          name: "tooltip",
          fn: L(() => [
            W(T.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : H("", !0),
      Y("div", {
        class: ce(["input-textarea-wrapper", {
          autosize: e.autosize,
          legacy: e.autosize && !D(Wh)
        }]),
        "data-allow-mismatch": "class",
        "data-value": D(Wh) ? null : u.value
      }, [
        Y("textarea", Re({ id: y.value }, C.value, {
          "aria-invalid": c.value,
          class: ["input-textarea", {
            resizable: e.resizable || e.isResizable
          }],
          rows: e.rows,
          value: k(),
          onDblclick: A[0] || (A[0] = //@ts-ignore
          (...F) => D(S) && D(S)(...F)),
          onInput: g
        }), null, 16, TY)
      ], 10, xY),
      G(ea, {
        mode: "out-in",
        name: "kongponents-fade-transition"
      }, {
        default: L(() => [
          w.value || r.help ? (m(), $("p", {
            key: String(d.value),
            class: "help-text"
          }, [
            p.value ? W(T.$slots, "help", { key: 0 }, () => [
              be(re(w.value), 1)
            ], !0) : (m(), $(Ee, { key: 1 }, [
              be(re(w.value), 1)
            ], 64))
          ])) : H("", !0)
        ]),
        _: 3
      })
    ], 2));
  }
}), AY = /* @__PURE__ */ Pe(DY, [["__scopeId", "data-v-2080bcde"]]), IY = { class: "toaster-icon-container" }, EY = { class: "toaster-content" }, MY = {
  key: 0,
  class: "toaster-title"
}, OY = {
  key: 1,
  class: "toaster-message"
}, PY = ["onClick"], NY = /* @__PURE__ */ oe({
  __name: "KToaster",
  props: {
    toasterState: { default: () => [] },
    zIndex: { default: 1e4 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    Wt((r) => ({
      v22b9170f: r.zIndex
    }));
    const a = t, n = (r) => {
      switch (r) {
        case "info":
          return En;
        case "success":
          return mg;
        case "warning":
          return Yu;
        case "danger":
          return fy;
        case "system":
          return Fu;
        default:
          return En;
      }
    };
    return (r, i) => (m(), X(U1, {
      class: "k-toaster",
      name: "kongponents-slide-up-transition",
      tag: "div"
    }, {
      default: L(() => [
        (m(!0), $(Ee, null, Fe(e.toasterState, (o) => (m(), $("div", {
          key: o.key,
          class: ce(["toaster", `${o.appearance}`]),
          role: "alert"
        }, [
          Y("div", IY, [
            (m(), X(Ye(n(o.appearance)), {
              class: "toaster-icon",
              color: `var(--kui-color-text, ${D(Gy)})`,
              decorative: ""
            }, null, 8, ["color"]))
          ]),
          Y("div", EY, [
            o.title ? (m(), $("span", MY, re(o.title), 1)) : H("", !0),
            o.message ? (m(), $("p", OY, re(o.message), 1)) : H("", !0)
          ]),
          Y("button", {
            "aria-label": "Close",
            class: "toaster-close-icon",
            "data-testid": "toaster-close-icon",
            type: "button",
            onClick: Ke((u) => a("close", o.key), ["stop"])
          }, [
            G(D(ha), {
              color: `var(--kui-color-text-neutral-weak, ${D(Cg)})`,
              size: D(Xy)
            }, null, 8, ["color", "size"])
          ], 8, PY)
        ], 2))), 128))
      ]),
      _: 1
    }));
  }
}), C1 = /* @__PURE__ */ Pe(NY, [["__scopeId", "data-v-d307308f"]]), LY = "kongponents-toaster-container", Hs = {
  timeoutMilliseconds: 5e3,
  appearance: hg.info
}, BY = 1e4;
class RY {
  constructor(t) {
    Ja(this, "toastersContainer", null);
    Ja(this, "toaster", null);
    Ja(this, "toasts", N([]));
    if (typeof document > "u") {
      console.warn("ToastManager should only be initialized in the browser environment. Docs: https://kongponents.konghq.com/components/toaster.html");
      return;
    }
    this.toastersContainer = document.createElement("div"), this.toastersContainer.id = LY, document.body.appendChild(this.toastersContainer), this.toaster = G(C1, {
      toasterState: this.toasts.value,
      zIndex: t != null && t.zIndex ? t.zIndex : BY,
      onClose: (a) => this.close(a)
    }), this.toastersContainer && qc(this.toaster, this.toastersContainer);
  }
  setTimer(t, a) {
    return (window == null ? void 0 : window.setTimeout(() => this.close(t), a)) || 0;
  }
  open(t) {
    const { key: a, timeoutMilliseconds: n, appearance: r, message: i, title: o } = t, u = a ? String(a) : cs(), s = r && Object.keys(hg).indexOf(r) !== -1 ? r : Hs.appearance, l = this.setTimer(a, n || Hs.timeoutMilliseconds), c = typeof t == "string" ? t : i;
    this.toasts.value.push({
      key: u,
      appearance: s,
      title: o,
      message: c,
      timer: l,
      timeoutMilliseconds: n || Hs.timeoutMilliseconds
    });
  }
  close(t) {
    var n, r;
    const a = (n = this.toasts.value) == null ? void 0 : n.findIndex((i) => t === i.key);
    clearTimeout((r = this.toasts.value[a]) == null ? void 0 : r.timer), this.toasts.value.splice(a, 1);
  }
  closeAll() {
    this.toasts.value.forEach((t) => clearTimeout(t == null ? void 0 : t.timer)), this.toasts.value = [];
  }
  destroy() {
    this.toastersContainer && (qc(null, this.toastersContainer), this.toastersContainer.remove());
  }
}
/*!
  * vue-draggable-next v2.3.0
  * (c) 2025 Anish George
  * @license MIT
  */
function FY() {
  return typeof window < "u" ? window.console : global.console;
}
const zY = FY();
function YY(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] || (t[n] = e(n));
  };
}
const HY = /-(\w)/g, Uh = YY((e) => e.replace(HY, (t, a) => a ? a.toUpperCase() : ""));
function qs(e) {
  e.parentElement !== null && e.parentElement.removeChild(e);
}
function Kh(e, t, a) {
  const n = a === 0 ? e.children[0] : e.children[a - 1].nextSibling;
  e.insertBefore(t, n);
}
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Vh(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function Wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vh(Object(a), !0).forEach(function(n) {
      qY(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Vh(Object(a)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(a, n));
    });
  }
  return e;
}
function Xo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Xo = function(t) {
    return typeof t;
  } : Xo = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Xo(e);
}
function qY(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function dn() {
  return dn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var n in a)
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
    return e;
  }, dn.apply(this, arguments);
}
function WY(e, t) {
  if (e == null) return {};
  var a = {}, n = Object.keys(e), r, i;
  for (i = 0; i < n.length; i++)
    r = n[i], !(t.indexOf(r) >= 0) && (a[r] = e[r]);
  return a;
}
function UY(e, t) {
  if (e == null) return {};
  var a = WY(e, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
var KY = "1.14.0";
function rn(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var pn = rn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Ui = rn(/Edge/i), jh = rn(/firefox/i), $i = rn(/safari/i) && !rn(/chrome/i) && !rn(/android/i), k1 = rn(/iP(ad|od|hone)/i), VY = rn(/chrome/i) && rn(/android/i), $1 = {
  capture: !1,
  passive: !1
};
function ot(e, t, a) {
  e.addEventListener(t, a, !pn && $1);
}
function at(e, t, a) {
  e.removeEventListener(t, a, !pn && $1);
}
function Ml(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function jY(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Pa(e, t, a, n) {
  if (e) {
    a = a || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === a && Ml(e, t) : Ml(e, t)) || n && e === a)
        return e;
      if (e === a) break;
    } while (e = jY(e));
  }
  return null;
}
var Gh = /\s+/g;
function ia(e, t, a) {
  if (e && t)
    if (e.classList)
      e.classList[a ? "add" : "remove"](t);
    else {
      var n = (" " + e.className + " ").replace(Gh, " ").replace(" " + t + " ", " ");
      e.className = (n + (a ? " " + t : "")).replace(Gh, " ");
    }
}
function qe(e, t, a) {
  var n = e && e.style;
  if (n) {
    if (a === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? a = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (a = e.currentStyle), t === void 0 ? a : a[t];
    !(t in n) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), n[t] = a + (typeof a == "string" ? "" : "px");
  }
}
function Br(e, t) {
  var a = "";
  if (typeof e == "string")
    a = e;
  else
    do {
      var n = qe(e, "transform");
      n && n !== "none" && (a = n + " " + a);
    } while (!t && (e = e.parentNode));
  var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r && new r(a);
}
function S1(e, t, a) {
  if (e) {
    var n = e.getElementsByTagName(t), r = 0, i = n.length;
    if (a)
      for (; r < i; r++)
        a(n[r], r);
    return n;
  }
  return [];
}
function za() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Pt(e, t, a, n, r) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var i, o, u, s, l, c, d;
    if (e !== window && e.parentNode && e !== za() ? (i = e.getBoundingClientRect(), o = i.top, u = i.left, s = i.bottom, l = i.right, c = i.height, d = i.width) : (o = 0, u = 0, s = window.innerHeight, l = window.innerWidth, c = window.innerHeight, d = window.innerWidth), (t || a) && e !== window && (r = r || e.parentNode, !pn))
      do
        if (r && r.getBoundingClientRect && (qe(r, "transform") !== "none" || a && qe(r, "position") !== "static")) {
          var f = r.getBoundingClientRect();
          o -= f.top + parseInt(qe(r, "border-top-width")), u -= f.left + parseInt(qe(r, "border-left-width")), s = o + i.height, l = u + i.width;
          break;
        }
      while (r = r.parentNode);
    if (n && e !== window) {
      var v = Br(r || e), y = v && v.a, C = v && v.d;
      v && (o /= C, u /= y, d /= y, c /= C, s = o + c, l = u + d);
    }
    return {
      top: o,
      left: u,
      bottom: s,
      right: l,
      width: d,
      height: c
    };
  }
}
function Qh(e, t, a) {
  for (var n = Dn(e, !0), r = Pt(e)[t]; n; ) {
    var i = Pt(n)[a], o = void 0;
    if (o = r >= i, !o) return n;
    if (n === za()) break;
    n = Dn(n, !1);
  }
  return !1;
}
function Vr(e, t, a, n) {
  for (var r = 0, i = 0, o = e.children; i < o.length; ) {
    if (o[i].style.display !== "none" && o[i] !== We.ghost && (n || o[i] !== We.dragged) && Pa(o[i], a.draggable, e, !1)) {
      if (r === t)
        return o[i];
      r++;
    }
    i++;
  }
  return null;
}
function Fc(e, t) {
  for (var a = e.lastElementChild; a && (a === We.ghost || qe(a, "display") === "none" || t && !Ml(a, t)); )
    a = a.previousElementSibling;
  return a || null;
}
function fa(e, t) {
  var a = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== We.clone && (!t || Ml(e, t)) && a++;
  return a;
}
function Zh(e) {
  var t = 0, a = 0, n = za();
  if (e)
    do {
      var r = Br(e), i = r.a, o = r.d;
      t += e.scrollLeft * i, a += e.scrollTop * o;
    } while (e !== n && (e = e.parentNode));
  return [t, a];
}
function GY(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a)) {
      for (var n in t)
        if (t.hasOwnProperty(n) && t[n] === e[a][n]) return Number(a);
    }
  return -1;
}
function Dn(e, t) {
  if (!e || !e.getBoundingClientRect) return za();
  var a = e, n = !1;
  do
    if (a.clientWidth < a.scrollWidth || a.clientHeight < a.scrollHeight) {
      var r = qe(a);
      if (a.clientWidth < a.scrollWidth && (r.overflowX == "auto" || r.overflowX == "scroll") || a.clientHeight < a.scrollHeight && (r.overflowY == "auto" || r.overflowY == "scroll")) {
        if (!a.getBoundingClientRect || a === document.body) return za();
        if (n || t) return a;
        n = !0;
      }
    }
  while (a = a.parentNode);
  return za();
}
function QY(e, t) {
  if (e && t)
    for (var a in t)
      t.hasOwnProperty(a) && (e[a] = t[a]);
  return e;
}
function Ws(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var Si;
function x1(e, t) {
  return function() {
    if (!Si) {
      var a = arguments, n = this;
      a.length === 1 ? e.call(n, a[0]) : e.apply(n, a), Si = setTimeout(function() {
        Si = void 0;
      }, t);
    }
  };
}
function ZY() {
  clearTimeout(Si), Si = void 0;
}
function T1(e, t, a) {
  e.scrollLeft += t, e.scrollTop += a;
}
function D1(e) {
  var t = window.Polymer, a = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : a ? a(e).clone(!0)[0] : e.cloneNode(!0);
}
var sa = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function XY() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(r) {
          if (!(qe(r, "display") === "none" || r === We.ghost)) {
            e.push({
              target: r,
              rect: Pt(r)
            });
            var i = Wa({}, e[e.length - 1].rect);
            if (r.thisAnimationDuration) {
              var o = Br(r, !0);
              o && (i.top -= o.f, i.left -= o.e);
            }
            r.fromRect = i;
          }
        });
      }
    },
    addAnimationState: function(n) {
      e.push(n);
    },
    removeAnimationState: function(n) {
      e.splice(GY(e, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var r = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof n == "function" && n();
        return;
      }
      var i = !1, o = 0;
      e.forEach(function(u) {
        var s = 0, l = u.target, c = l.fromRect, d = Pt(l), f = l.prevFromRect, v = l.prevToRect, y = u.rect, C = Br(l, !0);
        C && (d.top -= C.f, d.left -= C.e), l.toRect = d, l.thisAnimationDuration && Ws(f, d) && !Ws(c, d) && // Make sure animatingRect is on line between toRect & fromRect
        (y.top - d.top) / (y.left - d.left) === (c.top - d.top) / (c.left - d.left) && (s = _Y(y, f, v, r.options)), Ws(d, c) || (l.prevFromRect = c, l.prevToRect = d, s || (s = r.options.animation), r.animate(l, y, d, s)), s && (i = !0, o = Math.max(o, s), clearTimeout(l.animationResetTimer), l.animationResetTimer = setTimeout(function() {
          l.animationTime = 0, l.prevFromRect = null, l.fromRect = null, l.prevToRect = null, l.thisAnimationDuration = null;
        }, s), l.thisAnimationDuration = s);
      }), clearTimeout(t), i ? t = setTimeout(function() {
        typeof n == "function" && n();
      }, o) : typeof n == "function" && n(), e = [];
    },
    animate: function(n, r, i, o) {
      if (o) {
        qe(n, "transition", ""), qe(n, "transform", "");
        var u = Br(this.el), s = u && u.a, l = u && u.d, c = (r.left - i.left) / (s || 1), d = (r.top - i.top) / (l || 1);
        n.animatingX = !!c, n.animatingY = !!d, qe(n, "transform", "translate3d(" + c + "px," + d + "px,0)"), this.forRepaintDummy = JY(n), qe(n, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), qe(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          qe(n, "transition", ""), qe(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, o);
      }
    }
  };
}
function JY(e) {
  return e.offsetWidth;
}
function _Y(e, t, a, n) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - a.top, 2) + Math.pow(t.left - a.left, 2)) * n.animation;
}
var wr = [], Us = {
  initializeByDefault: !0
}, Ki = {
  mount: function(t) {
    for (var a in Us)
      Us.hasOwnProperty(a) && !(a in t) && (t[a] = Us[a]);
    wr.forEach(function(n) {
      if (n.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), wr.push(t);
  },
  pluginEvent: function(t, a, n) {
    var r = this;
    this.eventCanceled = !1, n.cancel = function() {
      r.eventCanceled = !0;
    };
    var i = t + "Global";
    wr.forEach(function(o) {
      a[o.pluginName] && (a[o.pluginName][i] && a[o.pluginName][i](Wa({
        sortable: a
      }, n)), a.options[o.pluginName] && a[o.pluginName][t] && a[o.pluginName][t](Wa({
        sortable: a
      }, n)));
    });
  },
  initializePlugins: function(t, a, n, r) {
    wr.forEach(function(u) {
      var s = u.pluginName;
      if (!(!t.options[s] && !u.initializeByDefault)) {
        var l = new u(t, a, t.options);
        l.sortable = t, l.options = t.options, t[s] = l, dn(n, l.defaults);
      }
    });
    for (var i in t.options)
      if (t.options.hasOwnProperty(i)) {
        var o = this.modifyOption(t, i, t.options[i]);
        typeof o < "u" && (t.options[i] = o);
      }
  },
  getEventProperties: function(t, a) {
    var n = {};
    return wr.forEach(function(r) {
      typeof r.eventProperties == "function" && dn(n, r.eventProperties.call(a[r.pluginName], t));
    }), n;
  },
  modifyOption: function(t, a, n) {
    var r;
    return wr.forEach(function(i) {
      t[i.pluginName] && i.optionListeners && typeof i.optionListeners[a] == "function" && (r = i.optionListeners[a].call(t[i.pluginName], n));
    }), r;
  }
};
function eH(e) {
  var t = e.sortable, a = e.rootEl, n = e.name, r = e.targetEl, i = e.cloneEl, o = e.toEl, u = e.fromEl, s = e.oldIndex, l = e.newIndex, c = e.oldDraggableIndex, d = e.newDraggableIndex, f = e.originalEvent, v = e.putSortable, y = e.extraEventProperties;
  if (t = t || a && a[sa], !!t) {
    var C, h = t.options, g = "on" + n.charAt(0).toUpperCase() + n.substr(1);
    window.CustomEvent && !pn && !Ui ? C = new CustomEvent(n, {
      bubbles: !0,
      cancelable: !0
    }) : (C = document.createEvent("Event"), C.initEvent(n, !0, !0)), C.to = o || a, C.from = u || a, C.item = r || a, C.clone = i, C.oldIndex = s, C.newIndex = l, C.oldDraggableIndex = c, C.newDraggableIndex = d, C.originalEvent = f, C.pullMode = v ? v.lastPutMode : void 0;
    var p = Wa(Wa({}, y), Ki.getEventProperties(n, t));
    for (var w in p)
      C[w] = p[w];
    a && a.dispatchEvent(C), h[g] && h[g].call(t, C);
  }
}
var tH = ["evt"], _t = function(t, a) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.evt, i = UY(n, tH);
  Ki.pluginEvent.bind(We)(t, a, Wa({
    dragEl: we,
    parentEl: Dt,
    ghostEl: Qe,
    rootEl: bt,
    nextEl: Un,
    lastDownEl: Jo,
    cloneEl: At,
    cloneHidden: Tn,
    dragStarted: mi,
    putSortable: Rt,
    activeSortable: We.active,
    originalEvent: r,
    oldIndex: Er,
    oldDraggableIndex: xi,
    newIndex: oa,
    newDraggableIndex: kn,
    hideGhostForTarget: M1,
    unhideGhostForTarget: O1,
    cloneNowHidden: function() {
      Tn = !0;
    },
    cloneNowShown: function() {
      Tn = !1;
    },
    dispatchSortableEvent: function(u) {
      Kt({
        sortable: a,
        name: u,
        originalEvent: r
      });
    }
  }, i));
};
function Kt(e) {
  eH(Wa({
    putSortable: Rt,
    cloneEl: At,
    targetEl: we,
    rootEl: bt,
    oldIndex: Er,
    oldDraggableIndex: xi,
    newIndex: oa,
    newDraggableIndex: kn
  }, e));
}
var we, Dt, Qe, bt, Un, Jo, At, Tn, Er, oa, xi, kn, Ro, Rt, Ar = !1, Ol = !1, Pl = [], Yn, ka, Ks, Vs, Xh, Jh, mi, Cr, Ti, Di = !1, Fo = !1, _o, zt, js = [], Au = !1, Nl = [], ds = typeof document < "u", zo = k1, _h = Ui || pn ? "cssFloat" : "float", aH = ds && !VY && !k1 && "draggable" in document.createElement("div"), A1 = (function() {
  if (ds) {
    if (pn)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
})(), I1 = function(t, a) {
  var n = qe(t), r = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), i = Vr(t, 0, a), o = Vr(t, 1, a), u = i && qe(i), s = o && qe(o), l = u && parseInt(u.marginLeft) + parseInt(u.marginRight) + Pt(i).width, c = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + Pt(o).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i && u.float && u.float !== "none") {
    var d = u.float === "left" ? "left" : "right";
    return o && (s.clear === "both" || s.clear === d) ? "vertical" : "horizontal";
  }
  return i && (u.display === "block" || u.display === "flex" || u.display === "table" || u.display === "grid" || l >= r && n[_h] === "none" || o && n[_h] === "none" && l + c > r) ? "vertical" : "horizontal";
}, nH = function(t, a, n) {
  var r = n ? t.left : t.top, i = n ? t.right : t.bottom, o = n ? t.width : t.height, u = n ? a.left : a.top, s = n ? a.right : a.bottom, l = n ? a.width : a.height;
  return r === u || i === s || r + o / 2 === u + l / 2;
}, rH = function(t, a) {
  var n;
  return Pl.some(function(r) {
    var i = r[sa].options.emptyInsertThreshold;
    if (!(!i || Fc(r))) {
      var o = Pt(r), u = t >= o.left - i && t <= o.right + i, s = a >= o.top - i && a <= o.bottom + i;
      if (u && s)
        return n = r;
    }
  }), n;
}, E1 = function(t) {
  function a(i, o) {
    return function(u, s, l, c) {
      var d = u.options.group.name && s.options.group.name && u.options.group.name === s.options.group.name;
      if (i == null && (o || d))
        return !0;
      if (i == null || i === !1)
        return !1;
      if (o && i === "clone")
        return i;
      if (typeof i == "function")
        return a(i(u, s, l, c), o)(u, s, l, c);
      var f = (o ? u : s).options.group.name;
      return i === !0 || typeof i == "string" && i === f || i.join && i.indexOf(f) > -1;
    };
  }
  var n = {}, r = t.group;
  (!r || Xo(r) != "object") && (r = {
    name: r
  }), n.name = r.name, n.checkPull = a(r.pull, !0), n.checkPut = a(r.put), n.revertClone = r.revertClone, t.group = n;
}, M1 = function() {
  !A1 && Qe && qe(Qe, "display", "none");
}, O1 = function() {
  !A1 && Qe && qe(Qe, "display", "");
};
ds && document.addEventListener("click", function(e) {
  if (Ol)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Ol = !1, !1;
}, !0);
var Hn = function(t) {
  if (we) {
    t = t.touches ? t.touches[0] : t;
    var a = rH(t.clientX, t.clientY);
    if (a) {
      var n = {};
      for (var r in t)
        t.hasOwnProperty(r) && (n[r] = t[r]);
      n.target = n.rootEl = a, n.preventDefault = void 0, n.stopPropagation = void 0, a[sa]._onDragOver(n);
    }
  }
}, iH = function(t) {
  we && we.parentNode[sa]._isOutsideThisEl(t.target);
};
function We(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = dn({}, t), e[sa] = this;
  var a = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return I1(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(o, u) {
      o.setData("Text", u.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: We.supportPointer !== !1 && "PointerEvent" in window && !$i,
    emptyInsertThreshold: 5
  };
  Ki.initializePlugins(this, e, a);
  for (var n in a)
    !(n in t) && (t[n] = a[n]);
  E1(t);
  for (var r in this)
    r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : aH, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? ot(e, "pointerdown", this._onTapStart) : (ot(e, "mousedown", this._onTapStart), ot(e, "touchstart", this._onTapStart)), this.nativeDraggable && (ot(e, "dragover", this), ot(e, "dragenter", this)), Pl.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), dn(this, XY());
}
We.prototype = /** @lends Sortable.prototype */
{
  constructor: We,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Cr = null);
  },
  _getDirection: function(t, a) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, a, we) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var a = this, n = this.el, r = this.options, i = r.preventOnFilter, o = t.type, u = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, s = (u || t).target, l = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || s, c = r.filter;
      if (vH(n), !we && !(/mousedown|pointerdown/.test(o) && t.button !== 0 || r.disabled) && !l.isContentEditable && !(!this.nativeDraggable && $i && s && s.tagName.toUpperCase() === "SELECT") && (s = Pa(s, r.draggable, n, !1), !(s && s.animated) && Jo !== s)) {
        if (Er = fa(s), xi = fa(s, r.draggable), typeof c == "function") {
          if (c.call(this, t, s, this)) {
            Kt({
              sortable: a,
              rootEl: l,
              name: "filter",
              targetEl: s,
              toEl: n,
              fromEl: n
            }), _t("filter", a, {
              evt: t
            }), i && t.cancelable && t.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(d) {
          if (d = Pa(l, d.trim(), n, !1), d)
            return Kt({
              sortable: a,
              rootEl: d,
              name: "filter",
              targetEl: s,
              fromEl: n,
              toEl: n
            }), _t("filter", a, {
              evt: t
            }), !0;
        }), c)) {
          i && t.cancelable && t.preventDefault();
          return;
        }
        r.handle && !Pa(l, r.handle, n, !1) || this._prepareDragStart(t, u, s);
      }
    }
  },
  _prepareDragStart: function(t, a, n) {
    var r = this, i = r.el, o = r.options, u = i.ownerDocument, s;
    if (n && !we && n.parentNode === i) {
      var l = Pt(n);
      if (bt = i, we = n, Dt = we.parentNode, Un = we.nextSibling, Jo = n, Ro = o.group, We.dragged = we, Yn = {
        target: we,
        clientX: (a || t).clientX,
        clientY: (a || t).clientY
      }, Xh = Yn.clientX - l.left, Jh = Yn.clientY - l.top, this._lastX = (a || t).clientX, this._lastY = (a || t).clientY, we.style["will-change"] = "all", s = function() {
        if (_t("delayEnded", r, {
          evt: t
        }), We.eventCanceled) {
          r._onDrop();
          return;
        }
        r._disableDelayedDragEvents(), !jh && r.nativeDraggable && (we.draggable = !0), r._triggerDragStart(t, a), Kt({
          sortable: r,
          name: "choose",
          originalEvent: t
        }), ia(we, o.chosenClass, !0);
      }, o.ignore.split(",").forEach(function(c) {
        S1(we, c.trim(), Gs);
      }), ot(u, "dragover", Hn), ot(u, "mousemove", Hn), ot(u, "touchmove", Hn), ot(u, "mouseup", r._onDrop), ot(u, "touchend", r._onDrop), ot(u, "touchcancel", r._onDrop), jh && this.nativeDraggable && (this.options.touchStartThreshold = 4, we.draggable = !0), _t("delayStart", this, {
        evt: t
      }), o.delay && (!o.delayOnTouchOnly || a) && (!this.nativeDraggable || !(Ui || pn))) {
        if (We.eventCanceled) {
          this._onDrop();
          return;
        }
        ot(u, "mouseup", r._disableDelayedDrag), ot(u, "touchend", r._disableDelayedDrag), ot(u, "touchcancel", r._disableDelayedDrag), ot(u, "mousemove", r._delayedDragTouchMoveHandler), ot(u, "touchmove", r._delayedDragTouchMoveHandler), o.supportPointer && ot(u, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(s, o.delay);
      } else
        s();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var a = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(a.clientX - this._lastX), Math.abs(a.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    we && Gs(we), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    at(t, "mouseup", this._disableDelayedDrag), at(t, "touchend", this._disableDelayedDrag), at(t, "touchcancel", this._disableDelayedDrag), at(t, "mousemove", this._delayedDragTouchMoveHandler), at(t, "touchmove", this._delayedDragTouchMoveHandler), at(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, a) {
    a = a || t.pointerType == "touch" && t, !this.nativeDraggable || a ? this.options.supportPointer ? ot(document, "pointermove", this._onTouchMove) : a ? ot(document, "touchmove", this._onTouchMove) : ot(document, "mousemove", this._onTouchMove) : (ot(we, "dragend", this), ot(bt, "dragstart", this._onDragStart));
    try {
      document.selection ? el(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, a) {
    if (Ar = !1, bt && we) {
      _t("dragStarted", this, {
        evt: a
      }), this.nativeDraggable && ot(document, "dragover", iH);
      var n = this.options;
      !t && ia(we, n.dragClass, !1), ia(we, n.ghostClass, !0), We.active = this, t && this._appendGhost(), Kt({
        sortable: this,
        name: "start",
        originalEvent: a
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (ka) {
      this._lastX = ka.clientX, this._lastY = ka.clientY, M1();
      for (var t = document.elementFromPoint(ka.clientX, ka.clientY), a = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(ka.clientX, ka.clientY), t !== a); )
        a = t;
      if (we.parentNode[sa]._isOutsideThisEl(t), a)
        do {
          if (a[sa]) {
            var n = void 0;
            if (n = a[sa]._onDragOver({
              clientX: ka.clientX,
              clientY: ka.clientY,
              target: t,
              rootEl: a
            }), n && !this.options.dragoverBubble)
              break;
          }
          t = a;
        } while (a = a.parentNode);
      O1();
    }
  },
  _onTouchMove: function(t) {
    if (Yn) {
      var a = this.options, n = a.fallbackTolerance, r = a.fallbackOffset, i = t.touches ? t.touches[0] : t, o = Qe && Br(Qe, !0), u = Qe && o && o.a, s = Qe && o && o.d, l = zo && zt && Zh(zt), c = (i.clientX - Yn.clientX + r.x) / (u || 1) + (l ? l[0] - js[0] : 0) / (u || 1), d = (i.clientY - Yn.clientY + r.y) / (s || 1) + (l ? l[1] - js[1] : 0) / (s || 1);
      if (!We.active && !Ar) {
        if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n)
          return;
        this._onDragStart(t, !0);
      }
      if (Qe) {
        o ? (o.e += c - (Ks || 0), o.f += d - (Vs || 0)) : o = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f: d
        };
        var f = "matrix(".concat(o.a, ",").concat(o.b, ",").concat(o.c, ",").concat(o.d, ",").concat(o.e, ",").concat(o.f, ")");
        qe(Qe, "webkitTransform", f), qe(Qe, "mozTransform", f), qe(Qe, "msTransform", f), qe(Qe, "transform", f), Ks = c, Vs = d, ka = i;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Qe) {
      var t = this.options.fallbackOnBody ? document.body : bt, a = Pt(we, !0, zo, !0, t), n = this.options;
      if (zo) {
        for (zt = t; qe(zt, "position") === "static" && qe(zt, "transform") === "none" && zt !== document; )
          zt = zt.parentNode;
        zt !== document.body && zt !== document.documentElement ? (zt === document && (zt = za()), a.top += zt.scrollTop, a.left += zt.scrollLeft) : zt = za(), js = Zh(zt);
      }
      Qe = we.cloneNode(!0), ia(Qe, n.ghostClass, !1), ia(Qe, n.fallbackClass, !0), ia(Qe, n.dragClass, !0), qe(Qe, "transition", ""), qe(Qe, "transform", ""), qe(Qe, "box-sizing", "border-box"), qe(Qe, "margin", 0), qe(Qe, "top", a.top), qe(Qe, "left", a.left), qe(Qe, "width", a.width), qe(Qe, "height", a.height), qe(Qe, "opacity", "0.8"), qe(Qe, "position", zo ? "absolute" : "fixed"), qe(Qe, "zIndex", "100000"), qe(Qe, "pointerEvents", "none"), We.ghost = Qe, t.appendChild(Qe), qe(Qe, "transform-origin", Xh / parseInt(Qe.style.width) * 100 + "% " + Jh / parseInt(Qe.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, a) {
    var n = this, r = t.dataTransfer, i = n.options;
    if (_t("dragStart", this, {
      evt: t
    }), We.eventCanceled) {
      this._onDrop();
      return;
    }
    _t("setupClone", this), We.eventCanceled || (At = D1(we), At.draggable = !1, At.style["will-change"] = "", this._hideClone(), ia(At, this.options.chosenClass, !1), We.clone = At), n.cloneId = el(function() {
      _t("clone", n), !We.eventCanceled && (n.options.removeCloneOnHide || bt.insertBefore(At, we), n._hideClone(), Kt({
        sortable: n,
        name: "clone"
      }));
    }), !a && ia(we, i.dragClass, !0), a ? (Ol = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (at(document, "mouseup", n._onDrop), at(document, "touchend", n._onDrop), at(document, "touchcancel", n._onDrop), r && (r.effectAllowed = "move", i.setData && i.setData.call(n, r, we)), ot(document, "drop", n), qe(we, "transform", "translateZ(0)")), Ar = !0, n._dragStartId = el(n._dragStarted.bind(n, a, t)), ot(document, "selectstart", n), mi = !0, $i && qe(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var a = this.el, n = t.target, r, i, o, u = this.options, s = u.group, l = We.active, c = Ro === s, d = u.sort, f = Rt || l, v, y = this, C = !1;
    if (Au) return;
    function h(K, J) {
      _t(K, y, Wa({
        evt: t,
        isOwner: c,
        axis: v ? "vertical" : "horizontal",
        revert: o,
        dragRect: r,
        targetRect: i,
        canSort: d,
        fromSortable: f,
        target: n,
        completed: p,
        onMove: function(se, fe) {
          return Yo(bt, a, we, r, se, Pt(se), t, fe);
        },
        changed: w
      }, J));
    }
    function g() {
      h("dragOverAnimationCapture"), y.captureAnimationState(), y !== f && f.captureAnimationState();
    }
    function p(K) {
      return h("dragOverCompleted", {
        insertion: K
      }), K && (c ? l._hideClone() : l._showClone(y), y !== f && (ia(we, Rt ? Rt.options.ghostClass : l.options.ghostClass, !1), ia(we, u.ghostClass, !0)), Rt !== y && y !== We.active ? Rt = y : y === We.active && Rt && (Rt = null), f === y && (y._ignoreWhileAnimating = n), y.animateAll(function() {
        h("dragOverAnimationComplete"), y._ignoreWhileAnimating = null;
      }), y !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (n === we && !we.animated || n === a && !n.animated) && (Cr = null), !u.dragoverBubble && !t.rootEl && n !== document && (we.parentNode[sa]._isOutsideThisEl(t.target), !K && Hn(t)), !u.dragoverBubble && t.stopPropagation && t.stopPropagation(), C = !0;
    }
    function w() {
      oa = fa(we), kn = fa(we, u.draggable), Kt({
        sortable: y,
        name: "change",
        toEl: a,
        newIndex: oa,
        newDraggableIndex: kn,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), n = Pa(n, u.draggable, a, !0), h("dragOver"), We.eventCanceled) return C;
    if (we.contains(t.target) || n.animated && n.animatingX && n.animatingY || y._ignoreWhileAnimating === n)
      return p(!1);
    if (Ol = !1, l && !u.disabled && (c ? d || (o = Dt !== bt) : Rt === this || (this.lastPutMode = Ro.checkPull(this, l, we, t)) && s.checkPut(this, l, we, t))) {
      if (v = this._getDirection(t, n) === "vertical", r = Pt(we), h("dragOverValid"), We.eventCanceled) return C;
      if (o)
        return Dt = bt, g(), this._hideClone(), h("revert"), We.eventCanceled || (Un ? bt.insertBefore(we, Un) : bt.appendChild(we)), p(!0);
      var k = Fc(a, u.draggable);
      if (!k || uH(t, v, this) && !k.animated) {
        if (k === we)
          return p(!1);
        if (k && a === t.target && (n = k), n && (i = Pt(n)), Yo(bt, a, we, r, n, i, t, !!n) !== !1)
          return g(), a.appendChild(we), Dt = a, w(), p(!0);
      } else if (k && sH(t, v, this)) {
        var S = Vr(a, 0, u, !0);
        if (S === we)
          return p(!1);
        if (n = S, i = Pt(n), Yo(bt, a, we, r, n, i, t, !1) !== !1)
          return g(), a.insertBefore(we, S), Dt = a, w(), p(!0);
      } else if (n.parentNode === a) {
        i = Pt(n);
        var T = 0, A, F = we.parentNode !== a, Z = !nH(we.animated && we.toRect || r, n.animated && n.toRect || i, v), O = v ? "top" : "left", z = Qh(n, "top", "top") || Qh(we, "top", "top"), U = z ? z.scrollTop : void 0;
        Cr !== n && (A = i[O], Di = !1, Fo = !Z && u.invertSwap || F), T = cH(t, n, i, v, Z ? 1 : u.swapThreshold, u.invertedSwapThreshold == null ? u.swapThreshold : u.invertedSwapThreshold, Fo, Cr === n);
        var x;
        if (T !== 0) {
          var I = fa(we);
          do
            I -= T, x = Dt.children[I];
          while (x && (qe(x, "display") === "none" || x === Qe));
        }
        if (T === 0 || x === n)
          return p(!1);
        Cr = n, Ti = T;
        var E = n.nextElementSibling, P = !1;
        P = T === 1;
        var R = Yo(bt, a, we, r, n, i, t, P);
        if (R !== !1)
          return (R === 1 || R === -1) && (P = R === 1), Au = !0, setTimeout(lH, 30), g(), P && !E ? a.appendChild(we) : n.parentNode.insertBefore(we, P ? E : n), z && T1(z, 0, U - z.scrollTop), Dt = we.parentNode, A !== void 0 && !Fo && (_o = Math.abs(A - Pt(n)[O])), w(), p(!0);
      }
      if (a.contains(we))
        return p(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    at(document, "mousemove", this._onTouchMove), at(document, "touchmove", this._onTouchMove), at(document, "pointermove", this._onTouchMove), at(document, "dragover", Hn), at(document, "mousemove", Hn), at(document, "touchmove", Hn);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    at(t, "mouseup", this._onDrop), at(t, "touchend", this._onDrop), at(t, "pointerup", this._onDrop), at(t, "touchcancel", this._onDrop), at(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var a = this.el, n = this.options;
    if (oa = fa(we), kn = fa(we, n.draggable), _t("drop", this, {
      evt: t
    }), Dt = we && we.parentNode, oa = fa(we), kn = fa(we, n.draggable), We.eventCanceled) {
      this._nulling();
      return;
    }
    Ar = !1, Fo = !1, Di = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Iu(this.cloneId), Iu(this._dragStartId), this.nativeDraggable && (at(document, "drop", this), at(a, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), $i && qe(document.body, "user-select", ""), qe(we, "transform", ""), t && (mi && (t.cancelable && t.preventDefault(), !n.dropBubble && t.stopPropagation()), Qe && Qe.parentNode && Qe.parentNode.removeChild(Qe), (bt === Dt || Rt && Rt.lastPutMode !== "clone") && At && At.parentNode && At.parentNode.removeChild(At), we && (this.nativeDraggable && at(we, "dragend", this), Gs(we), we.style["will-change"] = "", mi && !Ar && ia(we, Rt ? Rt.options.ghostClass : this.options.ghostClass, !1), ia(we, this.options.chosenClass, !1), Kt({
      sortable: this,
      name: "unchoose",
      toEl: Dt,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), bt !== Dt ? (oa >= 0 && (Kt({
      rootEl: Dt,
      name: "add",
      toEl: Dt,
      fromEl: bt,
      originalEvent: t
    }), Kt({
      sortable: this,
      name: "remove",
      toEl: Dt,
      originalEvent: t
    }), Kt({
      rootEl: Dt,
      name: "sort",
      toEl: Dt,
      fromEl: bt,
      originalEvent: t
    }), Kt({
      sortable: this,
      name: "sort",
      toEl: Dt,
      originalEvent: t
    })), Rt && Rt.save()) : oa !== Er && oa >= 0 && (Kt({
      sortable: this,
      name: "update",
      toEl: Dt,
      originalEvent: t
    }), Kt({
      sortable: this,
      name: "sort",
      toEl: Dt,
      originalEvent: t
    })), We.active && ((oa == null || oa === -1) && (oa = Er, kn = xi), Kt({
      sortable: this,
      name: "end",
      toEl: Dt,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    _t("nulling", this), bt = we = Dt = Qe = Un = At = Jo = Tn = Yn = ka = mi = oa = kn = Er = xi = Cr = Ti = Rt = Ro = We.dragged = We.ghost = We.clone = We.active = null, Nl.forEach(function(t) {
      t.checked = !0;
    }), Nl.length = Ks = Vs = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        we && (this._onDragOver(t), oH(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], a, n = this.el.children, r = 0, i = n.length, o = this.options; r < i; r++)
      a = n[r], Pa(a, o.draggable, this.el, !1) && t.push(a.getAttribute(o.dataIdAttr) || fH(a));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, a) {
    var n = {}, r = this.el;
    this.toArray().forEach(function(i, o) {
      var u = r.children[o];
      Pa(u, this.options.draggable, r, !1) && (n[i] = u);
    }, this), a && this.captureAnimationState(), t.forEach(function(i) {
      n[i] && (r.removeChild(n[i]), r.appendChild(n[i]));
    }), a && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, a) {
    return Pa(t, a || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, a) {
    var n = this.options;
    if (a === void 0)
      return n[t];
    var r = Ki.modifyOption(this, t, a);
    typeof r < "u" ? n[t] = r : n[t] = a, t === "group" && E1(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    _t("destroy", this);
    var t = this.el;
    t[sa] = null, at(t, "mousedown", this._onTapStart), at(t, "touchstart", this._onTapStart), at(t, "pointerdown", this._onTapStart), this.nativeDraggable && (at(t, "dragover", this), at(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(a) {
      a.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Pl.splice(Pl.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Tn) {
      if (_t("hideClone", this), We.eventCanceled) return;
      qe(At, "display", "none"), this.options.removeCloneOnHide && At.parentNode && At.parentNode.removeChild(At), Tn = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Tn) {
      if (_t("showClone", this), We.eventCanceled) return;
      we.parentNode == bt && !this.options.group.revertClone ? bt.insertBefore(At, we) : Un ? bt.insertBefore(At, Un) : bt.appendChild(At), this.options.group.revertClone && this.animate(we, At), qe(At, "display", ""), Tn = !1;
    }
  }
};
function oH(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function Yo(e, t, a, n, r, i, o, u) {
  var s, l = e[sa], c = l.options.onMove, d;
  return window.CustomEvent && !pn && !Ui ? s = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (s = document.createEvent("Event"), s.initEvent("move", !0, !0)), s.to = t, s.from = e, s.dragged = a, s.draggedRect = n, s.related = r || t, s.relatedRect = i || Pt(t), s.willInsertAfter = u, s.originalEvent = o, e.dispatchEvent(s), c && (d = c.call(l, s, o)), d;
}
function Gs(e) {
  e.draggable = !1;
}
function lH() {
  Au = !1;
}
function sH(e, t, a) {
  var n = Pt(Vr(a.el, 0, a.options, !0)), r = 10;
  return t ? e.clientX < n.left - r || e.clientY < n.top && e.clientX < n.right : e.clientY < n.top - r || e.clientY < n.bottom && e.clientX < n.left;
}
function uH(e, t, a) {
  var n = Pt(Fc(a.el, a.options.draggable)), r = 10;
  return t ? e.clientX > n.right + r || e.clientX <= n.right && e.clientY > n.bottom && e.clientX >= n.left : e.clientX > n.right && e.clientY > n.top || e.clientX <= n.right && e.clientY > n.bottom + r;
}
function cH(e, t, a, n, r, i, o, u) {
  var s = n ? e.clientY : e.clientX, l = n ? a.height : a.width, c = n ? a.top : a.left, d = n ? a.bottom : a.right, f = !1;
  if (!o) {
    if (u && _o < l * r) {
      if (!Di && (Ti === 1 ? s > c + l * i / 2 : s < d - l * i / 2) && (Di = !0), Di)
        f = !0;
      else if (Ti === 1 ? s < c + _o : s > d - _o)
        return -Ti;
    } else if (s > c + l * (1 - r) / 2 && s < d - l * (1 - r) / 2)
      return dH(t);
  }
  return f = f || o, f && (s < c + l * i / 2 || s > d - l * i / 2) ? s > c + l / 2 ? 1 : -1 : 0;
}
function dH(e) {
  return fa(we) < fa(e) ? 1 : -1;
}
function fH(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, a = t.length, n = 0; a--; )
    n += t.charCodeAt(a);
  return n.toString(36);
}
function vH(e) {
  Nl.length = 0;
  for (var t = e.getElementsByTagName("input"), a = t.length; a--; ) {
    var n = t[a];
    n.checked && Nl.push(n);
  }
}
function el(e) {
  return setTimeout(e, 0);
}
function Iu(e) {
  return clearTimeout(e);
}
ds && ot(document, "touchmove", function(e) {
  (We.active || Ar) && e.cancelable && e.preventDefault();
});
We.utils = {
  on: ot,
  off: at,
  css: qe,
  find: S1,
  is: function(t, a) {
    return !!Pa(t, a, t, !1);
  },
  extend: QY,
  throttle: x1,
  closest: Pa,
  toggleClass: ia,
  clone: D1,
  index: fa,
  nextTick: el,
  cancelNextTick: Iu,
  detectDirection: I1,
  getChild: Vr
};
We.get = function(e) {
  return e[sa];
};
We.mount = function() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(n) {
    if (!n.prototype || !n.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n));
    n.utils && (We.utils = Wa(Wa({}, We.utils), n.utils)), Ki.mount(n);
  });
};
We.create = function(e, t) {
  return new We(e, t);
};
We.version = KY;
var Et = [], pi, Eu, Mu = !1, Qs, Zs, Ll, yi;
function hH() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(a) {
      var n = a.originalEvent;
      this.sortable.nativeDraggable ? ot(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? ot(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? ot(document, "touchmove", this._handleFallbackAutoScroll) : ot(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(a) {
      var n = a.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? at(document, "dragover", this._handleAutoScroll) : (at(document, "pointermove", this._handleFallbackAutoScroll), at(document, "touchmove", this._handleFallbackAutoScroll), at(document, "mousemove", this._handleFallbackAutoScroll)), eg(), tl(), ZY();
    },
    nulling: function() {
      Ll = Eu = pi = Mu = yi = Qs = Zs = null, Et.length = 0;
    },
    _handleFallbackAutoScroll: function(a) {
      this._handleAutoScroll(a, !0);
    },
    _handleAutoScroll: function(a, n) {
      var r = this, i = (a.touches ? a.touches[0] : a).clientX, o = (a.touches ? a.touches[0] : a).clientY, u = document.elementFromPoint(i, o);
      if (Ll = a, n || this.options.forceAutoScrollFallback || Ui || pn || $i) {
        Xs(a, this.options, u, n);
        var s = Dn(u, !0);
        Mu && (!yi || i !== Qs || o !== Zs) && (yi && eg(), yi = setInterval(function() {
          var l = Dn(document.elementFromPoint(i, o), !0);
          l !== s && (s = l, tl()), Xs(a, r.options, l, n);
        }, 10), Qs = i, Zs = o);
      } else {
        if (!this.options.bubbleScroll || Dn(u, !0) === za()) {
          tl();
          return;
        }
        Xs(a, this.options, Dn(u, !1), !1);
      }
    }
  }, dn(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function tl() {
  Et.forEach(function(e) {
    clearInterval(e.pid);
  }), Et = [];
}
function eg() {
  clearInterval(yi);
}
var Xs = x1(function(e, t, a, n) {
  if (t.scroll) {
    var r = (e.touches ? e.touches[0] : e).clientX, i = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, u = t.scrollSpeed, s = za(), l = !1, c;
    Eu !== a && (Eu = a, tl(), pi = t.scroll, c = t.scrollFn, pi === !0 && (pi = Dn(a, !0)));
    var d = 0, f = pi;
    do {
      var v = f, y = Pt(v), C = y.top, h = y.bottom, g = y.left, p = y.right, w = y.width, k = y.height, S = void 0, T = void 0, A = v.scrollWidth, F = v.scrollHeight, Z = qe(v), O = v.scrollLeft, z = v.scrollTop;
      v === s ? (S = w < A && (Z.overflowX === "auto" || Z.overflowX === "scroll" || Z.overflowX === "visible"), T = k < F && (Z.overflowY === "auto" || Z.overflowY === "scroll" || Z.overflowY === "visible")) : (S = w < A && (Z.overflowX === "auto" || Z.overflowX === "scroll"), T = k < F && (Z.overflowY === "auto" || Z.overflowY === "scroll"));
      var U = S && (Math.abs(p - r) <= o && O + w < A) - (Math.abs(g - r) <= o && !!O), x = T && (Math.abs(h - i) <= o && z + k < F) - (Math.abs(C - i) <= o && !!z);
      if (!Et[d])
        for (var I = 0; I <= d; I++)
          Et[I] || (Et[I] = {});
      (Et[d].vx != U || Et[d].vy != x || Et[d].el !== v) && (Et[d].el = v, Et[d].vx = U, Et[d].vy = x, clearInterval(Et[d].pid), (U != 0 || x != 0) && (l = !0, Et[d].pid = setInterval((function() {
        n && this.layer === 0 && We.active._onTouchMove(Ll);
        var E = Et[this.layer].vy ? Et[this.layer].vy * u : 0, P = Et[this.layer].vx ? Et[this.layer].vx * u : 0;
        typeof c == "function" && c.call(We.dragged.parentNode[sa], P, E, e, Ll, Et[this.layer].el) !== "continue" || T1(Et[this.layer].el, P, E);
      }).bind({
        layer: d
      }), 24))), d++;
    } while (t.bubbleScroll && f !== s && (f = Dn(f, !1)));
    Mu = l;
  }
}, 30), P1 = function(t) {
  var a = t.originalEvent, n = t.putSortable, r = t.dragEl, i = t.activeSortable, o = t.dispatchSortableEvent, u = t.hideGhostForTarget, s = t.unhideGhostForTarget;
  if (a) {
    var l = n || i;
    u();
    var c = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a, d = document.elementFromPoint(c.clientX, c.clientY);
    s(), l && !l.el.contains(d) && (o("spill"), this.onSpill({
      dragEl: r,
      putSortable: n
    }));
  }
};
function zc() {
}
zc.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var a = t.oldDraggableIndex;
    this.startIndex = a;
  },
  onSpill: function(t) {
    var a = t.dragEl, n = t.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var r = Vr(this.sortable.el, this.startIndex, this.options);
    r ? this.sortable.el.insertBefore(a, r) : this.sortable.el.appendChild(a), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: P1
};
dn(zc, {
  pluginName: "revertOnSpill"
});
function Yc() {
}
Yc.prototype = {
  onSpill: function(t) {
    var a = t.dragEl, n = t.putSortable, r = n || this.sortable;
    r.captureAnimationState(), a.parentNode && a.parentNode.removeChild(a), r.animateAll();
  },
  drop: P1
};
dn(Yc, {
  pluginName: "removeOnSpill"
});
We.mount(new hH());
We.mount(Yc, zc);
function gH(e, t) {
  return Object.values(e).indexOf(t);
}
function mH(e, t, a, n) {
  if (!e)
    return [];
  const r = Object.values(e), i = t.length - n;
  return [...t].map((u, s) => s >= i ? r.length : r.indexOf(u));
}
function pH(e) {
  return ["transition-group", "TransitionGroup"].includes(e);
}
function tg(e) {
  if (!e || e.length !== 1)
    return !1;
  const [{ type: t }] = e;
  return t ? pH(t.name) : !1;
}
function yH(e, t) {
  return t ? { ...t.props, ...t.attrs } : e;
}
const Ou = ["Start", "Add", "Remove", "Update", "End"], Pu = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], bH = ["Move", ...Ou, ...Pu].map((e) => "on" + e);
let Js = null;
const wH = oe({
  name: "VueDraggableNext",
  inheritAttrs: !1,
  props: {
    options: Object,
    list: {
      type: Array,
      required: !1,
      default: null
    },
    noTransitionOnDrag: {
      type: Boolean,
      default: !1
    },
    clone: {
      type: Function,
      default: (e) => e
    },
    tag: {
      type: String,
      default: "div"
    },
    move: {
      type: Function,
      default: null
    },
    componentData: {
      type: Object,
      required: !1,
      default: null
    },
    component: {
      type: String,
      default: null
    },
    modelValue: {
      type: Array,
      required: !1,
      default: null
    }
  },
  emits: [
    "update:modelValue",
    "move",
    "change",
    ...Ou.map((e) => e.toLowerCase()),
    ...Pu.map((e) => e.toLowerCase())
  ],
  setup(e, { emit: t, slots: a, attrs: n }) {
    const r = N(!1), i = N(!1), o = N(0), u = N(0), s = N([]), l = N(null), c = N(null), d = b(() => e.list ? e.list : e.modelValue), f = Nu();
    function v() {
      return e.component ? qt(e.component) : e.tag;
    }
    function y(ne) {
      if (c.value)
        for (const ae in ne) {
          const ve = Uh(ae);
          bH.indexOf(ve) === -1 && c.value.option(ve, ne[ae]);
        }
    }
    function C() {
      var ne;
      return ((ne = f == null ? void 0 : f.proxy) == null ? void 0 : ne.$el.children) || [];
    }
    async function h() {
      var ne;
      await ht(), s.value = mH(C(), ((ne = f == null ? void 0 : f.proxy) == null ? void 0 : ne.$el.children) || [], r.value, u.value);
    }
    function g(ne) {
      const ae = gH(C() || [], ne);
      if (ae === -1)
        return null;
      const ve = d.value ? d.value[ae] : null;
      return { index: ae, element: ve };
    }
    function p(ne) {
      ht(() => t("change", ne));
    }
    function w(ne) {
      if (e.list) {
        ne(e.list);
        return;
      }
      const ae = [...e.modelValue || []];
      ne(ae), t("update:modelValue", ae);
    }
    function k(...ne) {
      w((ve) => ve.splice(...ne));
    }
    function S(ne, ae) {
      w((Ae) => Ae.splice(ae, 0, Ae.splice(ne, 1)[0]));
    }
    function T(ne) {
      const ae = s.value, ve = ae.length;
      return ne > ve - 1 ? ve : ae[ne];
    }
    function A() {
      var ae, ve;
      return a.default && ((ve = (ae = a.default()[0]) == null ? void 0 : ae.component) == null ? void 0 : ve.proxy) || null;
    }
    function F(ne) {
      if (!e.noTransitionOnDrag || !r.value)
        return;
      const ae = C();
      ae[ne] && (ae[ne].data = null);
      const ve = A();
      ve && (ve.children = [], ve.kept = void 0);
    }
    function Z(ne) {
      h(), l.value = g(ne.item), l.value && (ne.item._underlying_vm_ = e.clone(l.value.element), Js = ne.item);
    }
    function O(ne) {
      const ae = ne.item._underlying_vm_;
      if (ae === void 0)
        return;
      qs(ne.item);
      const ve = T(ne.newIndex);
      k(ve, 0, ae), h(), p({ added: { element: ae, newIndex: ve } });
    }
    function z(ne) {
      var ve;
      if (Kh((ve = f == null ? void 0 : f.proxy) == null ? void 0 : ve.$el, ne.item, ne.oldIndex), ne.pullMode === "clone") {
        qs(ne.clone);
        return;
      }
      if (!l.value)
        return;
      const ae = l.value.index;
      k(ae, 1), F(ae), p({ removed: { element: l.value.element, oldIndex: ae } });
    }
    function U(ne) {
      var Ae, Te;
      qs(ne.item), Kh(ne.from, ne.item, ne.oldIndex);
      const ae = (Ae = l.value) == null ? void 0 : Ae.index, ve = T(ne.newIndex);
      S(ae, ve), p({
        moved: { element: (Te = l.value) == null ? void 0 : Te.element, oldIndex: ae, newIndex: ve }
      });
    }
    function x(ne, ae) {
      Object.prototype.hasOwnProperty.call(ne, ae) && (ne[ae] += o.value);
    }
    function I(ne) {
      return ne.__draggable_component__;
    }
    function E({ to: ne, related: ae }) {
      const ve = I(ne);
      if (!ve)
        return { component: ve };
      const Ae = ve.realList, Te = { list: Ae, component: ve };
      if (ne !== ae && Ae && ve.getUnderlyingVm) {
        const Le = ve.getUnderlyingVm(ae);
        if (Le)
          return Object.assign(Le, Te);
      }
      return Te;
    }
    function P(ne, ae) {
      const ve = [...ae.to.children].filter((ze) => ze.style.display !== "none");
      if (ve.length === 0)
        return 0;
      const Ae = ve.indexOf(ae.related), Te = ne.component.getVmIndex(Ae);
      return ve.indexOf(Js) !== -1 || !ae.willInsertAfter ? Te : Te + 1;
    }
    const R = () => {
      var Te, Le;
      const ne = {};
      Ou.forEach((ze) => {
        ne["on" + ze] = J(ze);
      }), Pu.forEach((ze) => {
        ne["on" + ze] = K.bind(null, ze);
      });
      const ae = Object.keys(n).reduce((ze, _e) => (ze[Uh(_e)] = n[_e], ze), {}), ve = Object.assign({}, ae, ne, {
        onMove: (ze, _e) => q(ze, _e)
      });
      "draggable" in ve || (ve.draggable = ">*");
      const Ae = ((Te = f == null ? void 0 : f.proxy) == null ? void 0 : Te.$el.nodeType) === 1 ? f.proxy.$el : ((Le = f == null ? void 0 : f.proxy) == null ? void 0 : Le.$el.parentElement) || null;
      Ae && (c.value = new We(Ae, ve), Ae.__draggable_component__ = f == null ? void 0 : f.proxy, h());
    };
    function K(ne, ae) {
      ht(() => t(ne.toLowerCase(), ae));
    }
    function J(ne) {
      return (ae) => {
        if (d.value !== null) {
          const ve = "onDrag" + ne, Ae = fe[ve];
          Ae && Ae(ae);
        }
        K(ne, ae);
      };
    }
    function q(ne, ae) {
      const ve = e.move;
      if (!ve || !d.value)
        return !0;
      const Ae = E(ne), Te = l.value, Le = P(Ae, ne);
      Te && Object.assign(Te, { futureIndex: Le });
      const ze = Object.assign({}, ne, {
        relatedContext: Ae,
        draggedContext: Te
      });
      return ve(ze, ae);
    }
    function se() {
      h(), Js = null;
    }
    const fe = {
      onDragStart: Z,
      onDragAdd: O,
      onDragRemove: z,
      onDragUpdate: U,
      onDragMove: q,
      onDragEnd: se
    };
    return it(() => {
      R();
    }), e.list !== null && e.modelValue !== null && zY.error("list props are mutually exclusive! Please set one."), {
      getTag: v,
      realList: d,
      visibleIndexes: s,
      noneFunctionalComponentMode: i,
      headerOffset: o,
      footerOffset: u,
      transitionMode: r,
      computeIndexes: h,
      updateOptions: y,
      getChildrenNodes: C,
      getUnderlyingVm: g,
      emitChanges: p,
      alterList: w,
      spliceList: k,
      updatePosition: S,
      getVmIndex: T,
      getComponent: A,
      resetTransitionData: F,
      onDragStart: Z,
      onDragAdd: O,
      onDragRemove: z,
      onDragUpdate: U,
      updateProperty: x,
      onDragMove: q,
      onDragEnd: se,
      mounted: R,
      context: l,
      sortableInstance: c,
      getRelatedContextFromMoveEvent: E,
      getTargetedComponent: I,
      computeFutureIndex: P
      // ... other exposed functions as needed
    };
  },
  render() {
    const e = this.getTag(), t = yH(this.$attrs, this.componentData);
    if (typeof e == "string") {
      const n = this.$slots.default && typeof this.$slots.default == "function" ? this.$slots.default() : null;
      return n ? (this.transitionMode = tg(n), fs(e, t, n)) : fs(e, t, []);
    }
    const a = this.$slots.default ? { default: this.$slots.default } : {};
    if (this.$slots.default) {
      const n = typeof this.$slots.default == "function" ? this.$slots.default() : null;
      this.transitionMode = tg(n || []);
    }
    return fs(e, t, a);
  }
}), CH = ["data-testid"], kH = ["aria-controls", "aria-expanded", "aria-label"], $H = ["data-testid"], SH = {
  key: 0,
  class: "tree-item-icon",
  "data-testid": "tree-item-icon"
}, xH = {
  class: "tree-item-label",
  "data-testid": "tree-item-label"
}, TH = /* @__PURE__ */ oe({
  __name: "KTreeItem",
  props: {
    item: {},
    disabled: { type: Boolean },
    hideIcons: { type: Boolean },
    collapsible: { type: Boolean },
    initialCollapse: { type: Boolean },
    hasChildren: { type: Boolean },
    controlsId: {}
  },
  emits: ["selected", "expanded"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = $t(), i = b(() => !e.hideIcons || !!r["item-icon"]), o = (c) => {
      c.target && c.target.closest("a:not(.disabled), button:not([data-tree-item-trigger]), label, input, select") !== null || n("selected", e.item);
    }, u = N(!0), s = (c) => {
      u.value = c;
    };
    ie(() => e.initialCollapse, (c, d) => {
      c !== d && (u.value = !c);
    }, {
      immediate: !0
    });
    const l = () => {
      u.value = !u.value, n("expanded", u.value);
    };
    return t({ setExpandedValue: s, id: e.item.id }), (c, d) => (m(), $("div", {
      class: "tree-item-wrapper",
      "data-testid": `tree-item-wrapper-${e.item.id}`
    }, [
      e.collapsible && e.hasChildren ? (m(), $("span", {
        key: 0,
        "aria-controls": `tree-list-draggable-${e.controlsId}`,
        "aria-expanded": u.value,
        "aria-label": u.value ? "Collapse" : "Expand",
        class: ce(["tree-item-expanded-button", {
          collapsed: !u.value,
          expanded: u.value
        }]),
        "data-testid": "tree-item-expanded-button",
        role: "button",
        onClick: Ke(l, ["stop"]),
        onKeyup: ct(l, ["enter"])
      }, [
        G(D(Ru), {
          class: ce(["tree-item-expanded-icon", {
            collapsed: !u.value,
            expanded: u.value
          }]),
          "data-testid": "tree-item-expanded-icon",
          decorative: "",
          size: D(Qt),
          tabindex: "0"
        }, null, 8, ["class", "size"])
      ], 42, kH)) : H("", !0),
      Y("button", {
        class: ce(["tree-item", {
          "not-draggable": e.disabled,
          selected: e.item.selected,
          expanded: e.collapsible && u.value,
          collapsed: e.collapsible && !u.value,
          "no-children": e.collapsible && !e.hasChildren
        }]),
        "data-testid": `tree-item-${e.item.id}`,
        "data-tree-item-trigger": "true",
        draggable: "false",
        type: "button",
        onClick: Ke(o, ["prevent"])
      }, [
        i.value ? (m(), $("div", SH, [
          W(c.$slots, "item-icon", {}, () => [
            G(D(By), { decorative: "" })
          ], !0)
        ])) : H("", !0),
        Y("div", xH, [
          W(c.$slots, "item-label", {}, () => [
            be(re(e.item.name), 1)
          ], !0)
        ])
      ], 10, $H)
    ], 8, CH));
  }
}), DH = /* @__PURE__ */ Pe(TH, [["__scopeId", "data-v-18967eab"]]), Hc = ({ children: e = [] }) => e.length === 0 ? 0 : 1 + Math.max(...e.map(Hc)), AH = /* @__PURE__ */ oe({
  __name: "KTreeDraggable",
  props: {
    items: {},
    disableDrag: { type: Boolean },
    filter: { type: [String, Function] },
    maxDepth: {},
    level: { default: 0 },
    parentId: {},
    hideIcons: { type: Boolean },
    group: {},
    collapsible: { type: Boolean },
    initialCollapseAll: { type: Boolean }
  },
  emits: ["change", "child-change", "selected"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = N(0), i = N([]), o = {
      tag: "div",
      // Note: force-fallback: true is required to override cursor when dragging
      "force-fallback": !0,
      animation: "100",
      draggable: ".tree-item-container",
      "item-key": "id",
      "ghost-class": "tree-item-dragged",
      "drag-class": "tree-item-grabbing",
      class: "child-drop-zone",
      "fallback-tolerance": 10
    }, u = N(!1), s = b(() => [".tree-item-expanded-button", ...(typeof e.filter == "function" ? e.filter() : e.filter).split(",").map((z) => z.trim()).filter(Boolean)].join(", ")), l = (O) => {
      var z, U;
      return !((U = (z = i.value.filter((x) => x.id === O.id)) == null ? void 0 : z[0].children) != null && U.length);
    }, c = (O) => O.children || [], d = (O) => {
      e.parentId ? n("child-change", {
        parentId: e.parentId,
        children: i.value,
        target: (O == null ? void 0 : O.added) || (O == null ? void 0 : O.removed) || (O == null ? void 0 : O.moved)
      }) : n("change", {
        items: i.value,
        target: (O == null ? void 0 : O.added) || (O == null ? void 0 : O.removed) || (O == null ? void 0 : O.moved)
      });
    }, f = (O) => {
      n("child-change", O);
    }, v = (O) => {
      n("selected", O);
    }, y = N(/* @__PURE__ */ new Map()), C = (O, z) => {
      y.value.set(z, O);
    }, h = (O) => e.collapsible ? !!y.value.get(O) : !0, g = dt("tree-items"), p = () => {
      var O;
      i.value.forEach((z) => {
        y.value.set(z.id, !1);
      }), (O = g.value) == null || O.forEach((z) => {
        z == null || z.setExpandedValue(!1);
      });
    }, w = () => {
      var O;
      i.value.forEach((z) => {
        y.value.set(z.id, !0);
      }), (O = g.value) == null || O.forEach((z) => {
        z == null || z.setExpandedValue(!0);
      });
    }, k = b(() => e.level > e.maxDepth - 1), S = (O) => {
      var E, P, R, K;
      const z = ((P = (E = O.relatedContext) == null ? void 0 : E.component) == null ? void 0 : P.$attrs.level) || 0, U = (R = O.draggedContext) == null ? void 0 : R.element;
      let x = 0;
      return (K = U.children) != null && K.length && (x = Hc(U)), !(z + x > e.maxDepth - 1);
    }, T = (O) => {
      var x, I;
      const z = ((I = (x = O.item) == null ? void 0 : x._underlying_vm_) == null ? void 0 : I.id) || "", U = i.value.find((E) => E.id === z);
      u.value = !0, U && n("selected", U), F(!0);
    }, A = async () => {
      var O;
      u.value = !1, F(!1), r.value++, await ht(), (O = g.value) == null || O.forEach((z) => {
        z == null || z.setExpandedValue(y.value.get(z == null ? void 0 : z.id));
      });
    }, F = (O) => {
      const z = document == null ? void 0 : document.getElementsByTagName("html").item(0);
      z && z.classList.toggle("tree-list-grabbing", O);
    };
    ie(() => e.items, (O, z) => {
      JSON.stringify(O) !== JSON.stringify(z) && (i.value = O, i.value.forEach((U) => {
        U.children || (U.children = []);
      }));
    });
    const Z = () => {
      i.value.forEach((O) => {
        y.value.set(O.id, !e.initialCollapseAll);
      });
    };
    return it(async () => {
      i.value = e.items, i.value.forEach((O) => {
        O.children || (O.children = []);
      }), await ht(), e.collapsible && Z();
    }), t({ collapseAll: p, expandAll: w }), (O, z) => {
      const U = qt("KTreeDraggable", !0);
      return m(), X(D(wH), Re(o, {
        class: "tree-draggable",
        direction: "vertical",
        disabled: e.disableDrag,
        filter: s.value,
        group: { name: e.group, pull: [e.group], put: k.value ? [] : [e.group] },
        level: e.level,
        list: i.value,
        move: S,
        tag: "div",
        onChange: d,
        onEnd: A,
        onStart: T
      }), {
        default: L(() => [
          (m(!0), $(Ee, null, Fe(i.value, (x) => (m(), $("div", {
            key: x.id,
            class: ce(["tree-item-container", {
              "has-no-children": l(x)
            }])
          }, [
            (m(), X(DH, {
              key: `tree-item-${x.id}-${r.value}`,
              ref_for: !0,
              ref: "tree-items",
              collapsible: e.collapsible,
              "controls-id": x.id,
              disabled: e.disableDrag,
              "has-children": !l(x),
              "hide-icons": e.hideIcons,
              "initial-collapse": e.initialCollapseAll,
              item: x,
              onExpanded: (I) => C(I, x.id),
              onSelected: v
            }, kt({
              "item-label": L(() => [
                W(O.$slots, "item-label", { item: x }, () => [
                  be(re(x.name), 1)
                ], !0)
              ]),
              _: 2
            }, [
              O.$slots["item-icon"] ? {
                name: "item-icon",
                fn: L(() => [
                  W(O.$slots, "item-icon", { item: x }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["collapsible", "controls-id", "disabled", "has-children", "hide-icons", "initial-collapse", "item", "onExpanded"])),
            pa((m(), X(U, {
              id: `tree-list-draggable-${x.id}`,
              key: `tree-item-${x.id}-children-${r.value}`,
              class: ce({
                collapsible: e.collapsible
              }),
              collapsible: e.collapsible,
              "disable-drag": e.disableDrag,
              filter: s.value,
              group: e.group,
              "hide-icons": e.hideIcons,
              "initial-collapse-all": e.initialCollapseAll,
              items: c(x),
              level: e.level + 1,
              "max-depth": e.maxDepth,
              "parent-id": x.id,
              onChildChange: f,
              onSelected: v
            }, kt({
              "item-label": L(({ item: I }) => [
                W(O.$slots, "item-label", { item: I }, void 0, !0)
              ]),
              _: 2
            }, [
              O.$slots["item-icon"] ? {
                name: "item-icon",
                fn: L(({ item: I }) => [
                  W(O.$slots, "item-icon", { item: I }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["id", "class", "collapsible", "disable-drag", "filter", "group", "hide-icons", "initial-collapse-all", "items", "level", "max-depth", "parent-id"])), [
              [Xn, h(x.id)]
            ])
          ], 2))), 128))
        ]),
        _: 3
      }, 16, ["disabled", "filter", "group", "level", "list"]);
    };
  }
}), IH = /* @__PURE__ */ Pe(AH, [["__scopeId", "data-v-8e1a81f7"]]), EH = /* @__PURE__ */ oe({
  __name: "KTreeList",
  props: {
    modelValue: { default: null },
    items: { default: null },
    disableDrag: { type: Boolean },
    ignoreDragSelectors: { type: [String, Function], default: "" },
    maxDepth: { default: 3 },
    width: { default: "" },
    hideIcons: { type: Boolean },
    group: { default: "k-tree-list" },
    collapsible: { type: Boolean },
    initialCollapseAll: { type: Boolean }
  },
  emits: ["change", "child-change", "selected"],
  setup(e, { expose: t, emit: a }) {
    const n = (h, g) => (h.forEach((p) => {
      var w;
      g.push(p.id), (w = p.children) != null && w.length && n(p.children, g);
    }), g), r = (h) => {
      const g = n(h, []), p = new Set(g);
      return g.length === p.size;
    }, i = (h, g) => {
      let p = !0;
      return h.forEach((w) => {
        p = p && (!w.children || Hc(w) <= g);
      }), p;
    };
    ie(() => e.modelValue, (h) => {
      h && !r(h) && $n("modelValue", "Item `id` must be unique.");
    }, { immediate: !0 }), ie(() => e.items, (h) => {
      h && !r(h) && $n("items", "Item `id` must be unique.");
    }, { immediate: !0 }), ie(() => e.maxDepth, (h) => {
      h > 5 && $n("maxDepth", "Maximum depth must be less than or equal to 5.");
    }, { immediate: !0 }), ie([() => e.modelValue, () => e.items], ([h, g]) => {
      h && g && $n("modelValue / items", "You should not provide both v-model (or props.modelValue) and props.items");
    }, { immediate: !0 });
    const o = N([]);
    ie([o, () => e.maxDepth], ([h, g]) => {
      i(h, g) || $n(e.modelValue ? "modelValue" : "items", "Provided list depth exceeds `maxDepth`");
    }, {
      immediate: !0,
      deep: !0
    });
    const u = a, s = b({
      get() {
        return e.modelValue;
      },
      set(h) {
        o.value = h;
      }
    }), l = b(() => ({
      maxWidth: It(e.width)
    })), c = (h, g) => {
      (g || o.value).forEach((w) => {
        var k;
        w.id === h.id ? (w.selected = !0, u("selected", h)) : w.selected = !1, (k = w.children) != null && k.length && c(h, w.children);
      });
    }, d = (h) => {
      u("change", h);
    }, f = (h) => {
      u("child-change", h);
    };
    ie(s, (h, g) => {
      JSON.stringify(h) !== JSON.stringify(g) && (o.value = h || [], o.value.forEach((p) => {
        p.children || (p.children = []);
      }));
    }), ie(() => e.items, (h, g) => {
      JSON.stringify(h) !== JSON.stringify(g) && (o.value = h || [], o.value.forEach((p) => {
        p.children || (p.children = []);
      }));
    });
    const v = dt("tree-draggable");
    return t({ collapseAll: () => {
      var h;
      (h = v.value) == null || h.collapseAll();
    }, expandAll: () => {
      var h;
      (h = v.value) == null || h.expandAll();
    } }), it(() => {
      e.modelValue ? o.value = e.modelValue : e.items && (o.value = e.items), o.value.forEach((h) => {
        h.children || (h.children = []);
      });
    }), (h, g) => (m(), $("div", {
      class: "k-tree-list",
      "data-testid": "k-tree-list",
      style: Oe(e.width ? l.value : void 0)
    }, [
      G(IH, {
        ref: "tree-draggable",
        collapsible: e.collapsible,
        "data-testid": `k-tree-list-${e.group}`,
        "disable-drag": e.disableDrag,
        filter: e.ignoreDragSelectors,
        group: e.group,
        "hide-icons": e.hideIcons,
        "initial-collapse-all": e.initialCollapseAll,
        items: o.value,
        "max-depth": e.maxDepth,
        onChange: d,
        onChildChange: f,
        onSelected: c
      }, kt({
        "item-label": L(({ item: p }) => [
          W(h.$slots, "item-label", { item: p })
        ]),
        _: 2
      }, [
        h.$slots["item-icon"] ? {
          name: "item-icon",
          fn: L(({ item: p }) => [
            W(h.$slots, "item-icon", { item: p })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["collapsible", "data-testid", "disable-drag", "filter", "group", "hide-icons", "initial-collapse-all", "items", "max-depth"])
    ], 4));
  }
}), MH = ["href"], OH = /* @__PURE__ */ oe({
  __name: "KExternalLink",
  props: {
    href: {},
    hideIcon: { type: Boolean }
  },
  setup(e) {
    ie(() => e.href, (a) => {
      Yh(a) || $n("href", `\`href\` should be a valid URL, but got "${a}".`);
    }, { immediate: !0 });
    const t = b(() => !!Yh(e.href));
    return (a, n) => t.value ? (m(), $("a", {
      key: 0,
      class: "k-external-link",
      href: e.href,
      rel: "noopener",
      target: "_blank"
    }, [
      W(a.$slots, "default", {}, void 0, !0),
      e.hideIcon ? H("", !0) : (m(), X(D(yy), {
        key: 0,
        decorative: "",
        size: D(Sa)
      }, null, 8, ["size"]))
    ], 8, MH)) : H("", !0);
  }
}), PH = /* @__PURE__ */ Pe(OH, [["__scopeId", "data-v-ec2a67ce"]]), NH = {
  key: 0,
  class: "truncate-expand-controls"
}, LH = {
  key: 0,
  "data-testid": "expand-trigger-wrapper"
}, BH = ["aria-label"], RH = {
  key: 0,
  "data-testid": "collapse-trigger-wrapper"
}, FH = {
  key: 0,
  "data-testid": "expand-trigger-wrapper"
}, zH = { key: 1 }, YH = /* @__PURE__ */ oe({
  __name: "KTruncate",
  props: {
    rows: { default: 1 },
    truncateText: { type: Boolean },
    expanded: { type: Boolean },
    width: { default: "100%" }
  },
  setup(e) {
    Wt((C) => ({
      v33a5f62a: u.value,
      c9851d34: D(s),
      v67141d6e: C.rows
    })), ie(
      () => e.rows,
      (C) => {
        C < 0 && $n("rows", `\`rows\` prop cannot be less than 0, but got "${C}".`);
      },
      { immediate: !0 }
    );
    const t = N(e.expanded), a = N(!1), n = N(), r = N(), i = N(), o = N(), u = N("0px"), s = Yl, l = N(0), c = () => {
      var C;
      if (!e.truncateText && r.value && (C = r.value.children) != null && C.length) {
        const h = r.value.children, g = Number(String(s).replace(/px$/gi, ""));
        let p = 0;
        for (let S = 0; S < h.length; S++)
          p = h[S].offsetHeight > p ? h[S].offsetHeight : p;
        const w = (e.rows === 1 ? 0 : (e.rows - 1) * g) + p * e.rows + 6, k = r.value.offsetHeight > w ? `${w}px` : "auto";
        window.requestAnimationFrame(() => {
          u.value = k, window.requestAnimationFrame(d);
        });
      }
    }, d = () => {
      if (r.value && i.value) {
        const C = e.truncateText ? r.value.scrollHeight : r.value.offsetHeight, h = o.value ? o.value.offsetHeight : 0;
        a.value = C > i.value.offsetHeight - h, f();
      }
    }, f = () => {
      if (!e.truncateText && (l.value = 0, r.value && i.value)) {
        const C = r.value.children;
        for (let h = 0; h < C.length; h++)
          C[h].offsetTop > i.value.offsetHeight ? (l.value += 1, C[h].getAttribute("tabindex") && (C[h].tabIndex = -1)) : C[h].getAttribute("tabindex") && (C[h].tabIndex = 0);
      }
    }, v = async () => {
      t.value = !t.value, await ht(), d();
    }, y = b(() => ({
      width: It(e.width)
    }));
    return it(() => {
      n.value = lr.create(c), n.value.observe(r.value), e.truncateText && d();
    }), fn(() => {
      var C;
      (C = n.value) == null || C.unobserve(r.value);
    }), (C, h) => {
      const g = qt("KButton");
      return m(), $("div", {
        ref_key: "kTruncateWrapper",
        ref: i,
        class: ce(["k-truncate", [t.value ? "expanded" : "", `truncate-${e.truncateText ? "text" : "content"}`]]),
        style: Oe(y.value)
      }, [
        !e.truncateText && a.value ? (m(), $("div", NH, [
          t.value ? H("", !0) : (m(), $("div", LH, [
            W(C.$slots, "expand-trigger", {
              expand: v,
              truncatedCount: l.value
            }, () => [
              Y("button", {
                "aria-label": `Show ${l.value} more items`,
                class: "expand-trigger",
                type: "button",
                onClick: Ke(v, ["stop"])
              }, re(l.value), 9, BH)
            ], !0)
          ]))
        ])) : H("", !0),
        Y("div", {
          ref_key: "kTruncateContainer",
          ref: r,
          class: "truncate-container"
        }, [
          W(C.$slots, "default", {}, void 0, !0),
          !e.truncateText && t.value ? (m(), $("div", RH, [
            W(C.$slots, "collapse-trigger", { collapse: v }, () => [
              Y("button", {
                "aria-label": "Collapse content",
                class: "collapse-trigger",
                type: "button",
                onClick: Ke(v, ["stop"])
              }, [
                G(D(cy), {
                  decorative: "",
                  size: D(Sa)
                }, null, 8, ["size"])
              ])
            ], !0)
          ])) : H("", !0)
        ], 512),
        e.truncateText && (a.value || t.value) ? (m(), $("div", {
          key: 1,
          ref_key: "textToggleControls",
          ref: o,
          class: "truncate-collapse-controls"
        }, [
          t.value ? H("", !0) : (m(), $("div", FH, [
            W(C.$slots, "expand-trigger", { expand: v }, () => [
              G(g, {
                appearance: "tertiary",
                size: "small",
                onClick: Ke(v, ["stop"])
              }, {
                default: L(() => [...h[0] || (h[0] = [
                  be(" Show more ", -1)
                ])]),
                _: 1
              })
            ], !0)
          ])),
          t.value ? (m(), $("div", zH, [
            W(C.$slots, "collapse-trigger", { collapse: v }, () => [
              G(g, {
                appearance: "tertiary",
                size: "small",
                onClick: Ke(v, ["stop"])
              }, {
                default: L(() => [...h[1] || (h[1] = [
                  be(" Show less ", -1)
                ])]),
                _: 1
              })
            ], !0)
          ])) : H("", !0)
        ], 512)) : H("", !0)
      ], 6);
    };
  }
}), HH = /* @__PURE__ */ Pe(YH, [["__scopeId", "data-v-3404bed6"]]), qH = { class: "k-copy" }, WH = {
  key: 0,
  class: "copy-badge-text"
}, UH = ["id", "aria-label", "onClick"], KH = /* @__PURE__ */ oe({
  __name: "KCopy",
  props: {
    badgeLabel: { default: "" },
    text: {},
    textTooltip: { default: "" },
    copyTooltip: { default: "" },
    format: { default: "default" },
    badge: { type: Boolean },
    monospace: { type: Boolean },
    truncate: { type: Boolean },
    successTooltip: { default: "Copied!" },
    truncationLimit: { default: 8 }
  },
  setup(e, { expose: t }) {
    const a = yt(), n = N(""), r = b(() => !e.badgeLabel || e.copyTooltip ? e.copyTooltip || "Copy" : `Copy ${e.badgeLabel.replace(/:$/, "")}`);
    ie(r, (h) => {
      n.value = h;
    }, { immediate: !0 });
    const i = b(() => `copy-tooltip-wrapper ${e.truncate && y.value || e.badge ? "truncate-content" : ""}`), o = b(() => e.format === "redacted" ? "*****" : e.format === "deleted" ? `*${String(e.text || "").substring(0, 5)}` : e.truncate && e.truncationLimit && v.value ? v.value.replace(/^"(.*)"$/, "$1") : e.text), u = b(() => {
      if (e.textTooltip)
        return e.textTooltip;
      if (!(e.format === "redacted" || !y.value))
        return e.text;
    }), s = (h) => {
      n.value = h || e.successTooltip, setTimeout(() => {
        n.value = r.value;
      }, 1800);
    }, l = async (h) => {
      if (!await h(e.text)) {
        s("Failed to copy");
        return;
      }
      s();
    };
    t({
      copy: () => {
        var h;
        document != null && document.getElementById(a) && ((h = document == null ? void 0 : document.getElementById(a)) == null || h.click());
      }
    });
    const d = N(), f = N(), v = b(() => e.truncate && typeof e.truncationLimit == "number" ? `${String(e.text || "").substring(0, e.truncationLimit) + "..."}` : null), y = N(!1), C = () => {
      var h, g;
      e.truncate && (e.truncationLimit !== "auto" && v.value ? y.value = !0 : e.truncationLimit === "auto" && d.value && (y.value = ((h = d.value) == null ? void 0 : h.offsetWidth) < ((g = d.value) == null ? void 0 : g.scrollWidth)));
    };
    return it(() => {
      f.value = lr.create(C), f.value.observe(d.value);
    }), fn(() => {
      f.value && f.value.unobserve(d.value);
    }), (h, g) => (m(), $("div", qH, [
      e.badge && e.badgeLabel ? (m(), $("span", WH, re(e.badgeLabel), 1)) : H("", !0),
      Y("div", {
        class: ce(["copy-container", { "copy-element": e.truncate || e.badge, "badge-styles": e.badge }])
      }, [
        e.format !== "hidden" ? (m(), X(ba, {
          key: 0,
          class: ce([i.value]),
          "data-testid": "copy-tooltip-wrapper",
          "max-width": "500px",
          placement: "bottom-start",
          text: u.value
        }, {
          default: L(() => [
            Y("div", {
              ref_key: "copyTextElement",
              ref: d,
              class: ce(["copy-text", { monospace: e.monospace || !e.badge }])
            }, re(o.value), 3)
          ]),
          _: 1
        }, 8, ["class", "text"])) : H("", !0),
        G(ba, {
          class: "text-icon-wrapper",
          "max-width": "500px",
          placement: "bottom-start",
          text: n.value
        }, {
          default: L(() => [
            G(dg, null, {
              default: L(({ copyToClipboard: p }) => [
                Y("button", {
                  id: D(a),
                  "aria-label": n.value,
                  class: "copy-to-clipboard-button",
                  "data-testid": "copy-to-clipboard",
                  type: "button",
                  onClick: Ke((w) => l(p), ["stop"])
                }, [
                  G(D(pg), {
                    class: "text-icon",
                    decorative: "",
                    size: D(Sa)
                  }, null, 8, ["size"])
                ], 8, UH)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["text"])
      ], 2)
    ]));
  }
}), VH = /* @__PURE__ */ Pe(KH, [["__scopeId", "data-v-5cce612d"]]), jH = {
  key: 0,
  class: "bulk-actions-dropdown-trigger-count"
}, GH = /* @__PURE__ */ oe({
  __name: "BulkActionsDropdown",
  props: {
    disabled: { type: Boolean },
    count: { default: "" },
    buttonLabel: { default: "" }
  },
  setup(e) {
    return (t, a) => (m(), X(Fr, {
      class: "bulk-actions-dropdown",
      "data-testid": "bulk-actions-dropdown",
      disabled: e.disabled,
      "kpop-attributes": { placement: "bottom-end" }
    }, {
      items: L(() => [
        W(t.$slots, "items", {}, void 0, !0)
      ]),
      default: L(() => [
        G(ba, {
          placement: "bottom-end",
          text: "Selected Row Actions"
        }, {
          default: L(() => [
            G(rt, {
              appearance: "secondary",
              "aria-label": e.buttonLabel,
              class: "bulk-actions-dropdown-trigger",
              "data-testid": "bulk-actions-dropdown-trigger",
              disabled: e.disabled,
              icon: "",
              size: "large"
            }, {
              default: L(() => [
                G(D(bg), {
                  class: "more-icon",
                  decorative: ""
                }),
                G(ea, { name: "kongponents-fade-transition" }, {
                  default: L(() => [
                    e.count ? (m(), $("span", jH, re(e.count), 1)) : H("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["aria-label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
}), QH = /* @__PURE__ */ Pe(GH, [["__scopeId", "data-v-cf7c2833"]]), ZH = {
  key: 0,
  class: "table-toolbar",
  "data-testid": "table-toolbar"
}, XH = {
  key: 0,
  class: "toolbar-default-items-container"
}, JH = {
  key: 2,
  class: "table-error-state",
  "data-testid": "table-error-state"
}, _H = {
  key: 3,
  class: "table-empty-state",
  "data-testid": "table-empty-state"
}, eq = {
  key: 4,
  class: "table-container"
}, tq = ["data-tableid"], aq = ["aria-sort", "data-key", "data-testid", "onClick", "onMouseover"], nq = ["onMousedown", "onMouseover"], rq = ["aria-describedby"], iq = {
  key: 1,
  class: "table-header-bulk-actions-container"
}, oq = ["onMousedown", "onMouseover"], lq = ["role", "tabindex"], sq = {
  key: 1,
  class: "expandable-row-control-container"
}, uq = ["aria-controls", "aria-expanded", "onClick"], cq = ["id"], dq = ["colspan"], fq = { class: "expandable-content-wrapper" }, vq = /* @__PURE__ */ oe({
  __name: "KTableView",
  props: {
    data: { default: () => [] },
    headers: { default: () => [] },
    resizeColumns: { type: Boolean },
    tablePreferences: { default: () => ({}) },
    rowHover: { type: Boolean, default: !0 },
    rowAttrs: { default: () => (() => ({})) },
    rowLink: { default: () => (() => ({})) },
    rowBulkActionEnabled: { default: () => (() => !0) },
    rowKey: {},
    cellAttrs: { default: () => (() => ({})) },
    loading: { type: Boolean },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: {},
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: () => Na.Default },
    emptyStateButtonAppearance: { default: "primary" },
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: {},
    errorStateActionMessage: { default: "" },
    maxHeight: { default: "none" },
    hidePagination: { type: Boolean },
    paginationAttributes: { default: () => ({}) },
    rowExpandable: { default: () => (() => !1) },
    rowExpanded: { default: () => (() => !1) },
    hideHeaders: { type: Boolean },
    nested: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    hideToolbar: { type: Boolean },
    tooltipTarget: { default: "body" },
    "onRow:click": { type: Function },
    "onRow:dblclick": { type: Function },
    "onRow:auxclick": { type: Function },
    "onRow:contextmenu": { type: Function },
    "onRow:mouseover": { type: Function },
    "onRow:mouseout": { type: Function },
    "onRow:mouseenter": { type: Function },
    "onRow:mouseleave": { type: Function },
    "onRow:mousedown": { type: Function },
    "onRow:mouseup": { type: Function },
    "onRow:focus": { type: Function },
    "onRow:focusin": { type: Function },
    "onRow:blur": { type: Function },
    "onRow:focusout": { type: Function },
    "onRow:keydown": { type: Function },
    "onRow:keyup": { type: Function },
    "onRow:keypress": { type: Function },
    "onCell:click": { type: Function },
    "onCell:dblclick": { type: Function },
    "onCell:auxclick": { type: Function },
    "onCell:contextmenu": { type: Function },
    "onCell:mouseover": { type: Function },
    "onCell:mouseout": { type: Function },
    "onCell:mouseenter": { type: Function },
    "onCell:mouseleave": { type: Function },
    "onCell:mousedown": { type: Function },
    "onCell:mouseup": { type: Function },
    "onCell:focus": { type: Function },
    "onCell:focusin": { type: Function },
    "onCell:blur": { type: Function },
    "onCell:focusout": { type: Function },
    "onCell:keydown": { type: Function },
    "onCell:keyup": { type: Function },
    "onCell:keypress": { type: Function }
  },
  emits: ["page-change", "page-size-change", "get-next-offset", "get-previous-offset", "cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "row-select", "update:row-expanded", "row-actions-toggle"],
  setup(e, { emit: t }) {
    Wt((B) => ({
      v7d6bd3b8: D(tt).expandable,
      v5a9df56f: Be.value,
      b14b44f2: T.value,
      v3181b04a: K.value
    }));
    const a = ug(e, ["resizeColumns", "tablePreferences", "rowHover", "rowAttrs", "rowLink", "rowBulkActionEnabled", "rowKey", "cellAttrs", "loading", "emptyStateTitle", "emptyStateMessage", "emptyStateActionMessage", "emptyStateIconVariant", "emptyStateButtonAppearance", "emptyStateActionRoute", "error", "errorStateTitle", "errorStateMessage", "errorStateActionMessage", "errorStateActionRoute", "maxHeight", "hidePagination", "paginationAttributes", "rowExpandable", "rowExpanded", "hideHeaders", "nested", "hidePaginationWhenOptional", "hideToolbar", "tooltipTarget", "data", "headers"]), n = t, r = $t(), i = yt(), o = (B) => typeof e.rowKey == "function" && typeof e.rowKey(B) == "string" ? e.rowKey(B) : typeof e.rowKey == "string" && e.rowKey in B && typeof B[e.rowKey] == "string" ? B[e.rowKey] : "", u = dt("table-wrapper"), s = dt("table"), l = dt("header-row"), c = N([]), d = N([]), f = N(""), v = N(""), y = N(""), C = b(() => c.value.some((B) => B.key === Ge.ACTIONS)), h = b(() => c.value.filter((B) => B.hidable).length > 0), g = b(() => e.nested || !h.value || e.error ? !1 : r.toolbar ? !0 : !e.loading && !!e.data && !!e.data.length), p = b(() => e.loading || !(e.data && e.data.length)), w = b(() => c.value.filter((B) => B.hidable && !Je(B.key))), k = b(() => g.value ? e.tablePreferences.columnVisibility || {} : {}), S = N(g.value ? e.tablePreferences.columnVisibility || {} : {}), T = N("100%"), A = N(!1), F = N(!1), Z = N(!1), O = N(!1), z = N(e.tablePreferences.sortColumnKey || ""), U = N(e.tablePreferences.sortColumnOrder || "desc"), x = N(!1), I = b(() => !e.hideToolbar && !e.nested && (!!r.toolbar || g.value || fe.value)), E = dt("actionsDropdown"), P = N(!1), R = b(() => ({
      maxHeight: It(e.maxHeight)
    })), K = b(() => `${$m()}px`), J = N([]), q = b(() => !e.nested && !e.error && c.value.some((B) => B.key === Ge.BULK_ACTIONS) && !!(r["bulk-action-items"] || r["bulk-actions"]) && !!e.data.every((B) => o(B))), se = N([]), fe = b(() => e.nested || !q.value || e.error ? !1 : r.toolbar ? !0 : !e.loading && !!e.data && !!e.data.length), ne = b(() => {
      const B = J.value.length;
      return B ? B > 100 ? "99+" : String(B) : "";
    }), ae = N(/* @__PURE__ */ new WeakMap()), ve = (B) => `column-${B}`, Ae = (B) => `tooltip-${B}`, Te = (B, te) => (ee, xe) => {
      const ye = /^on[^a-z]/, Ue = {};
      for (const Ze in te)
        ye.test(Ze) && te[Ze] && (Ue[Ze] = te[Ze]);
      return Object.keys(Ue).reduce((Ze, gt) => {
        if (gt.indexOf(B) === 0) {
          const Bt = gt.split(B);
          Ze[Bt[1]] = (Za) => Ue[gt](Za, ee, xe);
        }
        return Ze;
      }, {});
    }, Le = b(() => (B, te) => {
      const ee = Te("onRow:", a)(te, "row"), xe = Te("onCell:", a)(B, "cell"), ye = ["a", "button", "label", "input", "select", 'span[role="checkbox"]'];
      return (ee.click || xe.click) && (x.value = !0), {
        ...ee,
        ...xe,
        click(Ue) {
          const Ze = Ue.target, gt = Ze.className;
          let Bt = ye.includes(Ze.tagName.toLowerCase()), Za = !1;
          typeof gt == "string" || Array.isArray(gt) ? Za = gt.includes("k-popover") : typeof gt == "object" && (Za = Object.keys(gt).includes("k-popover")), Ze.closest(".popover-content") !== null && (Za = !0);
          for (let Xa = 0; Xa < ye.length; Xa++)
            if (Ze.closest(ye[Xa]) !== null) {
              Bt = !0;
              break;
            }
          if ((!Bt || Ze.hasAttribute("disabled")) && !Za && (ee.click || xe.click))
            if (xe.click) {
              n("cell-click", { data: B });
              const Xa = xe.click(Ue, B, "cell");
              typeof Xa == "function" && Xa(Ue, B);
            } else {
              n("row-click", { data: te });
              const Xa = ee.click(Ue, te, "row");
              typeof Xa == "function" && Xa(Ue, te);
            }
        }
      };
    }), ze = parseInt(Sg) * 2 + parseInt(Sa), _e = { expandable: ze, bulkActions: 48, actions: 54 }, tt = Z$(_e, (B) => `${B}px`), Xe = N({
      ...e.tablePreferences.columnWidths || {},
      ..._e
      // override special columns with default widths
    }), et = b(() => {
      const B = {};
      for (const te in Xe.value) {
        const ee = te;
        if (!Xe.value[ee])
          continue;
        const xe = Xe.value[ee] + "px";
        B[ee] = {
          width: xe,
          maxWidth: xe,
          minWidth: xe
        };
      }
      return B;
    }), pe = (B, te) => ({
      // display the resize handle on the right side of the column if resizeColumns is enabled, hovering current column, and not the last column
      "resize-hover": V.value === B.key && te !== d.value.length - 1 && lt(B),
      resizable: e.resizeColumns && !e.nested,
      // display sort control if column is sortable, label is visible, and sorting is not disabled
      sortable: !B.hideLabel && !!B.sortable,
      // display active sorting styles if column is currently sorted
      "active-sort": !B.hideLabel && !!B.sortable && B.key === z.value,
      [U.value]: B.key === z.value && !B.hideLabel,
      "is-scrolled": F.value,
      "has-tooltip": !!B.tooltip,
      "sticky-column": Ve(B.key),
      "second-sticky-column": wt(B.key),
      "has-row-scroll-overlay": vt(B.key),
      "actions-column": B.key === Ge.ACTIONS
    }), me = (B) => {
      if (B.sortable && B.key !== Ge.BULK_ACTIONS && B.key !== Ge.ACTIONS) {
        let te = "asc";
        B.key === z.value && U.value === "asc" && (te = "desc"), n("sort", {
          prevKey: z.value,
          sortColumnKey: B.key,
          sortColumnOrder: te
        }), ra(B);
      }
    }, he = b(() => f.value ? "resizing" : v.value ? "resize-hover" : y.value ? "th-hover" : ""), V = b(() => {
      switch (he.value) {
        case "resizing":
          return f.value;
        case "resize-hover":
          return v.value;
        case "th-hover":
          return y.value;
        default:
          return "";
      }
    }), Se = b(() => {
      var B;
      return (B = l.value) == null ? void 0 : B.querySelectorAll("th.resizable");
    }), Be = b(() => {
      var te;
      const B = (te = Se.value) == null ? void 0 : te.item(0);
      if (B) {
        const ee = window == null ? void 0 : window.getComputedStyle(B);
        if (ee != null && ee.height)
          return `${parseInt(ee.height, 10)}px`;
      }
      return "auto";
    }), Me = (B, te) => {
      var gt;
      if (B.button !== 0)
        return;
      let ee = 0, xe = 0;
      f.value = te;
      let ye = null;
      (gt = Se.value) == null || gt.forEach((Bt) => {
        Bt.getAttribute("data-testid") === `table-header-${te}` && (ye = document == null ? void 0 : document.querySelector(`[data-tableid="${i}"] [data-testid="table-header-${te}"]`));
      });
      const Ue = (Bt) => {
        const Za = Bt.clientX - ee;
        ye == null || ye.setAttribute("style", `width: ${xe + Za}px`), Xe.value[te] = xe + Za;
      }, Ze = () => {
        f.value = "", document == null || document.removeEventListener("mousemove", Ue), document == null || document.removeEventListener("mouseup", Ze), $e(), nt.value && le();
      };
      if (ee = B.clientX, ye) {
        const Bt = window == null ? void 0 : window.getComputedStyle(ye);
        Bt != null && Bt.width && (xe = parseInt(Bt.width, 10)), document == null || document.addEventListener("mousemove", Ue), document == null || document.addEventListener("mouseup", Ze);
      }
    }, Ve = (B) => Z.value ? B === Ge.BULK_ACTIONS || B === Ge.EXPANDABLE : !1, wt = (B) => B === Ge.BULK_ACTIONS && nt.value, vt = (B) => Z.value ? q.value ? B === Ge.BULK_ACTIONS : nt.value ? B === Ge.EXPANDABLE : !1 : !1, Je = (B) => B === Ge.EXPANDABLE || B === Ge.BULK_ACTIONS || B === Ge.ACTIONS, lt = (B, te = !1) => {
      if (!e.resizeColumns || e.nested)
        return !1;
      if (te) {
        if (d.value.indexOf(B) === d.value.length - 1)
          return !1;
        const xe = d.value[d.value.indexOf(B) - 1];
        return !Je(xe.key);
      }
      const ee = d.value[d.value.indexOf(B) + 1];
      return !Je(B.key) && !Je(ee.key);
    }, xt = (B, te, ee) => {
      n("row-actions-toggle", { row: B, open: te }), setTimeout(() => {
        ee.isRowActionsDropdownOpen = te;
      }, te ? 0 : 100);
    }, Lt = b(() => !(e.hidePagination || e.nested || e.hidePaginationWhenOptional && e.data.length && e.paginationAttributes.totalCount && e.paginationAttributes.totalCount <= e.data.length));
    ie(() => e.headers, (B) => {
      if (B && B.length) {
        const te = B.filter((ye) => ye.key !== Ge.BULK_ACTIONS && ye.key !== Ge.ACTIONS), ee = B.find((ye) => ye.key === Ge.BULK_ACTIONS), xe = B.find((ye) => ye.key === Ge.ACTIONS);
        ee && te.unshift(ee), xe && te.push(xe), c.value = te;
      }
    }, { deep: !0, immediate: !0 });
    const Xt = (B) => !B.hideLabel && !!B.sortable && B.key !== Ge.BULK_ACTIONS && B.key !== Ge.ACTIONS, ra = (B) => {
      const { key: te } = B;
      z.value && te === z.value ? U.value === "asc" ? U.value = "desc" : U.value = "asc" : (z.value = te, U.value = "asc"), $e();
    }, Jt = (B) => {
      var ee;
      const te = B.target;
      te && (typeof te.scrollTop == "number" || typeof te.scrollLeft == "number") && (te.scrollTop > 1 ? (A.value = !0, F.value = !0) : te.scrollTop === 0 && (F.value = !1), te.scrollLeft > 1 ? Z.value = !0 : te.scrollLeft === 0 && (Z.value = !1), te.scrollWidth <= te.scrollLeft + te.clientWidth ? O.value = !1 : O.value = !0), (ee = E.value) == null || ee.forEach((xe) => {
        xe && xe.closeDropdown && xe.closeDropdown();
      });
    }, Mt = (B) => se.value.find((te) => te.rowKey === o(B)), ue = (B, te) => ({
      "data-testid": e.rowAttrs(B)["data-testid"] ? `${e.rowAttrs(B)["data-testid"]}-actions-dropdown-popover` : `row-${te}-actions-dropdown-popover`
    }), He = (B) => {
      if (typeof e.rowBulkActionEnabled != "function")
        return !1;
      const te = e.rowBulkActionEnabled(B);
      return typeof te == "boolean" ? te : te.enabled;
    }, _ = (B) => {
      if (typeof e.rowBulkActionEnabled != "function")
        return "";
      const te = e.rowBulkActionEnabled(B);
      return typeof te == "boolean" ? "" : te.disabledTooltip || "";
    }, de = (B, te) => {
      const { to: ee } = e.rowLink(B);
      return !ee || te === Ge.BULK_ACTIONS || te === Ge.ACTIONS ? "div" : typeof ee == "object" ? "router-link" : "a";
    }, Ie = (B, te) => {
      if (te === Ge.BULK_ACTIONS || te === Ge.ACTIONS)
        return {};
      const { to: ee, target: xe } = e.rowLink(B), ye = ee && typeof ee == "object", Ue = ee && typeof ee == "string";
      return {
        ...ye && { to: ee },
        ...Ue && { href: ee },
        ...(ye || Ue) && {
          ...xe && { target: xe }
        }
      };
    }, Q = N(0), M = N(b1(e.tablePreferences, e.paginationAttributes)), j = (B) => {
      M.value = B.pageSize, n("page-size-change", B), $e();
    }, ge = b(() => ({
      sortColumnKey: z.value,
      sortColumnOrder: U.value,
      ...e.resizeColumns ? { columnWidths: Xe.value } : {},
      ...h.value ? { columnVisibility: S.value } : {},
      ...M.value && !e.hidePagination && { pageSize: M.value }
    })), $e = () => {
      n("update:table-preferences", ge.value);
    }, nt = b(() => !e.nested && e.data.some((B) => e.rowExpandable(B))), Tt = { key: Ge.EXPANDABLE, label: "Expandable rows controls", hideLabel: !0 }, Nt = () => {
      const B = [];
      return e.data.forEach((te, ee) => {
        e.rowExpanded(te) && B.push(ee);
      }), B;
    }, Ot = N(Nt()), Ma = async (B, te) => {
      le(), await ht(), Ot.value.includes(B) ? (Ot.value = Ot.value.filter((ee) => ee !== B), n("update:row-expanded", { row: te, expanded: !1 })) : (Ot.value = [...Ot.value, B], n("update:row-expanded", { row: te, expanded: !0 }));
    }, yn = b(() => d.value.filter((B) => B.key !== Ge.EXPANDABLE && B.key !== Ge.BULK_ACTIONS)), Ct = N({}), le = () => {
      if (typeof document > "u")
        return;
      const B = document == null ? void 0 : document.querySelector(`[data-tableid="${i}"]`), te = B == null ? void 0 : B.querySelectorAll("th"), ee = {};
      te == null || te.forEach((xe, ye) => {
        const Ue = xe.getAttribute("data-key");
        if (Ue === Ge.EXPANDABLE)
          return;
        let Ze = xe.getBoundingClientRect().width;
        ye === 1 && (Ze += ze), ye === te.length - 1 && (Ze -= 15), ee[Ue] = Ze;
      }), Ct.value = ee;
    };
    ie([S, c, nt], (B) => {
      const [te, ee, xe] = B;
      let ye = ee.filter((Ue) => Ue.key === Ge.BULK_ACTIONS ? q.value : te[Ue.key] !== !1);
      ye.find((Ue) => Ue.key === Ge.EXPANDABLE) && (ye = ye.filter((Ue) => Ue.key !== Ge.EXPANDABLE)), xe && ye.unshift(Tt), JSON.stringify(ye) !== JSON.stringify(d.value) && (d.value = ye, $e()), xe && le();
    }, { deep: !0, immediate: !0 }), ie(g, (B) => {
      B && (S.value = e.tablePreferences.columnVisibility || {});
    }, { immediate: !0 });
    const Ce = N(!1), ke = b(() => {
      const B = se.value.filter((te) => !te.disabled && e.data.find((ee) => o(ee) === te.rowKey));
      return !!B.filter((te) => te.selected).length && !!B.filter((te) => !te.selected).length;
    }), je = (B) => {
      se.value.forEach((te) => {
        e.data.find((ee) => o(ee) === te.rowKey) && !te.disabled && (te.selected = B);
      });
    };
    return ie([() => e.data, se], (B) => {
      const [te, ee] = B;
      if (te.forEach((xe) => {
        if (!ae.value.get(xe)) {
          const ye = o(xe) || cs();
          ae.value.set(xe, `table-${i}-row-${ye}`);
        }
      }), q.value) {
        te.forEach((Ze) => {
          Mt(Ze) || se.value.push({
            rowKey: o(Ze),
            selected: !1,
            disabled: !He(Ze)
          });
        });
        const xe = ee.filter((Ze) => !Ze.disabled && te.find((gt) => o(gt) === Ze.rowKey));
        xe.length && xe.filter((Ze) => Ze.selected).length === xe.length ? Ce.value = !0 : (xe.filter((Ze) => !Ze.selected).length, xe.length, Ce.value = !1);
        const ye = te.filter((Ze) => {
          const gt = ee.find((Bt) => Bt.rowKey === o(Ze));
          return !!(gt && gt.selected);
        }), Ue = [];
        J.value.forEach((Ze) => {
          te.find((Bt) => o(Ze) === o(Bt)) || Ue.push(Ze);
        }), J.value = [...Ue, ...ye];
      }
      Ot.value = Nt();
    }, { deep: !0, immediate: !0 }), ie(J, (B) => {
      n("row-select", B);
    }), ie(() => e.tablePreferences, (B) => {
      B != null && B.pageSize && (M.value = B.pageSize, Q.value++), z.value = B != null && B.sortColumnKey ? B.sortColumnKey : z.value, U.value = B != null && B.sortColumnOrder ? B.sortColumnOrder : U.value, Xe.value = B != null && B.columnWidths ? B.columnWidths : Xe.value, S.value = B != null && B.columnVisibility ? B.columnVisibility : S.value;
    }), f0([u, s], () => {
      const B = u.value;
      B && (O.value = B.scrollWidth > B.clientWidth, T.value = B.clientHeight + "px", A.value = B.scrollHeight > B.clientHeight);
    }), (B, te) => (m(), $("div", {
      class: ce(["k-table-view", { "hide-headers": e.hideHeaders }])
    }, [
      I.value ? (m(), $("div", ZH, [
        W(B.$slots, "toolbar", {}, void 0, !0),
        fe.value || g.value ? (m(), $("div", XH, [
          fe.value ? W(B.$slots, "bulk-actions", {
            key: 0,
            selectedRows: J.value
          }, () => [
            B.$slots["bulk-actions"] ? H("", !0) : (m(), X(QH, {
              key: 0,
              "button-label": c.value.find((ee) => ee.key === D(Ge).BULK_ACTIONS).label,
              count: ne.value,
              disabled: !ne.value || e.loading || !e.data.length
            }, {
              items: L(() => [
                W(B.$slots, "bulk-action-items", { selectedRows: J.value }, void 0, !0)
              ]),
              _: 3
            }, 8, ["button-label", "count", "disabled"]))
          ], !0) : H("", !0),
          g.value ? (m(), X(w1, {
            key: 1,
            columns: w.value,
            disabled: p.value,
            "table-id": D(i),
            "visibility-preferences": k.value,
            onUpdate: te[0] || (te[0] = (ee) => S.value = ee)
          }, null, 8, ["columns", "disabled", "table-id", "visibility-preferences"])) : H("", !0)
        ])) : H("", !0)
      ])) : H("", !0),
      e.loading && !e.error ? (m(), X(jl, {
        key: 1,
        "data-testid": "table-skeleton",
        type: "table"
      })) : e.error ? (m(), $("div", JH, [
        W(B.$slots, "error-state", {}, () => [
          G(_n, {
            "icon-variant": "error",
            message: e.errorStateMessage,
            title: e.errorStateTitle
          }, kt({ _: 2 }, [
            e.errorStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  "data-testid": "error-state-action",
                  to: e.errorStateActionRoute,
                  onClick: te[1] || (te[1] = (ee) => n("error-action-click"))
                }, {
                  default: L(() => [
                    be(re(e.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : !e.error && !e.loading && e.data && !e.data.length ? (m(), $("div", _H, [
        W(B.$slots, "empty-state", {}, () => [
          G(_n, {
            "icon-variant": e.emptyStateIconVariant,
            message: e.emptyStateMessage,
            title: e.emptyStateTitle
          }, kt({ _: 2 }, [
            e.emptyStateActionMessage ? {
              name: "action",
              fn: L(() => [
                G(rt, {
                  appearance: e.emptyStateButtonAppearance,
                  "data-testid": "empty-state-action",
                  to: e.emptyStateActionRoute,
                  onClick: te[2] || (te[2] = (ee) => n("empty-state-action-click"))
                }, {
                  default: L(() => [
                    W(B.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + re(e.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (m(), $("div", eq, [
        Y("div", {
          ref: "table-wrapper",
          class: "table-wrapper",
          style: Oe(R.value),
          onScrollPassive: Jt
        }, [
          Y("table", {
            ref: "table",
            class: ce(["table", {
              "has-hover": e.rowHover && !P.value,
              "is-clickable": x.value
            }]),
            "data-tableid": D(i)
          }, [
            e.hideHeaders ? H("", !0) : (m(), $("thead", {
              key: 0,
              class: ce({ "is-scrolled": F.value })
            }, [
              Y("tr", {
                ref: "header-row",
                class: ce({ "is-scrolled": F.value })
              }, [
                (m(!0), $(Ee, null, Fe(d.value, (ee, xe) => (m(), $("th", {
                  key: `table-${D(i)}-headers-${ee.key}`,
                  "aria-sort": ee.key === z.value ? U.value === "asc" ? "ascending" : "descending" : void 0,
                  class: ce(["table-headers", pe(ee, xe)]),
                  "data-key": ee.key,
                  "data-testid": `table-header-${ee.key}`,
                  style: Oe(et.value[ee.key]),
                  onClick: () => me(ee),
                  onMouseleave: te[8] || (te[8] = (ye) => y.value = ""),
                  onMouseover: (ye) => y.value = ee.key
                }, [
                  xe !== 0 && lt(ee, !0) ? (m(), $("div", {
                    key: 0,
                    class: "resize-handle previous",
                    onClick: te[3] || (te[3] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (ye) => Me(ye, d.value[xe - 1].key),
                    onMouseleave: te[4] || (te[4] = (ye) => v.value = ""),
                    onMouseover: (ye) => v.value = d.value[xe - 1].key
                  }, null, 40, nq)) : H("", !0),
                  Y("div", {
                    "aria-describedby": ee.tooltip || r[Ae(ee.key)] ? `${Ae(ee.key)}-${D(i)}` : void 0,
                    class: ce(["table-headers-container", { resized: f.value === ee.key }])
                  }, [
                    ee.key !== D(Ge).BULK_ACTIONS ? W(B.$slots, ve(ee.key), {
                      key: 0,
                      column: ee
                    }, () => [
                      Y("span", {
                        class: ce(["table-header-label", {
                          "sr-only": ee.hideLabel || ee.key === D(Ge).ACTIONS && ee.hideLabel !== !1
                        }])
                      }, re(ee.label ? ee.label : ee.key), 3)
                    ], !0) : (m(), $("div", iq, [
                      G(sl, {
                        modelValue: Ce.value,
                        "onUpdate:modelValue": te[5] || (te[5] = (ye) => Ce.value = ye),
                        "aria-label": "Toggle selection for all rows",
                        class: "table-header-bulk-actions-checkbox",
                        "data-testid": "table-header-bulk-actions-checkbox",
                        indeterminate: ke.value,
                        onChange: je
                      }, null, 8, ["modelValue", "indeterminate"])
                    ])),
                    ee.tooltip || B.$slots[Ae(ee.key)] ? (m(), X(ba, {
                      key: 2,
                      "data-testid": Ae(ee.key),
                      "kpop-attributes": { target: e.tooltipTarget },
                      "max-width": "300",
                      "tooltip-id": `${Ae(ee.key)}-${D(i)}`
                    }, {
                      content: L(() => [
                        W(B.$slots, Ae(ee.key), { column: ee }, () => [
                          be(re(ee.tooltip), 1)
                        ], !0)
                      ]),
                      default: L(() => [
                        G(D(En), {
                          class: "header-tooltip-trigger",
                          color: `var(--kui-color-text-neutral, ${D(Ya)})`,
                          size: D(Sa),
                          tabindex: "0"
                        }, null, 8, ["color", "size"])
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "kpop-attributes", "tooltip-id"])) : H("", !0),
                    Xt(ee) ? (m(), $(Ee, { key: 3 }, [
                      z.value === ee.key ? (m(), X(D(Bu), {
                        key: 0,
                        class: "active-sort-icon",
                        color: `var(--kui-color-text-primary, ${D(kg)})`,
                        decorative: "",
                        size: D(Sa)
                      }, null, 8, ["color", "size"])) : (m(), X(D(Fy), {
                        key: 1,
                        class: "sort-icon",
                        color: `var(--kui-color-text-neutral-weak, ${D(Cg)})`,
                        size: D(Sa),
                        title: `Sort by ${ee.label}`
                      }, null, 8, ["color", "size", "title"]))
                    ], 64)) : H("", !0)
                  ], 10, rq),
                  xe !== d.value.length - 1 && lt(ee) ? (m(), $("div", {
                    key: 1,
                    class: "resize-handle",
                    onClick: te[6] || (te[6] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (ye) => Me(ye, ee.key),
                    onMouseleave: te[7] || (te[7] = (ye) => v.value = ""),
                    onMouseover: (ye) => v.value = ee.key
                  }, null, 40, oq)) : H("", !0),
                  vt(ee.key) ? (m(), $("div", {
                    key: 2,
                    "aria-hidden": "true",
                    class: ce(["scroll-overlay row-overlay left", {
                      "overlay-visible": Z.value
                    }])
                  }, null, 2)) : H("", !0),
                  ee.key === D(Ge).ACTIONS ? (m(), $("div", {
                    key: 3,
                    "aria-hidden": "true",
                    class: ce(["scroll-overlay row-overlay right", {
                      "overlay-visible": O.value
                    }])
                  }, null, 2)) : H("", !0)
                ], 46, aq))), 128))
              ], 2)
            ], 2)),
            Y("tbody", null, [
              (m(!0), $(Ee, null, Fe(e.data, (ee, xe) => (m(), $(Ee, {
                key: ae.value.get(ee)
              }, [
                Y("tr", Re({
                  class: {
                    "last-row": xe === e.data.length - 1 && !Ot.value.includes(xe)
                  },
                  role: e.rowLink(ee).to ? "link" : void 0,
                  tabindex: x.value && !e.rowLink(ee).to ? 0 : void 0
                }, { ref_for: !0 }, e.rowAttrs(ee)), [
                  (m(!0), $(Ee, null, Fe(d.value, (ye, Ue) => (m(), X(D(fg), {
                    key: `${ae.value.get(ee)}-cell-${ye.key}`,
                    data: { isRowActionsDropdownOpen: !1 }
                  }, {
                    default: L(({ data: Ze }) => [
                      Y("td", Re({
                        class: {
                          "resize-hover": V.value === ye.key && Ue !== d.value.length - 1 && lt(ye),
                          "row-link": !!e.rowLink(ee).to,
                          "sticky-column": Ve(ye.key),
                          "second-sticky-column": wt(ye.key),
                          "has-row-scroll-overlay": vt(ye.key),
                          "actions-column": ye.key === D(Ge).ACTIONS
                        },
                        style: {
                          ...et.value[ye.key],
                          ...Ze.isRowActionsDropdownOpen ? { zIndex: 2 } : {}
                        }
                      }, { ref_for: !0 }, e.cellAttrs({ headerKey: ye.key, row: ee, rowIndex: xe, colIndex: Ue }), Bl(Le.value(ee[ye.key], ee), !0)), [
                        ye.key !== D(Ge).EXPANDABLE ? (m(), X(Ye(de(ee, ye.key)), Re({
                          key: 0,
                          class: "cell-wrapper"
                        }, { ref_for: !0 }, Ie(ee, ye.key)), {
                          default: L(() => [
                            ye.key !== D(Ge).BULK_ACTIONS && ye.key !== D(Ge).ACTIONS ? W(B.$slots, ye.key, {
                              key: 0,
                              row: ee,
                              rowKey: xe,
                              rowValue: ee[ye.key]
                            }, () => [
                              be(re(ee[ye.key]), 1)
                            ], !0) : ye.key === D(Ge).BULK_ACTIONS && Mt(ee) ? (m(), X(ba, {
                              key: 1,
                              "kpop-attributes": { target: e.tooltipTarget },
                              "max-width": "200",
                              placement: "bottom-start",
                              text: He(ee) ? void 0 : _(ee)
                            }, {
                              default: L(() => [
                                G(sl, {
                                  modelValue: Mt(ee).selected,
                                  "onUpdate:modelValue": (gt) => Mt(ee).selected = gt,
                                  "aria-label": "Toggle row selection",
                                  class: "bulk-actions-checkbox",
                                  "data-testid": "bulk-actions-checkbox",
                                  disabled: !He(ee)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["kpop-attributes", "text"])) : ye.key === D(Ge).ACTIONS ? (m(), X(Fr, {
                              key: 2,
                              ref_for: !0,
                              ref: "actionsDropdown",
                              class: "actions-dropdown",
                              "data-testid": "actions-dropdown",
                              "kpop-attributes": { placement: "bottom-end", target: "body", popoverElementAttributes: ue(ee, xe) },
                              onToggleDropdown: (gt) => xt(ee, gt, Ze)
                            }, {
                              items: L(() => [
                                W(B.$slots, "action-items", { row: ee }, void 0, !0)
                              ]),
                              default: L(() => [
                                G(rt, {
                                  appearance: "tertiary",
                                  "aria-label": ye.label,
                                  class: "actions-dropdown-trigger",
                                  "data-testid": "row-actions-dropdown-trigger",
                                  icon: "",
                                  size: "small",
                                  onMouseleave: te[9] || (te[9] = (gt) => P.value = !1),
                                  onMouseover: te[10] || (te[10] = (gt) => P.value = !0)
                                }, {
                                  default: L(() => [
                                    G(D(bg), {
                                      class: "more-icon",
                                      decorative: ""
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["aria-label"])
                              ]),
                              _: 2
                            }, 1032, ["kpop-attributes", "onToggleDropdown"])) : H("", !0)
                          ]),
                          _: 2
                        }, 1040)) : e.rowExpandable(ee) ? (m(), $("div", sq, [
                          Y("button", {
                            "aria-controls": `table-${D(i)}-row-${xe}-expandable-content`,
                            "aria-expanded": Ot.value.includes(xe),
                            "aria-label": "Toggle row expandable content",
                            class: ce(["expandable-row-control", { expanded: Ot.value.includes(xe) }]),
                            "data-testid": "expandable-row-control",
                            type: "button",
                            onClick: (gt) => Ma(xe, ee)
                          }, [
                            G(D(Ru), {
                              class: "expandable-row-control-icon",
                              decorative: ""
                            })
                          ], 10, uq)
                        ])) : H("", !0),
                        vt(ye.key) ? (m(), $("div", {
                          key: 2,
                          "aria-hidden": "true",
                          class: ce(["scroll-overlay row-overlay left", {
                            "overlay-visible": Z.value
                          }])
                        }, null, 2)) : H("", !0),
                        ye.key === D(Ge).ACTIONS ? (m(), $("div", {
                          key: 3,
                          "aria-hidden": "true",
                          class: ce(["scroll-overlay row-overlay right", {
                            "overlay-visible": O.value
                          }])
                        }, null, 2)) : H("", !0)
                      ], 16)
                    ]),
                    _: 2
                  }, 1024))), 128))
                ], 16, lq),
                nt.value && e.rowExpandable(ee) ? pa((m(), $("tr", {
                  key: 0,
                  id: `table-${D(i)}-row-${xe}-expandable-content`,
                  class: "expandable-content-row",
                  "data-testid": "expandable-content-row"
                }, [
                  Y("td", {
                    colspan: d.value.length
                  }, [
                    Y("div", fq, [
                      W(B.$slots, "row-expanded", {
                        columnWidths: Ct.value,
                        nestedHeaders: yn.value,
                        row: ee
                      }, void 0, !0)
                    ])
                  ], 8, dq)
                ], 8, cq)), [
                  [Xn, Ot.value.includes(xe)]
                ]) : H("", !0)
              ], 64))), 128))
            ])
          ], 10, tq)
        ], 36),
        !q.value && !nt.value ? (m(), $("div", {
          key: 0,
          "aria-hidden": "true",
          class: ce(["scroll-overlay table-overlay left", {
            "overlay-visible": Z.value
          }])
        }, null, 2)) : H("", !0),
        C.value ? H("", !0) : (m(), $("div", {
          key: 1,
          "aria-hidden": "true",
          class: ce(["scroll-overlay table-overlay right", {
            "overlay-visible": O.value,
            "scrollbar-offset": A.value
          }])
        }, null, 2)),
        Lt.value ? (m(), X(Gl, Re({
          key: `table-${D(i)}-pagination-${Q.value}`,
          class: "table-pagination",
          "data-testid": "table-pagination",
          "initial-page-size": M.value
        }, e.paginationAttributes, {
          onGetNextOffset: te[11] || (te[11] = (ee) => n("get-next-offset")),
          onGetPreviousOffset: te[12] || (te[12] = (ee) => n("get-previous-offset")),
          onPageChange: te[13] || (te[13] = (ee) => n("page-change", ee)),
          onPageSizeChange: j
        }), null, 16, ["initial-page-size"])) : H("", !0)
      ]))
    ], 2));
  }
}), N1 = /* @__PURE__ */ Pe(vq, [["__scopeId", "data-v-33c02eaf"]]), hq = /* @__PURE__ */ oe({
  __name: "KTableData",
  props: {
    fetcher: { type: Function },
    headers: { default: () => [] },
    fetcherCacheKey: { default: "" },
    cacheIdentifier: { default: "" },
    searchInput: { default: "" },
    initialFetcherParams: { default: () => ({}) },
    clientSort: { type: Boolean },
    sortHandlerFunction: {},
    sortable: { type: Boolean, default: !0 },
    resizeColumns: { type: Boolean },
    tablePreferences: { default: () => ({}) },
    rowHover: { type: Boolean, default: !0 },
    rowAttrs: { default: () => (() => ({})) },
    rowLink: { default: () => (() => ({})) },
    rowBulkActionEnabled: { default: () => (() => !0) },
    rowKey: {},
    cellAttrs: { default: () => (() => ({})) },
    loading: { type: Boolean },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: {},
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: () => Na.Default },
    emptyStateButtonAppearance: {},
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: {},
    errorStateActionMessage: { default: "" },
    maxHeight: { default: "none" },
    hidePagination: { type: Boolean },
    paginationAttributes: { default: () => ({}) },
    rowExpandable: { default: () => (() => !1) },
    rowExpanded: { default: () => (() => !1) },
    hideHeaders: { type: Boolean },
    nested: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    hideToolbar: { type: Boolean },
    tooltipTarget: {},
    "onRow:click": { type: Function },
    "onRow:dblclick": { type: Function },
    "onRow:auxclick": { type: Function },
    "onRow:contextmenu": { type: Function },
    "onRow:mouseover": { type: Function },
    "onRow:mouseout": { type: Function },
    "onRow:mouseenter": { type: Function },
    "onRow:mouseleave": { type: Function },
    "onRow:mousedown": { type: Function },
    "onRow:mouseup": { type: Function },
    "onRow:focus": { type: Function },
    "onRow:focusin": { type: Function },
    "onRow:blur": { type: Function },
    "onRow:focusout": { type: Function },
    "onRow:keydown": { type: Function },
    "onRow:keyup": { type: Function },
    "onRow:keypress": { type: Function },
    "onCell:click": { type: Function },
    "onCell:dblclick": { type: Function },
    "onCell:auxclick": { type: Function },
    "onCell:contextmenu": { type: Function },
    "onCell:mouseover": { type: Function },
    "onCell:mouseout": { type: Function },
    "onCell:mouseenter": { type: Function },
    "onCell:mouseleave": { type: Function },
    "onCell:mousedown": { type: Function },
    "onCell:mouseup": { type: Function },
    "onCell:focus": { type: Function },
    "onCell:focusin": { type: Function },
    "onCell:blur": { type: Function },
    "onCell:focusout": { type: Function },
    "onCell:keydown": { type: Function },
    "onCell:keyup": { type: Function },
    "onCell:keypress": { type: Function }
  },
  emits: ["state", "cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "row-select", "update:row-expanded", "row-actions-toggle"],
  setup(e, { expose: t, emit: a }) {
    const n = ug(e, ["resizeColumns", "tablePreferences", "rowHover", "rowAttrs", "rowLink", "rowBulkActionEnabled", "rowKey", "cellAttrs", "loading", "emptyStateTitle", "emptyStateMessage", "emptyStateActionMessage", "emptyStateIconVariant", "emptyStateButtonAppearance", "emptyStateActionRoute", "error", "errorStateTitle", "errorStateMessage", "errorStateActionMessage", "errorStateActionRoute", "maxHeight", "hidePagination", "paginationAttributes", "rowExpandable", "rowExpanded", "hideHeaders", "nested", "hidePaginationWhenOptional", "hideToolbar", "headers", "fetcherCacheKey", "cacheIdentifier", "searchInput", "initialFetcherParams", "clientSort", "sortable", "fetcher", "sortHandlerFunction", "tooltipTarget"]), r = b(() => {
      const ue = /^on[^a-z]/;
      return _$(n, (He, _) => ue.test(_));
    }), i = a, o = $t(), { useDebounce: u, useRequest: s, useSwrvState: l, clientSideSorter: c } = Bn(), d = yt(), f = N([]), v = b(() => e.sortable ? e.headers : e.headers.map((ue) => ({ ...ue, sortable: !1 }))), y = b(() => e.emptyStateButtonAppearance ? e.emptyStateButtonAppearance : e.searchInput ? "tertiary" : "primary"), C = N(0), h = N(1), g = N(b1(e.tablePreferences, e.paginationAttributes)), p = N(e.searchInput ?? ""), w = N(e.tablePreferences.sortColumnKey || e.initialFetcherParams.sortColumnKey || ""), k = N(e.tablePreferences.sortColumnOrder || e.initialFetcherParams.sortColumnOrder || "desc"), S = N(!(w.value && e.clientSort)), T = N(null), A = N([]), F = N(!0), Z = N(!1), O = {
      pageSize: g.value,
      page: h.value,
      query: p.value,
      sortColumnKey: w.value,
      sortColumnOrder: k.value,
      offset: T.value
    }, z = b(() => ({
      totalCount: C.value,
      initialPageSize: g.value,
      currentPage: h.value,
      offsetPreviousButtonDisabled: !ae.value,
      offsetNextButtonDisabled: !ve.value || !F.value,
      ...e.paginationAttributes
    })), U = (ue) => ue.startsWith("column-"), x = (ue) => ue.startsWith("tooltip-"), I = (ue) => v.value.some((He) => He.key === ue), E = b(() => o ? Object.keys(o).filter(U) : []), P = b(() => o ? Object.keys(o).filter(x) : []), R = b(() => o ? Object.keys(o).filter(I) : []), K = b(() => ({
      sortColumnKey: w.value,
      sortColumnOrder: k.value
    })), J = b(() => ({
      pageSize: g.value,
      page: h.value,
      query: p.value,
      offset: T.value,
      ...e.clientSort ? {} : K.value
    })), q = b(() => ({
      ...J.value,
      ...K.value
    })), se = N(!0), fe = async () => {
      const ue = await e.fetcher(q.value);
      return se.value = !1, ue;
    }, ne = () => {
      var He;
      const ue = {
        ...O,
        ...e.initialFetcherParams
      };
      if (h.value = ue.page ?? O.page, g.value = ue.pageSize ?? O.pageSize, p.value = ue.query ?? O.query, w.value = ue.sortColumnKey ?? O.sortColumnKey, k.value = ue.sortColumnOrder ?? O.sortColumnOrder, e.clientSort && w.value && k.value) {
        const _ = v.value.find((Ie) => Ie.key === w.value) || {}, { useSortHandlerFunction: de } = _;
        if (de && e.sortHandlerFunction) {
          const Ie = e.sortHandlerFunction({
            key: w.value,
            prevKey: "",
            sortColumnOrder: k.value,
            data: f.value
          });
          Ie && (f.value = [...Ie]);
        } else
          c(w.value, "", k.value, f.value);
      }
      (He = e.paginationAttributes) != null && He.offset && (T.value = ue.offset, A.value.push(ue.offset)), Z.value = !0;
    }, ae = b(() => A.value[h.value - 1]), ve = N(null), Ae = b(() => {
      if (!e.fetcher || !Z.value)
        return "";
      let ue = d;
      return e.cacheIdentifier && (ue = e.cacheIdentifier), ue += `-${JSON.stringify(J.value)}`, e.fetcherCacheKey && (ue += `-${e.fetcherCacheKey}`), `k-table_${ue}`;
    }), { debouncedFn: Te, generateDebouncedFn: Le } = u((ue) => {
      p.value = ue;
    }, 350), ze = Le(0), {
      data: _e,
      response: tt,
      error: Xe,
      revalidate: et,
      isValidating: pe,
      isLoading: me
    } = s(
      () => Ae.value,
      () => fe(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: he, hasData: V } = l(_e, Xe, pe), Se = b(() => ({
      hasData: V.value,
      state: he.value
    })), Be = b(() => me.value ? "loading" : Xe.value ? "error" : "success"), { debouncedFn: Me } = u(et, 500), Ve = ({ sortColumnKey: ue, prevKey: He, sortColumnOrder: _ }, de = !0) => {
      var M;
      S.value = !0;
      const Ie = v.value.find((j) => j.key === ue) || {}, { useSortHandlerFunction: Q } = Ie;
      if (de && i("sort", {
        prevKey: He,
        sortColumnKey: ue,
        sortColumnOrder: _
      }), h.value = 1, (!w.value || ue !== w.value) && (A.value = [null]), w.value = ue, k.value = _, e.clientSort)
        if (Q && e.sortHandlerFunction) {
          const j = e.sortHandlerFunction({
            key: ue,
            prevKey: He,
            sortColumnOrder: k.value,
            data: f.value
          });
          j && (f.value = [...j]);
        } else
          c(ue, He, k.value, f.value);
      else (M = e.paginationAttributes) != null && M.offset || Me();
    }, wt = ({ page: ue }) => {
      h.value = ue;
    }, vt = ({ pageSize: ue }) => {
      A.value = [null], T.value = null, g.value = ue, h.value = 1;
    }, Je = ({ columnWidths: ue, columnVisibility: He }) => {
      lt.value = {
        ...lt.value,
        ...ue
      }, xt.value = {
        ...xt.value,
        ...He
      }, Xt();
    }, lt = N(e.tablePreferences.columnWidths || {}), xt = N(e.tablePreferences.columnVisibility || {}), Lt = b(() => ({
      pageSize: g.value,
      sortColumnKey: w.value,
      sortColumnOrder: k.value,
      ...lt.value ? { columnWidths: lt.value } : {},
      ...xt.value ? { columnVisibility: xt.value } : {}
    }));
    ie(() => e.tablePreferences, (ue) => {
      g.value = ue != null && ue.pageSize ? ue.pageSize : g.value, lt.value = ue != null && ue.columnWidths ? ue.columnWidths : lt.value, xt.value = ue != null && ue.columnVisibility ? ue.columnVisibility : xt.value, (ue != null && ue.sortColumnKey || ue != null && ue.sortColumnOrder) && (w.value !== ue.sortColumnKey || k.value !== ue.sortColumnOrder) && Ve({
        sortColumnKey: ue.sortColumnKey,
        prevKey: w.value,
        sortColumnOrder: ue.sortColumnOrder
      }, !1);
    });
    const Xt = () => {
      Be.value === "success" && i("update:table-preferences", Lt.value);
    }, ra = () => {
      h.value++, T.value = ve.value;
    }, Jt = () => {
      h.value--, T.value = ae.value;
    }, Mt = b(() => {
      var He, _, de;
      if (!e.fetcher || e.hidePagination)
        return !1;
      const ue = ((_ = (He = e.paginationAttributes) == null ? void 0 : He.pageSizes) == null ? void 0 : _[0]) ?? y1;
      return e.hidePaginationWhenOptional && h.value === 1 ? (de = e.paginationAttributes) != null && de.offset ? !!ae.value || !!ve.value || f.value.length >= ue : C.value > ue : !0;
    });
    return ie(tt, (ue) => {
      var He, _, de, Ie;
      ue != null && ue.data && (f.value = [...ue.data], C.value = ((He = e.paginationAttributes) == null ? void 0 : He.totalCount) || ue.total || ((_ = ue.data) == null ? void 0 : _.length) || 0, (de = e.paginationAttributes) != null && de.offset && ((Ie = ue.pagination) != null && Ie.offset ? (ve.value = ue.pagination.offset, A.value[h.value] || A.value.push(ue.pagination.offset)) : ve.value = null, F.value = ue.pagination && "hasNextPage" in ue.pagination ? ue.pagination.hasNextPage || !1 : !0), f.value.length === 0 && h.value > 1 && (h.value = 1, A.value = [null], T.value = null), e.sortable && !S.value && Ve({ sortColumnKey: w.value, prevKey: "", sortColumnOrder: k.value }, !1));
    }, { deep: !0, immediate: !0 }), ie([Se, Be], (ue) => {
      const [He, _] = ue;
      i("state", {
        state: _,
        hasData: He.hasData
      });
    }), ie(() => e.searchInput, (ue) => {
      ue === "" ? ze(ue) : Te(ue);
    }, { immediate: !0 }), ie([p, g], async (ue, He) => {
      const [_] = He, [de] = ue;
      de !== _ && h.value !== 1 && (h.value = 1, A.value = [null], T.value = null);
    }, { deep: !0, immediate: !0 }), it(() => {
      ne();
    }), t({
      revalidate: () => {
        et();
      }
    }), (ue, He) => (m(), X(N1, Re({
      "cell-attrs": e.cellAttrs,
      class: "k-table-data",
      data: f.value,
      "empty-state-action-message": e.emptyStateActionMessage,
      "empty-state-action-route": e.emptyStateActionRoute,
      "empty-state-button-appearance": y.value,
      "empty-state-icon-variant": e.emptyStateIconVariant,
      "empty-state-message": e.emptyStateMessage,
      "empty-state-title": e.emptyStateTitle,
      error: e.error,
      "error-state-action-message": e.errorStateActionMessage,
      "error-state-action-route": e.errorStateActionRoute,
      "error-state-message": e.errorStateMessage,
      "error-state-title": e.errorStateTitle,
      headers: v.value,
      "hide-headers": e.hideHeaders,
      "hide-pagination": e.hidePagination || !Mt.value,
      "hide-pagination-when-optional": !1,
      "hide-toolbar": e.hideToolbar,
      loading: e.loading || D(me),
      "max-height": e.maxHeight,
      nested: e.nested,
      "pagination-attributes": z.value,
      "resize-columns": e.resizeColumns,
      "row-attrs": e.rowAttrs,
      "row-bulk-action-enabled": e.rowBulkActionEnabled,
      "row-expandable": e.rowExpandable,
      "row-expanded": e.rowExpanded,
      "row-hover": e.rowHover,
      "row-key": e.rowKey,
      "row-link": e.rowLink,
      "table-preferences": Lt.value,
      "tooltip-target": e.tooltipTarget
    }, r.value, {
      onEmptyStateActionClick: He[0] || (He[0] = (_) => i("empty-state-action-click")),
      onErrorActionClick: He[1] || (He[1] = (_) => i("error-action-click")),
      onGetNextOffset: ra,
      onGetPreviousOffset: Jt,
      onPageChange: wt,
      onPageSizeChange: vt,
      onRowActionsToggle: He[2] || (He[2] = (_) => ue.$emit("row-actions-toggle", _)),
      onRowSelect: He[3] || (He[3] = (_) => i("row-select", _)),
      onSort: Ve,
      "onUpdate:rowExpanded": He[4] || (He[4] = (_) => i("update:row-expanded", _)),
      "onUpdate:tablePreferences": Je
    }), kt({ _: 2 }, [
      o.toolbar && !e.hideToolbar ? {
        name: "toolbar",
        fn: L(() => [
          W(ue.$slots, "toolbar", { state: Se.value })
        ]),
        key: "0"
      } : void 0,
      o["bulk-actions"] ? {
        name: "bulk-actions",
        fn: L((_) => [
          W(ue.$slots, "bulk-actions", la(Oa(_)))
        ]),
        key: "1"
      } : void 0,
      o["bulk-action-items"] ? {
        name: "bulk-action-items",
        fn: L((_) => [
          W(ue.$slots, "bulk-action-items", la(Oa(_)))
        ]),
        key: "2"
      } : void 0,
      o["error-state"] ? {
        name: "error-state",
        fn: L(() => [
          W(ue.$slots, "error-state")
        ]),
        key: "3"
      } : void 0,
      o["empty-state"] ? {
        name: "empty-state",
        fn: L(() => [
          W(ue.$slots, "empty-state")
        ]),
        key: "4"
      } : void 0,
      o["empty-state-action-icon"] ? {
        name: "empty-state-action-icon",
        fn: L(() => [
          W(ue.$slots, "empty-state-action-icon")
        ]),
        key: "5"
      } : void 0,
      Fe(E.value, (_) => ({
        name: _,
        fn: L((de) => [
          W(ue.$slots, _, la(Oa(de)))
        ])
      })),
      Fe(P.value, (_) => ({
        name: _,
        fn: L((de) => [
          W(ue.$slots, _, la(Oa(de)))
        ])
      })),
      Fe(R.value, (_) => ({
        name: _,
        fn: L((de) => [
          W(ue.$slots, _, la(Oa(de)))
        ])
      })),
      o["action-items"] ? {
        name: "action-items",
        fn: L((_) => [
          W(ue.$slots, "action-items", la(Oa(_)))
        ]),
        key: "6"
      } : void 0,
      o["row-expanded"] ? {
        name: "row-expanded",
        fn: L((_) => [
          W(ue.$slots, "row-expanded", la(Oa(_)))
        ]),
        key: "7"
      } : void 0
    ]), 1040, ["cell-attrs", "data", "empty-state-action-message", "empty-state-action-route", "empty-state-button-appearance", "empty-state-icon-variant", "empty-state-message", "empty-state-title", "error", "error-state-action-message", "error-state-action-route", "error-state-message", "error-state-title", "headers", "hide-headers", "hide-pagination", "hide-toolbar", "loading", "max-height", "nested", "pagination-attributes", "resize-columns", "row-attrs", "row-bulk-action-enabled", "row-expandable", "row-expanded", "row-hover", "row-key", "row-link", "table-preferences", "tooltip-target"]));
  }
}), gq = {
  class: "k-slider",
  "data-testid": "k-slider"
}, mq = { class: "slider-container" }, pq = { class: "input-value" }, yq = ["id", "disabled", "list", "max", "min", "step"], bq = ["id"], wq = ["data-testid", "label", "value"], Cq = {
  "aria-hidden": "true",
  class: "slider-marks",
  "data-testid": "slider-marks"
}, kq = ["data-testid"], $q = /* @__PURE__ */ oe({
  __name: "KSlider",
  props: /* @__PURE__ */ _s({
    label: { default: "" },
    min: { default: 0 },
    max: { default: 10 },
    step: { default: 1 },
    showMarks: { type: Boolean, default: !1 },
    marks: { default: () => [] },
    showValue: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    labelAttributes: { default: () => ({}) }
  }, {
    modelValue: {
      required: !0,
      type: Number
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ _s(["change", "update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const a = t, n = yt(), r = b(() => ({ width: C(c.value) })), i = b(() => ({
      left: C(c.value),
      transform: `translateX(-${C(c.value)})`
    })), o = () => {
      a("change", c.value), s();
    }, u = dt("thumbPopover"), s = () => {
      var h;
      (h = u.value) == null || h.showPopover();
    }, l = () => {
      var h;
      (h = u.value) == null || h.hidePopover();
    }, c = eu(e, "modelValue"), d = b(() => {
      const h = Math.max(
        (String(e.step).split(".")[1] || "").length,
        (String(e.min).split(".")[1] || "").length,
        (String(e.max).split(".")[1] || "").length
      );
      return Math.pow(10, h);
    }), f = b(() => {
      if (e.max <= e.min || e.step <= 0)
        return [];
      const h = [], g = e.min * d.value, p = e.max * d.value, w = e.step * d.value;
      for (let k = g; k <= p; k += w)
        h.push(k / d.value);
      return h;
    }), v = (h) => h >= e.min && h <= e.max && f.value.includes(h), y = b(() => {
      var h, g;
      if (e.marks.length) {
        if (typeof e.marks[0] == "object")
          return e.marks.filter((p) => v(p.value));
        {
          const p = e.marks.filter((w) => v(w)).map((w) => ({
            label: String(w),
            value: w
          }));
          return ((h = p[0]) == null ? void 0 : h.value) !== e.min && p.unshift({ label: String(e.min), value: e.min }), ((g = p.at(-1)) == null ? void 0 : g.value) !== e.max && p.push({ label: String(e.max), value: e.max }), p;
        }
      }
      return e.showMarks ? f.value.map((p) => ({
        label: String(p),
        value: p
      })) : [
        {
          label: String(e.min),
          value: e.min
        },
        {
          label: String(e.max),
          value: e.max
        }
      ];
    }), C = (h) => `${(h - e.min) / (e.max - e.min) * 100}%`;
    return ie(() => e.max, (h) => {
      h <= e.min && console.warn(`KSlider: max value ${h} must be greater than min value ${e.min}.`);
    }, { immediate: !0 }), ie(() => e.step, (h) => {
      e.max > e.min && (h <= 0 || (e.max * d.value - e.min * d.value) % (h * d.value) !== 0) && console.warn(`KSlider: step value ${h} is invalid.`);
    }, { immediate: !0 }), ie(c, (h) => {
      e.max > e.min && !v(h) && (console.warn(`KSlider: value ${h} is out of range [${f.value.join(", ")}]. Setting to min value ${e.min}.`), c.value = e.min);
    }, { immediate: !0 }), ie(() => e.marks, (h) => {
      if (h.length) {
        let g = [];
        g = h.filter((p) => !v(typeof e.marks[0] == "object" ? p.value : p)), g.length && console.warn(`KSlider: marks [${g.map((p) => typeof g[0] == "object" ? p.value : p).join(", ")}] are out of range [${f.value.join(", ")}].`);
      }
    }, { immediate: !0 }), (h, g) => (m(), $("div", gq, [
      e.label ? (m(), X(Ka, Re({ key: 0 }, e.labelAttributes, {
        for: `${D(n)}-input`
      }), {
        default: L(() => [
          be(re(e.label), 1)
        ]),
        _: 1
      }, 16, ["for"])) : H("", !0),
      Y("div", mq, [
        Y("span", {
          "aria-hidden": "true",
          class: ce(["lower-range-track", { "is-disabled": e.disabled }]),
          style: Oe(r.value)
        }, null, 6),
        G(or, {
          ref: "thumbPopover",
          "aria-hidden": "true",
          disabled: e.disabled || !e.showValue,
          "hide-close-icon": "",
          placement: "top",
          "popover-timeout": 500,
          trigger: "hover",
          width: "auto"
        }, {
          content: L(() => [
            Y("span", pq, re(c.value), 1)
          ]),
          default: L(() => [
            Y("span", {
              class: ce(["thumb", { "is-disabled": e.disabled }]),
              style: Oe(i.value)
            }, null, 6)
          ]),
          _: 1
        }, 8, ["disabled"]),
        pa(Y("input", {
          id: `${D(n)}-input`,
          "onUpdate:modelValue": g[0] || (g[0] = (p) => c.value = p),
          "data-testid": "slider-input",
          disabled: e.disabled,
          list: `${D(n)}-markers`,
          max: e.max,
          min: e.min,
          step: e.step,
          type: "range",
          onBlur: l,
          onFocus: s,
          onInput: o,
          onMouseup: l,
          onTouchend: l
        }, null, 40, yq), [
          [
            tu,
            c.value,
            void 0,
            { number: !0 }
          ]
        ]),
        Y("datalist", {
          id: `${D(n)}-markers`,
          "data-testid": "slider-datalist-marks"
        }, [
          (m(!0), $(Ee, null, Fe(y.value, (p) => (m(), $("option", {
            key: `datalist-mark-${p.value}`,
            "data-testid": `datalist-mark-${p.value}`,
            label: p.label,
            style: Oe({ left: C(p.value) }),
            value: p.value
          }, null, 12, wq))), 128))
        ], 8, bq),
        Y("div", Cq, [
          (m(!0), $(Ee, null, Fe(y.value, (p) => (m(), $("span", {
            key: `mark-${p.value}`,
            "data-testid": `mark-${p.value}`,
            style: Oe({ left: C(p.value) })
          }, re(p.label || p.value), 13, kq))), 128))
        ])
      ])
    ]));
  }
}), Sq = /* @__PURE__ */ Pe($q, [["__scopeId", "data-v-dea0bffd"]]), ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KAlert: ob,
  KBadge: vi,
  KBreadcrumbs: D0,
  KButton: rt,
  KCard: Vu,
  KCatalog: ew,
  KCatalogItem: Hg,
  KCheckbox: sl,
  KClipboardProvider: dg,
  KCodeBlock: ES,
  KCodeBlockIconButton: xr,
  KCollapse: FS,
  KComponent: fg,
  KCopy: VH,
  KDateTimePicker: vR,
  KDropdown: Fr,
  KDropdownItem: Gu,
  KDropdownMenu: Fr,
  KEmptyState: _n,
  KExternalLink: PH,
  KFileUpload: kR,
  KInput: Nn,
  KInputSwitch: DR,
  KLabel: Ka,
  KModal: p1,
  KModalFullscreen: IF,
  KMultiselect: rz,
  KPagination: Gl,
  KPop: or,
  KPrompt: dz,
  KRadio: Cz,
  KSegmentedControl: Lm,
  KSelect: Hz,
  KSkeleton: jl,
  KSkeletonBox: xa,
  KSlideout: Gz,
  KSlider: Sq,
  KStepper: tY,
  KTable: yY,
  KTableData: hq,
  KTableView: N1,
  KTabs: SY,
  KTextArea: AY,
  KToaster: C1,
  KToggle: Rl,
  KTooltip: ba,
  KTreeList: EH,
  KTruncate: HH,
  ToastManager: RY
}, Symbol.toStringTag, { value: "Module" })), Wq = {
  install: (e) => {
    for (const t in ag)
      e.component(t, ag[t]);
  }
};
export {
  gr as AlertAppearances,
  Dq as BadgeAppearances,
  vg as BadgeMethodAppearances,
  Aq as BadgeSizes,
  K1 as ButtonAppearances,
  Iq as ButtonSizes,
  Mq as CardSizeArray,
  Fl as DateTimePickerModes,
  Na as EmptyStateIconVariants,
  Eq as HeaderTags,
  ob as KAlert,
  vi as KBadge,
  D0 as KBreadcrumbs,
  rt as KButton,
  Vu as KCard,
  ew as KCatalog,
  Hg as KCatalogItem,
  sl as KCheckbox,
  dg as KClipboardProvider,
  ES as KCodeBlock,
  xr as KCodeBlockIconButton,
  FS as KCollapse,
  fg as KComponent,
  VH as KCopy,
  vR as KDateTimePicker,
  Fr as KDropdown,
  Gu as KDropdownItem,
  Fr as KDropdownMenu,
  _n as KEmptyState,
  PH as KExternalLink,
  kR as KFileUpload,
  Nn as KInput,
  DR as KInputSwitch,
  Ka as KLabel,
  p1 as KModal,
  IF as KModalFullscreen,
  rz as KMultiselect,
  Gl as KPagination,
  or as KPop,
  dz as KPrompt,
  Cz as KRadio,
  Lm as KSegmentedControl,
  Hz as KSelect,
  jl as KSkeleton,
  xa as KSkeletonBox,
  Gz as KSlideout,
  Sq as KSlider,
  tY as KStepper,
  yY as KTable,
  hq as KTableData,
  N1 as KTableView,
  SY as KTabs,
  AY as KTextArea,
  C1 as KToaster,
  Rl as KToggle,
  ba as KTooltip,
  EH as KTreeList,
  HH as KTruncate,
  Lq as MethodsArray,
  Nq as ModeArray,
  V1 as ModeArrayCustom,
  j1 as ModeArrayRelative,
  G1 as ModeDateOnly,
  Rq as PopPlacementsArray,
  Bq as PopTriggerArray,
  Fq as RadioTypesArray,
  Hq as SkeletonBoxHeightArray,
  Yq as SkeletonBoxWidthArray,
  zq as SkeletonTypeArray,
  qq as StepperStateArray,
  Ge as TableViewHeaderKeys,
  Pq as TimepickerMode,
  RY as ToastManager,
  hg as ToasterAppearances,
  Oq as TriggerAlignmentArray,
  ag as components,
  Wq as default
};
